(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobxReact"), require("ecCom"), require("antd"), require("mobx"), require("ReactDOM"), require("weaPortalPublic"), require("loadjs"), require("comsMobx"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "mobxReact", "ecCom", "antd", "mobx", "ReactDOM", "weaPortalPublic", "loadjs", "comsMobx"], factory);
	else if(typeof exports === 'object')
		exports["weaPortalTheme"] = factory(require("React"), require("mobxReact"), require("ecCom"), require("antd"), require("mobx"), require("ReactDOM"), require("weaPortalPublic"), require("loadjs"), require("comsMobx"));
	else
		root["weaPortalTheme"] = factory(root["React"], root["mobxReact"], root["ecCom"], root["antd"], root["mobx"], root["ReactDOM"], root["weaPortalPublic"], root["loadjs"], root["comsMobx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_146__, __WEBPACK_EXTERNAL_MODULE_157__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/theme/static/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 191);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(49);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(129);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(133);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(49);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(38);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(113), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(30);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * 添加多级路径
 *
 * @param {*} url
 */var addContentPath=exports.addContentPath=function addContentPath(url){var ecologyContentPath=window.ecologyContentPath;if(url&&ecologyContentPath){if(url.startsWith('/')&&!url.startsWith(ecologyContentPath)){url=ecologyContentPath+url;}}return url;};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(46)('wks');
var uid = __webpack_require__(36);
var Symbol = __webpack_require__(13).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(8);
var ctx = __webpack_require__(31);
var hide = __webpack_require__(23);
var has = __webpack_require__(22);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(209)();
}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(20);
var IE8_DOM_DEFINE = __webpack_require__(59);
var toPrimitive = __webpack_require__(40);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(27);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(60);
var defined = __webpack_require__(41);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(41);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(63);
var enumBugKeys = __webpack_require__(47);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(52);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(160);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(22);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(21);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(95);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(20);
var dPs = __webpack_require__(99);
var enumBugKeys = __webpack_require__(47);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(53)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(69).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(46)('keys');
var uid = __webpack_require__(36);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var global = __webpack_require__(13);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(32) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(115);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(120);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(8);
var LIBRARY = __webpack_require__(32);
var wksExt = __webpack_require__(50);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
var document = __webpack_require__(13).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(35);
var createDesc = __webpack_require__(27);
var toIObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(40);
var has = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(59);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(15);
var core = __webpack_require__(8);
var fails = __webpack_require__(25);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(97)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(61)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(43);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(269),
    getValue = __webpack_require__(274);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(53)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(34);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(32);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(62);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(28);
var $iterCreate = __webpack_require__(98);
var setToStringTag = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(64);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(22);
var toIObject = __webpack_require__(24);
var arrayIndexOf = __webpack_require__(100)(false);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(22);
var toObject = __webpack_require__(26);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(63);
var hiddenKeys = __webpack_require__(47).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _E9QuickSearchTypes=__webpack_require__(320);var _E9QuickSearchTypes2=_interopRequireDefault(_E9QuickSearchTypes);var _E9QuickSearchRcmd=__webpack_require__(321);var _E9QuickSearchRcmd2=_interopRequireDefault(_E9QuickSearchRcmd);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9QuickSearch=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9QuickSearch,_React$Component);function E9QuickSearch(props){(0,_classCallCheck3.default)(this,E9QuickSearch);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QuickSearch.__proto__||(0,_getPrototypeOf2.default)(E9QuickSearch)).call(this,props));_this.onTypeSearch=_this.onTypeSearch.bind(_this);_this.onRcmdSearch=_this.onRcmdSearch.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.onTypesVisibleChange=_this.onTypesVisibleChange.bind(_this);_this.onRcmdVisibleChange=_this.onRcmdVisibleChange.bind(_this);return _this;}(0,_createClass3.default)(E9QuickSearch,[{key:'componentWillMount',value:function componentWillMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getQuickSearchTypes();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var logo=$('.e9header-left').width();var rleft=$('.e9header-right-menu').width();var rright=$('.e9header-right-toolbar').width();var topswitch=$('.e9header-switch').width();var wid=logo+rleft+rright+topswitch+30;$('.e9theme-layout-container').css({'min-width':wid+'px'});$('.e9theme-layout2-container').css({'min-width':wid+'px'});$('.e9theme-layout3-container').css({'min-width':wid+'px'});$('.e9theme-layout4-container').css({'min-width':wid+'px'});var logo2=$('.e8header-left').width();var rleft2=$('.e8header-right-menu').width();var rright2=$('.e8header-right-toolbar').width();var wid2=logo2+rleft2+rright2+30;$('.e8theme-layout-container').css({'min-width':wid2});var desklogo=$('.e9header-top-logo').width();var deskrleft=$('.e9header-home').width()+$('.e9header-quick-search').width()+10;var deskrright=$('.e9header-right-toolbar').width();var deskwid=desklogo+deskrleft+deskrright+50;$('.e9layout-desktop-container').css({'min-width':deskwid+'px'});}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var langId=portalThemeStore.langId,showQuickSearch=portalThemeStore.showQuickSearch,quickSearchTypesVisible=portalThemeStore.quickSearchTypesVisible,quickSearchTypesSelected=portalThemeStore.quickSearchTypesSelected,quickSearchRcmdVisible=portalThemeStore.quickSearchRcmdVisible,quickSearchShowRcmd=portalThemeStore.quickSearchShowRcmd,translatepage=portalThemeStore.translatepage;var selectedName=quickSearchTypesSelected.name;// 不显示快捷搜索
if(!showQuickSearch){return null;}return _react2.default.createElement('div',{className:'e9header-quick-search'},quickSearchShowRcmd?_react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@sdy4y9',trigger:'click',placement:'bottomLeft',content:_react2.default.createElement(_E9QuickSearchRcmd2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearchRcmd@i1rq6b',onTypeSearch:this.onTypeSearch,onVisibleChange:this.onRcmdVisibleChange}),overlayClassName:translatepage=='1'?'e9header-quick-search-rcmd-overlay-tran':'e9header-quick-search-rcmd-overlay',visible:quickSearchRcmdVisible,onVisibleChange:this.onRcmdVisibleChange},_react2.default.createElement('div',null)):null,_react2.default.createElement('div',{className:'e9header-quick-search-types',style:langId=='8'?{width:'100px'}:{}},_react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@d426ai',trigger:'click',placement:'bottomLeft',content:_react2.default.createElement(_E9QuickSearchTypes2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearchTypes@n5gg6k',onVisibleChange:this.onTypesVisibleChange}),overlayClassName:translatepage=='1'?'e9header-quick-search-types-overlay-tran':'e9header-quick-search-types-overlay',visible:quickSearchTypesVisible,onVisibleChange:this.onTypesVisibleChange},_react2.default.createElement('div',{className:'e9header-quick-search-type'},_react2.default.createElement('span',{className:'e9header-quick-search-types-name',style:langId=='8'?{width:'80px'}:{},title:selectedName},selectedName),_react2.default.createElement('span',{className:'e9header-quick-search-types-icon'},_react2.default.createElement('i',{className:'wevicon-quick-search-arrow'}))))),_react2.default.createElement('div',{className:'e9header-quick-search-split'}),_react2.default.createElement('div',{className:'e9header-quick-search-content'},_react2.default.createElement('input',{id:'e9header-quick-search-input',className:'e9header-quick-search-input',placeholder:getLabel(84128,'请输入关键词搜索'),onClick:this.onRcmdSearch,onChange:this.onRcmdSearch,onKeyDown:this.handleKeyDown})),_react2.default.createElement('div',{className:'e9header-quick-search-icon',onClick:this.onTypeSearch},_react2.default.createElement('i',{className:'wevicon-quick-search-search'})));}},{key:'onTypesVisibleChange',value:function onTypesVisibleChange(visible){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onQuickSearchTypesVisibleChange(visible);var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){themeLayoutMask.style.display='block';}else{themeLayoutMask.style.display='none';}}},{key:'onRcmdVisibleChange',value:function onRcmdVisibleChange(visible){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onQuickSearchRcmdVisibleChange(visible);var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){themeLayoutMask.style.display='block';}else{themeLayoutMask.style.display='none';}}},{key:'onTypeSearch',value:function onTypeSearch(){this.onRcmdVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onQuickSearch({from:'theme',value:jQuery('#e9header-quick-search-input').val()});}},{key:'onRcmdSearch',value:function onRcmdSearch(e){var value=e.target.value;var portalThemeStore=this.props.portalThemeStore;var quickSearchShowRcmd=portalThemeStore.quickSearchShowRcmd;if(quickSearchShowRcmd){this.onRcmdVisibleChange(!!value);portalThemeStore.onRcmdSearch(value);}}},{key:'handleKeyDown',value:function handleKeyDown(e){if(e.keyCode==13){this.onTypeSearch();}}}]);return E9QuickSearch;}(_react2.default.Component))||_class)||_class);exports.default=E9QuickSearch;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return menuAllProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function noop() {}

function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || prefix + 'item_' + index;
}

function getMenuIdFromSubMenuEventKey(eventKey) {
  return eventKey + '-menu-';
}

function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    index++;
    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(c.props.children, function (c2) {
        index++;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}

function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    if (c) {
      var construct = c.type;
      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }
      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}

var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements',

// the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(13).document;
module.exports = document && document.documentElement;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(20);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(28);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(73);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(28);
module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(34);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117);
var global = __webpack_require__(13);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(28);
var TO_STRING_TAG = __webpack_require__(12)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 76 */
/***/ (function(module, exports) {



/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = __webpack_require__(0);

var PropTypes = __webpack_require__(16); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(211);

var ErrorCorrectLevel = __webpack_require__(152);

function getBackingStorePixelRatio(ctx) {
  return (// $FlowFixMe
    ctx.webkitBackingStorePixelRatio || // $FlowFixMe
    ctx.mozBackingStorePixelRatio || // $FlowFixMe
    ctx.msBackingStorePixelRatio || // $FlowFixMe
    ctx.oBackingStorePixelRatio || // $FlowFixMe
    ctx.backingStorePixelRatio || 1
  );
} // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000'
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string
};

var QRCodeCanvas =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QRCodeCanvas, _React$Component);

  function QRCodeCanvas() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = QRCodeCanvas.__proto__ || Object.getPrototypeOf(QRCodeCanvas)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "_canvas", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    }), _temp));
  }

  _createClass(QRCodeCanvas, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this2.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _props = this.props,
          value = _props.value,
          size = _props.size,
          level = _props.level,
          bgColor = _props.bgColor,
          fgColor = _props.fgColor; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var tileW = size / cells.length;
        var tileH = size / cells.length;
        var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
        canvas.height = canvas.width = size * scale;
        ctx.scale(scale, scale);
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          value = _props2.value,
          size = _props2.size,
          level = _props2.level,
          bgColor = _props2.bgColor,
          fgColor = _props2.fgColor,
          style = _props2.style,
          otherProps = _objectWithoutProperties(_props2, ["value", "size", "level", "bgColor", "fgColor", "style"]);

      var canvasStyle = _extends({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this3._canvas = _ref2;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.Component);

Object.defineProperty(QRCodeCanvas, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeCanvas, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCodeSVG =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(QRCodeSVG, _React$Component2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, (QRCodeSVG.__proto__ || Object.getPrototypeOf(QRCodeSVG)).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this4 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this4.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          value = _props3.value,
          size = _props3.size,
          level = _props3.level,
          bgColor = _props3.bgColor,
          fgColor = _props3.fgColor,
          otherProps = _objectWithoutProperties(_props3, ["value", "size", "level", "bgColor", "fgColor"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return;
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var ops = [];
      cells.forEach(function (row, y) {
        var lastIsDark = false;
        var start = null;
        row.forEach(function (cell, x) {
          if (!cell && start !== null) {
            // M0 0h7v1H0z injects the space with the move and dropd the comma,
            // saving a char per operation
            ops.push("M".concat(start, " ").concat(y, "h").concat(x - start, "v1H").concat(start, "z"));
            start = null;
            return;
          } // end of row, clean up or skip


          if (x === row.length - 1) {
            if (!cell) {
              // We would have closed the op above already so this can only mean
              // 2+ light modules in a row.
              return;
            }

            if (start === null) {
              // Just a single dark module.
              ops.push("M".concat(x, ",").concat(y, " h1v1H").concat(x, "z"));
            } else {
              // Otherwise finish the current line.
              ops.push("M".concat(start, ",").concat(y, " h").concat(x + 1 - start, "v1H").concat(start, "z"));
            }

            return;
          }

          if (cell && start === null) {
            start = x;
          }
        });
      });
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(cells.length, " ").concat(cells.length)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(cells.length, "v").concat(cells.length, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: ops.join('')
      }));
    }
  }]);

  return QRCodeSVG;
}(React.Component);

Object.defineProperty(QRCodeSVG, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeSVG, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _extends({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _IntroStep=__webpack_require__(252);var _IntroStep2=_interopRequireDefault(_IntroStep);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9FreqUseMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9FreqUseMenu,_React$Component);function E9FreqUseMenu(props){(0,_classCallCheck3.default)(this,E9FreqUseMenu);return(0,_possibleConstructorReturn3.default)(this,(E9FreqUseMenu.__proto__||(0,_getPrototypeOf2.default)(E9FreqUseMenu)).call(this,props));}(0,_createClass3.default)(E9FreqUseMenu,[{key:'componentWillMount',value:function componentWillMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getFreqUseMenu();}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var showFreqUseMenu=portalThemeStore.showFreqUseMenu;// 不显示常用菜单
if(!showFreqUseMenu){return null;}return _react2.default.createElement('div',{className:'e9header-freq-use-menu',title:getLabel(129413,'常用菜单')},_react2.default.createElement(_IntroStep2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_IntroStep3@31xk9j'}));}}]);return E9FreqUseMenu;}(_react2.default.Component))||_class)||_class);exports.default=E9FreqUseMenu;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(259),
    listCacheDelete = __webpack_require__(260),
    listCacheGet = __webpack_require__(261),
    listCacheHas = __webpack_require__(262),
    listCacheSet = __webpack_require__(263);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(158);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(137),
    getRawTag = __webpack_require__(270),
    objectToString = __webpack_require__(271);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(283);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9TopLogo=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9TopLogo,_React$Component);function E9TopLogo(){(0,_classCallCheck3.default)(this,E9TopLogo);return(0,_possibleConstructorReturn3.default)(this,(E9TopLogo.__proto__||(0,_getPrototypeOf2.default)(E9TopLogo)).apply(this,arguments));}(0,_createClass3.default)(E9TopLogo,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo;var themeLogo=themeInfo.themeLogo,themeLogoName=themeInfo.themeLogoName,_themeInfo$themeLogoW=themeInfo.themeLogoWidth,themeLogoWidth=_themeInfo$themeLogoW===undefined?'':_themeInfo$themeLogoW,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$toplogo=styleConfig.toplogo,toplogo=_styleConfig$toplogo===undefined?{}:_styleConfig$toplogo;var fontSize=parseInt(toplogo.fontSize||'14px');var logoWidth=themeLogoWidth==''?197:parseInt(themeLogoWidth);return _react2.default.createElement('div',{className:'e9header-top-logo wea-f'+fontSize,style:{width:logoWidth}},themeLogo?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(themeLogo),alt:''}):_react2.default.createElement('span',null,themeLogoName));}}]);return E9TopLogo;}(_react2.default.Component))||_class)||_class);exports.default=E9TopLogo;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9ToolBar=__webpack_require__(171);var _E9ToolBar2=_interopRequireDefault(_E9ToolBar);var _E9ToolBarMore=__webpack_require__(172);var _E9ToolBarMore2=_interopRequireDefault(_E9ToolBarMore);var _E9Account=__webpack_require__(351);var _E9Account2=_interopRequireDefault(_E9Account);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9HeaderRight=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9HeaderRight,_React$Component);function E9HeaderRight(props){(0,_classCallCheck3.default)(this,E9HeaderRight);return(0,_possibleConstructorReturn3.default)(this,(E9HeaderRight.__proto__||(0,_getPrototypeOf2.default)(E9HeaderRight)).call(this,props));}(0,_createClass3.default)(E9HeaderRight,[{key:'componentDidMount',value:function componentDidMount(){var portalThemeStore=this.props.portalThemeStore;var pluginReload=portalThemeStore.pluginReload;if(pluginReload){portalThemeStore.getPlugins();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var logo=$('.e9header-left').width();var rleft=$('.e9header-right-menu').width();var rright=$('.e9header-right-toolbar').width();var topswitch=$('.e9header-switch').width();var wid=logo+rleft+rright+topswitch+30;$('.e9theme-layout-container').css({'min-width':wid+'px'});$('.e9theme-layout2-container').css({'min-width':wid+'px'});$('.e9theme-layout3-container').css({'min-width':wid+'px'});$('.e9theme-layout4-container').css({'min-width':wid+'px'});var desklogo=$('.e9header-top-logo').width();var deskrleft=$('.e9header-home').width()+$('.e9header-quick-search').width()+10;var deskrright=$('.e9header-right-toolbar').width();var deskwid=desklogo+deskrleft+deskrright+50;$('.e9layout-desktop-container').css({'min-width':deskwid+'px'});}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$plu=portalThemeStore.pluginIds,pluginIds=_portalThemeStore$plu===undefined?[]:_portalThemeStore$plu,pluginInsertCount=portalThemeStore.pluginInsertCount;return _react2.default.createElement('div',{className:'e9header-right-toolbar'},pluginIds.map(function(item,index){return _react2.default.createElement('div',{key:index,id:item,className:'e9header-toolbar-plugin'});}),pluginInsertCount>0?_react2.default.createElement('div',{className:'e9header-toolbar-splitter'}):null,_react2.default.createElement(_E9ToolBar2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9ToolBar@01f1fd'}),_react2.default.createElement(_E9ToolBarMore2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9ToolBarMore@ttvfxh'}),_react2.default.createElement('div',{className:'e9header-toolbar-splitter'}),_react2.default.createElement(_E9Account2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Account@9ay0hn'}));}}]);return E9HeaderRight;}(_react2.default.Component))||_class)||_class);exports.default=E9HeaderRight;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__(361);

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__(362);

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__(365);

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorPrefix = exports.events = undefined;
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
exports.getPosition = getPosition;
exports.isTouchEvent = isTouchEvent;
exports.getEdgeOffset = getEdgeOffset;
exports.getLockPixelOffset = getLockPixelOffset;

var _invariant = __webpack_require__(92);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}

function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}

function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { top: 0, left: 0 };

  // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
  if (node) {
    var nodeOffset = {
      top: offset.top + node.offsetTop,
      left: offset.left + node.offsetLeft
    };

    if (node.parentNode !== parent) {
      return getEdgeOffset(node.parentNode, parent, nodeOffset);
    } else {
      return nodeOffset;
    }
  }
}

function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;

  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

    (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

    offsetX = offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(102);
module.exports = __webpack_require__(8).Array.from;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(41);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(44);
var descriptor = __webpack_require__(27);
var setToStringTag = __webpack_require__(39);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(23)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(20);
var getKeys = __webpack_require__(29);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(24);
var toLength = __webpack_require__(57);
var toAbsoluteIndex = __webpack_require__(101);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(31);
var $export = __webpack_require__(15);
var toObject = __webpack_require__(26);
var call = __webpack_require__(70);
var isArrayIter = __webpack_require__(71);
var toLength = __webpack_require__(57);
var createProperty = __webpack_require__(103);
var getIterFn = __webpack_require__(72);

$export($export.S + $export.F * !__webpack_require__(74)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(27);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
module.exports = __webpack_require__(8).Object.keys;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(26);
var $keys = __webpack_require__(29);

__webpack_require__(55)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(15);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(109) });


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(18);
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(35);
var toObject = __webpack_require__(26);
var IObject = __webpack_require__(60);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.initLSValue=exports.setLSValue=exports.getLSValue=exports.getQueryParams=exports.getSearchParams=exports.getCookieValue=undefined;var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 获取Cookie值
 *
 * @param {*} name
 */var getCookieValue=exports.getCookieValue=function getCookieValue(name){var value='';var cookie=window.document.cookie;var cookies=cookie.split('; ');for(var i=0,len=cookies.length;i<len;i++){var item=cookies[i].split('=');if(item[0]==name){value=item[1];}}if(value=='true'){value=true;}else if(value=='false'){value=false;}return value;};/**
 * 获取查询参数
 *
 * @param {*} search
 */var getSearchParams=exports.getSearchParams=function getSearchParams(search){var searchParams={};if(search){var params=search.slice(search.indexOf('?')+1).split('&');for(var i=0,len=params.length;i<len;i++){var item=params[i].split('=');searchParams[item[0]]=item[1];}}return searchParams;};/**
 * 获取地址栏查询参数
 */var getQueryParams=exports.getQueryParams=function getQueryParams(){var queryParams=(0,_extends3.default)({},getSearchParams(window.location.search),getSearchParams(window.location.hash));// 当启用统一认证时，还需要从统一认证的service参数中提取参数
if(queryParams.appid&&queryParams.service){var service=window.decodeURIComponent(window.decodeURIComponent(queryParams.service));var length=service.length;var start=service.indexOf('index.html?');var end=service.indexOf('#');if(start!=-1){var search=service.substring(start,end!=-1?end:length);queryParams=(0,_extends3.default)({},queryParams,getSearchParams(search));}}if(queryParams.gopage){queryParams.gopage=decodeURIComponent(queryParams.gopage);}return queryParams;};/**
 * 获取本地缓存数据
 *
 * @param {*} key1
 * @param {*} key2
 */var getLSValue=exports.getLSValue=function getLSValue(key1,key2){var obj=_ecCom.WeaTools.ls.getJSONObj(key1);return obj&&obj[key2];};/**
 * 设置本地缓存数据
 *
 * @param {*} key1
 * @param {*} key2
 * @param {*} value
 */var setLSValue=exports.setLSValue=function setLSValue(key1,key2,value){var obj=_ecCom.WeaTools.ls.getJSONObj(key1)||{};obj[key2]=value;_ecCom.WeaTools.ls.set(key1,obj);};/**
 * 初始化本地缓存数据
 *
 * @param {*} loginId
 * @param {*} langId
 */var initLSValue=exports.initLSValue=function initLSValue(loginId,langId){var ls_loginId=getLSValue('login','loginId');var ls_langId=getLSValue('login','langId');var ls=window.localStorage;var keys=[];if(!ls_loginId||!ls_langId||loginId!=ls_loginId||langId!=ls_langId){keys.push('e9_locale');for(var i=0,len=ls.length;i<len;i++){var key=ls.key(i);if(/^theme-/.test(key)||/^portal-/.test(key)||/^edata-/.test(key)||/^tabdata-/.test(key)){keys.push(key);}}}for(var _i=0,_len=keys.length;_i<_len;_i++){ls.removeItem(keys[_i]);}_ecCom.WeaTools.ls.set('isInitLSValue',true);};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(201), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
module.exports = __webpack_require__(8).Object.getPrototypeOf;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(26);
var $getPrototypeOf = __webpack_require__(64);

__webpack_require__(55)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(116), __esModule: true };

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(75);
module.exports = __webpack_require__(50).f('iterator');


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(118);
var step = __webpack_require__(119);
var Iterators = __webpack_require__(28);
var toIObject = __webpack_require__(24);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(61)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(121), __esModule: true };

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(122);
__webpack_require__(76);
__webpack_require__(127);
__webpack_require__(128);
module.exports = __webpack_require__(8).Symbol;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(13);
var has = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(62);
var META = __webpack_require__(123).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(46);
var setToStringTag = __webpack_require__(39);
var uid = __webpack_require__(36);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(50);
var wksDefine = __webpack_require__(51);
var enumKeys = __webpack_require__(124);
var isArray = __webpack_require__(125);
var anObject = __webpack_require__(20);
var isObject = __webpack_require__(21);
var toObject = __webpack_require__(26);
var toIObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(40);
var createDesc = __webpack_require__(27);
var _create = __webpack_require__(44);
var gOPNExt = __webpack_require__(126);
var $GOPD = __webpack_require__(54);
var $GOPS = __webpack_require__(48);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(29);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(65).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(35).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(32)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(36)('meta');
var isObject = __webpack_require__(21);
var has = __webpack_require__(22);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(35);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(34);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(24);
var gOPN = __webpack_require__(65).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('asyncIterator');


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('observable');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(130), __esModule: true };

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131);
module.exports = __webpack_require__(8).Object.setPrototypeOf;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(15);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(132).set });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(21);
var anObject = __webpack_require__(20);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(31)(Function.call, __webpack_require__(54).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
var $Object = __webpack_require__(8).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(44) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(37),
    stubFalse = __webpack_require__(307);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)(module)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(309),
    baseUnary = __webpack_require__(310),
    nodeUtil = __webpack_require__(311);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9Home=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Home,_React$Component);function E9Home(props){(0,_classCallCheck3.default)(this,E9Home);var _this=(0,_possibleConstructorReturn3.default)(this,(E9Home.__proto__||(0,_getPrototypeOf2.default)(E9Home)).call(this,props));_this.onHomeClick=_this.onHomeClick.bind(_this);return _this;}(0,_createClass3.default)(E9Home,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var hiddenMyPortal=portalThemeStore.hiddenMyPortal,_portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$topmenu=styleConfig.topmenu,topmenu=_styleConfig$topmenu===undefined?{}:_styleConfig$topmenu;if(hiddenMyPortal||topmenu.style=='text'){return _react2.default.createElement('div',null);}return _react2.default.createElement('div',{className:'e9header-home',title:getLabel(513043,'我的门户'),onClick:this.onHomeClick},_react2.default.createElement('div',{className:'e9header-home-icon'},_react2.default.createElement('i',{className:'wevicon-home'})));}},{key:'onHomeClick',value:function onHomeClick(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getHome();}}]);return E9Home;}(_react2.default.Component))||_class)||_class);exports.default=E9Home;

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(38);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLoginInfo=exports.logout=exports.login4qc=exports.getActiveLanguage=exports.checkCasIsDeployed=exports.getUpgradeInfo=undefined;var _ecCom=__webpack_require__(7);// 获取升级信息
var getUpgradeInfo=exports.getUpgradeInfo=function getUpgradeInfo(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/login/UpgradeMessage.jsp?getupgradeinfo=1','GET',params);};// 检查是否部署了CAS
var checkCasIsDeployed=exports.checkCasIsDeployed=function checkCasIsDeployed(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/integration/common1/checkCasIsDeployed','POST',params);};// 获取使用的语言
var getActiveLanguage=exports.getActiveLanguage=function getActiveLanguage(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/system/language/base/getActiveLanguage','GET',params);};// 扫码登录
var login4qc=exports.login4qc=function login4qc(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/login/qrcode/getQCLoginStatus','POST',params);};// 退出
var logout=exports.logout=function logout(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/login/checkLogout','POST',params);};// 获取登录页信息
var getLoginInfo=exports.getLoginInfo=function getLoginInfo(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/login/logininfo','POST',params);};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.doEvent=undefined;var _antd=__webpack_require__(10);var _loadjs2=__webpack_require__(146);var _loadjs3=_interopRequireDefault(_loadjs2);var _files=__webpack_require__(147);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 执行事件回调
 *
 * @param {*} callback
 */var doEventCallback=function doEventCallback(callback){if(callback&&typeof callback=='function'){callback();}};/**
 * 执行事件回调
 *
 * @param {*} eventName
 * @param {*} callback
 */var doEventSuccess=function doEventSuccess(eventName,callback){var eventRegister=window.eventRegister;if(eventRegister&&eventRegister.startList&&typeof eventRegister.startList=='function'){try{eventRegister.startList(eventName,function(){return doEventCallback(callback);},function(){return doEventCallback(callback);});}catch(e){_antd.message.error(e.message);doEventCallback(callback);}}else{doEventCallback(callback);}};/**
 * 执行事件
 *
 * 已支持事件类型：
 * 1、登录页加载前：beforLoginRender
 * 2、登录页加载后：afterLoginRender
 * 3、登录前：beforLogin
 * 4、登录成功后：afterLogin
 * 5、主题加载前：beforThemeRender
 * 6、主题加载后：afterThemeRender
 * 7、退出前：beforLogout
 * 8、退出成功后：afterLogout
 *
 * @param {*} eventName
 * @param {*} callback
 */var doEvent=exports.doEvent=function doEvent(eventName,callback){var loadjs=window.loadjs||_loadjs3.default;loadjs.isDefined('devModuleCustom')?loadjs.ready('devModuleCustom',{success:function success(){return doEventSuccess(eventName,callback);},error:function error(){return doEventSuccess(eventName,callback);}}):loadjs(_files.devModuleCustomFiles,'devModuleCustom',{async:true,success:function success(){return doEventSuccess(eventName,callback);},error:function error(){return doEventSuccess(eventName,callback);}});};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_146__;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.portalPublicFiles=exports.comMobxFiles=exports.ecComFiles=exports.devModuleCustomFiles=undefined;var _pathUtil=__webpack_require__(11);var devModuleCustomFiles=exports.devModuleCustomFiles=['css!'+(0,_pathUtil.addContentPath)('/cloudstore/config/devStatic/devModuleStyle.css')+'?v='+Date.now(),(0,_pathUtil.addContentPath)('/cloudstore/config/devStatic/devModuleCustom.js')+'?v='+Date.now()];var ecComFiles=exports.ecComFiles=[(0,_pathUtil.addContentPath)('/cloudstore/resource/pc/com/v1/ecCom.min.js')];var comMobxFiles=exports.comMobxFiles=[(0,_pathUtil.addContentPath)('/spa/coms/index.mobx.css'),(0,_pathUtil.addContentPath)('/spa/coms/index.mobx.js')];var portalPublicFiles=exports.portalPublicFiles=[(0,_pathUtil.addContentPath)('/spa/portal/public/index.css'),(0,_pathUtil.addContentPath)('/spa/portal/public/index.js')];

/***/ }),
/* 148 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.onClearEmail=exports.setTranslatepage=exports.getTranslatepage=exports.getTranslatepower=exports.setPortalIntroInfo=exports.getPortalIntroInfo=exports.setQuickSearchShowRcmd=exports.changeLang=exports.setMyFontSize=exports.setMyThemeLayout=exports.setMyThemeColor=exports.setMyThemeTs=exports.setMyTheme=exports.setTopMenuStatictics=exports.getAccountMoreMenu=exports.getAccountMenu=exports.changeAccount=exports.getAccount=exports.getToolbarMoreMenu=exports.getToolbarMenu=exports.getWsAssociate=exports.getQuickSearchRoute=exports.getQuickSearchTypes=exports.getFreqUseMenu=exports.getEmailMenu=exports.getPortalMenu=exports.getTopMenu=exports.getBackEndMenu=exports.getFrontEndMenu=exports.getPlugins=exports.getThemeConfig=exports.getMyTheme=undefined;var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 获取主题
var getMyTheme=exports.getMyTheme=function getMyTheme(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeCenter/getMyTheme','GET',params);};// 获取主题配置
var getThemeConfig=exports.getThemeConfig=function getThemeConfig(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeConfig/getThemeConfig','GET',params);};// 获取插件
var getPlugins=exports.getPlugins=function getPlugins(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/plugin/getPlugins','GET',params);};// 获取前端菜单
var getFrontEndMenu=exports.getFrontEndMenu=function getFrontEndMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/menu/getFrontEndMenu','GET',(0,_extends3.default)({withPortal:'1',isLoadAll:'1'},params));};// 获取后端菜单
var getBackEndMenu=exports.getBackEndMenu=function getBackEndMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/menu/getBackEndMenu','GET',params);};// 获取顶部菜单
var getTopMenu=exports.getTopMenu=function getTopMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/menu/getFrontEndMenu','GET',(0,_extends3.default)({withPortal:'1',isLoadAll:'0'},params));};// 获取门户菜单
var getPortalMenu=exports.getPortalMenu=function getPortalMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/menu/getPortalMenu','GET',params);};// 获取邮件菜单
var getEmailMenu=exports.getEmailMenu=function getEmailMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/emailmenu/emailmenu','POST',params);};// 获取常用菜单
var getFreqUseMenu=exports.getFreqUseMenu=function getFreqUseMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/frequsemenu/getdata','POST',(0,_extends3.default)({parentid:0},params));};// 获取快速搜索类型
var getQuickSearchTypes=exports.getQuickSearchTypes=function getQuickSearchTypes(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/quickSearch/getQuickSearchTypes','GET',params);};// 获取快速搜索路由
var getQuickSearchRoute=exports.getQuickSearchRoute=function getQuickSearchRoute(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/fullsearch/base/getQuickSearchRoute','POST',params);};// 获取微搜联想推荐
var getWsAssociate=exports.getWsAssociate=function getWsAssociate(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/fullsearch/base/getAssociate','POST',params);};// 获取工具栏菜单
var getToolbarMenu=exports.getToolbarMenu=function getToolbarMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/toolbar/getToolbarMenu','GET',params);};// 获取工具栏更多菜单
var getToolbarMoreMenu=exports.getToolbarMoreMenu=function getToolbarMoreMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/toolbarMore/getToolbarMoreMenu','GET',(0,_extends3.default)({menutype:'front'},params));};// 获取账号信息
var getAccount=exports.getAccount=function getAccount(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/login/getAccountList','GET',params);};// 切换账号
var changeAccount=exports.changeAccount=function changeAccount(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/login/identityShift','POST',params);};// 获取账号菜单
var getAccountMenu=exports.getAccountMenu=function getAccountMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/account/getAccountMenu','GET',(0,_extends3.default)({menutype:'front'},params));};// 获取账号更多菜单
var getAccountMoreMenu=exports.getAccountMoreMenu=function getAccountMoreMenu(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/accountmore/getAccountMoreMenu','GET',(0,_extends3.default)({menutype:'front'},params));};// 设置顶部菜单点击次数
var setTopMenuStatictics=exports.setTopMenuStatictics=function setTopMenuStatictics(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/menu/setTopMenuStatictics','POST',params);};// 设置主题
var setMyTheme=exports.setMyTheme=function setMyTheme(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeCenter/setMyTheme','POST',params);};// 设置主题特色
var setMyThemeTs=exports.setMyThemeTs=function setMyThemeTs(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeCenter/setMyThemeTs','POST',params);};// 设置主题颜色
var setMyThemeColor=exports.setMyThemeColor=function setMyThemeColor(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeCenter/setMyThemeColor','POST',params);};// 设置主题布局
var setMyThemeLayout=exports.setMyThemeLayout=function setMyThemeLayout(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeCenter/setMyThemeLayout','POST',params);};// 设置字体大小
var setMyFontSize=exports.setMyFontSize=function setMyFontSize(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/themeCenter/setMyFontSize','POST',params);};// 切换多语言
var changeLang=exports.changeLang=function changeLang(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/system/language/base/changeLang','GET',params);};// 设置快捷搜索栏是否显示搜索推荐
var setQuickSearchShowRcmd=exports.setQuickSearchShowRcmd=function setQuickSearchShowRcmd(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/customSetting/setQuickSearchShowRcmd','POST',params);};// 获取门户向导信息
var getPortalIntroInfo=exports.getPortalIntroInfo=function getPortalIntroInfo(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/portalintro/getdata','POST',params);};// 设置门户向导信息
var setPortalIntroInfo=exports.setPortalIntroInfo=function setPortalIntroInfo(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/portal/portalintro/save','POST',params);};// 获取翻译模式
var getTranslatepower=exports.getTranslatepower=function getTranslatepower(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/system/language/base/isShowTransMode','GET',params);};var getTranslatepage=exports.getTranslatepage=function getTranslatepage(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/system/language/base/getTransStat','GET',params);};var setTranslatepage=exports.setTranslatepage=function setTranslatepage(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/system/language/base/changeTransStat','GET',params);};// 清空邮件
var onClearEmail=exports.onClearEmail=function onClearEmail(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/email/setting/operateUserMailFolder','POST',(0,_extends3.default)({operation:'clear',folderId:'-4'},params));};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setE9ThemeStyle=exports.getE9ThemeCss=exports.setFontSize=exports.formatMenuData=exports.cssAsyncLoad=exports.jsAsyncLoad=exports.getSearchParams=undefined;var _pathUtil=__webpack_require__(11);/**
 * 获取查询参数
 *
 * @param {*} search
 */var getSearchParams=exports.getSearchParams=function getSearchParams(search){var searchParams={};if(search){var params=search.slice(search.indexOf('?')+1).split('&');for(var i=0,len=params.length;i<len;i++){var item=params[i].split('=');searchParams[item[0]]=item[1];}}return searchParams;};/**
 * js异步加载
 *
 * @param src           js文件路径
 * @param callbackfunc  js执行完的回调函数
 */var jsAsyncLoad=exports.jsAsyncLoad=function jsAsyncLoad(src,callbackfunc){var body=document.getElementsByTagName('body')[0];var script=document.createElement('script');script.id='theme-plugin-'+new Date().getTime();script.type='text/javascript';script.src=(0,_pathUtil.addContentPath)(src);if(script.readyState){// IE
script.onreadystatechange=function(){if(script.readyState=='loaded'||script.readyState=='complete'){script.onreadystatechange=null;if(callbackfunc&&typeof callbackfunc=='function'){callbackfunc();}}};}else{script.onload=function(){if(callbackfunc&&typeof callbackfunc=='function'){callbackfunc();}};}body.appendChild(script);};/**
 * css异步加载
 *
 * @param href          css文件路径
 * @param callbackfunc  css加载完的回调函数
 */var cssAsyncLoad=exports.cssAsyncLoad=function cssAsyncLoad(href,callbackfunc){var body=document.getElementsByTagName('body')[0];var link=document.createElement('link');link.id='theme-plugin-'+new Date().getTime();link.rel='stylesheet';link.type='text/css';link.href=(0,_pathUtil.addContentPath)(href);if(link.readyState){// IE
link.onreadystatechange=function(){if(link.readyState=='loaded'||link.readyState=='complete'){link.onreadystatechange=null;if(callbackfunc&&typeof callbackfunc=='function'){callbackfunc();}}};}else{link.onload=function(){if(callbackfunc&&typeof callbackfunc=='function'){callbackfunc();}};}body.appendChild(link);};/**
 * 格式化菜单数据
 *
 * @param data 菜单数据
 * @returns {Array}
 */var formatMenuData=exports.formatMenuData=function formatMenuData(data,topId,pathIds){var result=[];for(var i=0,len=data.length;i<len;i++){var item=data[i]||{};var id=item.infoId||item.id;var parentId=item.parentId||'0';var isPortalMenu=!!item.hpid;var url=item.linkAddress||item.url||'';// 添加路径
var _topId=topId||id;var _pathIds=pathIds?pathIds+','+id:id;result.push({topId:_topId,pathIds:_pathIds,infoId:id,parentId:parentId,id:(isPortalMenu?'portal_':'')+parentId+'-'+id,hpid:item.hpid||'',numId:isPortalMenu?'portal_'+item.hpid:id,levelid:parentId+'-'+(isPortalMenu?item.levelid&&item.pid=='0'?item.levelid.split('_')[0]%20+'_portal':item.levelid||'0':item.levelid),name:item.name||'',fname:item.fname||'',pinyin:item.pinyin||'',url:url&&url.replace(/&#38;/g,'&'),routeurl:item.routeurl||'',mobxrouteurl:item.mobxrouteurl||'',fullrouteurl:item.fullrouteurl||'',target:item.target||'mainFrame',icon:item.icon||'',iconType:item.iconType,iconImgSrc:item.iconImgSrc,child:item.child?formatMenuData(item.child,_topId,_pathIds):[],count:item.count!=undefined?item.count:'',countId:item.countId||'',titleUrl:item.titleUrl||'',titleUrlIcon:item.titleUrlIcon||'',titleUrlName:item.titleUrlName||'',tagColor:item.tagColor||'',hasTopLine:item.hasTopLine||''});}return result;};/**
 * 设置字体大小
 *
 * @param fontSize 字体大小
 */var setFontSize=exports.setFontSize=function setFontSize(fontSize){jQuery('#theme-font').remove();var href='/cloudstore/resource/pc/com/font-size/'+fontSize+'px.css';jQuery(jQuery('head')[0]).append('<link id="theme-font" rel="stylesheet" type="text/css" href="'+(0,_pathUtil.addContentPath)(href)+'" />');};/**
 * 获取E9主题样式
 *
 * @param data E9主题样式配置数据
 */var getE9ThemeCss=exports.getE9ThemeCss=function getE9ThemeCss(data){var _data$header=data.header,header=_data$header===undefined?{}:_data$header,_data$toplogo=data.toplogo,toplogo=_data$toplogo===undefined?{}:_data$toplogo,_data$topmenu=data.topmenu,topmenu=_data$topmenu===undefined?{}:_data$topmenu,_data$frequsemenu=data.frequsemenu,frequsemenu=_data$frequsemenu===undefined?{}:_data$frequsemenu,_data$leftmenuswitch=data.leftmenuswitch,leftmenuswitch=_data$leftmenuswitch===undefined?{}:_data$leftmenuswitch,_data$leftmenu=data.leftmenu,leftmenu=_data$leftmenu===undefined?{}:_data$leftmenu,_data$main=data.main,main=_data$main===undefined?{}:_data$main;var css=[];css.push('.e9header-container {color:'+header.color+';font-size:'+header.fontSize+';font-family:'+header.fontFamily+';background:'+header.background+';} ');css.push('.e9header-container .e9header-top-logo {color:'+toplogo.color+';font-size:'+toplogo.fontSize+';font-family:'+toplogo.fontFamily+';background:'+toplogo.background+';} ');if(header.backgroundImage){css.push('.e9header-container .e9header-right {background:url('+(0,_pathUtil.addContentPath)(header.backgroundImage)+') center center / 100% 100% no-repeat;} ');}css.push('.e9header-container .e9header-top-menu2-open {background:'+(topmenu.openedBackground||header.background)+';} ');css.push('.e9header-container .e9header-top-menu2-open .e9header-top-menu2-content {height:auto;background:'+(topmenu.openedBackground||frequsemenu.background)+';} ');css.push('.e9header-container .e9header-top-menu2-item-selected {color:'+topmenu.selectedColor+';} ');css.push('.e9header-container .e9header-top-menu2-btn {background:rgba(0, 0, 0, 0.08);} ');css.push('.e9header-container .e9header-top-menu2-btn:hover {background:rgba(0, 0, 0, 0.14);} ');css.push('.e9header-container .e9header-top-menu2-open .e9header-top-menu2-btn {background:none;} ');css.push('.e9header-container .e9header-freq-use-menu {background:rgba(0, 0, 0, 0.08);} ');css.push('.e9header-container .e9header-freq-use-menu:hover {background:rgba(0, 0, 0, 0.14);} ');css.push('.e9header-container .e9header-quick-search {background:rgba(0, 0, 0, 0.08);} ');css.push('.e9header-container .e9header-quick-search:hover {background:rgba(0, 0, 0, 0.14);} ');css.push('.e9aside-container [class*=wevicon-menu],');css.push('.e9aside-container [class^=wevicon-menu] {font-family:'+(leftmenu.iconstyle=='line'?'wevicon-line':'wevicon')+' !important;} ');css.push('.e9aside-container .wea-menu-inline,');css.push('.e9aside-container .ant-menu-inline,');css.push('.e9aside-container .wea-menu-vertical,');css.push('.e9aside-container .ant-menu-vertical {background:'+leftmenu.background+';} ');css.push('.e9aside-container .wea-menu-inline .wea-menu-switch,');css.push('.e9aside-container .wea-menu-vertical .wea-menu-switch {background:'+leftmenuswitch.background+';} ');css.push('.e9aside-container .wea-menu-inline .wea-menu-switch i,');css.push('.e9aside-container .wea-menu-vertical .wea-menu-switch i {color:'+leftmenuswitch.color+';} ');css.push('.e9aside-container .wea-menu-inline .ant-menu-item,');css.push('.e9aside-container .wea-menu-inline .ant-menu-submenu-title {color:'+leftmenu.titleColor+';font-family:'+leftmenu.titleFontFamily+';} ');css.push('.e9navbar-container,');css.push('.e9navbar-sub-container,');css.push('.e9left-container,');css.push('.e9left-sub-container,');css.push('.e9left-container .pt-menu-vertical .pt-menu-submenu-arrow,');css.push('.e9left-sub-container .pt-menu-submenu-arrow,');css.push('.e9aside-container .wea-menu-inline .ant-menu-item .wea-menu-title,');css.push('.e9aside-container .wea-menu-inline .ant-menu-submenu-title .wea-menu-title,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-item .wea-menu-title,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-submenu-title .wea-menu-title {font-size:'+leftmenu.titleFontSize+';} ');css.push('.e9aside-container .wea-menu-inline .ant-menu-item .wevicon,');css.push('.e9aside-container .wea-menu-inline .ant-menu-submenu-title .wevicon,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-item .wevicon,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-submenu-title .wevicon {color:'+leftmenu.iconColor+';} ');css.push('.e9aside-container .wea-menu-inline .wea-menu-selected,');css.push('.e9aside-container .wea-menu-inline .ant-menu-item-active,');css.push('.e9aside-container .wea-menu-inline .ant-menu-submenu-title:hover {color:'+leftmenu.selectedTitleColor+' !important;background:'+leftmenu.selectedTitleBackground+' !important;} ');css.push('.e9aside-container .wea-menu-inline .wea-menu-selected .wevicon,');css.push('.e9aside-container .wea-menu-inline .ant-menu-item-active .wevicon,');css.push('.e9aside-container .wea-menu-inline .ant-menu-submenu-title:hover .wevicon {color:'+leftmenu.selectedIconColor+' !important;} ');css.push('.e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-item-active:before,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-submenu-active:before {border:2px solid '+leftmenu.selectedTitleBackground+';border-top:21px solid '+leftmenu.selectedTitleBackground+';border-bottom:21px solid '+leftmenu.selectedTitleBackground+';} ');css.push('.e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-item-active,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-root > .ant-menu-submenu-active {color:inherit;background:'+leftmenu.vBackground+';} ');css.push('.e9aside-container .wea-menu-vertical .wea-menu-selected .wevicon,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-submenu-active .wevicon,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-submenu-title:hover .wevicon {color:'+leftmenu.vSelectedIconColor+' !important;} ');css.push('.e9aside-container .wea-menu-vertical .ant-menu-sub {color:'+leftmenu.vColor+';background:'+leftmenu.vBackground+';} ');css.push('.e9aside-container .wea-menu-vertical .wea-menu-selected,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-submenu-selected,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-item-active,');css.push('.e9aside-container .wea-menu-vertical .ant-menu-sub .ant-menu-submenu-active {color:'+leftmenu.vSelectedTitleColor+' !important;background:'+leftmenu.vSelectedTitleBackground+' !important;} ');var headerBackground=header.background&&header.background.toLowerCase();var headerColor=header.color;var background=headerBackground!='#fff'&&headerBackground!='#ffffff'?headerBackground:headerColor;css.push('.e9left-menu-email-item {color:#fff;background:'+background+';} ');css.push('.e9left-menu-email-item-selected {color:#003666;background:#f6f6f6;} ');css.push('.e9left-menu-email-item-ul {color:#003666;background:#f6f6f6;} ');css.push('.e9left-menu-email-item-ul li:hover {background:#dadfe3;} ');css.push('.e9theme-layout2-navbar .pt-menu-root > .pt-menu-submenu-active > .pt-menu-submenu-title,');css.push('.e9theme-layout2-navbar .pt-menu-root > .pt-menu-submenu-selected > .pt-menu-submenu-title,');css.push('.e9theme-layout2-navbar .pt-menu-root > .pt-menu-item-active > .pt-menu-item-title,');css.push('.e9theme-layout2-navbar .pt-menu-root > .pt-menu-item-selected > .pt-menu-item-title {color:#fff;background:'+background+';} ');css.push('.e9theme-layout3-left .pt-menu-root > .pt-menu-submenu-active > .pt-menu-submenu-title,');css.push('.e9theme-layout3-left .pt-menu-root > .pt-menu-submenu-selected > .pt-menu-submenu-title,');css.push('.e9theme-layout3-left .pt-menu-root > .pt-menu-item-active > .pt-menu-item-title,');css.push('.e9theme-layout3-left .pt-menu-root > .pt-menu-item-selected > .pt-menu-item-title {color:#fff;background:'+background+';} ');css.push('.e9theme-layout-content .e9theme-layout-main {background-color:'+(main.background||'#e8edf4')+';} ');css.push('.e9theme-layout2-content .e9theme-layout2-main {background-color:'+(main.background||'#e8edf4')+';} ');css.push('.e9theme-layout3-content .e9theme-layout3-main {background-color:'+(main.background||'#e8edf4')+';} ');css.push('.e9theme-layout4-content .e9theme-layout4-main {background-color:'+(main.background||'#e8edf4')+';} ');return css.join('');};/**
 * 设置E9主题样式
 *
 * @param data E9主题样式配置数据
 */var setE9ThemeStyle=exports.setE9ThemeStyle=function setE9ThemeStyle(data){var css=data?getE9ThemeCss(data):'';if(jQuery('#theme-style')&&jQuery('#theme-style').length){jQuery('#theme-style').html(css);}else{jQuery(jQuery('head')[0]).append('<style id="theme-style" type="text/css">'+css+'</style>');}};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(154);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);__webpack_require__(221);var _multiLang=__webpack_require__(223);var _multiLang2=_interopRequireDefault(_multiLang);var _e7Form=__webpack_require__(224);var _e7Form2=_interopRequireDefault(_e7Form);var _e7QRCode=__webpack_require__(225);var _e7QRCode2=_interopRequireDefault(_e7QRCode);var _LoginBtn=__webpack_require__(226);var _LoginBtn2=_interopRequireDefault(_LoginBtn);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E7FormCloud=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(E7FormCloud,_React$Component);function E7FormCloud(props){(0,_classCallCheck3.default)(this,E7FormCloud);var _this=(0,_possibleConstructorReturn3.default)(this,(E7FormCloud.__proto__||(0,_getPrototypeOf2.default)(E7FormCloud)).call(this,props));_initialiseProps.call(_this);return _this;}(0,_createClass3.default)(E7FormCloud,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.loginInfo&&(nextProps.loginInfo.showQrcode!=this.props.loginInfo.showQrcode||nextProps.loginInfo.defaultQrcode!=this.props.loginInfo.defaultQrcode||nextProps.loginInfo.onlyQrcode!=this.props.loginInfo.onlyQrcode)){this.setLoginType(nextProps);}}},{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,portalLoginStore=_props.portalLoginStore,isNeedGetLoginInfo=_props.isNeedGetLoginInfo;if(isNeedGetLoginInfo==true){portalLoginStore.getLoginInfo();}else{this.setLoginType();}this.setState({loadFinish:true});}},{key:'render',value:function render(){var loadFinish=this.state.loadFinish;if(loadFinish){var portalLoginStore=this.props.portalLoginStore;var state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache,getElementStyle=portalLoginStore.getElementStyle,labelObj=portalLoginStore.labelObj;state=this.getState();var _state2=state,_state2$loginSettingI=_state2.loginSettingInfo,loginSettingInfo=_state2$loginSettingI===undefined?{}:_state2$loginSettingI,loginType=_state2.loginType;var loginInfo=loginSettingInfo.loginInfo,loginForm=loginSettingInfo.loginForm;var showQrcode=loginInfo.showQrcode,defaultQrcode=loginInfo.defaultQrcode,onlyQrcode=loginInfo.onlyQrcode;var _loginForm$color=loginForm.color,color=_loginForm$color===undefined?'rgb(140, 140, 140)':_loginForm$color,_loginForm$e7Bgi=loginForm.e7Bgi,e7Bgi=_loginForm$e7Bgi===undefined?'/wui/theme/ecology7/page/images/login/login_cbg_wev8.png':_loginForm$e7Bgi,_loginForm$e7Silder=loginForm.e7Silder,e7Silder=_loginForm$e7Silder===undefined?'/wui/theme/ecology7/page/images/login/lg_bg1_wev8.jpg,/wui/theme/ecology7/page/images/login/lg_bg2_wev8.jpg,/wui/theme/ecology7/page/images/login/lg_bg3_wev8.jpg':_loginForm$e7Silder,_loginForm$e7SilderAu=loginForm.e7SilderAutoPlay,e7SilderAutoPlay=_loginForm$e7SilderAu===undefined?'1':_loginForm$e7SilderAu;var isSetting=false;if(this.props.isFormCloudSetting==true){isSetting=true;}var positionDynamicCss={};if(this.props.isPositionDynamicCss==true){positionDynamicCss=getElementStyle(loginForm);positionDynamicCss.position='absolute';}else{positionDynamicCss.position='relative';}return _react2.default.createElement('div',{className:'e7FormCloud',style:(0,_extends3.default)({},positionDynamicCss,{color:color,'background-image':'url('+(0,_pathUtil.addContentPath)(e7Bgi)+')'})},_react2.default.createElement('div',{className:'e7FormCloud-slider'},_react2.default.createElement(_antd.Carousel,{ecId:(this&&this.props&&this.props.ecId||'')+'_Carousel@qprdp9',autoplay:e7SilderAutoPlay=='1'?true:false,dots:false},e7Silder.split(',').map(function(item,index){return _react2.default.createElement('div',{className:'e7FormCloud-slider-item',key:index},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item),alt:''}));}))),_react2.default.createElement('div',{className:'e7FormCloud-main'},_react2.default.createElement('div',{className:'multilang-qrcode'},_react2.default.createElement(_multiLang2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MultiLang@wzuzkb',isSetting:isSetting,getState:this.getState}),isSetting&&showQrcode&&!defaultQrcode&&!onlyQrcode||!isSetting&&showQrcode&&loginType=='form'?_react2.default.createElement('i',{className:'qRCode-scan icon-coms-Scan',title:labelObj.smdl,onClick:function onClick(){return setStateAndCache('loginType','QRCode');}}):null,isSetting&&showQrcode&&defaultQrcode&&!onlyQrcode||!isSetting&&(showQrcode&&!onlyQrcode||!showQrcode)&&loginType!='form'?_react2.default.createElement('i',{className:'qRCode-revoke icon-coms-Revoke2',title:labelObj.fh,onClick:function onClick(){return setStateAndCache('loginType','form');}}):null),isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?_react2.default.createElement(_e7Form2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E7Form@lh9360',getState:this.getState}):_react2.default.createElement(_e7QRCode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E7QRCode@f70uqt',getState:this.getState}),isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?_react2.default.createElement(_LoginBtn2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LoginBtn@6x1udf',isSetting:isSetting,getState:this.getState}):null));}return null;}}]);return E7FormCloud;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.state={loadFinish:false};this.getState=function(props){if(!props){props=_this2.props;}var portalLoginStore=_this2.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var _state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn;var _props2=props,loginInfo=_props2.loginInfo,loginForm=_props2.loginForm,isRememberPW=_props2.isRememberPW;var _state=(0,_assign2.default)({},state);var _loginSettingInfo=(0,_assign2.default)({},loginSettingInfo);if(loginInfo&&loginForm){var _loginInfo=(0,_assign2.default)({},loginSettingInfo.loginInfo,loginInfo);var _loginForm=(0,_assign2.default)({},loginSettingInfo.loginForm,loginForm);_loginSettingInfo.loginInfo=_loginInfo;_loginSettingInfo.loginForm=_loginForm;_state.loginSettingInfo=_loginSettingInfo;if(isRememberPW){_state.isRememberPW=isRememberPW;}}return _state;};this.setLoginType=function(props){var portalLoginStore=_this2.props.portalLoginStore;var state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache;state=_this2.getState(props);var _state3=state,_state3$loginSettingI=_state3.loginSettingInfo,loginSettingInfo=_state3$loginSettingI===undefined?{}:_state3$loginSettingI;var _loginSettingInfo$log=loginSettingInfo.loginInfo,showQrcode=_loginSettingInfo$log.showQrcode,defaultQrcode=_loginSettingInfo$log.defaultQrcode;if(showQrcode&&defaultQrcode){setStateAndCache('loginType','QRCode');}else{setStateAndCache('loginType','form');}};},_temp))||_class)||_class);exports.default=E7FormCloud;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);__webpack_require__(227);var _multiLang=__webpack_require__(229);var _multiLang2=_interopRequireDefault(_multiLang);var _e8Form=__webpack_require__(230);var _e8Form2=_interopRequireDefault(_e8Form);var _e8QRCode=__webpack_require__(231);var _e8QRCode2=_interopRequireDefault(_e8QRCode);var _LoginBtn=__webpack_require__(232);var _LoginBtn2=_interopRequireDefault(_LoginBtn);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8FormCloud=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(E8FormCloud,_React$Component);function E8FormCloud(props){(0,_classCallCheck3.default)(this,E8FormCloud);var _this=(0,_possibleConstructorReturn3.default)(this,(E8FormCloud.__proto__||(0,_getPrototypeOf2.default)(E8FormCloud)).call(this,props));_initialiseProps.call(_this);return _this;}(0,_createClass3.default)(E8FormCloud,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.loginInfo&&(nextProps.loginInfo.showQrcode!=this.props.loginInfo.showQrcode||nextProps.loginInfo.defaultQrcode!=this.props.loginInfo.defaultQrcode||nextProps.loginInfo.onlyQrcode!=this.props.loginInfo.onlyQrcode)){this.setLoginType(nextProps);}}},{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,portalLoginStore=_props.portalLoginStore,isNeedGetLoginInfo=_props.isNeedGetLoginInfo;if(isNeedGetLoginInfo==true){portalLoginStore.getLoginInfo();}else{this.setLoginType();}this.setState({loadFinish:true});}},{key:'render',value:function render(){var loadFinish=this.state.loadFinish;if(loadFinish){var portalLoginStore=this.props.portalLoginStore;var state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache,getElementStyle=portalLoginStore.getElementStyle,labelObj=portalLoginStore.labelObj;state=this.getState();var _state2=state,_state2$loginSettingI=_state2.loginSettingInfo,loginSettingInfo=_state2$loginSettingI===undefined?{}:_state2$loginSettingI,loginType=_state2.loginType;var loginInfo=loginSettingInfo.loginInfo,loginForm=loginSettingInfo.loginForm;var showQrcode=loginInfo.showQrcode,defaultQrcode=loginInfo.defaultQrcode,onlyQrcode=loginInfo.onlyQrcode;var _loginForm$color=loginForm.color,color=_loginForm$color===undefined?'#ffffff':_loginForm$color;var isSetting=false;if(this.props.isFormCloudSetting==true){isSetting=true;}var positionDynamicCss={};if(this.props.isPositionDynamicCss==true){positionDynamicCss=getElementStyle(loginForm);positionDynamicCss.position='absolute';}return _react2.default.createElement('div',{className:'e8FormCloud',style:(0,_extends3.default)({},positionDynamicCss,{color:color})},_react2.default.createElement('div',{className:'multilang-qrcode '+(isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?'':'multilang-qrcode-scan')},_react2.default.createElement(_multiLang2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MultiLang@aoxsoh',isSetting:isSetting,getState:this.getState,overClass:isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?'':'e8login-multiLangList-scan'}),isSetting&&showQrcode&&!defaultQrcode&&!onlyQrcode||!isSetting&&showQrcode&&loginType=='form'?_react2.default.createElement('i',{className:'qRCode-scan icon-coms-Scan',title:labelObj.smdl,onClick:function onClick(){return setStateAndCache('loginType','QRCode');}}):null),isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?_react2.default.createElement(_e8Form2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8Form@zuqcb4',getState:this.getState}):_react2.default.createElement(_e8QRCode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8QRCode@pslore',getState:this.getState}),isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?_react2.default.createElement(_LoginBtn2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LoginBtn@3q3fmu',isSetting:isSetting,getState:this.getState}):null,isSetting&&showQrcode&&defaultQrcode&&!onlyQrcode||!isSetting&&(showQrcode&&!onlyQrcode||!showQrcode)&&loginType!='form'?_react2.default.createElement('div',{className:'qRCode-revoke'},_react2.default.createElement('div',{title:labelObj.fh,className:'qRCode-revoke-btn',onClick:function onClick(){return setStateAndCache('loginType','form');}},labelObj.fh)):null);}return null;}}]);return E8FormCloud;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.state={loadFinish:false};this.getState=function(props){if(!props){props=_this2.props;}var portalLoginStore=_this2.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var _state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn;var _props2=props,loginInfo=_props2.loginInfo,loginForm=_props2.loginForm,isRememberPW=_props2.isRememberPW;var _state=(0,_assign2.default)({},state);var _loginSettingInfo=(0,_assign2.default)({},loginSettingInfo);if(loginInfo&&loginForm){var _loginInfo=(0,_assign2.default)({},loginSettingInfo.loginInfo,loginInfo);var _loginForm=(0,_assign2.default)({},loginSettingInfo.loginForm,loginForm);_loginSettingInfo.loginInfo=_loginInfo;_loginSettingInfo.loginForm=_loginForm;_state.loginSettingInfo=_loginSettingInfo;if(isRememberPW){_state.isRememberPW=isRememberPW;}}return _state;};this.setLoginType=function(props){var portalLoginStore=_this2.props.portalLoginStore;var state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache;state=_this2.getState(props);var _state3=state,_state3$loginSettingI=_state3.loginSettingInfo,loginSettingInfo=_state3$loginSettingI===undefined?{}:_state3$loginSettingI;var _loginSettingInfo$log=loginSettingInfo.loginInfo,showQrcode=_loginSettingInfo$log.showQrcode,defaultQrcode=_loginSettingInfo$log.defaultQrcode;if(showQrcode&&defaultQrcode){setStateAndCache('loginType','QRCode');}else{setStateAndCache('loginType','form');}};},_temp))||_class)||_class);exports.default=E8FormCloud;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_157__;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isObject = __webpack_require__(161);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(275),
    mapCacheDelete = __webpack_require__(282),
    mapCacheGet = __webpack_require__(284),
    mapCacheHas = __webpack_require__(285),
    mapCacheSet = __webpack_require__(286);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(287),
    arraySome = __webpack_require__(290),
    cacheHas = __webpack_require__(291);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(306),
    isObjectLike = __webpack_require__(85);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(168),
    nativeKeys = __webpack_require__(312);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(159),
    isLength = __webpack_require__(166);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(314),
    Map = __webpack_require__(136),
    Promise = __webpack_require__(315),
    Set = __webpack_require__(316),
    WeakMap = __webpack_require__(317),
    baseGetTag = __webpack_require__(81),
    toSource = __webpack_require__(162);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _comsMobx=__webpack_require__(157);var _weaPortalPublic=__webpack_require__(33);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9ToolBar=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9ToolBar,_React$Component);function E9ToolBar(props){(0,_classCallCheck3.default)(this,E9ToolBar);var _this=(0,_possibleConstructorReturn3.default)(this,(E9ToolBar.__proto__||(0,_getPrototypeOf2.default)(E9ToolBar)).call(this,props));_this.onMenuClick=_this.onMenuClick.bind(_this);return _this;}(0,_createClass3.default)(E9ToolBar,[{key:'componentWillMount',value:function componentWillMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getToolbarMenu();}},{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$too=portalThemeStore.toolbarMenu,toolbarMenu=_portalThemeStore$too===undefined?[]:_portalThemeStore$too;var _toolbarMenu=(0,_mobx.toJS)(toolbarMenu);return _react2.default.createElement('div',{className:'e9header-toolbar'},_toolbarMenu.map(function(item,index){var key=item.key,type=item.type,name=item.name,icon=item.icon;var iconCom=_react2.default.createElement('i',{className:'wevicon-toolbar-'+key});if(icon){iconCom=_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(icon),alt:'',width:'18px',height:'18px'});}if(key&&key.indexOf('more_')!=-1){iconCom=_react2.default.createElement('i',{className:icon});}if(type=='message'){var messageIconStyle={position:'absolute',top:'50%',left:'50%',marginTop:'-9px',marginLeft:'-9px',fontSize:'18px'};return _react2.default.createElement('div',{key:index,className:'e9header-remind-icon',title:name},_react2.default.createElement(_comsMobx.WeaMessageCenter.DialogComponent,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaMessageCenter.DialogComponent@ej5m6d',iconClass:item.icon,iconStyle:messageIconStyle}));}else if(type=='fav'){return _react2.default.createElement('div',{key:index,className:'e9header-toolbar-item-icon',title:name},_react2.default.createElement(_weaPortalPublic.WeaFavourite,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaFavourite@1nd6nl'},iconCom));}return _react2.default.createElement('div',{key:index,className:'e9header-toolbar-item-icon',title:name,onClick:function onClick(){return _this2.onMenuClick(item);}},iconCom);}),_react2.default.createElement(_weaPortalPublic.WeaPlugin,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPlugin@gjcy9m',ref:'WeaPlugin'}),_react2.default.createElement(_weaPortalPublic.WeaLicense,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLicense@d2325g',ref:'WeaLicense'}),_react2.default.createElement(_weaPortalPublic.WeaVersion,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaVersion@vln1iz',ref:'WeaVersion'}),_react2.default.createElement(_weaPortalPublic.WeaSystemSetting,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSystemSetting@snfnz2',ref:'WeaSystemSetting'}));}},{key:'onMenuClick',value:function onMenuClick(item){var key=item.key,id=item.id,name=item.name,url=item.url,mobxrouteurl=item.mobxrouteurl,opentype=item.opentype,_item$width=item.width,width=_item$width===undefined?700:_item$width,_item$height=item.height,height=_item$height===undefined?500:_item$height;if(key=='elink'||key=='rtx'){if(window.checkRTXLoginUrl&&typeof window.checkRTXLoginUrl=='function'){window.checkRTXLoginUrl(url);}return;}if(opentype=='1'){if(id=='3'||id=='5'||id=='6'||id=='8'){var ref={'3':'WeaPlugin','5':'WeaLicense','6':'WeaVersion','8':'WeaSystemSetting'}[id];this.refs[ref].onShow();}else{var dialog=_ecCom.WeaTools.createDialog({title:name,url:url,icon:'icon-coms-content',iconBgcolor:'#1a57a0',style:{width:width,height:height},parentClassName:'e9header-toolbar-dialog'});dialog.show();}}else{var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain({url:url,mobxrouteurl:mobxrouteurl,target:opentype=='0'?'_blank':'mainFrame'});}}}]);return E9ToolBar;}(_react2.default.Component))||_class)||_class);exports.default=E9ToolBar;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _IntroStep=__webpack_require__(325);var _IntroStep2=_interopRequireDefault(_IntroStep);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9ToolBarMore=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9ToolBarMore,_React$Component);function E9ToolBarMore(props){(0,_classCallCheck3.default)(this,E9ToolBarMore);return(0,_possibleConstructorReturn3.default)(this,(E9ToolBarMore.__proto__||(0,_getPrototypeOf2.default)(E9ToolBarMore)).call(this,props));}(0,_createClass3.default)(E9ToolBarMore,[{key:'componentWillMount',value:function componentWillMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getToolbarMoreMenu();}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e9header-toolbar-more'},_react2.default.createElement(_IntroStep2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_IntroStep4@km90hx'}));}}]);return E9ToolBarMore;}(_react2.default.Component))||_class)||_class);exports.default=E9ToolBarMore;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9TopLogo=__webpack_require__(86);var _E9TopLogo2=_interopRequireDefault(_E9TopLogo);var _E9Home=__webpack_require__(140);var _E9Home2=_interopRequireDefault(_E9Home);var _E9FreqUseMenu=__webpack_require__(78);var _E9FreqUseMenu2=_interopRequireDefault(_E9FreqUseMenu);var _E9QuickSearch=__webpack_require__(66);var _E9QuickSearch2=_interopRequireDefault(_E9QuickSearch);var _E9HeaderRight=__webpack_require__(87);var _E9HeaderRight2=_interopRequireDefault(_E9HeaderRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Header=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Header,_React$Component);function E9Header(){(0,_classCallCheck3.default)(this,E9Header);return(0,_possibleConstructorReturn3.default)(this,(E9Header.__proto__||(0,_getPrototypeOf2.default)(E9Header)).apply(this,arguments));}(0,_createClass3.default)(E9Header,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo;var themeLogoWidth=themeInfo.themeLogoWidth,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$header=styleConfig.header,header=_styleConfig$header===undefined?{}:_styleConfig$header;var fontSize=parseInt(header.fontSize||'12px');var logoWidth=themeLogoWidth==''?197:parseInt(themeLogoWidth);return _react2.default.createElement('div',{className:'e9header-container wea-f'+fontSize},_react2.default.createElement('div',{className:'e9header-left',style:{width:logoWidth}},_react2.default.createElement(_E9TopLogo2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9TopLogo@f2a6cl'})),_react2.default.createElement('div',{className:'e9header-right',style:{marginLeft:logoWidth}},_react2.default.createElement('div',{className:'e9header-right-menu'},_react2.default.createElement(_E9Home2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Home@r9skui'}),_react2.default.createElement(_E9FreqUseMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9FreqUseMenu@ilin7y'}),_react2.default.createElement(_E9QuickSearch2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearch@wxfv5j'})),_react2.default.createElement(_E9HeaderRight2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9HeaderRight@9funch'})));}}]);return E9Header;}(_react2.default.Component))||_class)||_class);exports.default=E9Header;

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });








/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DOMWrap__ = __webpack_require__(367);














function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }
  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var _extends2;

  var state = store.getState();
  store.setState({
    activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.activeKey, (_extends2 = {}, _extends2[menuId] = activeKey, _extends2))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found = void 0;
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
      if (c && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });
    if (found) {
      return activeKey;
    }
  }
  activeKey = null;
  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }
  return activeKey;
}

function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);
    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}

var SubPopupMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _extends3;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubPopupMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    props.store.setState({
      activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props.store.getState().activeKey, (_extends3 = {}, _extends3[props.eventKey] = getActiveKey(props, props.activeKey), _extends3))
    });

    _this.instanceArray = [];
    return _this;
  }

  SubPopupMenu.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  SubPopupMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.visible || nextProps.visible;
  };

  SubPopupMenu.prototype.componentDidUpdate = function componentDidUpdate() {
    var props = this.props;
    var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
    var activeKey = getActiveKey(props, originalActiveKey);
    if (activeKey !== originalActiveKey) {
      updateActiveKey(props.store, getEventKey(props), activeKey);
    }
  };

  // all keyboard events callbacks run from here at first


  SubPopupMenu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    this.instanceArray = [];
    var className = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
    var domProps = {
      className: className,
      // role could be 'select' and by default set to menu
      role: props.role || 'menu'
    };
    if (props.id) {
      domProps.id = props.id;
    }
    if (props.focusable) {
      domProps.tabIndex = '0';
      domProps.onKeyDown = this.onKeyDown;
    }
    var prefixCls = props.prefixCls,
        eventKey = props.eventKey,
        visible = props.visible;

    __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Otherwise, the propagated click event will trigger another onClick
    delete props.onClick;
    return (
      // ESLint is not smart enough to know that the type of `children` was checked.
      /* eslint-disable */
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__DOMWrap__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
          tag: 'ul',
          hiddenClassName: prefixCls + '-hidden',
          visible: visible
        }, domProps),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c, i) {
          return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
        })
      )
      /*eslint-enable */

    );
  };

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SubPopupMenu.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),

  // adding in refactor
  focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['click', 'hover']),
  inlineIndent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e, callback) {
    var keyCode = e.keyCode;
    var handled = void 0;
    _this3.getFlatInstanceArray().forEach(function (obj) {
      if (obj && obj.props.active && obj.onKeyDown) {
        handled = obj.onKeyDown(e);
      }
    });
    if (handled) {
      return 1;
    }
    var activeItem = null;
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      activeItem = _this3.step(keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
    }
    if (activeItem) {
      e.preventDefault();
      updateActiveKey(_this3.props.store, getEventKey(_this3.props), activeItem.props.eventKey);

      if (typeof callback === 'function') {
        callback(activeItem);
      }

      return 1;
    }
  };

  this.onItemHover = function (e) {
    var key = e.key,
        hover = e.hover;

    updateActiveKey(_this3.props.store, getEventKey(_this3.props), hover ? key : null);
  };

  this.onDeselect = function (selectInfo) {
    _this3.props.onDeselect(selectInfo);
  };

  this.onSelect = function (selectInfo) {
    _this3.props.onSelect(selectInfo);
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onDestroy = function (key) {
    /* istanbul ignore next */
    _this3.props.onDestroy(key);
  };

  this.getFlatInstanceArray = function () {
    return _this3.instanceArray;
  };

  this.getOpenTransitionName = function () {
    return _this3.props.openTransitionName;
  };

  this.step = function (direction) {
    var children = _this3.getFlatInstanceArray();
    var activeKey = _this3.props.store.getState().activeKey[getEventKey(_this3.props)];
    var len = children.length;
    if (!len) {
      return null;
    }
    if (direction < 0) {
      children = children.concat().reverse();
    }
    // find current activeIndex
    var activeIndex = -1;
    children.every(function (c, ci) {
      if (c && c.props.eventKey === activeKey) {
        activeIndex = ci;
        return false;
      }
      return true;
    });
    if (!_this3.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
      return undefined;
    }
    var start = (activeIndex + 1) % len;
    var i = start;

    do {
      var child = children[i];
      if (!child || child.props.disabled) {
        i = (i + 1) % len;
      } else {
        return child;
      }
    } while (i !== start);

    return null;
  };

  this.renderCommonMenuItem = function (child, i, extraProps) {
    var state = _this3.props.store.getState();
    var props = _this3.props;
    var key = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
    var childProps = child.props;
    var isActive = key === state.activeKey;
    var newChildProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      mode: props.mode,
      level: props.level,
      inlineIndent: props.inlineIndent,
      renderMenuItem: _this3.renderMenuItem,
      rootPrefixCls: props.prefixCls,
      index: i,
      parentMenu: props.parentMenu,
      // customized ref function, need to be invoked manually in child's componentDidMount
      manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_this3)),
      eventKey: key,
      active: !childProps.disabled && isActive,
      multiple: props.multiple,
      onClick: function onClick(e) {
        (childProps.onClick || __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */])(e);
        _this3.onClick(e);
      },
      onItemHover: _this3.onItemHover,
      openTransitionName: _this3.getOpenTransitionName(),
      openAnimation: props.openAnimation,
      subMenuOpenDelay: props.subMenuOpenDelay,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      onOpenChange: _this3.onOpenChange,
      onDeselect: _this3.onDeselect,
      onSelect: _this3.onSelect,
      builtinPlacements: props.builtinPlacements
    }, extraProps);
    if (props.mode === 'inline') {
      newChildProps.triggerSubMenuAction = 'click';
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, newChildProps);
  };

  this.renderMenuItem = function (c, i, subMenuKey) {
    /* istanbul ignore if */
    if (!c) {
      return null;
    }
    var state = _this3.props.store.getState();
    var extraProps = {
      openKeys: state.openKeys,
      selectedKeys: state.selectedKeys,
      triggerSubMenuAction: _this3.props.triggerSubMenuAction,
      subMenuKey: subMenuKey
    };
    return _this3.renderCommonMenuItem(c, i, extraProps);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(SubPopupMenu));

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(184);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _reactDom=__webpack_require__(19);var _reactDom2=_interopRequireDefault(_reactDom);var _weaPortalPublic=__webpack_require__(33);var _stores=__webpack_require__(192);var _stores2=_interopRequireDefault(_stores);var _login=__webpack_require__(202);var _login2=_interopRequireDefault(_login);var _theme=__webpack_require__(233);var _theme2=_interopRequireDefault(_theme);var _formCloud=__webpack_require__(155);var _formCloud2=_interopRequireDefault(_formCloud);var _formCloud3=__webpack_require__(156);var _formCloud4=_interopRequireDefault(_formCloud3);var _formCloud5=__webpack_require__(424);var _formCloud6=_interopRequireDefault(_formCloud5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 执行主题相关方法
window.doThemeAction=function(actionName){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var callback=arguments[2];var portalThemeStore=_stores2.default.portalThemeStore;if(actionName=='onLoadMain'){portalThemeStore.onLoadMain(params,callback);// 加载内容区域
}else if(actionName=='onLogout'){portalThemeStore.onLogout(params,callback);// 退出
}else if(actionName=='onLeftMenuModeChange'){portalThemeStore.onLeftMenuModeChange(params.leftMenuMode,callback);// 展开收缩左侧菜单
}else if(actionName=='onQuickSearch'){portalThemeStore.onQuickSearch(params,callback);// 快捷搜索跳转
}else if(actionName=='onLoadEmailMenu'){portalThemeStore.onLoadEmailMenu(params,callback);// 加载邮件菜单
}else if(actionName=='onThemeChange'){portalThemeStore.onThemeChange(params,callback);// 修改主题
}else if(actionName=='onThemeTsChange'){portalThemeStore.onThemeTsChange(params,callback);// 修改主题特色
}else if(actionName=='onColorChange'){portalThemeStore.onColorChange(params,callback);// 修改主题颜色
}else if(actionName=='onLayoutChange'){portalThemeStore.onLayoutChange(params,callback);// 修改主题布局
}else if(actionName=='getAccount'){portalThemeStore.getAccount(params,callback);// 刷新账号栏
}else if(actionName=='onLoadLeftMenuCount'){portalThemeStore.onLoadLeftMenuCount(params,callback);// 加载左侧菜单统计数
}};// 加载左侧菜单统计数
window.loadLeftMenuCount=function(params,callback){window.doThemeAction('onLoadLeftMenuCount',params,callback);};// 提交license
window.doLicenseSubmit=function(){var div=document.createElement('div');document.body.appendChild(div);_reactDom2.default.render(React.createElement(_weaPortalPublic.WeaLicenseSubmit,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_WeaLicenseSubmit@wv6e5n',visible:true,from:'login'}),div);};module.exports={store:_stores2.default,Login:_login2.default,Theme:_theme2.default,E7FormCloud:_formCloud2.default,E8FormCloud:_formCloud4.default,FormCloud:_formCloud6.default};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _LoginStore=__webpack_require__(193);var _LoginStore2=_interopRequireDefault(_LoginStore);var _ThemeStore=__webpack_require__(197);var _ThemeStore2=_interopRequireDefault(_ThemeStore);var _IntroStore=__webpack_require__(199);var _IntroStore2=_interopRequireDefault(_IntroStore);var _DeskTopStore=__webpack_require__(200);var _DeskTopStore2=_interopRequireDefault(_DeskTopStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var portalLoginStore=new _LoginStore2.default();var portalThemeStore=new _ThemeStore2.default();var portalIntroStore=new _IntroStore2.default();var portalDeskTopStore=new _DeskTopStore2.default();exports.default={portalLoginStore:portalLoginStore,portalThemeStore:portalThemeStore,portalIntroStore:portalIntroStore,portalDeskTopStore:portalDeskTopStore};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getOwnPropertyDescriptor=__webpack_require__(68);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(104);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _defineProperty4=__webpack_require__(143);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _mobx=__webpack_require__(14);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _login=__webpack_require__(144);var LOGIN_API=_interopRequireWildcard(_login);var _eventUtil=__webpack_require__(145);var _pathUtil=__webpack_require__(11);var _loginUtil=__webpack_require__(110);var _loadjsUtil=__webpack_require__(196);var _files=__webpack_require__(147);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ua=_ecCom.WeaTools.ua;var getCurrentLabel=_ecCom.WeaInputLocale.getCurrentLabel,getMultiStrFromBase64=_ecCom.WeaInputLocale.getMultiStrFromBase64;var LoginStore=(_class=function(){// 自定义登录组件加载状态
// 移动客户端下载地址
// 登录验证码刷新参数
// 动态密码有效时间
// CAS状态，状态为0时正常显示登录页，否则跳转登录后页面
// 浏览器地址查询参数
function LoginStore(){var _this=this;(0,_classCallCheck3.default)(this,LoginStore);_initDefineProp(this,'loading',_descriptor,this);_initDefineProp(this,'queryParams',_descriptor2,this);_initDefineProp(this,'updatestatus',_descriptor3,this);_initDefineProp(this,'casstatus',_descriptor4,this);_initDefineProp(this,'multiLangs',_descriptor5,this);_initDefineProp(this,'dynamicPasswordTime',_descriptor6,this);_initDefineProp(this,'dynamicPasswordInterval',_descriptor7,this);_initDefineProp(this,'seriesnum_',_descriptor8,this);_initDefineProp(this,'qrcodeValidTime',_descriptor9,this);_initDefineProp(this,'qrcodeReqTime',_descriptor10,this);_initDefineProp(this,'qrcodeIsInvalid',_descriptor11,this);_initDefineProp(this,'emobileDownloadUrl',_descriptor12,this);_initDefineProp(this,'loginFormDataLoading',_descriptor13,this);_initDefineProp(this,'customloading',_descriptor14,this);_initDefineProp(this,'beforLoginRenderEventStatus',_descriptor15,this);_initDefineProp(this,'afterLoginRenderEventStatus',_descriptor16,this);_initDefineProp(this,'state',_descriptor17,this);this.setTitle=function(){var _state=_this.state,langId=_state.langId,loginTemplateTitle=_state.loginTemplateTitle,loginTemplateTitle_base64=_state.loginTemplateTitle_base64;if(loginTemplateTitle_base64){document.title=getCurrentLabel(getMultiStrFromBase64(loginTemplateTitle_base64),langId)||loginTemplateTitle;}else{document.title=loginTemplateTitle;}};this.onWindowResize=this.onWindowResize.bind(this);this.setQueryParams=this.setQueryParams.bind(this);this.setState=this.setState.bind(this);this.setStateAndCache=this.setStateAndCache.bind(this);this.onBgImageChange=this.onBgImageChange.bind(this);this.getLoginBgImageStyle=this.getLoginBgImageStyle.bind(this);this.getElementStyle=this.getElementStyle.bind(this);this.getMultiLangs=this.getMultiLangs.bind(this);this.getUpgradeInfo=this.getUpgradeInfo.bind(this);this.getLoginInfo=this.getLoginInfo.bind(this);this.getLoginForm=this.getLoginForm.bind(this);this.onPasswordForget=this.onPasswordForget.bind(this);this.onRememberChange=this.onRememberChange.bind(this);this.onValidateCodeChange=this.onValidateCodeChange.bind(this);jQuery(window).resize(function(){return _this.onWindowResize();});}// 登录页状态
// 登录页事件加载状态
// 登录表单数据加载状态
// 二维码是否已失效
// 二维码有效时间
// 多语言
// 升级状态，状态为0时正常显示登录页，否则跳转升级页面
(0,_createClass3.default)(LoginStore,[{key:'onWindowResize',value:function onWindowResize(){var width=jQuery(window).width();var height=jQuery(window).height();if(width<800){jQuery('#LoginContainer').css({overflowX:'scroll'});}else{jQuery('#LoginContainer').css({overflowX:'hidden'});}if(height<660){jQuery('#LoginContainer').css({overflowY:'scroll'});}else{jQuery('#LoginContainer').css({overflowY:'hidden'});}this.setState({win_width:width<800?800:width,win_height:height<660?660:height});}},{key:'setQueryParams',value:function setQueryParams(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.queryParams=params;window.queryParams=params;_ecCom.WeaTools.ls.set('login-pop-params',params);}},{key:'setState',value:function setState(state){this.state=(0,_assign2.default)({},this.state,state);if(state.langId&&state.langText){(0,_loginUtil.setLSValue)('login','langId',state.langId);(0,_loginUtil.setLSValue)('login','langText',state.langText);_ecCom.WeaTools.ls.set('languageidweaver',state.langId);}}},{key:'setStateAndCache',value:function setStateAndCache(key,value){this.setState((0,_defineProperty5.default)({},key,value));(0,_loginUtil.setLSValue)('login',key,value);}},{key:'onBgImageChange',value:function onBgImageChange(params,index){var imgsrc=params.imgsrc,width=params.width,height=params.height;var loginInfo=(0,_assign2.default)({},this.state.loginSettingInfo.loginInfo,{imgsrc:imgsrc,width:width,height:height});var loginSettingInfo=(0,_assign2.default)({},this.state.loginSettingInfo,{loginInfo:loginInfo});this.setState({loginSettingInfo:loginSettingInfo,initialSlide:index});(0,_loginUtil.setLSValue)('login','initialSlide',index);(0,_loginUtil.setLSValue)('login','loginBgImage',imgsrc);(0,_loginUtil.setLSValue)('login','loginBgImageWidth',width);(0,_loginUtil.setLSValue)('login','loginBgImageHeight',height);}},{key:'getLoginBgImageStyle',value:function getLoginBgImageStyle(loginInfo){var fillStyle=loginInfo.fillStyle;var src=(0,_loginUtil.getLSValue)('login','loginBgImage')||loginInfo.imgsrc;var width=(0,_loginUtil.getLSValue)('login','loginBgImageWidth')||loginInfo.width;var height=(0,_loginUtil.getLSValue)('login','loginBgImageHeight')||loginInfo.height;var style={backgroundImage:'url('+(0,_pathUtil.addContentPath)(src)+')'};switch(fillStyle){case'adapt':case'fill':{style.backgroundRepeat='no-repeat';style.backgroundSize='cover';var _style={};var win_width=jQuery(window).width();var win_height=jQuery(window).height();win_width=win_width<800?800:win_width;win_height=win_height<660?660:win_height;var rate=width/height;var _rate=win_width/win_height;if(rate>_rate){if(fillStyle=='adapt'){_style={width:win_width,height:win_width/rate,marginTop:(win_height-win_width/rate)/2};}if(fillStyle=='fill'){_style={width:win_height*rate,height:win_height,marginLeft:-((win_height*rate-win_width)/2)};}}else if(rate<_rate){if(fillStyle=='adapt'){_style={width:win_height*rate,height:win_height,marginLeft:(win_width-win_height*rate)/2};}if(fillStyle=='fill'){_style={width:win_width,height:win_width/rate};}}else{_style={width:win_width,height:win_height};}style=(0,_extends3.default)({},style,_style);break;}case'tile':style.backgroundRepeat='repeat';break;case'center':style.backgroundPosition='center';style.backgroundRepeat='no-repeat';break;default:style.backgroundRepeat='no-repeat';style.backgroundSize='100% 100%';break;}return style;}},{key:'getElementStyle',value:function getElementStyle(element){var _state2=this.state,win_width=_state2.win_width,win_height=_state2.win_height,loginType=_state2.loginType,loginFormItems=_state2.loginFormItems,templateType=_state2.templateType;var showtype=element.showtype,isAbsolute=element.isAbsolute,width=element.width,height=element.height,imgWidth=element.imgWidth,imgbtn=element.imgbtn,isloginbtn=element.isloginbtn,imgHeight=element.imgHeight,rate_x=element.rate_x,rate_y=element.rate_y,level=element.level,vertical=element.vertical,levelMargin=element.levelMargin,verticalMargin=element.verticalMargin;if(!width){width=win_width;}if(!height){height=win_height;}if(!imgWidth){imgWidth=win_width;}if(!imgHeight){imgHeight=win_height;}var style={};if(isAbsolute==1){if(isloginbtn==false){// 老数据
style={left:rate_x*100+'%',width:imgWidth,height:imgHeight};}else{style={left:rate_x*100+'%',top:rate_y*100+'%',width:width,height:height};}}else{if(imgbtn==true){// 图片按钮
var left=0;switch(level){case'left':left=levelMargin;break;case'center':left=(win_width-imgWidth)/2+levelMargin;break;case'right':left=win_width-imgWidth-levelMargin;break;}var top=0;switch(vertical){case'top':top=verticalMargin;break;case'middle':top=(win_height-imgHeight)/2+verticalMargin;break;case'bottom':top=win_height-imgHeight-verticalMargin;break;}style={left:left,top:top,width:width,height:height};}else{// 登录按钮
var _left=0;switch(level){case'left':_left=levelMargin;break;case'center':_left=(win_width-width)/2+levelMargin;break;case'right':_left=win_width-width-levelMargin;break;}var _top=0;switch(vertical){case'top':_top=verticalMargin;break;case'middle':_top=(win_height-height)/2+verticalMargin;break;case'bottom':_top=win_height-height-verticalMargin;break;}style={left:_left,top:_top,width:width,height:height};}if(loginType=='form'&&(templateType=='E9'||templateType=='V'||templateType=='H'||templateType=='Ecology8')){var len=loginFormItems.length-2;if(len>0){if(showtype=='loginbox'){style.height+=len*65;style.top-=len*32.5;}if(showtype=='logo'||showtype=='loginForm'||showtype=='qrcode'||showtype=='loginButton'){style.top-=len*32.5;}}}}return style;}},{key:'doBeforLoginRenderEvent',value:function doBeforLoginRenderEvent(){var _this2=this;// 防止重复执行
if(!this.beforLoginRenderEventStatus){(0,_eventUtil.doEvent)('beforLoginRender',function(){return _this2.beforLoginRenderEventStatus=true;});}}},{key:'doAfterLoginRenderEvent',value:function doAfterLoginRenderEvent(){var _this3=this;// 防止重复执行
if(!this.afterLoginRenderEventStatus){(0,_eventUtil.doEvent)('afterLoginRender',function(){return _this3.afterLoginRenderEventStatus=true;});}}},{key:'getMultiLangs',value:function getMultiLangs(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};LOGIN_API.getActiveLanguage(params).then(function(result){if(result.status=='1'){var activeLanguageInfo=result.activeLanguageInfo,activeLanguageIds=result.activeLanguageIds,languageIdentify=result.languageIdentify,_result$systemDefault=result.systemDefaultLang,systemDefaultLang=_result$systemDefault===undefined?{}:_result$systemDefault;_this4.multiLangs=activeLanguageInfo;(0,_loginUtil.setLSValue)('login','multiLangs',activeLanguageInfo);_ecCom.WeaTools.ls.set('activeLanguageIds',activeLanguageIds);_ecCom.WeaTools.ls.set('languageIdentify',languageIdentify);// 当前状态中没有语言时，取默认语言
if(!_this4.state.langId){var language={};for(var key in systemDefaultLang){language={id:key,language:systemDefaultLang[key]};}var _language=language,_language$id=_language.id,langId=_language$id===undefined?'7':_language$id,_language$language=_language.language,langText=_language$language===undefined?'简体中文':_language$language;_this4.setState({langId:langId,langText:langText});_this4.getLoginForm({langId:langId});}}_this4.setTitle();});}},{key:'getUpgradeInfo',value:function getUpgradeInfo(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};LOGIN_API.getUpgradeInfo(params).then(function(result){var updatestatus=result.updatestatus,upgradeurl=result.upgradeurl;if(updatestatus=='0'){if(/E-Mobile/i.test(window.navigator.userAgent)){var paramstr='';(0,_keys2.default)(params).map(function(key){paramstr+='&'+key+'='+params[key];});if(paramstr!=''){paramstr=paramstr.substring(1);}if(params.service){window.location.href=(0,_pathUtil.addContentPath)('/spa/portal/static4mobilelogin/index.html?service='+params.service+'#/login?'+paramstr);}else{window.location.href=(0,_pathUtil.addContentPath)('/spa/portal/static4mobilelogin/index.html#/login?'+paramstr);}}else{_this5.doBeforLoginRenderEvent();// 检查是否部署了CAS
LOGIN_API.checkCasIsDeployed().then(function(result){var hasSession=result.hasSession;// 用户已登录，则直接跳转登录后页面
if(hasSession&&!params.preview&&!params.templateType){(0,_eventUtil.doEvent)('afterLogin',function(){return window.location.href=(0,_pathUtil.addContentPath)('/wui/index.html?#/main');});}else{_this5.getLoginInfo(params);}});}}else if(upgradeurl){window.location.href=(0,_pathUtil.addContentPath)(upgradeurl);}});}},{key:'getLoginInfo',value:function getLoginInfo(){var _this6=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var callback=arguments[1];this.updatestatus='0';this.casstatus='0';if(window.hasloginpop){// 弹出登录弹窗的情况下，手动删除浏览器参数，回到登录页，清除掉超时登录框
delete window.hasloginpop;var WeaLoginPopList=document.getElementsByClassName("wea-login-pop");for(var i=0,len=WeaLoginPopList.length;i<len;i++){WeaLoginPopList[i].remove();}}// 获取多语言
this.getMultiLangs(params);this.loading=true;LOGIN_API.getLoginInfo(params).then(function(result){// 缓存登录日期
var date=new Date();var loginDate=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();_ecCom.WeaTools.ls.set('loginDate',loginDate);if(result.status!='2'){var settingversion=result.settingversion,templateId=result.id,templateType=result.templateType,_result$loginSettingI=result.loginSettingInfo,loginSettingInfo=_result$loginSettingI===undefined?{}:_result$loginSettingI,_result$bgImagesInfo=result.bgImagesInfo,bgImagesInfo=_result$bgImagesInfo===undefined?[]:_result$bgImagesInfo,_result$layoutData=result.layoutData,layoutData=_result$layoutData===undefined?{}:_result$layoutData,isRememberAccount=result.isRememberAccount,isRememberPassword=result.isRememberPassword,_result$cacheAccount=result.cacheAccount,cacheAccount=_result$cacheAccount===undefined?'':_result$cacheAccount,_result$cachePassword=result.cachePassword,cachePassword=_result$cachePassword===undefined?'':_result$cachePassword,emobileDownloadUrl=result.emobileDownloadUrl;var _loginSettingInfo$log=loginSettingInfo.loginInfo,loginInfo=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var showQrcode=loginInfo.showQrcode,_loginInfo$qrcodeVali=loginInfo.qrcodeValidTime,qrcodeValidTime=_loginInfo$qrcodeVali===undefined?30:_loginInfo$qrcodeVali,_loginInfo$qrcodeReqT=loginInfo.qrcodeReqTime,qrcodeReqTime=_loginInfo$qrcodeReqT===undefined?1:_loginInfo$qrcodeReqT,defaultQrcode=loginInfo.defaultQrcode,onlyQrcode=loginInfo.onlyQrcode;// 判断接口返回的设置版本和缓存的设置版本是否一致
var ls_settingversion=(0,_loginUtil.getLSValue)('login','settingversion');var ls_templateId=(0,_loginUtil.getLSValue)('login','templateId');var isNewVersion=settingversion!=ls_settingversion||templateId!=ls_templateId;// 设置移动客户端下载地址
_this6.emobileDownloadUrl=emobileDownloadUrl;// 获取登录方式
_this6.qrcodeValidTime=qrcodeValidTime;_this6.qrcodeReqTime=qrcodeReqTime;var loginType='form';if(showQrcode){if(onlyQrcode){loginType='QRCode';}else{var ls_loginType=(0,_loginUtil.getLSValue)('login','loginType')||'';loginType=ls_loginType||(defaultQrcode?'QRCode':'form');}}(0,_loginUtil.setLSValue)('login','loginType',loginType);// 获取幻灯片默认位置
var initialSlide=0;var ls_loginBgImage=!isNewVersion?(0,_loginUtil.getLSValue)('login','loginBgImage'):'';var loginBgImage=ls_loginBgImage||loginInfo.imgsrc;for(var _i=0,_len=bgImagesInfo.length;_i<_len;_i++){if(bgImagesInfo[_i].imgsrc==loginBgImage){initialSlide=_i;break;}}(0,_loginUtil.setLSValue)('login','initialSlide',initialSlide);// 获取幻灯片是否自动轮播
var ls_autoCarousel=!isNewVersion?(0,_loginUtil.getLSValue)('login','autoCarousel'):undefined;var autoCarousel=ls_autoCarousel!=undefined?ls_autoCarousel:loginInfo.autoCarousel;(0,_loginUtil.setLSValue)('login','autoCarousel',autoCarousel);// 获取幻灯片自动轮播间隔时间
var ls_carouselTime=!isNewVersion?(0,_loginUtil.getLSValue)('login','carouselTime'):'';var carouselTime=ls_carouselTime||loginInfo.carouselTime;(0,_loginUtil.setLSValue)('login','carouselTime',carouselTime);// 获取记住的账号和密码
if(isRememberAccount!=undefined){(0,_loginUtil.setLSValue)('login','isRememberAccount',isRememberAccount);(0,_loginUtil.setLSValue)('login','isRememberPassword',isRememberPassword);(0,_loginUtil.setLSValue)('login','cacheAccount',cacheAccount);(0,_loginUtil.setLSValue)('login','cachePassword',cachePassword);_this6.setState({isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,cacheAccount:cacheAccount,cachePassword:cachePassword});}var state=(0,_assign2.default)({},result,{loginType:loginType,initialSlide:initialSlide,autoCarousel:autoCarousel,carouselTime:carouselTime});(0,_loginUtil.setLSValue)('login','loginCache',state);if(isNewVersion||templateType=='ECustom'){(0,_loginUtil.setLSValue)('login','settingversion',settingversion);(0,_loginUtil.setLSValue)('login','templateId',templateId);(0,_loginUtil.setLSValue)('login','templateType',templateType);(0,_loginUtil.setLSValue)('login','loginBgImage',loginInfo.imgsrc);(0,_loginUtil.setLSValue)('login','loginBgImageWidth',loginInfo.width);(0,_loginUtil.setLSValue)('login','loginBgImageHeight',loginInfo.height);_this6.setState(state);if(templateType=='ECustom'){_this6.onLoadECustomLogin(layoutData);}}_this6.setTitle();}if(callback&&typeof callback=='function'){callback();}_this6.loading=false;});}},{key:'onLoadECustomLogin',value:function onLoadECustomLogin(){var _this7=this;var layoutData=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var layoutCustom=layoutData.layoutCustom,layoutConfig=layoutData.layoutConfig;if(layoutCustom=='1'&&layoutConfig&&layoutConfig.id){_ecCom.WeaTools.loadDevModules(layoutConfig.id,layoutConfig.module).then(function(){var _interval=window.setInterval(function(){if(window[layoutConfig.module]){_this7.customloading=true;window.clearInterval(_interval);}},100);});}else{(0,_loadjsUtil.loadModule)({module:'portalPublic',files:[].concat((0,_toConsumableArray3.default)(_files.ecComFiles),(0,_toConsumableArray3.default)(_files.comMobxFiles),(0,_toConsumableArray3.default)(_files.portalPublicFiles)),success:function success(){var _interval=window.setInterval(function(){if(window.weaPortalPublic){_this7.customloading=true;window.clearInterval(_interval);}},100);}});}}},{key:'getLoginForm',value:function getLoginForm(){var _this8=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _callback=arguments[1];var queryParams=this.queryParams;var _queryParams$logintyp=queryParams.logintype,logintype=_queryParams$logintyp===undefined?'1':_queryParams$logintyp;var _params$loginId=params.loginId,loginId=_params$loginId===undefined?'':_params$loginId,_params$langId=params.langId,langId=_params$langId===undefined?this.state.langId:_params$langId;if(langId){window.doLoginAction&&window.doLoginAction('getLoginForm',{queryParams:queryParams,logintype:logintype,loginid:loginId,langid:langId,callback:function callback(result){var _result$hasMultiLang=result.hasMultiLang,hasMultiLang=_result$hasMultiLang===undefined?false:_result$hasMultiLang,_result$loginFormItem=result.loginFormItems,loginFormItems=_result$loginFormItem===undefined?[]:_result$loginFormItem,_result$loginFormHidd=result.loginFormHiddenItems,loginFormHiddenItems=_result$loginFormHidd===undefined?[]:_result$loginFormHidd,_result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,_result$qrCode=result.qrCode,qrCode=_result$qrCode===undefined?{}:_result$qrCode;_this8.setState({hasMultiLang:hasMultiLang,loginFormItems:loginFormItems,loginFormHiddenItems:loginFormHiddenItems,loginSetting:loginSetting,qrCode:qrCode});if(_callback&&typeof _callback=='function'){_callback(result);}// 登录表单数据加载完成
_this8.loginFormDataLoading=true;}});}}},{key:'getDynamicPassword',value:function getDynamicPassword(){var _this9=this;var queryParams=this.queryParams;var _queryParams$logintyp2=queryParams.logintype,logintype=_queryParams$logintyp2===undefined?'1':_queryParams$logintyp2;var _state3=this.state,langId=_state3.langId,loginSetting=_state3.loginSetting;window.doLoginAction&&window.doLoginAction('getDynamicPassword',{queryParams:queryParams,logintype:logintype,langid:langId,loginSetting:loginSetting,success:function success(result){var _result$validitySec=result.validitySec,validitySec=_result$validitySec===undefined?60:_result$validitySec;_this9.dynamicPasswordTime=validitySec;var _interval=setInterval(function(){var time=_this9.dynamicPasswordTime;if(time==1){window.clearInterval(_this9.dynamicPasswordInterval);}_this9.dynamicPasswordTime=time-1;},1000);_this9.dynamicPasswordInterval=_interval;}});}},{key:'onRememberChange',value:function onRememberChange(type,checked){var _state4=this.state,isRememberAccount=_state4.isRememberAccount,isRememberPassword=_state4.isRememberPassword;if(type=='account'){this.setState({isRememberAccount:checked,isRememberPassword:!checked?checked:isRememberPassword});}else if(type=='password'){this.setState({isRememberAccount:checked||isRememberAccount,isRememberPassword:checked});}}},{key:'onPasswordForget',value:function onPasswordForget(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _params$langId2=params.langId,langId=_params$langId2===undefined?this.state.langId:_params$langId2;window.doLoginAction&&window.doLoginAction('forgetPassword',{langid:langId});}},{key:'onValidateCodeChange',value:function onValidateCodeChange(){var _this10=this;setTimeout(function(){return _this10.setState({validateCode:'/weaver/weaver.file.MakeValidateCode?seriesnum_='+ ++_this10.seriesnum_});},50);}},{key:'onLogin',value:function onLogin(){var _this11=this;var queryParams=this.queryParams;var _queryParams$logintyp3=queryParams.logintype,logintype=_queryParams$logintyp3===undefined?'1':_queryParams$logintyp3,_queryParams$gopage=queryParams.gopage,gopage=_queryParams$gopage===undefined?'':_queryParams$gopage,_queryParams$target=queryParams.target,target=_queryParams$target===undefined?'1':_queryParams$target;var _state5=this.state,langId=_state5.langId,langText=_state5.langText,isRememberAccount=_state5.isRememberAccount,isRememberPassword=_state5.isRememberPassword,loginSetting=_state5.loginSetting,_state5$loginSettingI=_state5.loginSettingInfo,loginSettingInfo=_state5$loginSettingI===undefined?{}:_state5$loginSettingI;var _loginSettingInfo$log2=loginSettingInfo.loginInfo,loginInfo=_loginSettingInfo$log2===undefined?{}:_loginSettingInfo$log2;var _loginInfo$isOpenGopa=loginInfo.isOpenGopage,isOpenGopage=_loginInfo$isOpenGopa===undefined?true:_loginInfo$isOpenGopa;_ecCom.WeaTools.ls.set('login-pop-window.location',window.location);this.setState({isLogging:true});(0,_eventUtil.doEvent)('beforLogin',function(){window.doLoginAction&&window.doLoginAction('login',{queryParams:queryParams,logintype:logintype,langid:langId,loginSetting:loginSetting,isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,success:function success(username,password){var result=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();var cacheAccount='';var cachePassword='';if(isRememberAccount){cacheAccount=username;}if(isRememberPassword){cachePassword=password;}_this11.setState({isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,cacheAccount:cacheAccount,cachePassword:cachePassword});(0,_loginUtil.initLSValue)(username,langId);(0,_loginUtil.setLSValue)('login','logintype',logintype);(0,_loginUtil.setLSValue)('login','loginId',username);(0,_loginUtil.setLSValue)('login','cacheAccount',cacheAccount);(0,_loginUtil.setLSValue)('login','cachePassword',cachePassword);(0,_loginUtil.setLSValue)('login','isRememberAccount',isRememberAccount);(0,_loginUtil.setLSValue)('login','isRememberPassword',isRememberPassword);// 直接跳转到后端
if(result.needJumpToBackstage){window.top.location.href=(0,_pathUtil.addContentPath)('/wui/engine.html');return;}(0,_eventUtil.doEvent)('afterLogin',function(){_this11.setState({isLogging:false});_this11.beforLoginRenderEventStatus=false;_this11.afterLoginRenderEventStatus=false;_this11.dynamicPasswordTime=0;window.clearInterval(_this11.dynamicPasswordInterval);// 登录后跳转超时前页面
var ls_gopage=_ecCom.WeaTools.ls.getStr('gopage');_ecCom.WeaTools.ls.set('gopage','');if(ls_gopage&&isOpenGopage){window.top.location.href=(0,_pathUtil.addContentPath)(decodeURIComponent(ls_gopage));}else{// 登录成功回调
var _result$needJump=result.needJump,needJump=_result$needJump===undefined?true:_result$needJump;if(window.onLoginCallback&&typeof window.onLoginCallback=='function'){needJump=window.onLoginCallback(result);}// 登录成功回调返回true时，继续标准跳转
if(needJump){if(logintype=='2'){window.top.location.href=(0,_pathUtil.addContentPath)('/spa/crmPortal/mobx/index.html#/main');}else{// 判断当前登录日期和上次登录的日期是否为同一天，不是同一天则强制刷新页面
var date=new Date();var loginDate=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();var ls_loginDate=_ecCom.WeaTools.ls.getStr('loginDate');if(!/\/wui\/index\.html/.test(window.top.location.pathname)){window.top.location.href=(0,_pathUtil.addContentPath)('/wui/index.html#/main');}else if(loginDate!=ls_loginDate){_ecCom.WeaTools.ls.set('loginDate',loginDate);var href='/wui/index.html?#/main';if(gopage){href+='?gopage='+encodeURIComponent(gopage)+'&target='+target;}window.top.location.href=(0,_pathUtil.addContentPath)(href);}else{var pathname='/main';if(gopage){pathname+='?gopage='+encodeURIComponent(gopage)+'&target='+target;}window.top.weaHistory.push({pathname:pathname});}}}}});},failure:function failure(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this11.setState({isLogging:false});if(result.reflashValidateCode){_this11.onValidateCodeChange();}_this11.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting2=result.loginSetting,loginSetting=_result$loginSetting2===undefined?{}:_result$loginSetting2,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);_this11.setStateAndCache('loginType','QRCode');}});}});});}// 扫码登录
},{key:'onQCLogin',value:function onQCLogin(){var _this12=this;// 二维码已失效
if(this.qrcodeIsInvalid){return;}var queryParams=this.queryParams;var _queryParams$logintyp4=queryParams.logintype,logintype=_queryParams$logintyp4===undefined?'1':_queryParams$logintyp4,_queryParams$gopage2=queryParams.gopage,gopage=_queryParams$gopage2===undefined?'':_queryParams$gopage2,_queryParams$target2=queryParams.target,target=_queryParams$target2===undefined?'1':_queryParams$target2;var _state6=this.state,langId=_state6.langId,langText=_state6.langText,qrCode=_state6.qrCode,_state6$loginSettingI=_state6.loginSettingInfo,loginSettingInfo=_state6$loginSettingI===undefined?{}:_state6$loginSettingI;var _loginSettingInfo$log3=loginSettingInfo.loginInfo,loginInfo=_loginSettingInfo$log3===undefined?{}:_loginSettingInfo$log3;var _loginInfo$isOpenGopa2=loginInfo.isOpenGopage,isOpenGopage=_loginInfo$isOpenGopa2===undefined?true:_loginInfo$isOpenGopa2;LOGIN_API.login4qc((0,_extends3.default)({langid:langId,loginkey:qrCode.loginkey,isie:ua.browser==='IE'},queryParams)).then(function(result){if(result.status=='1'){jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();(0,_loginUtil.setLSValue)('login','logintype',logintype);// 处理sso扫码登录
if(queryParams&&queryParams.appid&&queryParams.service){queryParams.authenticationType=2;jQuery('body').append('<form name="ssoForm"></form>');var form=jQuery('form[name="ssoForm"]');form.attr('action',(0,_pathUtil.addContentPath)('/login/VerifyLoginWeaversso.jsp'));form.attr('method','post');form.attr('style','display:none');for(var key in queryParams){if(Object.prototype.hasOwnProperty.call(queryParams,key)){form.append('<input type="text" name="'+key+'" value="'+queryParams[key]+'"></input>');}}// 跳转到sso
form.submit();return;}// 直接跳转到后端
if(result.needJumpToBackstage){window.top.location.href=(0,_pathUtil.addContentPath)('/wui/engine.html');return;}(0,_eventUtil.doEvent)('afterLogin',function(){_this12.beforLoginRenderEventStatus=false;_this12.afterLoginRenderEventStatus=false;// 登录后跳转超时前页面
var ls_gopage=_ecCom.WeaTools.ls.getStr('gopage');_ecCom.WeaTools.ls.set('gopage','');if(ls_gopage&&isOpenGopage){window.top.location.href=(0,_pathUtil.addContentPath)(decodeURIComponent(ls_gopage));}else if(!/\/wui\/index\.html/.test(window.top.location.pathname)){window.top.location.href=(0,_pathUtil.addContentPath)('/wui/index.html#/main');}else{var pathname='/main';if(gopage){pathname+='?gopage='+encodeURIComponent(gopage)+'&target='+target;}window.top.weaHistory.push({pathname:pathname});}});}});}},{key:'onQCLoginStart',value:function onQCLoginStart(cusQrcodeValidTime,cusQrcodeReqTime){var _this13=this;this.qrcodeIsInvalid=false;// 二维码生效
var qrcodeValidTime=cusQrcodeValidTime||this.qrcodeValidTime;var qrcodeReqTime=cusQrcodeReqTime||this.qrcodeReqTime;var qrcodeUsedTime=1;this.qrcodeCdInterval=window.setInterval(function(){if(qrcodeUsedTime>=qrcodeValidTime){_this13.onQCLoginEnd();}qrcodeUsedTime++;},1000);this.qrcodeLoginInterval=window.setInterval(function(){return _this13.onQCLogin();},qrcodeReqTime*1000);}},{key:'onQCLoginEnd',value:function onQCLoginEnd(){this.qrcodeIsInvalid=true;// 二维码失效
window.clearInterval(this.qrcodeCdInterval);window.clearInterval(this.qrcodeLoginInterval);}},{key:'labelObj',get:function get(){var _state7=this.state,langId=_state7.langId,labelInfo=_state7.labelInfo,loginTemplateTitle=_state7.loginTemplateTitle,loginTemplateTitle_base64=_state7.loginTemplateTitle_base64;if(loginTemplateTitle_base64){document.title=getCurrentLabel(getMultiStrFromBase64(loginTemplateTitle_base64),langId)||loginTemplateTitle;}else{document.title=loginTemplateTitle;}return labelInfo['langid'+langId]||{};}}]);return LoginStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'queryParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'updatestatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'casstatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'multiLangs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_loginUtil.getLSValue)('login','multiLangs')||[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'dynamicPasswordTime',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'dynamicPasswordInterval',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'seriesnum_',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'qrcodeValidTime',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 30;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'qrcodeReqTime',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'qrcodeIsInvalid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'emobileDownloadUrl',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'loginFormDataLoading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'customloading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'beforLoginRenderEventStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'afterLoginRenderEventStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'state',[_mobx.observable],{enumerable:true,initializer:function initializer(){return(0,_assign2.default)({},{win_width:jQuery(window).width(),win_height:jQuery(window).height(),isLogging:false,hasMultiLang:false,multiLangVisible:false,loginFormItems:[],loginFormHiddenItems:[],loginSetting:{},qrCode:{},validateCode:'/weaver/weaver.file.MakeValidateCode?seriesnum_=0',labelInfo:[]},(0,_assign2.default)({},(0,_loginUtil.getLSValue)('login','loginCache'),{loginType:(0,_loginUtil.getLSValue)('login','loginType')||'form',langId:(0,_loginUtil.getLSValue)('login','langId')||'',langText:(0,_loginUtil.getLSValue)('login','langText')||'',isRememberAccount:(0,_loginUtil.getLSValue)('login','isRememberAccount')||(0,_loginUtil.getCookieValue)('isRememberAccount')||false,isRememberPassword:(0,_loginUtil.getLSValue)('login','isRememberPassword')||(0,_loginUtil.getCookieValue)('isRememberPassword')||false,cacheAccount:(0,_loginUtil.getLSValue)('login','cacheAccount')||(0,_loginUtil.getCookieValue)('cacheAccount')||'',cachePassword:(0,_loginUtil.getLSValue)('login','cachePassword')||(0,_loginUtil.getCookieValue)('cachePassword')||'',initialSlide:(0,_loginUtil.getLSValue)('login','initialSlide')||0,autoCarousel:(0,_loginUtil.getLSValue)('login','autoCarousel')||false,carouselTime:(0,_loginUtil.getLSValue)('login','carouselTime')||3}));}}),_applyDecoratedDescriptor(_class.prototype,'labelObj',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'labelObj'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onWindowResize',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onWindowResize'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setQueryParams',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setQueryParams'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setState',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setState'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setStateAndCache',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setStateAndCache'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onBgImageChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onBgImageChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getLoginBgImageStyle',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getLoginBgImageStyle'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getElementStyle',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getElementStyle'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'doBeforLoginRenderEvent',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'doBeforLoginRenderEvent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'doAfterLoginRenderEvent',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'doAfterLoginRenderEvent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getMultiLangs',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getMultiLangs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getUpgradeInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getUpgradeInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getLoginInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getLoginInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLoadECustomLogin',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLoadECustomLogin'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getLoginForm',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getLoginForm'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getDynamicPassword',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getDynamicPassword'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onRememberChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onRememberChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onPasswordForget',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onPasswordForget'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onValidateCodeChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onValidateCodeChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLogin',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLogin'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQCLogin',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQCLogin'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQCLoginStart',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQCLoginStart'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQCLoginEnd',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQCLoginEnd'),_class.prototype)),_class);exports.default=LoginStore;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(195);
var $Object = __webpack_require__(8).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(24);
var $getOwnPropertyDescriptor = __webpack_require__(54).f;

__webpack_require__(55)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.loadModule=undefined;var _loadjs2=__webpack_require__(146);var _loadjs3=_interopRequireDefault(_loadjs2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadModule=exports.loadModule=function loadModule(_ref){var module=_ref.module,_ref$files=_ref.files,files=_ref$files===undefined?[]:_ref$files,_ref$async=_ref.async,async=_ref$async===undefined?false:_ref$async,success=_ref.success,error=_ref.error;var loadjs=window.loadjs||_loadjs3.default;loadjs.isDefined(module)?loadjs.ready(module,{success:success,error:error}):loadjs(files,module,{async:async,success:success,error:error});};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(38);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(68);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39,_descriptor40,_descriptor41,_descriptor42,_descriptor43,_descriptor44;var _reactDom=__webpack_require__(19);var _reactDom2=_interopRequireDefault(_reactDom);var _mobx=__webpack_require__(14);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _lodash=__webpack_require__(198);var _=_interopRequireWildcard(_lodash);var _login=__webpack_require__(144);var LOGIN_API=_interopRequireWildcard(_login);var _theme=__webpack_require__(149);var THEME_API=_interopRequireWildcard(_theme);var _eventUtil=__webpack_require__(145);var _loginUtil=__webpack_require__(110);var _themeUtil=__webpack_require__(150);var _pathUtil=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ThemeStore=(_class=function(){function ThemeStore(){(0,_classCallCheck3.default)(this,ThemeStore);_initDefineProp(this,'loading',_descriptor,this);_initDefineProp(this,'pluginloading',_descriptor2,this);_initDefineProp(this,'customloading',_descriptor3,this);_initDefineProp(this,'searchParams',_descriptor4,this);_initDefineProp(this,'pluginIds',_descriptor5,this);_initDefineProp(this,'pluginInsertCount',_descriptor6,this);_initDefineProp(this,'pluginReload',_descriptor7,this);_initDefineProp(this,'multiLangs',_descriptor8,this);_initDefineProp(this,'langId',_descriptor9,this);_initDefineProp(this,'themeInfo',_descriptor10,this);_initDefineProp(this,'frontEndMenu',_descriptor11,this);_initDefineProp(this,'topMenuObj',_descriptor12,this);_initDefineProp(this,'topMenuVisible',_descriptor13,this);_initDefineProp(this,'leftMenuObj',_descriptor14,this);_initDefineProp(this,'leftMenuMode',_descriptor15,this);_initDefineProp(this,'selectedMenuIds',_descriptor16,this);_initDefineProp(this,'selectedMenuKeys',_descriptor17,this);_initDefineProp(this,'hiddenMyPortal',_descriptor18,this);_initDefineProp(this,'showFreqUseMenu',_descriptor19,this);_initDefineProp(this,'freqUseMenu',_descriptor20,this);_initDefineProp(this,'freqUseMenuVisible',_descriptor21,this);_initDefineProp(this,'showQuickSearch',_descriptor22,this);_initDefineProp(this,'quickSearchTypes',_descriptor23,this);_initDefineProp(this,'quickSearchTypesVisible',_descriptor24,this);_initDefineProp(this,'quickSearchTypesSelected',_descriptor25,this);_initDefineProp(this,'quickSearchMenus',_descriptor26,this);_initDefineProp(this,'quickSearchAssociate',_descriptor27,this);_initDefineProp(this,'quickSearchRcmdVisible',_descriptor28,this);_initDefineProp(this,'quickSearchShowRcmd',_descriptor29,this);_initDefineProp(this,'quickSearchShowWs',_descriptor30,this);_initDefineProp(this,'toolbarMenu',_descriptor31,this);_initDefineProp(this,'toolbarMoreMenu',_descriptor32,this);_initDefineProp(this,'toolbarMoreMenuVisible',_descriptor33,this);_initDefineProp(this,'account',_descriptor34,this);_initDefineProp(this,'accountVisible',_descriptor35,this);_initDefineProp(this,'accountSize',_descriptor36,this);_initDefineProp(this,'accountList',_descriptor37,this);_initDefineProp(this,'accountListVisible',_descriptor38,this);_initDefineProp(this,'accountMenu',_descriptor39,this);_initDefineProp(this,'accountMoreMenu',_descriptor40,this);_initDefineProp(this,'fontSettingVisible',_descriptor41,this);_initDefineProp(this,'langSettingVisible',_descriptor42,this);_initDefineProp(this,'translatepower',_descriptor43,this);_initDefineProp(this,'translatepage',_descriptor44,this);}// 插件加载状态
// 自定义主题组件加载状态
// 地址栏查询参数
// 插件相关
// 多语言
// 主题信息
// 前端菜单
// 顶部菜单
// 左侧菜单
// inline | vertical
// 选中菜单
// 我的门户
// 常用菜单
// 快捷搜索
// 快捷搜索栏搜索时前端菜单搜索推荐
// 快捷搜索栏搜索时微搜联想推荐
// 快捷搜索栏是否显示搜索推荐
// 快捷搜索栏是否显示微搜
// 工具栏
// 账号栏
// 翻译模式权限
(0,_createClass3.default)(ThemeStore,[{key:'doBeforThemeRenderEvent',value:function doBeforThemeRenderEvent(callback){(0,_eventUtil.doEvent)('beforThemeRender',callback);}},{key:'doAfterThemeRenderEvent',value:function doAfterThemeRenderEvent(){var _this=this;(0,_eventUtil.doEvent)('afterThemeRender',function(){if(window.pluginDelayTime&&parseInt(window.pluginDelayTime)>0){setTimeout(function(){_this.getPlugins();_this.pluginloading=false;},parseInt(window.pluginDelayTime));}else{_this.getPlugins();_this.pluginloading=false;}});}},{key:'setThemeInfo',value:function setThemeInfo(themeInfo){this.themeInfo=(0,_assign2.default)({},this.themeInfo,themeInfo);}},{key:'getThemeInfo',value:function getThemeInfo(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.searchParams=params;// 地址栏查询参数
if(window.location.pathname==(0,_pathUtil.addContentPath)('/spa/theme/static/index.html')){params.from='static';}// 缓存清除
var isInitLSValue=_ecCom.WeaTools.ls.getJSONObj('isInitLSValue');if(!isInitLSValue){(0,_loginUtil.initLSValue)();}// 自定义跳转
var gopage=params.gopage,_params$target=params.target,target=_params$target===undefined?'1':_params$target;if(gopage){if(target=='2'){window.open((0,_pathUtil.addContentPath)(gopage),'_blank');}else if(target=='3'){window.location.href=(0,_pathUtil.addContentPath)(gopage);return;}}// 加载主题
this.loading=true;this.doBeforThemeRenderEvent(function(){var themeInfo=_ecCom.WeaTools.ls.getJSONObj('theme-themeInfo');if(themeInfo&&!params.from){_this2.onLoadTheme(themeInfo);_this2.loading=false;}THEME_API.getMyTheme(params).then(function(result){var _result$data=result.data,data=_result$data===undefined?{}:_result$data;var _themeInfo=data;var _themeInfo2=_themeInfo,themeType=_themeInfo2.themeType,_themeInfo2$themeData=_themeInfo2.themeData,themeData=_themeInfo2$themeData===undefined?{}:_themeInfo2$themeData,_themeInfo2$layoutDat=_themeInfo2.layoutData,layoutData=_themeInfo2$layoutDat===undefined?{}:_themeInfo2$layoutDat;if(themeType=='ecology9'){var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?'{}':_themeData$styleConfi;_themeInfo=(0,_extends3.default)({},data,{themeData:(0,_extends3.default)({},themeData,{styleConfig:JSON.parse(styleConfig.replace(/&quot;/g,'"'))})});}else if(themeType=='ECustom'){var _layoutData$layoutSet=layoutData.layoutSetting,layoutSetting=_layoutData$layoutSet===undefined?'{}':_layoutData$layoutSet;_themeInfo=(0,_extends3.default)({},data,{layoutData:(0,_extends3.default)({},layoutData,{layoutSetting:JSON.parse(layoutSetting)})});}else if(themeType=='ecology8'){_themeInfo.themeLayoutType='1';_this2.setThemeInfo(_themeInfo);}if(!_.isEqual(_themeInfo,themeInfo)||!!params.from){_this2.onLoadTheme(_themeInfo,!params.from);}_this2.loading=false;});});}},{key:'onLoadTheme',value:function onLoadTheme(themeInfo){var isCache=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;this.themeInfo=themeInfo;isCache&&_ecCom.WeaTools.ls.set('theme-themeInfo',themeInfo);var themeTitle=themeInfo.themeTitle,themeType=themeInfo.themeType,themeLayoutType=themeInfo.themeLayoutType,themeFontSize=themeInfo.themeFontSize,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData,_themeInfo$layoutData=themeInfo.layoutData,layoutData=_themeInfo$layoutData===undefined?{}:_themeInfo$layoutData;// 设置浏览器窗口标题
document.title=themeTitle||'';// 设置字体大小
(0,_themeUtil.setFontSize)(themeFontSize||'12');if(themeType=='ecology9'){if(themeLayoutType=='5'){(0,_themeUtil.setE9ThemeStyle)(null);}else{var _themeData$styleConfi2=themeData.styleConfig,styleConfig=_themeData$styleConfi2===undefined?{}:_themeData$styleConfi2;(0,_themeUtil.setE9ThemeStyle)(styleConfig);}}else if(themeType=='ECustom'){this.onLoadECustomTheme(layoutData);}}},{key:'onLoadECustomTheme',value:function onLoadECustomTheme(){var _this3=this;var layoutData=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var layoutCustom=layoutData.layoutCustom,layoutConfig=layoutData.layoutConfig;if(layoutCustom=='1'&&layoutConfig&&layoutConfig.id){_ecCom.WeaTools.loadDevModules(layoutConfig.id,layoutConfig.module).then(function(){var _interval=window.setInterval(function(){if(window[layoutConfig.module]){_this3.customloading=true;window.clearInterval(_interval);}},100);});}}},{key:'getMultiLangs',value:function getMultiLangs(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};LOGIN_API.getActiveLanguage(params).then(function(result){if(result.status=='1'){var activeLanguageInfo=result.activeLanguageInfo,activeLanguageIds=result.activeLanguageIds,languageIdentify=result.languageIdentify;_this4.multiLangs=activeLanguageInfo;(0,_loginUtil.setLSValue)('login','multiLangs',activeLanguageInfo);_ecCom.WeaTools.ls.set('activeLanguageIds',activeLanguageIds);_ecCom.WeaTools.ls.set('languageIdentify',languageIdentify);}});}},{key:'getTranslatepower',value:function getTranslatepower(){var _this5=this;THEME_API.getTranslatepower().then(function(result){var isShow=result.isShow;_this5.translatepower=isShow;});}},{key:'getTranslatepage',value:function getTranslatepage(){var _this6=this;this.translatepage=_ecCom.WeaTools.ls.getStr('ennableTrans')||0;THEME_API.getTranslatepage().then(function(result){var stat=result.stat;if(stat==true){_this6.translatepage=1;_ecCom.WeaTools.ls.set('ennableTrans',1);}else{_this6.translatepage=0;_ecCom.WeaTools.ls.set('ennableTrans',0);}});}},{key:'setTranslatepage',value:function setTranslatepage(stat){var _this7=this;THEME_API.setTranslatepage({stat:stat}).then(function(result){var status=result.status;if(status=='1'){_this7.translatepage=stat;(0,_loginUtil.initLSValue)();_ecCom.WeaTools.ls.set('ennableTrans',stat);window.location.reload();}});}},{key:'getFrontEndMenu',value:function getFrontEndMenu(){var _this8=this;THEME_API.getFrontEndMenu().then(function(result){var _result$data2=result.data,data=_result$data2===undefined?[]:_result$data2;var frontEndMenu=(0,_themeUtil.formatMenuData)(data);_this8.frontEndMenu=frontEndMenu;});}},{key:'getThemeConfig',value:function getThemeConfig(params){var _this9=this;// 加载多语言
this.getMultiLangs(params);// 加载翻译模式
this.getTranslatepage();// 加载前端菜单
this.getFrontEndMenu();// 左侧菜单展示模式
var leftMenuMode=_ecCom.WeaTools.ls.getStr('theme-leftMenuMode');if(leftMenuMode){// 有缓存，取缓存数据
this.onLeftMenuModeChange(leftMenuMode);}THEME_API.getThemeConfig().then(function(result){var _result$data3=result.data,data=_result$data3===undefined?{}:_result$data3;var openLeftMenu=data.openLeftMenu,hiddenMyPortal=data.hiddenMyPortal,showFreqUseMenu=data.showFreqUseMenu,showQuickSearch=data.showQuickSearch,quickSearchShowRcmd=data.quickSearchShowRcmd;if(!leftMenuMode){// 无缓存，取接口数据
_this9.onLeftMenuModeChange(openLeftMenu=='1'?'inline':'vertical');}_this9.hiddenMyPortal=hiddenMyPortal=='1';_this9.showFreqUseMenu=showFreqUseMenu=='1';_this9.showQuickSearch=showQuickSearch=='1';_this9.quickSearchShowRcmd=quickSearchShowRcmd=='1';});}},{key:'getPlugins',value:function getPlugins(){var _this10=this;jQuery('[id^=theme-plugin]').remove();window.generatePluginAreaHtml=function(html,key){var element=document.getElementById(key);if(element){element.innerHTML=html;_this10.pluginInsertCount++;}};window.generatePluginAreaCom=function(com,key){var element=document.getElementById(key);if(element){_reactDom2.default.render(com,element);_this10.pluginInsertCount++;}};setTimeout(function(){THEME_API.getPlugins().then(function(result){var _result$data4=result.data,data=_result$data4===undefined?{}:_result$data4;var _data$pluginIds=data.pluginIds,pluginIds=_data$pluginIds===undefined?[]:_data$pluginIds,_data$pluginCSS=data.pluginCSS,pluginCSS=_data$pluginCSS===undefined?[]:_data$pluginCSS,_data$pluginJS=data.pluginJS,pluginJS=_data$pluginJS===undefined?[]:_data$pluginJS;var _pluginIds=_.uniq(pluginIds);_.pull(_pluginIds,'docPop','hrm','checkPlugin','onlinePlugin','showHelp','showEmessage');_this10.pluginIds=_pluginIds;_this10.pluginReload=false;for(var i=0,len=pluginCSS.length;i<len;i++){(0,_themeUtil.cssAsyncLoad)(pluginCSS[i],null);}for(var j=0,len2=pluginJS.length;j<len2;j++){(0,_themeUtil.jsAsyncLoad)(pluginJS[j],null);}});},100);}},{key:'removePlugins',value:function removePlugins(){jQuery('[id^=theme-plugin]').remove();jQuery('#theme-font').remove();jQuery('#IMbg',parent.document).remove();jQuery('#immsgdiv',parent.document).remove();jQuery('#addressdiv',parent.document).remove();}},{key:'getTopMenu',value:function getTopMenu(pathname){var _this11=this;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};// 获取顶部和左侧选中的菜单
var menuIds=[];if(query.menuIds){menuIds=query.menuIds.split(',');}var topMenuId=menuIds[0];var leftMenuId=menuIds[1];// 加载顶部菜单
var isLoaded=false;var topMenu=_ecCom.WeaTools.ls.getJSONObj('theme-topMenu');if(topMenu&&topMenu.length){isLoaded=true;var topMenuSelected=this.getTopMenuSelected(topMenu,topMenuId,pathname)||{};this.topMenuObj=(0,_extends3.default)({},this.topMenuObj,{topMenu:topMenu,topMenuSelected:topMenuSelected});topMenuId=topMenuSelected.infoId||topMenuSelected.id;this.getLeftMenu(topMenuId,leftMenuId,pathname,query);}THEME_API.getTopMenu(params).then(function(result){var _result$data5=result.data,data=_result$data5===undefined?[]:_result$data5;_ecCom.WeaTools.ls.set('theme-topMenu',data);var topMenuSelected=_this11.getTopMenuSelected(data,topMenuId,pathname)||{};_this11.topMenuObj=(0,_extends3.default)({},_this11.topMenuObj,{topMenu:data,topMenuSelected:topMenuSelected});if(!isLoaded){topMenuId=topMenuSelected.infoId||topMenuSelected.id;_this11.getLeftMenu(topMenuId,leftMenuId,pathname,query);}});}},{key:'getLeftMenu',value:function getLeftMenu(topMenuId,leftMenuId,pathname){var _this12=this;var query=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var leftMenu=null;if(topMenuId==0){// 门户
leftMenu=null;}else if(topMenuId==536){// 邮件
leftMenu=null;}else{var frontEndMenu=this.frontEndMenu;if(frontEndMenu){for(var i=0,len=frontEndMenu.length;i<len;i++){if(frontEndMenu[i].infoId==topMenuId){leftMenu=frontEndMenu[i].child||[];break;}}}}if(leftMenu&&leftMenu.length){this.setLeftMenu(leftMenu,topMenuId,leftMenuId,pathname,query);}else{var leftMenuPromise=null;if(topMenuId==0){// 门户
leftMenuPromise=THEME_API.getPortalMenu();}else if(topMenuId==536){// 邮件
leftMenuPromise=THEME_API.getEmailMenu();}else{leftMenuPromise=THEME_API.getFrontEndMenu();}leftMenuPromise.then(function(result){if(topMenuId==0){// 门户
var _result$data6=result.data,data=_result$data6===undefined?{}:_result$data6;var defaulthpid=data.defaulthpid,showlasthp=data.showlasthp,lasthpid=data.lasthpid,_data$menuList=data.menuList,menuList=_data$menuList===undefined?[]:_data$menuList;// 访问首页时，需要获取是否有启用默认门户或者记住最后一次访问的门户
if(!leftMenuId&&(!pathname||pathname=='main'||pathname=='/main'||pathname=='main/'||pathname=='/main/')){leftMenuId=showlasthp=='1'&&lasthpid&&lasthpid!='0'?lasthpid:defaulthpid&&defaulthpid!='0'?defaulthpid:null;}leftMenu=(0,_themeUtil.formatMenuData)(menuList,'0');}else if(topMenuId==536){// 邮件
var _themeInfo$themeLayou=_this12.themeInfo.themeLayoutType,themeLayoutType=_themeInfo$themeLayou===undefined?1:_themeInfo$themeLayou;if(themeLayoutType==1){// 主题默认布局需要加载邮件菜单，顶部栏和侧边栏不需要加载邮件菜单
leftMenu=(0,_themeUtil.formatMenuData)(result,'536');}}else{var _result$data7=result.data,_data=_result$data7===undefined?[]:_result$data7;var _frontEndMenu=(0,_themeUtil.formatMenuData)(_data);_this12.frontEndMenu=_frontEndMenu;for(var _i=0,_len=_frontEndMenu.length;_i<_len;_i++){var item=_frontEndMenu[_i];if(item.infoId==topMenuId){leftMenu=item.child;break;}}}_this12.setLeftMenu(leftMenu,topMenuId,leftMenuId,pathname,query);});}}},{key:'setLeftMenu',value:function setLeftMenu(leftMenu,topMenuId,leftMenuId,pathname){var query=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};if(leftMenu&&leftMenu.length){var leftMenuSelected={};if(leftMenuId||pathname&&pathname!='main'&&pathname!='/main'&&pathname!='main/'&&pathname!='/main/'){leftMenuSelected=this.getLeftMenuSelected(leftMenu,leftMenuId,pathname)||{};}else if(topMenuId==536){// 邮件
leftMenuSelected=leftMenu[2];}else{leftMenuSelected=leftMenu[0];// 获取左侧菜单中第一个有链接的菜单
if(!leftMenuSelected||!leftMenuSelected.mobxrouteurl&&!leftMenuSelected.fullrouteurl&&!leftMenuSelected.url){var loop=function loop(data){var selected=null;for(var i=0,len=data.length;i<len;i++){var item=data[0];if(item.url!=''&&item.url!='javascript:void(0)'||item.mobxrouteurl!=''||item.fullrouteurl!=''){selected=item;break;}else{selected=loop(item.child||[]);if(selected){break;}}}return selected;};leftMenuSelected=loop(leftMenu)||{};}}var leftMenuType='portal';if(topMenuId==536){// 邮件
leftMenuType='email';}var gopage=query.gopage,_query$target=query.target,target=_query$target===undefined?'1':_query$target;if(gopage&&target=='1'){this.leftMenuObj=(0,_extends3.default)({},this.leftMenuObj,{leftMenu:leftMenu,leftMenuSelected:{},leftMenuType:leftMenuType});this.onLoadMain({url:gopage,target:'mainFrame'});}else{this.leftMenuObj=(0,_extends3.default)({},this.leftMenuObj,{leftMenu:leftMenu,leftMenuSelected:leftMenuSelected,leftMenuType:leftMenuType});this.onSelectedMenuKeysChange(topMenuId+','+leftMenuSelected.infoId,[leftMenuSelected.id]);if(!pathname||pathname=='main'||pathname=='/main'||pathname=='main/'||pathname=='/main/'){this.onLoadMain(leftMenuSelected);}}}else{var _leftMenuType='portal';if(topMenuId==536){// 邮件
_leftMenuType='email';}var _topMenuObj$topMenuSe=this.topMenuObj.topMenuSelected,topMenuSelected=_topMenuObj$topMenuSe===undefined?{}:_topMenuObj$topMenuSe;var parentId=topMenuSelected.parentId,infoId=topMenuSelected.infoId,id=topMenuSelected.id;var _leftMenuSelected={id:(parentId||'0')+'-'+(infoId||id),infoId:infoId};this.leftMenuObj=(0,_extends3.default)({},this.leftMenuObj,{leftMenu:[],leftMenuSelected:_leftMenuSelected,leftMenuType:_leftMenuType});this.onSelectedMenuKeysChange(topMenuId+','+_leftMenuSelected.infoId,[_leftMenuSelected.id]);if(!pathname||pathname=='main'||pathname=='/main'||pathname=='main/'||pathname=='/main/'){this.onLoadMain(topMenuSelected);}}}},{key:'getTopMenuSelected',value:function getTopMenuSelected(topMenu,topMenuId,pathname){var topMenuSelected={};if(topMenu&&topMenu.length){topMenuSelected=topMenu[0];}var routes=[];if(pathname){routes=pathname.split('/');}var module=routes[1];for(var i=0,len=topMenu.length;i<len;i++){var item=topMenu[i];if(topMenuId){if(item.infoId==topMenuId){topMenuSelected=item;break;}}else if(module&&(item.routeurl==module||item.mobxrouteurl==module)){topMenuSelected=item;break;}}return topMenuSelected;}},{key:'getLeftMenuSelected',value:function getLeftMenuSelected(leftMenu,leftMenuId,pathname){var leftMenuSelected=null;for(var i=0,len=leftMenu.length;i<len;i++){var item=leftMenu[i];if(leftMenuId){if(item.infoId==leftMenuId){leftMenuSelected=item;break;}}else if(item.mobxrouteurl&&pathname.endsWith(item.mobxrouteurl)){leftMenuSelected=item;break;}if(item.child&&item.child.length){leftMenuSelected=this.getLeftMenuSelected(item.child,leftMenuId,pathname);if(leftMenuSelected){return leftMenuSelected;}}}return leftMenuSelected;}},{key:'getHome',value:function getHome(){var topMenuObj=this.topMenuObj;var _topMenuObj$topMenu=topMenuObj.topMenu,topMenu=_topMenuObj$topMenu===undefined?[]:_topMenuObj$topMenu;var topMenuSelected={};if(topMenu&&topMenu.length){topMenuSelected=topMenu[0];}this.topMenuObj=(0,_extends3.default)({},topMenuObj,{topMenuSelected:topMenuSelected});var topMenuId=topMenuSelected.infoId||topMenuSelected.id;this.getLeftMenu(topMenuId,null,'/main');}},{key:'onTopMenuVisibleChange',value:function onTopMenuVisibleChange(visible){this.topMenuVisible=visible;}},{key:'onTopMenuSelectedChange',value:function onTopMenuSelectedChange(){var topMenuSelected=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var leftMenuId=arguments[1];var pathname=arguments[2];this.topMenuObj=(0,_extends3.default)({},this.topMenuObj,{topMenuSelected:topMenuSelected});var topMenuId=topMenuSelected.infoId||topMenuSelected.id;this.getLeftMenu(topMenuId,leftMenuId,pathname);this.setTopMenuStatictics(topMenuId);}},{key:'setTopMenuStatictics',value:function setTopMenuStatictics(mid){THEME_API.setTopMenuStatictics({mid:mid});}},{key:'onLeftMenuModeChange',value:function onLeftMenuModeChange(leftMenuMode){this.leftMenuMode=leftMenuMode;_ecCom.WeaTools.ls.set('theme-leftMenuMode',leftMenuMode);var width=leftMenuMode=='inline'?'197px':'61px';var aside=document.querySelector('.e9theme-layout-aside');var main=document.querySelector('.e9theme-layout-main');aside&&(aside.style.width=width);main&&(main.style.marginLeft=width);}},{key:'onLeftMenuSelectedChange',value:function onLeftMenuSelectedChange(){var leftMenuSelected=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.leftMenuObj=(0,_extends3.default)({},this.leftMenuObj,{leftMenuSelected:leftMenuSelected});this.onSelectedMenuKeysChange(leftMenuSelected.topId+','+leftMenuSelected.infoId,[leftMenuSelected.id]);}},{key:'onSelectedMenuKeysChange',value:function onSelectedMenuKeysChange(selectedMenuIds,selectedMenuKeys){this.selectedMenuIds=selectedMenuIds;this.selectedMenuKeys=selectedMenuKeys;}},{key:'getFreqUseMenu',value:function getFreqUseMenu(){var _this13=this;THEME_API.getFreqUseMenu().then(function(result){var data=result;_this13.freqUseMenu=data;});}},{key:'onFreqUseMenuVisibleChange',value:function onFreqUseMenuVisibleChange(visible){this.freqUseMenuVisible=visible;}},{key:'getQuickSearchTypes',value:function getQuickSearchTypes(){var _this14=this;THEME_API.getQuickSearchTypes().then(function(result){var _result$data8=result.data,data=_result$data8===undefined?[]:_result$data8;if(data&&data.length){_this14.quickSearchTypes=data;_this14.quickSearchTypesSelected=data[0];data.forEach(function(item){if(item.type=='9'){_this14.quickSearchShowWs=true;}});}});}},{key:'onQuickSearchTypesVisibleChange',value:function onQuickSearchTypesVisibleChange(visible){this.quickSearchTypesVisible=visible;}},{key:'onQuickSearchTypesSelectedChange',value:function onQuickSearchTypesSelectedChange(quickSearchTypesSelected){this.quickSearchTypesSelected=quickSearchTypesSelected;}},{key:'onQuickSearchRcmdVisibleChange',value:function onQuickSearchRcmdVisibleChange(visible){this.quickSearchRcmdVisible=visible;}},{key:'setQuickSearchShowRcmd',value:function setQuickSearchShowRcmd(quickSearchShowRcmd){var _this15=this;THEME_API.setQuickSearchShowRcmd({quickSearchShowMenu:quickSearchShowRcmd}).then(function(){_this15.quickSearchShowRcmd=false;});}},{key:'getToolbarMenu',value:function getToolbarMenu(){var _this16=this;THEME_API.getToolbarMenu().then(function(result){var _result$data9=result.data,data=_result$data9===undefined?[]:_result$data9;_this16.toolbarMenu=data;});}},{key:'getToolbarMoreMenu',value:function getToolbarMoreMenu(){var _this17=this;THEME_API.getToolbarMoreMenu().then(function(result){var _result$data10=result.data,data=_result$data10===undefined?[]:_result$data10;_this17.toolbarMoreMenu=data;});}},{key:'onToolbarMoreMenuVisibleChange',value:function onToolbarMoreMenuVisibleChange(visible){this.toolbarMoreMenuVisible=visible;}},{key:'getAccount',value:function getAccount(){var _this18=this;THEME_API.getAccount().then(function(result){var _result$data11=result.data,data=_result$data11===undefined?{}:_result$data11;var langId=data.userLanguage||'7';_this18.langId=langId;_this18.account=data;_this18.getAccountList();_ecCom.WeaTools.ls.set('theme-account',data);_ecCom.WeaTools.ls.set('languageidweaver',langId);});}},{key:'onAccountChange',value:function onAccountChange(userid){_ecCom.WeaTools.ls.set('isInitLSValue',false);THEME_API.changeAccount({shiftid:userid}).then(function(result){if(result.status=='1'){window.location.reload();}});}},{key:'onAccountVisibleChange',value:function onAccountVisibleChange(visible){if(window.accountVisible){visible=true;}this.accountVisible=visible;}},{key:'getAccountList',value:function getAccountList(subcompanyid){var _account$accountlist=this.account.accountlist,accountlist=_account$accountlist===undefined?[]:_account$accountlist;if(subcompanyid){this.accountList=accountlist.filter(function(item){return item.subcompanyid==subcompanyid;});window.accountVisible=false;window.accountListVisible=false;}else{this.accountSize=accountlist.length;this.accountList=accountlist;}}},{key:'onAccountListVisibleChange',value:function onAccountListVisibleChange(visible){if(window.accountListVisible){visible=true;}this.accountListVisible=visible;}},{key:'getAccountMenu',value:function getAccountMenu(){var _this19=this;THEME_API.getAccountMenu().then(function(result){var _result$data12=result.data,data=_result$data12===undefined?[]:_result$data12;_this19.accountMenu=data;});}},{key:'getAccountMoreMenu',value:function getAccountMoreMenu(){var _this20=this;THEME_API.getAccountMoreMenu().then(function(result){var _result$data13=result.data,data=_result$data13===undefined?[]:_result$data13;_this20.accountMoreMenu=data;});}},{key:'onFontSettingVisibleChange',value:function onFontSettingVisibleChange(visible){this.fontSettingVisible=visible;}},{key:'onLangSettingVisibleChange',value:function onLangSettingVisibleChange(visible){this.langSettingVisible=visible;}},{key:'onQuickSearch',value:function onQuickSearch(obj){var _this21=this;var from=obj.from,type=obj.type,value=obj.value;var _types=(0,_mobx.toJS)(this.quickSearchTypes);var _selected=(0,_mobx.toJS)(this.quickSearchTypesSelected);for(var i=0,len=_types.length;i<len;i++){if(_types[i].type==type){_selected=_types[i];break;}}var _type=_selected.type;var _contentType=_selected.contentType;var _url=_selected.url+encodeURIComponent(value);var target=_selected.linkmode=='2'?'_blank':'mainFrame';if(from=='theme'){THEME_API.getQuickSearchRoute({type:_type,value:value}).then(function(result){_this21.onLoadMain({url:_url,mobxrouteurl:result.route||'',target:target});});}else if(from=='fullSearch'){if(_url.indexOf('QuickSearchOperation.jsp')!=-1){_url+='&fromES=1&contentType='+_contentType;}this.onLoadMain({url:_url,target:target});}}},{key:'onRcmdSearch',value:function onRcmdSearch(value){var _this22=this;var frontEndMenu=this.frontEndMenu;var quickSearchMenus=[];var loop=function loop(moduleId,moduleName,item){var child=item.child;if(child&&child.length){for(var i=0,len=child.length;i<len;i++){var _child$i=child[i],_child$i$name=_child$i.name,name=_child$i$name===undefined?'':_child$i$name,_child$i$pinyin=_child$i.pinyin,pinyin=_child$i$pinyin===undefined?'':_child$i$pinyin;if(name.toLowerCase().indexOf(value.toLowerCase())!=-1||pinyin.indexOf(value.toLowerCase())!=-1){child[i].moduleId=moduleId;child[i].moduleName=moduleName;quickSearchMenus.push(child[i]);}loop(moduleId,moduleName,child[i]);}}};frontEndMenu.forEach(function(item){var moduleId=item.infoId||'';var moduleName=item.name||'';var _item$name=item.name,name=_item$name===undefined?'':_item$name,_item$pinyin=item.pinyin,pinyin=_item$pinyin===undefined?'':_item$pinyin;if(name.toLowerCase().indexOf(value.toLowerCase())!=-1||pinyin.indexOf(value.toLowerCase())!=-1){item.moduleId=moduleId;item.moduleName=moduleId;}loop(moduleId,moduleName,item);});this.quickSearchMenus=quickSearchMenus;if(this.quickSearchShowWs){THEME_API.getWsAssociate({key:value}).then(function(data){_this22.quickSearchAssociate=data.result||[];});}}},{key:'onLoadEmailMenu',value:function onLoadEmailMenu(){var _this23=this;THEME_API.getEmailMenu().then(function(result){var leftMenu=(0,_themeUtil.formatMenuData)(result,'536');_this23.leftMenuObj=(0,_extends3.default)({},_this23.leftMenuObj,{leftMenu:leftMenu});});}},{key:'onClearEmail',value:function onClearEmail(leftMenuSelected){var _this24=this;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(384163,'确定要清空该文件夹下的邮件吗？'),onOk:function onOk(){THEME_API.onClearEmail().then(function(){_this24.onLeftMenuSelectedChange(leftMenuSelected);_this24.onLoadMain(leftMenuSelected);window.weaEmail&&window.weaEmail.store&&window.weaEmail.store.emailOpsStore&&window.weaEmail.store.emailOpsStore.getEmailSize&&window.weaEmail.store.emailOpsStore.getEmailSize();});}});}},{key:'onLoadLeftMenuCount',value:function onLoadLeftMenuCount(){var levelid='';jQuery('span[id^="num_"]').each(function(){var id=jQuery(this).attr('id');if(!/portal/.test(id)){// 非门户菜单
if(levelid==''){levelid=id.replace(/\D/g,'');}else{levelid=levelid+','+id.replace(/\D/g,'');}}});if(levelid){_ecCom.WeaTools.callApi('/workflow/request/menuCount.jsp','POST',{levelid:levelid}).then(function(result){try{for(var key in result){jQuery('#'+key).html(result[key]);}}catch(e){}});}}},{key:'onThemeChange',value:function onThemeChange(params,callback){var _this25=this;THEME_API.setMyTheme(params).then(function(result){var _result$data14=result.data,data=_result$data14===undefined?{}:_result$data14;var themeType=data.themeType,_data$themeData=data.themeData,themeData=_data$themeData===undefined?{}:_data$themeData,_data$layoutData=data.layoutData,layoutData=_data$layoutData===undefined?{}:_data$layoutData,themeLayoutType=data.themeLayoutType;var themeInfo=data;if(themeType=='ecology9'){var _themeData$styleConfi3=themeData.styleConfig,styleConfig=_themeData$styleConfi3===undefined?'{}':_themeData$styleConfi3;themeInfo=(0,_extends3.default)({},data,{themeData:(0,_extends3.default)({},themeData,{styleConfig:JSON.parse(styleConfig.replace(/&quot;/g,'"'))})});}else if(themeType=='ECustom'||themeType=='tsECustom'){var _layoutData$layoutSet2=layoutData.layoutSetting,layoutSetting=_layoutData$layoutSet2===undefined?'{}':_layoutData$layoutSet2;themeInfo=(0,_extends3.default)({},data,{layoutData:(0,_extends3.default)({},layoutData,{layoutSetting:JSON.parse(layoutSetting)})});}else if(themeType=='ecology8'){themeInfo.themeLayoutType='1';_this25.setThemeInfo(themeInfo);}_this25.pluginReload=true;_this25.onLoadTheme(themeInfo);if(themeLayoutType!='5'&&themeType!='ECustom'){var leftMenuSelected=_this25.leftMenuObj.leftMenuSelected;_this25.onLoadMain(leftMenuSelected);}if(callback&&typeof callback=='function'){callback();}});}},{key:'onThemeTsChange',value:function onThemeTsChange(params,callback){var _this26=this;THEME_API.setMyThemeTs(params).then(function(result){var _result$data15=result.data,data=_result$data15===undefined?{}:_result$data15;var themeType=data.themeType,_data$layoutData2=data.layoutData,layoutData=_data$layoutData2===undefined?{}:_data$layoutData2;if(themeType=='ECustom'){var _layoutData$layoutSet3=layoutData.layoutSetting,layoutSetting=_layoutData$layoutSet3===undefined?'{}':_layoutData$layoutSet3;data.layoutData=(0,_extends3.default)({},layoutData,{layoutSetting:JSON.parse(layoutSetting)});}_this26.onLoadTheme(result.data);var leftMenuSelected=_this26.leftMenuObj.leftMenuSelected;_this26.onLoadMain(leftMenuSelected);if(callback&&typeof callback=='function'){callback();}});}},{key:'onColorChange',value:function onColorChange(params,callback){var _this27=this;THEME_API.setMyThemeColor(params).then(function(){var themeInfo=(0,_extends3.default)({},_this27.themeInfo,{themeData:{cssfile:params.color}});_this27.onLoadTheme(themeInfo);if(callback&&typeof callback=='function'){callback();}});}},{key:'onLayoutChange',value:function onLayoutChange(params,callback){var _this28=this;var type=params.type;THEME_API.setMyThemeLayout({layout:type}).then(function(){var themeInfo=(0,_extends3.default)({},_this28.themeInfo,{themeLayoutType:type});if(type=='5'){themeInfo.themeType='ecology9';// themeInfo.themeData = {};
}_this28.pluginReload=true;_this28.onLoadTheme(themeInfo);if(callback&&typeof callback=='function'){callback();}});}},{key:'onFontSizeChange',value:function onFontSizeChange(fontSize){var _this29=this;(0,_themeUtil.setFontSize)(fontSize);THEME_API.setMyFontSize({fontSize:fontSize}).then(function(){var themeInfo=(0,_extends3.default)({},_this29.themeInfo,{themeFontSize:fontSize});_this29.themeInfo=themeInfo;_ecCom.WeaTools.ls.set('theme-themeInfo',themeInfo);});}},{key:'onLangChange',value:function onLangChange(langId,langText){THEME_API.changeLang({languageId:langId}).then(function(){(0,_loginUtil.initLSValue)();(0,_loginUtil.setLSValue)('login','langId',langId);(0,_loginUtil.setLSValue)('login','langText',langText);_ecCom.WeaTools.ls.set('languageidweaver',langId);window.location.reload();});}},{key:'addMenuIds',value:function addMenuIds(mobxrouteurl){// 添加选中的菜单id参数，用于刷新浏览器时定位选中菜单。
if(mobxrouteurl&&mobxrouteurl.indexOf('menuIds')==-1){var menuIds=this.selectedMenuIds||'';if(menuIds){if(mobxrouteurl.indexOf('?')!=-1){mobxrouteurl+='&menuIds='+menuIds;}else{mobxrouteurl+='?menuIds='+menuIds;}}}return mobxrouteurl;}},{key:'addMenuPathIds',value:function addMenuPathIds(mobxrouteurl,menuPathIds,topId){// 添加菜单路径id参数，用于自动化测试定位菜单。
if(mobxrouteurl&&mobxrouteurl.indexOf('menuPathIds')==-1){if(menuPathIds){if(mobxrouteurl.indexOf('?')!=-1){mobxrouteurl+='&menuPathIds='+(topId=='0'||topId=='536'?topId+','+menuPathIds:menuPathIds);}else{mobxrouteurl+='?menuPathIds='+(topId=='0'||topId=='536'?topId+','+menuPathIds:menuPathIds);}}}return mobxrouteurl;}},{key:'addHideParams',value:function addHideParams(mobxrouteurl){// 添加隐藏主题顶部和左侧参数
var _searchParams=this.searchParams,hideHeader=_searchParams.hideHeader,hideAside=_searchParams.hideAside;if(hideHeader){if(mobxrouteurl.indexOf('?')!=-1){mobxrouteurl+='&hideHeader='+hideHeader;}else{mobxrouteurl+='?hideHeader='+hideHeader;}}if(hideAside){if(mobxrouteurl.indexOf('?')!=-1){mobxrouteurl+='&hideAside='+hideAside;}else{mobxrouteurl+='?hideAside='+hideAside;}}return mobxrouteurl;}},{key:'onLoadMain',value:function onLoadMain(obj){var _obj$url=obj.url,url=_obj$url===undefined?'':_obj$url,_obj$mobxrouteurl=obj.mobxrouteurl,mobxrouteurl=_obj$mobxrouteurl===undefined?'':_obj$mobxrouteurl,_obj$target=obj.target,target=_obj$target===undefined?'mainFrame':_obj$target,_obj$topId=obj.topId,topId=_obj$topId===undefined?'':_obj$topId,_obj$pathIds=obj.pathIds,pathIds=_obj$pathIds===undefined?'':_obj$pathIds;if(target!='mainFrame'){if(url&&url!='javascript:void(0);'){window.open((0,_pathUtil.addContentPath)(url),target);}}else{// 当路由地址不存在时，调用工具方法，解析单页地址中的路由地址
if(!mobxrouteurl&&url&&url!='javascript:void(0);'){var urlObj=_ecCom.WeaTools.checkStdRouter(/\.(html|jsp)/.test(url)?(0,_pathUtil.addContentPath)(url):url)||{};if(urlObj.isRouter&&urlObj.url){mobxrouteurl=urlObj.url;}}if(mobxrouteurl){document.getElementById('themeLayoutFrame').style.visibility='hidden';document.getElementById('themeLayoutRoute').style.display='block';document.getElementById('mainFrame').src='about:blank';mobxrouteurl=this.addMenuIds(mobxrouteurl);mobxrouteurl=this.addMenuPathIds(mobxrouteurl,pathIds,topId);mobxrouteurl=this.addHideParams(mobxrouteurl);if(/^\/main/.test(mobxrouteurl)){weaHistory.push({pathname:mobxrouteurl});}else{weaHistory.push({pathname:'/main'+mobxrouteurl});}}else if(url&&url!='javascript:void(0);'){mobxrouteurl='/main';mobxrouteurl=this.addMenuIds(mobxrouteurl);mobxrouteurl=this.addMenuPathIds(mobxrouteurl,pathIds,topId);mobxrouteurl=this.addHideParams(mobxrouteurl);weaHistory.push({pathname:mobxrouteurl});url=url.replace(/(jsp#)|(html#)/g,function(item){return item.replace(/(jsp)|(html)/g,function(type){return type+'?__random__='+Date.now();});});document.getElementById('mainFrame').src=(0,_pathUtil.addContentPath)(url);document.getElementById('themeLayoutFrame').style.visibility='visible';document.getElementById('themeLayoutRoute').style.display='none';}}// 多语言监测
var multiLangs=this.multiLangs;var languageidweaver=_ecCom.WeaTools.ls.getStr('languageidweaver');if(multiLangs&&multiLangs.length>1&&languageidweaver){_ecCom.WeaTools.checkLang&&_ecCom.WeaTools.checkLang();}}},{key:'onLogout',value:function onLogout(){_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(16628,'确定要退出系统吗？'),onOk:function onOk(){// 执行退出前事件
(0,_eventUtil.doEvent)('beforLogout',function(){LOGIN_API.logout().then(function(result){// 退出时修改清除缓存标识
_ecCom.WeaTools.ls.set('isInitLSValue',false);_ecCom.WeaTools.ls.set('ennableTrans',0);// 执行退出成功后事件
(0,_eventUtil.doEvent)('afterLogout',function(){// 退出成功回调
if(window.onLogoutCallback&&typeof window.onLogoutCallback=='function'){window.onLogoutCallback();}_ecCom.WeaTools.ssoLogout(result,false);});});});}});}}]);return ThemeStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'pluginloading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'customloading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'searchParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'pluginIds',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'pluginInsertCount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'pluginReload',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'multiLangs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'langId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'themeInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'frontEndMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'topMenuObj',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{topMenu:[],topMenuSelected:{}};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'topMenuVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'leftMenuObj',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{leftMenu:[],leftMenuSelected:{},leftMenuType:'portal'// portal | email
};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'leftMenuMode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'vertical';}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'selectedMenuIds',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'selectedMenuKeys',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'hiddenMyPortal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'showFreqUseMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'freqUseMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'freqUseMenuVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'showQuickSearch',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'quickSearchTypes',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'quickSearchTypesVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'quickSearchTypesSelected',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'quickSearchMenus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'quickSearchAssociate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'quickSearchRcmdVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'quickSearchShowRcmd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'quickSearchShowWs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'toolbarMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'toolbarMoreMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'toolbarMoreMenuVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'account',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'accountVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'accountSize',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'accountList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'accountListVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'accountMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor40=_applyDecoratedDescriptor(_class.prototype,'accountMoreMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor41=_applyDecoratedDescriptor(_class.prototype,'fontSettingVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor42=_applyDecoratedDescriptor(_class.prototype,'langSettingVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor43=_applyDecoratedDescriptor(_class.prototype,'translatepower',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor44=_applyDecoratedDescriptor(_class.prototype,'translatepage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class.prototype,'doBeforThemeRenderEvent',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'doBeforThemeRenderEvent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'doAfterThemeRenderEvent',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'doAfterThemeRenderEvent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setThemeInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setThemeInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getThemeInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getThemeInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLoadTheme',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLoadTheme'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLoadECustomTheme',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLoadECustomTheme'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getMultiLangs',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getMultiLangs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTranslatepower',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTranslatepower'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTranslatepage',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTranslatepage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTranslatepage',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setTranslatepage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getFrontEndMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getFrontEndMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getThemeConfig',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getThemeConfig'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getPlugins',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getPlugins'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'removePlugins',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'removePlugins'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTopMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTopMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getHome',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getHome'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onTopMenuVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onTopMenuVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onTopMenuSelectedChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onTopMenuSelectedChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTopMenuStatictics',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setTopMenuStatictics'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLeftMenuModeChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLeftMenuModeChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLeftMenuSelectedChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLeftMenuSelectedChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onSelectedMenuKeysChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onSelectedMenuKeysChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getFreqUseMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getFreqUseMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onFreqUseMenuVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onFreqUseMenuVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getQuickSearchTypes',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getQuickSearchTypes'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQuickSearchTypesVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQuickSearchTypesVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQuickSearchTypesSelectedChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQuickSearchTypesSelectedChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQuickSearchRcmdVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQuickSearchRcmdVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setQuickSearchShowRcmd',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setQuickSearchShowRcmd'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getToolbarMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getToolbarMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getToolbarMoreMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getToolbarMoreMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onToolbarMoreMenuVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onToolbarMoreMenuVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getAccount',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getAccount'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onAccountChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onAccountChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onAccountVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onAccountVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getAccountList',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getAccountList'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onAccountListVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onAccountListVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getAccountMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getAccountMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getAccountMoreMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getAccountMoreMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onFontSettingVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onFontSettingVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLangSettingVisibleChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLangSettingVisibleChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onQuickSearch',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onQuickSearch'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onRcmdSearch',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onRcmdSearch'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLoadEmailMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLoadEmailMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onClearEmail',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onClearEmail'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLoadLeftMenuCount',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLoadLeftMenuCount'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onThemeChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onThemeChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onThemeTsChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onThemeTsChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onColorChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onColorChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLayoutChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLayoutChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onFontSizeChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onFontSizeChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLangChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLangChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLoadMain',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLoadMain'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLogout',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onLogout'),_class.prototype)),_class);exports.default=ThemeStore;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148), __webpack_require__(111)(module)))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(38);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(68);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(14);var _ecCom=__webpack_require__(7);var _theme=__webpack_require__(149);var THEME_API=_interopRequireWildcard(_theme);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var IntroStore=(_class=function(){function IntroStore(){(0,_classCallCheck3.default)(this,IntroStore);_initDefineProp(this,'intro_step',_descriptor,this);}(0,_createClass3.default)(IntroStore,[{key:'onIntroStepChange',value:function onIntroStepChange(intro_step){this.intro_step=(0,_assign2.default)({},this.intro_step,intro_step);}},{key:'getPortalIntroInfo',value:function getPortalIntroInfo(portalThemeStore){var _this=this;this.interval=window.setInterval(function(){var topMenuObj=portalThemeStore.topMenuObj,_portalThemeStore$sho=portalThemeStore.showFreqUseMenu,showFreqUseMenu=_portalThemeStore$sho===undefined?true:_portalThemeStore$sho,_portalThemeStore$too=portalThemeStore.toolbarMoreMenu,toolbarMoreMenu=_portalThemeStore$too===undefined?[]:_portalThemeStore$too;var _topMenuObj$topMenu=topMenuObj.topMenu,topMenu=_topMenuObj$topMenu===undefined?[]:_topMenuObj$topMenu;if(topMenu.length>0){clearInterval(_this.interval);THEME_API.getPortalIntroInfo().then(function(result){if(result=='1'){var onend=function onend(){_this.onIntroStepChange({intro1:false,intro3:false,intro4:false,intro5:false,intro6:false});portalThemeStore.onTopMenuVisibleChange(false);portalThemeStore.onFreqUseMenuVisibleChange(false);portalThemeStore.onToolbarMoreMenuVisibleChange(false);portalThemeStore.onAccountVisibleChange(false);THEME_API.setPortalIntroInfo({firstLoad:'0'});};_this.onIntroStepChange({intro1:true});portalThemeStore.onTopMenuVisibleChange(true);portal_intro.onnextbuttonclick(function(step){if(step===1){_this.onIntroStepChange({intro1:false});portalThemeStore.onTopMenuVisibleChange(false);return true;}else if(step===2){if(showFreqUseMenu){_this.onIntroStepChange({intro3:true});portalThemeStore.onFreqUseMenuVisibleChange(true);}else if(toolbarMoreMenu.length>0){_this.onIntroStepChange({intro4:true});portalThemeStore.onToolbarMoreMenuVisibleChange(true);}else{_this.onIntroStepChange({intro5:true});portalThemeStore.onAccountVisibleChange(true);_this.onIntroStepChange({intro5:true});}return false;}else if(step===3){if(toolbarMoreMenu.length>0){_this.onIntroStepChange({intro3:false,intro4:true});portalThemeStore.onFreqUseMenuVisibleChange(false);portalThemeStore.onToolbarMoreMenuVisibleChange(true);}else{_this.onIntroStepChange({intro3:false,intro5:true});portalThemeStore.onFreqUseMenuVisibleChange(false);portalThemeStore.onAccountVisibleChange(true);_this.onIntroStepChange({intro3:false,intro5:true});}return false;}else if(step===4){_this.onIntroStepChange({intro4:false,intro5:true});portalThemeStore.onToolbarMoreMenuVisibleChange(false);portalThemeStore.onAccountVisibleChange(true);_this.onIntroStepChange({intro4:false,intro5:true});return false;}});portal_intro.oncomplete(onend);portal_intro.onexit(onend);portal_intro.setOptions({steps:[{element:'#portal-intro1',intro:getLabel(503580,'点击这里可选择系统所有的应用模块')},{element:'#portal-intro2',intro:getLabel(503581,'应用模块的下级菜单均在左侧菜单显示。点击这里可显示/隐藏左侧菜单')},{element:'#portal-intro3',intro:getLabel(503582,'点这里，你可以将自己最常使用的操作菜单设置为快捷操作菜单')},{element:'#portal-intro4',intro:getLabel(503584,'点击进入后台设置')},{element:'#portal-intro5',intro:getLabel(503583,'换肤、修改密码、切换账号…  所有的个性设置都在这里')}]});portal_intro.refresh();// 刷新队列
}});}},500);}}]);return IntroStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'intro_step',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{intro1:false,intro3:false,intro4:false,intro5:false,intro6:false};}}),_applyDecoratedDescriptor(_class.prototype,'onIntroStepChange',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onIntroStepChange'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getPortalIntroInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getPortalIntroInfo'),_class.prototype)),_class);exports.default=IntroStore;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(38);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(68);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _stringify=__webpack_require__(112);var _stringify2=_interopRequireDefault(_stringify);var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(14);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var DeskTopStore=(_class=function(){// 列数固定为7
function DeskTopStore(){(0,_classCallCheck3.default)(this,DeskTopStore);_initDefineProp(this,'colNum',_descriptor,this);_initDefineProp(this,'state',_descriptor2,this);_initDefineProp(this,'add_state',_descriptor3,this);this.getDatas=this.getDatas.bind(this);this.setState=this.setState.bind(this);this.setAddState=this.setAddState.bind(this);this.onAddSave=this.onAddSave.bind(this);this.onSave=this.onSave.bind(this);this.onSynchronize=this.onSynchronize.bind(this);this.onDelete=this.onDelete.bind(this);this.deleteToReal=this.deleteToReal.bind(this);this.deleteToMore=this.deleteToMore.bind(this);this.setColor=this.setColor.bind(this);this.addBgImage=this.addBgImage.bind(this);this.delBgImage=this.delBgImage.bind(this);}(0,_createClass3.default)(DeskTopStore,[{key:'getDatas',value:function getDatas(){var _this=this;_ecCom.WeaTools.callApi('/api/portal/desktop/datas','POST',{}).then(function(result){_this.setState(result);});}},{key:'setState',value:function setState(state){var _state=(0,_assign2.default)({},this.state,state);this.state=_state;if(state.isSystemer===undefined&&(state.imgid!==undefined||state.bgImages!==undefined||state.autoCarousel!==undefined||state.carouselTime!==undefined)){var imgid=_state.imgid,bgImages=_state.bgImages,autoCarousel=_state.autoCarousel,carouselTime=_state.carouselTime;_ecCom.WeaTools.callApi('/api/portal/desktop/update','POST',{imgid:imgid,bgImages:(0,_stringify2.default)(bgImages),autoCarousel:autoCarousel,carouselTime:carouselTime});}}},{key:'setState2',value:function setState2(state){this.state=(0,_assign2.default)({},this.state,state);}},{key:'setAddState',value:function setAddState(add_state){this.add_state=(0,_assign2.default)({},this.add_state,add_state);}},{key:'setColor',value:function setColor(color){var _this2=this;var bgImages=[].concat((0,_toConsumableArray3.default)(this.state.bgImages));var _bgImages=bgImages.map(function(item){if(item.id==_this2.state.imgid){item.color=color;}return item;});this.setState({bgImages:_bgImages});}},{key:'addBgImage',value:function addBgImage(imgsrc){var _this3=this;_ecCom.WeaTools.callApi('/api/portal/desktop/addBgImage','POST',{imgsrc:imgsrc}).then(function(result){if(result.imgsrc){var bgImages=[].concat((0,_toConsumableArray3.default)(_this3.state.bgImages));bgImages.push(result);if(_this3.state.bgImages.length){_this3.setState({bgImages:bgImages});_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(387134,'添加成功，是否替换背景？'),onOk:function onOk(){_this3.setState({imgid:result.id});}});}else{_this3.setState({imgid:result.id,bgImages:bgImages});}}else{_antd.message.error(getLabel(31877,'添加失败！'),3);}});}},{key:'delBgImage',value:function delBgImage(params){var _this4=this;var _bgImages=(0,_mobx.toJS)(this.state.bgImages);var bgImages=[];_bgImages.forEach(function(item){if(item.id!=params.id){bgImages.push(item);}});var imgid=this.state.imgid;if(imgid==params.id){if(bgImages.length){imgid=bgImages[0].id;}else{imgid='';}}_ecCom.WeaTools.callApi('/api/portal/desktop/delBgImage','POST',(0,_extends3.default)({},params,{imgid:imgid})).then(function(result){if(result.api_status=='success'){_this4.setState({imgid:imgid,bgImages:bgImages});_antd.message.success(getLabel(83472,'删除成功！'),3);}else{_antd.message.error(getLabel(83473,'删除失败！'),3);}});}},{key:'onSynchronize',value:function onSynchronize(subids){if(subids){this.onSave(subids);}}},{key:'onSave',value:function onSave(subids){var _this5=this;var _state2=this.state,datas=_state2.datas,moreDatas=_state2.moreDatas;var sortList=[];datas.map(function(item){sortList.push({id:item.id,ismore:'0'});});moreDatas.map(function(item){sortList.push({id:item.id,ismore:'1'});});_ecCom.WeaTools.callApi('/api/portal/desktop/sortMenuList','POST',{subids:subids,sortList:(0,_stringify2.default)(sortList)}).then(function(result){if(result.api_status=='success'){_this5.setState({isSetting:false});_antd.message.success(''+(subids?getLabel(387135,'同步成功！'):getLabel(83551,'保存成功！')),3);}else{_antd.message.error(''+(subids?getLabel(387136,'同步失败！'):getLabel(84544,'保存失败！')),3);}});}},{key:'onAddSave',value:function onAddSave(){var _this6=this;var _add_state=this.add_state,id=_add_state.id,menuid=_add_state.menuid,menutype=_add_state.menutype,menuname=_add_state.menuname,menuicon=_add_state.menuicon,url=_add_state.url,unreadapiaddr=_add_state.unreadapiaddr,replaceData=_add_state.replaceData;var isError=false;if(menutype=='1'){if(!menuid)isError=true;}else if(!url.trim())isError=true;if(!menuname.trim())isError=true;if(isError){_antd.message.warning(getLabel(15859,'必要信息不完整！'));return;}var updateMenu=function updateMenu(){_ecCom.WeaTools.callApi('/api/portal/desktop/updateMenu','POST',{id:id,menuid:menuid,menutype:menutype,menuname:menuname,menuicon:menuicon,url:url,unreadapiaddr:unreadapiaddr}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(83551,'保存成功！'),3);_this6.getDatas();var _state3=_this6.state,isSystemer=_state3.isSystemer,maxid=_state3.maxid;var obj={id:id,menuid:menuid,menutype:menutype,menuname:menuname,menuicon:menuicon,url:url,unreadapiaddr:unreadapiaddr,replaceData:replaceData};obj.createtype=isSystemer?'sys':'cus';var datas=[].concat((0,_toConsumableArray3.default)(_this6.state.datas));if(id){var index=datas.length;for(var i=0;i<datas.length;i++){var item=datas[i];if(item.id==id){index=i;break;}}datas.splice(index,1,obj);}else{obj.id=''+(maxid+1);datas.push(obj);}_this6.setState({maxid:maxid,datas:datas});_this6.setAddState({visible:false});}else{_antd.message.error(getLabel(84544,'保存失败！'),3);}});};if(unreadapiaddr){_ecCom.WeaTools.callApi(unreadapiaddr,'POST').then(function(result){if(result.count!==''&&result.count!==null&&!isNaN(result.count)){updateMenu();}else{_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(387137,'未读数接口地址返回的数据格式错误！')});}}).catch(function(){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(387138,'未读数接口地址不正确！')});});}else{updateMenu();}}},{key:'onDelete',value:function onDelete(index,item){var _this7=this;var isSystemer=this.state.isSystemer;var createtype=item.createtype;if(isSystemer||createtype=='cus'){var deleteType=1;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:React.createElement('div',null,React.createElement('div',{style:{height:'30px',lineHeight:'30px',textAlign:'center'}},React.createElement('span',null,getLabel(387139,'您是想要将此应用'))),React.createElement('div',{style:{height:'30px',lineHeight:'30px',textAlign:'center'}},React.createElement(RadioGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_RadioGroup@r1fcah',defaultValue:1,onChange:function onChange(e){return deleteType=e.target.value;}},React.createElement(_antd.Radio,{ecId:(this&&this.props&&this.props.ecId||'')+'_Radio@zipv9a',key:'1',value:1},getLabel(387140,'移至更多')),React.createElement(_antd.Radio,{ecId:(this&&this.props&&this.props.ecId||'')+'_Radio@m0l52l',key:'2',value:2},getLabel(81291,'彻底删除'))))),onOk:function onOk(){if(deleteType==1){_this7.deleteToMore(index);}else{_this7.deleteToReal(index);}}});}else{this.deleteToMore(index);}}},{key:'deleteToReal',value:function deleteToReal(index){var _this8=this;var datas=[].concat((0,_toConsumableArray3.default)(this.state.datas));var deleteDatas=datas.splice(index,1);var id=deleteDatas[0].id;_ecCom.WeaTools.callApi('/api/portal/desktop/delMenu','POST',{id:id}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(83472,'删除成功！'),3);_this8.setState({datas:datas});}else{_antd.message.error(getLabel(83473,'删除失败！'),3);}});}},{key:'deleteToMore',value:function deleteToMore(index){var _this9=this;var datas=[].concat((0,_toConsumableArray3.default)(this.state.datas));var deleteDatas=datas.splice(index,1);deleteDatas[0].ismore='1';var moreDatas=[].concat((0,_toConsumableArray3.default)(this.state.moreDatas));moreDatas.push(deleteDatas[0]);var sortList=[];datas.map(function(item){sortList.push({id:item.id,ismore:'0'});});moreDatas.map(function(item){sortList.push({id:item.id,ismore:'1'});});_ecCom.WeaTools.callApi('/api/portal/desktop/sortMenuList','POST',{sortList:(0,_stringify2.default)(sortList)}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(384404,'移动成功！'),3);_this9.setState({datas:datas,moreDatas:moreDatas});}else{_antd.message.error(getLabel(384405,'移动失败！'),3);}});}},{key:'bgImageObj',get:function get(){var _state4=this.state,imgid=_state4.imgid,bgImages=_state4.bgImages;var _bgImages=(0,_mobx.toJS)(bgImages);var bgImageObj={};for(var i=0,len=_bgImages.length;i<len;i++){if(_bgImages[i].id==imgid){bgImageObj=(0,_extends3.default)({},_bgImages[i],{initialSlide:i});break;}}return bgImageObj;}}]);return DeskTopStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'colNum',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 7;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'state',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{isSetting:false,// 是否为设置模式
isSystemer:false,// 是否为维护者
maxid:1,// 应用菜单最大id
datas:[],// 应用菜单列表
moreDatas:[],// 更多菜单列表
moreDatasVisible:false,rowNum:3,// 显示行数
current:0,// 显示页
menu_w_h:0,bgImagesVisible:false,imgid:'',// 背景图片id
bgImages:[],// 背景图片列表
autoCarousel:false,// 是否启用自动轮播
carouselTime:3// 轮播时间
};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'add_state',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,id:'',// 应用菜单id，为空时添加，不为空时编辑
menuid:'',// 菜单id
menutype:'1',// 菜单地址类型，1：系统菜单，2：自定义URL
menuname:'',// 显示名称
langmenuname:'',menuicon:'',// 图标地址
url:'',// 自定义URL
unreadapiaddr:'',// 未读数接口地址
replaceData:[]// 菜单浏览按钮默认值
};}}),_applyDecoratedDescriptor(_class.prototype,'bgImageObj',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'bgImageObj'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getDatas',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getDatas'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setState',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setState'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setState2',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setState2'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setAddState',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setAddState'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setColor',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setColor'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addBgImage',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'addBgImage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'delBgImage',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'delBgImage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onSynchronize',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onSynchronize'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onSave',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onSave'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onAddSave',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onAddSave'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onDelete',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'onDelete'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'deleteToReal',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'deleteToReal'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'deleteToMore',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'deleteToMore'),_class.prototype)),_class);exports.default=DeskTopStore;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9Login=__webpack_require__(203);var _E9Login2=_interopRequireDefault(_E9Login);var _loginUtil=__webpack_require__(110);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Login=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Login,_React$Component);function Login(){(0,_classCallCheck3.default)(this,Login);return(0,_possibleConstructorReturn3.default)(this,(Login.__proto__||(0,_getPrototypeOf2.default)(Login)).apply(this,arguments));}(0,_createClass3.default)(Login,[{key:'componentWillMount',value:function componentWillMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var templateType=state.templateType;// 加载自定义登录组件
if(templateType=='ECustom'){var _state$layoutData=state.layoutData,layoutData=_state$layoutData===undefined?{}:_state$layoutData;portalLoginStore.onLoadECustomLogin(layoutData);}var queryParams=(0,_loginUtil.getQueryParams)();portalLoginStore.setQueryParams(queryParams);portalLoginStore.getUpgradeInfo(queryParams);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var portalLoginStore=nextProps.portalLoginStore;var queryParams=(0,_loginUtil.getQueryParams)();portalLoginStore.setQueryParams(queryParams);}},{key:'render',value:function render(){var portalLoginStore=this.props.portalLoginStore;var updatestatus=portalLoginStore.updatestatus,casstatus=portalLoginStore.casstatus,_portalLoginStore$sta2=portalLoginStore.state,state=_portalLoginStore$sta2===undefined?{}:_portalLoginStore$sta2,customloading=portalLoginStore.customloading,beforLoginRenderEventStatus=portalLoginStore.beforLoginRenderEventStatus;var id=state.id,templateType=state.templateType,_state$layoutData2=state.layoutData,layoutData=_state$layoutData2===undefined?{}:_state$layoutData2;if(updatestatus!='0'||casstatus!='0'||!id||!beforLoginRenderEventStatus){return _react2.default.createElement('div',null);}if(templateType=='ECustom'){var layoutId=layoutData.layoutId,layoutType=layoutData.layoutType,layoutCustom=layoutData.layoutCustom,_layoutData$layoutCon=layoutData.layoutConfig,layoutConfig=_layoutData$layoutCon===undefined?{}:_layoutData$layoutCon,layoutUUID=layoutData.layoutUUID;if(layoutCustom=='1'){// 使用自定义登录组件
if(customloading&&window[layoutConfig.module]){var ECustomLogin=window[layoutConfig.module].com[layoutConfig.component];return _react2.default.createElement(ECustomLogin,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_ECustomLogin@i9kkd0'},this.props));}if(window.rewritePortalLogin&&typeof window.rewritePortalLogin=='function'){return window.rewritePortalLogin((0,_extends3.default)({},this.props),{id:layoutUUID});}return _react2.default.createElement('div',null);}// 使用特色门户布局
if(customloading&&window.weaPortalPublic){var WeaPortalLayout=window.weaPortalPublic.WeaPortalLayout;return _react2.default.createElement(WeaPortalLayout,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPortalLayout@s4ke32',id:layoutId,layoutId:layoutId,layoutType:layoutType},this.props));}return _react2.default.createElement('div',null);}return _react2.default.createElement(_E9Login2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Login@7ii7e5'});}}]);return Login;}(_react2.default.Component))||_class)||_class);exports.default=Login;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);__webpack_require__(204);var _E9MultiLang=__webpack_require__(206);var _E9MultiLang2=_interopRequireDefault(_E9MultiLang);var _E9Form=__webpack_require__(207);var _E9Form2=_interopRequireDefault(_E9Form);var _E9QRCode=__webpack_require__(208);var _E9QRCode2=_interopRequireDefault(_E9QRCode);var _E9BgImageBox=__webpack_require__(216);var _E9BgImageBox2=_interopRequireDefault(_E9BgImageBox);var _E9Custom=__webpack_require__(217);var _E9Custom2=_interopRequireDefault(_E9Custom);var _LoginBtn=__webpack_require__(219);var _LoginBtn2=_interopRequireDefault(_LoginBtn);var _formCloud=__webpack_require__(155);var _formCloud2=_interopRequireDefault(_formCloud);var _formCloud3=__webpack_require__(156);var _formCloud4=_interopRequireDefault(_formCloud3);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Login=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Login,_React$Component);function E9Login(props){(0,_classCallCheck3.default)(this,E9Login);return(0,_possibleConstructorReturn3.default)(this,(E9Login.__proto__||(0,_getPrototypeOf2.default)(E9Login)).call(this,props));}(0,_createClass3.default)(E9Login,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onWindowResize();}},{key:'render',value:function render(){var portalLoginStore=this.props.portalLoginStore;var loading=portalLoginStore.loading,labelObj=portalLoginStore.labelObj,state=portalLoginStore.state,setState=portalLoginStore.setState,setStateAndCache=portalLoginStore.setStateAndCache,getElementStyle=portalLoginStore.getElementStyle;var templateType=state.templateType,win_width=state.win_width,win_height=state.win_height,_state$bgImagesInfo=state.bgImagesInfo,bgImagesInfo=_state$bgImagesInfo===undefined?[]:_state$bgImagesInfo,_state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,loginType=state.loginType,initialSlide=state.initialSlide,autoCarousel=state.autoCarousel,carouselTime=state.carouselTime;var loginInfo=loginSettingInfo.loginInfo,loginForm=loginSettingInfo.loginForm,qrcode=loginSettingInfo.qrcode;var _loginInfo$bgType=loginInfo.bgType,bgType=_loginInfo$bgType===undefined?'img':_loginInfo$bgType,videosrc=loginInfo.videosrc,_loginInfo$videowidth=loginInfo.videowidth,videowidth=_loginInfo$videowidth===undefined?1920:_loginInfo$videowidth,_loginInfo$videoheigh=loginInfo.videoheight,videoheight=_loginInfo$videoheigh===undefined?1080:_loginInfo$videoheigh,bgColor=loginInfo.bgColor,bgOpacity=loginInfo.bgOpacity,showQrcode=loginInfo.showQrcode,onlyQrcode=loginInfo.onlyQrcode,showBgImageBox=loginInfo.showBgImageBox;var bgImageComp=_react2.default.createElement('div',null);var bgImageStyle=portalLoginStore.getLoginBgImageStyle(loginInfo);if(bgType=='img'){if(autoCarousel&&bgImagesInfo.length>1){var carouseImgHtml=bgImagesInfo.map(function(imgObj){bgImageStyle=(0,_assign2.default)({},bgImageStyle,{backgroundImage:'url('+(0,_pathUtil.addContentPath)(imgObj.imgsrc)+')'});return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'e9login-content'},_react2.default.createElement('div',{className:'e9login-bg-image',style:bgImageStyle})));});bgImageComp=_react2.default.createElement('div',{className:'e9login-carousel'},_react2.default.createElement(_antd.Carousel,{ecId:(this&&this.props&&this.props.ecId||'')+'_Carousel@9b9jzo',style:{height:'100%'},key:carouselTime,autoplay:true,dots:false,fade:true,speed:800,autoplaySpeed:carouselTime*1000,initialSlide:initialSlide,afterChange:function afterChange(current){return setState({initialSlide:current<0?0:current});}},carouseImgHtml));}else{bgImageComp=_react2.default.createElement('div',{className:'e9login-bg-image',style:portalLoginStore.getLoginBgImageStyle(loginInfo)});}}else if(bgType=='video'&&videosrc){var o=win_width<800?800:win_width;var r=win_height<660?660:win_height;var s=o;var l=o*videoheight/videowidth;if(r>l){l=r;s=r*videowidth/videoheight;}var p=l-r;var u=s-o;var c=-(Math.abs(p)/2);var d=-(Math.abs(u)/2);var style={position:'absolute',width:s+'px',height:l+'px',top:c+'px',left:d+'px'};bgImageComp=_react2.default.createElement('video',{muted:true,autoPlay:true,loop:true,style:style},_react2.default.createElement('source',{src:(0,_pathUtil.addContentPath)(videosrc),type:'video/mp4'}));}var formCloud=null;switch(templateType){case'E7':formCloud=_react2.default.createElement(_formCloud2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E7FormCloud@87d8bz'},this.props,{isPositionDynamicCss:true}));break;case'E8':formCloud=_react2.default.createElement(_formCloud4.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E8FormCloud@kawc52'},this.props,{isPositionDynamicCss:true}));break;default:formCloud=_react2.default.createElement(_react2.default.Fragment,{ecId:(this&&this.props&&this.props.ecId||'')+'_React.Fragment@jwnl6r'},showQrcode&&!onlyQrcode?_react2.default.createElement('div',{className:'e9login-qrcode e9login-element',style:(0,_extends3.default)({color:qrcode.color},getElementStyle(qrcode))},loginType=='form'?_react2.default.createElement('i',{className:'icon-coms-Scan',title:labelObj.smdl,onClick:function onClick(){return setStateAndCache('loginType','QRCode');}}):_react2.default.createElement('i',{className:'icon-coms-Revoke2',title:labelObj.fh,onClick:function onClick(){return setStateAndCache('loginType','form');}})):'',_react2.default.createElement('div',{className:'e9login-form-box e9login-element',style:getElementStyle(loginForm)},_react2.default.createElement(_E9MultiLang2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9MultiLang@fwtz7o'}),loginType=='form'?_react2.default.createElement(_E9Form2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Form@42jlrc'}):_react2.default.createElement(_E9QRCode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QRCode@44pjha'})),loginType=='form'?_react2.default.createElement(_LoginBtn2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LoginBtn@lv8n1r'}):'');}return _react2.default.createElement('div',{id:'LoginContainer',className:'e9login-container',onClick:function onClick(){return setState({multiLangVisible:false});}},_react2.default.createElement('div',{className:'e9login-content'},!loading&&formCloud,_react2.default.createElement('div',{className:'e9login-bg-color',style:{backgroundColor:bgColor,opacity:bgOpacity}}),bgImageComp,bgType=='img'&&showBgImageBox?_react2.default.createElement(_E9BgImageBox2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9BgImageBox@ldmk7e'}):'',_react2.default.createElement(_E9Custom2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Custom@yxeayu'})));}}]);return E9Login;}(_react2.default.Component))||_class)||_class);exports.default=E9Login;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(205);

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9MultiLang=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9MultiLang,_React$Component);function E9MultiLang(props){(0,_classCallCheck3.default)(this,E9MultiLang);return(0,_possibleConstructorReturn3.default)(this,(E9MultiLang.__proto__||(0,_getPrototypeOf2.default)(E9MultiLang)).call(this,props));}(0,_createClass3.default)(E9MultiLang,[{key:'render',value:function render(){var portalLoginStore=this.props.portalLoginStore;var multiLangs=portalLoginStore.multiLangs,state=portalLoginStore.state,setState=portalLoginStore.setState;var langId=state.langId,langText=state.langText,_state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,hasMultiLang=state.hasMultiLang,multiLangVisible=state.multiLangVisible;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=this.props.color||loginForm.color;if(!hasMultiLang){return _react2.default.createElement('div',{className:'e9login-multiLang'});}var selectedClassName='';var multiLangListComp='';if(multiLangVisible){selectedClassName='e9login-multiLangText-selected';multiLangListComp=_react2.default.createElement('div',{className:'e9login-multiLangList'},_react2.default.createElement('ul',null,multiLangs.map(function(item){return _react2.default.createElement('li',{className:item.id==langId?'e9login-multiLangList-selected':'',onClick:function onClick(){portalLoginStore.setState({langId:item.id,langText:item.language,multiLangVisible:false});portalLoginStore.getLoginForm({langId:item.id});}},item.language);})));}return _react2.default.createElement('div',{className:'e9login-multiLang'},_react2.default.createElement('span',{className:'e9login-multiLangText '+selectedClassName,style:multiLangVisible?{}:{color:color},onClick:function onClick(e){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();setState({multiLangVisible:!multiLangVisible});}},_react2.default.createElement('span',null,langText),_react2.default.createElement('i',{className:'wevicon-e9login-arrow'})),multiLangListComp);}}]);return E9MultiLang;}(_react2.default.Component))||_class)||_class);exports.default=E9MultiLang;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Form=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Form,_React$Component);function E9Form(props){(0,_classCallCheck3.default)(this,E9Form);var _this2=(0,_possibleConstructorReturn3.default)(this,(E9Form.__proto__||(0,_getPrototypeOf2.default)(E9Form)).call(this,props));_this2.getLoginForm=_this2.getLoginForm.bind(_this2);_this2.onLabelClick=_this2.onLabelClick.bind(_this2);_this2.onInputChange=_this2.onInputChange.bind(_this2);_this2.getDynamicPassword=_this2.getDynamicPassword.bind(_this2);_this2.onLogin=_this2.onLogin.bind(_this2);return _this2;}(0,_createClass3.default)(E9Form,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var portalLoginStore=this.props.portalLoginStore;var loginFormDataLoading=portalLoginStore.loginFormDataLoading;if(loginFormDataLoading){portalLoginStore.doAfterLoginRenderEvent();}var _this=this;jQuery('.e9login-form-input').unbind().keydown(function(e){e=e||window.event;var key=e.keyCode||e.which||e.charCode;if(key==13){var inputs=jQuery('.e9login-form-input');var idx=inputs.index(this);var nxtIdx=idx+1;var nxtInput=jQuery('.e9login-form-input:eq('+nxtIdx+')');if(nxtInput.length>0){nxtInput.focus();}else{_this.onLogin();}}});}},{key:'render',value:function render(){var _this3=this;var portalLoginStore=this.props.portalLoginStore;var labelObj=portalLoginStore.labelObj,state=portalLoginStore.state,dynamicPasswordTime=portalLoginStore.dynamicPasswordTime,onPasswordForget=portalLoginStore.onPasswordForget,onRememberChange=portalLoginStore.onRememberChange,onValidateCodeChange=portalLoginStore.onValidateCodeChange;var isRememberPW=state.isRememberPW,isRememberAccount=state.isRememberAccount,isRememberPassword=state.isRememberPassword,cacheAccount=state.cacheAccount,cachePassword=state.cachePassword,_state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,loginFormItems=state.loginFormItems,loginFormHiddenItems=state.loginFormHiddenItems,_state$loginSetting=state.loginSetting,loginSetting=_state$loginSetting===undefined?{}:_state$loginSetting,validateCode=state.validateCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=loginForm.color;var needforgotpassword=loginSetting.needforgotpassword,_loginSetting$validat=loginSetting.validateCodeKey,validateCodeKey=_loginSetting$validat===undefined?'':_loginSetting$validat;var validateCodeSrc=validateCode+'&validateCodeKey='+validateCodeKey;return _react2.default.createElement('div',{className:'e9login-form'},loginFormItems.map(function(item,index){var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;}else if(item.atype=='password'){defaultValue=cachePassword;}var itemComp=_react2.default.createElement('div',{key:index,className:'e9login-form-item',style:{color:color,borderBottom:'1px solid '+color}},_react2.default.createElement('i',{className:'wevicon-e9login-'+(item.atype=='account'?'account':'password')}),_react2.default.createElement('label',{className:'e9login-form-label '+(defaultValue?'e9login-display-hidden':''),onClick:_this3.onLabelClick},item.label),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e9login-form-input',defaultValue:defaultValue,onBlur:function onBlur(){return item.atype=='account'&&_this3.getLoginForm();},onChange:_this3.onInputChange}));if(_ecCom.WeaTools.ua.browser=='IE'){itemComp=_react2.default.createElement('div',{key:index,className:'e9login-form-item',style:{color:color,borderBottom:'1px solid '+color}},_react2.default.createElement('i',{className:'wevicon-e9login-'+(item.atype=='account'?'account':'password')}),_react2.default.createElement('label',{className:'e9login-form-label '+(defaultValue?'e9login-display-hidden':''),onClick:_this3.onLabelClick},item.label),_react2.default.createElement('input',{type:defaultValue?''+item.type:'text',id:item.id,name:item.name,autoComplete:'new-password',className:'e9login-form-input',onFocus:function onFocus(){$('#'+item.id)[0].type=''+item.type;_this3.type=''+item.type;},defaultValue:defaultValue,onBlur:function onBlur(){return item.atype=='account'&&_this3.getLoginForm();},onChange:_this3.onInputChange}));}if(item.atype=='dynamicPassword'){itemComp=_react2.default.createElement('div',{key:index,className:'e9login-form-item',style:{color:color,borderBottom:'1px solid '+color}},_react2.default.createElement('i',{className:'wevicon-e9login-password'}),_react2.default.createElement('label',{className:'e9login-form-label',onClick:_this3.onLabelClick},item.label),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e9login-form-input',onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e9login-form-dynamic',style:{color:color}},dynamicPasswordTime>0?_react2.default.createElement('span',{className:'e9login-form-dynamic-text',style:{color:'#ccc'}},labelObj.resend,'(',dynamicPasswordTime,'s)'):_react2.default.createElement('span',{className:'e9login-form-dynamic-text',onClick:_this3.getDynamicPassword},labelObj.send)));}if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',{key:index,className:'e9login-form-item',style:{color:color,borderBottom:'none'}},_react2.default.createElement('label',{className:'e9login-form-label e9login-form-label-vc',onClick:_this3.onLabelClick},item.label),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,className:'e9login-form-input e9login-form-input-vc',style:{border:'1px solid '+color},onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e9login-form-vc-img'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(validateCodeSrc),alt:'',onClick:onValidateCodeChange})));}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,style:{display:'none'},dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'e9login-form-remember',style:{color:color}},needforgotpassword=='1'&&_react2.default.createElement('div',{className:'e9login-form-remember-forget',title:labelObj.forgetPassword},_react2.default.createElement('span',{onClick:function onClick(){return onPasswordForget();}},labelObj.forgetPassword)),_react2.default.createElement('div',{className:'e9login-form-remember-content '+(isRememberPW=='1'?'':'e9login-display-hidden')},_react2.default.createElement('div',{className:'e9login-form-remember-account',title:labelObj.rememberAccount},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@d7cg64',checked:isRememberAccount,onChange:function onChange(e){return onRememberChange('account',e.target.checked);}},labelObj.rememberAccount)),_react2.default.createElement('div',{className:'e9login-form-remember-password',title:labelObj.rememberPassword},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@60d7og',checked:isRememberPassword,onChange:function onChange(e){return onRememberChange('password',e.target.checked);}},labelObj.rememberPassword))),_react2.default.createElement('div',{className:'e9login-form-clear'})));}},{key:'getLoginForm',value:function getLoginForm(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);portalLoginStore.setStateAndCache('loginType','QRCode');}});}},{key:'onLabelClick',value:function onLabelClick(e){jQuery(e.target.parentNode).find('input').focus();}},{key:'onInputChange',value:function onInputChange(e){if(e.target.value){jQuery(e.target.parentNode).find('.e9login-form-label').addClass('e9login-display-hidden');}else{jQuery(e.target.parentNode).find('.e9login-form-label').removeClass('e9login-display-hidden');}}},{key:'getDynamicPassword',value:function getDynamicPassword(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getDynamicPassword();}},{key:'onLogin',value:function onLogin(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onLogin();}}]);return E9Form;}(_react2.default.Component))||_class)||_class);exports.default=E9Form;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _qrcode=__webpack_require__(77);var _qrcode2=_interopRequireDefault(_qrcode);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9QRCode=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9QRCode,_React$Component);function E9QRCode(props){(0,_classCallCheck3.default)(this,E9QRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QRCode.__proto__||(0,_getPrototypeOf2.default)(E9QRCode)).call(this,props));_this.onRefresh=_this.onRefresh.bind(_this);_this.onDownload=_this.onDownload.bind(_this);return _this;}(0,_createClass3.default)(E9QRCode,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onQCLoginEnd();}},{key:'render',value:function render(){var portalLoginStore=this.props.portalLoginStore;var labelObj=portalLoginStore.labelObj,qrcodeIsInvalid=portalLoginStore.qrcodeIsInvalid,emobileDownloadUrl=portalLoginStore.emobileDownloadUrl,_portalLoginStore$sta2=portalLoginStore.state,state=_portalLoginStore$sta2===undefined?{}:_portalLoginStore$sta2;var _state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,qrCode=state.qrCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var size=this.props.size||180;var color=this.props.color||loginForm.color||'#fff';return _react2.default.createElement('div',{className:'e9login-QRCode'},_react2.default.createElement('div',{className:'e9login-QRCode-area'},qrcodeIsInvalid&&_react2.default.createElement('div',{className:'e9login-QRCode-timeout'},_react2.default.createElement('div',{className:'e9login-QRCode-timeout-mask'}),_react2.default.createElement('div',{className:'e9login-QRCode-timeout-tips'},labelObj.qrcodeisinvalid),_react2.default.createElement('i',{className:'icon-coms-Refresh e9login-QRCode-timeout-refresh',title:labelObj.refresh,onClick:this.onRefresh})),qrCode.text?_react2.default.createElement(_qrcode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_QRCode@9p5ycn',value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#eaeaea'}):''),_react2.default.createElement('div',{className:'e9login-QRCode-describe',style:{color:color}},labelObj.qrcode),emobileDownloadUrl&&_react2.default.createElement('div',{className:'e9login-QRCode-download',style:{color:color},onClick:this.onDownload},labelObj.download));}},{key:'onRefresh',value:function onRefresh(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta3=portalLoginStore.state,state=_portalLoginStore$sta3===undefined?{}:_portalLoginStore$sta3;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'onDownload',value:function onDownload(){var portalLoginStore=this.props.portalLoginStore;var emobileDownloadUrl=portalLoginStore.emobileDownloadUrl;window.open((0,_pathUtil.addContentPath)(emobileDownloadUrl));}}]);return E9QRCode;}(_react2.default.Component))||_class)||_class);exports.default=E9QRCode;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(210);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(212);
var RSBlock = __webpack_require__(213);
var BitBuffer = __webpack_require__(214);
var util = __webpack_require__(215);
var Polynomial = __webpack_require__(153);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(151);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(152);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(151);
var Polynomial = __webpack_require__(153);
var math = __webpack_require__(154);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9BgImageBox=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9BgImageBox,_React$Component);function E9BgImageBox(){(0,_classCallCheck3.default)(this,E9BgImageBox);return(0,_possibleConstructorReturn3.default)(this,(E9BgImageBox.__proto__||(0,_getPrototypeOf2.default)(E9BgImageBox)).apply(this,arguments));}(0,_createClass3.default)(E9BgImageBox,[{key:'render',value:function render(){var portalLoginStore=this.props.portalLoginStore;var labelObj=portalLoginStore.labelObj,state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache,onBgImageChange=portalLoginStore.onBgImageChange;var _state$bgImagesInfo=state.bgImagesInfo,bgImagesInfo=_state$bgImagesInfo===undefined?[]:_state$bgImagesInfo,initialSlide=state.initialSlide,autoCarousel=state.autoCarousel,carouselTime=state.carouselTime;var _carouselTime=carouselTime;if(carouselTime==undefined){_carouselTime=1;}var content=_react2.default.createElement('div',{className:'e9login-bg-image-box-content'},_react2.default.createElement('div',{className:'e9login-bg-image-box-toolbar'},_react2.default.createElement('div',{className:'e9login-bg-image-box-title'},labelObj.djqhbj),_react2.default.createElement('div',{className:'e9login-bg-image-box-item'},_react2.default.createElement(_ecCom.WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@r571v0',value:autoCarousel,content:labelObj.zdlb,onChange:function onChange(){return setStateAndCache('autoCarousel',!autoCarousel);}})),_react2.default.createElement('div',{className:'e9login-bg-image-box-item'},_react2.default.createElement('div',{className:'e9login-bg-image-box-label'},labelObj.lbsd),_react2.default.createElement(_antd.InputNumber,{ecId:(this&&this.props&&this.props.ecId||'')+'_InputNumber@4vacla',value:_carouselTime,min:0,disabled:!autoCarousel,style:{width:'70px',marginTop:'-4px'},onChange:function onChange(value){return setStateAndCache('carouselTime',value);}}))),_react2.default.createElement('div',{className:'e9login-bg-image-box-images'},bgImagesInfo.map(function(item,index){var selectedClassName=index==initialSlide?'e9login-bg-image-box-image-selected':'';return _react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item.imgsrc),alt:'',className:'e9login-bg-image-box-image '+selectedClassName,onClick:function onClick(){return onBgImageChange(item,index);}});})));return _react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@0sus3i',trigger:'click',placement:'topLeft',content:content},_react2.default.createElement('div',{className:'e9login-bg-image-box-btn',title:labelObj.backgroundtitle},_react2.default.createElement('div',{className:'e9login-bg-image-box-btn-background'}),_react2.default.createElement('div',{className:'e9login-bg-image-box-btn-icon'},_react2.default.createElement('i',{className:'wevicon-e9login-palette'}))));}}]);return E9BgImageBox;}(_react2.default.Component))||_class)||_class);exports.default=E9BgImageBox;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9CustomElement=__webpack_require__(218);var _E9CustomElement2=_interopRequireDefault(_E9CustomElement);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Custom=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Custom,_React$Component);function E9Custom(){(0,_classCallCheck3.default)(this,E9Custom);return(0,_possibleConstructorReturn3.default)(this,(E9Custom.__proto__||(0,_getPrototypeOf2.default)(E9Custom)).apply(this,arguments));}(0,_createClass3.default)(E9Custom,[{key:'render',value:function render(){var _this2=this;var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var _state$customElements=state.customElements,customElements=_state$customElements===undefined?[]:_state$customElements;return _react2.default.createElement('div',{className:'e9login-custom'},customElements.map(function(item,index){return _react2.default.createElement(_E9CustomElement2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_E9CustomElement@uvwgoy@'+index,key:index,item:item});}));}}]);return E9Custom;}(_react2.default.Component))||_class)||_class);exports.default=E9Custom;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getCurrentLabel=_ecCom.WeaInputLocale.getCurrentLabel;var getMultiStrFromBase64=_ecCom.WeaInputLocale.getMultiStrFromBase64;var E9CustomElement=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9CustomElement,_React$Component);function E9CustomElement(){(0,_classCallCheck3.default)(this,E9CustomElement);return(0,_possibleConstructorReturn3.default)(this,(E9CustomElement.__proto__||(0,_getPrototypeOf2.default)(E9CustomElement)).apply(this,arguments));}(0,_createClass3.default)(E9CustomElement,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,item=_props.item;var state=portalLoginStore.state,getElementStyle=portalLoginStore.getElementStyle;var langId=state.langId;if(item.type=='image'){var content=item.content,rotate=item.rotate;if(item.linktype==undefined){item.linktype='0';// 0地址链接，1电子邮件链接
item.linkmethoda='1';// 地址链接  0当前页，1弹出页
item.linkdza='';// 地址
item.linkdze='';// 邮件收件人
item.linktipa='';// 地址悬停提示
item.linktipe='';// 邮件悬停提示
}if(item.linktype=='0'){var _style={transform:'rotate('+rotate+'deg)',MsTransform:'rotate('+rotate+'deg)',MozTransform:'rotate('+rotate+'deg)',WebkitTransform:'rotate('+rotate+'deg)',OTransform:'rotate('+rotate+'deg)',opacity:item.opacity/100,cursor:item.linkdza!=''?'pointer':'default'};return _react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(content),title:getCurrentLabel(getMultiStrFromBase64(item.linktipa_base64),langId)||item.linktipa,alt:'',className:'e9login-element',style:(0,_extends3.default)({},_style,getElementStyle(item)),onClick:function onClick(){if(item.linkmethoda=='1'){// 弹出页打开
if(item.linkdza!=''){window.open((0,_pathUtil.addContentPath)(item.linkdza),'_blank');}}else if(item.linkdza!=''){window.open((0,_pathUtil.addContentPath)(item.linkdza),'_self');}}});}var style={transform:'rotate('+rotate+'deg)',MsTransform:'rotate('+rotate+'deg)',MozTransform:'rotate('+rotate+'deg)',WebkitTransform:'rotate('+rotate+'deg)',OTransform:'rotate('+rotate+'deg)',opacity:item.opacity/100,cursor:item.linkdze!=''?'pointer':'default'};return item.linkdze!=''?_react2.default.createElement('a',{href:'mailto:'+item.linkdze},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(content),alt:'',title:getCurrentLabel(getMultiStrFromBase64(item.linktipe_base64),langId)||item.linktipe,className:'e9login-element',style:(0,_extends3.default)({},style,getElementStyle(item))})):_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(content),alt:'',title:getCurrentLabel(getMultiStrFromBase64(item.linktipe_base64),langId)||item.linktipe,className:'e9login-element',style:(0,_extends3.default)({},style,getElementStyle(item))});}else if(item.type=='text'){var _content=item.content,color=item.color,fontSize=item.fontSize,fontFamily=item.fontFamily,fontStyle=item.fontStyle,fontWeight=item.fontWeight,backgroundColor=item.backgroundColor,opacity=item.opacity,textAlign=item.textAlign,verticalAlign=item.verticalAlign,textDecoration=item.textDecoration,_rotate=item.rotate;var _style2={transform:'rotate('+_rotate+'deg)',MsTransform:'rotate('+_rotate+'deg)',MozTransform:'rotate('+_rotate+'deg)',WebkitTransform:'rotate('+_rotate+'deg)',OTransform:'rotate('+_rotate+'deg)',backgroundColor:backgroundColor,opacity:opacity/100};return _react2.default.createElement('div',{className:'e9login-custom-text e9login-element',style:(0,_extends3.default)({},_style2,getElementStyle(item))},_react2.default.createElement('div',{className:'e9login-custom-text-content',style:{color:color,fontSize:fontSize+'px',fontFamily:fontFamily,fontStyle:fontStyle,fontWeight:fontWeight,textAlign:textAlign,verticalAlign:verticalAlign,textDecoration:textDecoration},dangerouslySetInnerHTML:{__html:_content}}));}return _react2.default.createElement('div',null);}}]);return E9CustomElement;}(_react2.default.Component))||_class)||_class);exports.default=E9CustomElement;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _mobx=__webpack_require__(14);var _loginButton=__webpack_require__(220);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginBtn=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(LoginBtn,_React$Component);function LoginBtn(props){(0,_classCallCheck3.default)(this,LoginBtn);var _this=(0,_possibleConstructorReturn3.default)(this,(LoginBtn.__proto__||(0,_getPrototypeOf2.default)(LoginBtn)).call(this,props));_this.onLogin=_this.onLogin.bind(_this);return _this;}(0,_createClass3.default)(LoginBtn,[{key:'render',value:function render(){var portalLoginStore=this.props.portalLoginStore;var labelObj=portalLoginStore.labelObj,state=portalLoginStore.state,getElementStyle=portalLoginStore.getElementStyle;var isLogging=state.isLogging,_state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,loginFormItems=state.loginFormItems;var _loginFormItems=(0,_mobx.toJS)(loginFormItems);var loginLength=_loginFormItems.length;var loginButton=loginSettingInfo.loginButton,_loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;if(loginButton==undefined){if(loginForm.isAbsolute==0){_loginButton.loginButtonDef.isAbsolute=loginForm.isAbsolute;_loginButton.loginButtonDef.level=loginForm.level;_loginButton.loginButtonDef.levelMargin=loginForm.levelMargin;_loginButton.loginButtonDef.vertical=loginForm.vertical;if(loginForm.vertical=='bottom'){_loginButton.loginButtonDef.verticalMargin=loginForm.verticalMargin;}else{_loginButton.loginButtonDef.verticalMargin=loginForm.verticalMargin+122;}_loginButton.loginButtonDef.color=loginForm.color;_loginButton.loginButtonDef.backgroundColor=loginForm.backgroundColor;_loginButton.loginButtonDef.x=loginForm.x;_loginButton.loginButtonDef.y=loginForm.y;_loginButton.loginButtonDef.rate_x=loginForm.rate_x;_loginButton.loginButtonDef.rate_y=loginForm.rate_y;_loginButton.loginButtonDef.isloginbtn=false;loginButton=_loginButton.loginButtonDef;}else if(loginForm.isAbsolute==1){_loginButton.loginButtonDef.isAbsolute=loginForm.isAbsolute;_loginButton.loginButtonDef.level=loginForm.level;_loginButton.loginButtonDef.levelMargin=loginForm.levelMargin;_loginButton.loginButtonDef.vertical=loginForm.vertical;_loginButton.loginButtonDef.verticalMargin=loginForm.verticalMargin;_loginButton.loginButtonDef.color=loginForm.color;_loginButton.loginButtonDef.backgroundColor=loginForm.backgroundColor;_loginButton.loginButtonDef.x=loginForm.x;_loginButton.loginButtonDef.y=loginForm.y;_loginButton.loginButtonDef.rate_x=loginForm.rate_x;_loginButton.loginButtonDef.rate_y=loginForm.rate_y;_loginButton.loginButtonDef.isloginbtn=false;loginButton=_loginButton.loginButtonDef;}}var submitStyle=loginButton.imgbtn==false?{width:loginButton.width,height:loginButton.height}:{width:loginButton.imgWidth,height:loginButton.imgHeight};var btnStyle={width:loginButton.width,height:loginButton.height,color:loginButton.color,backgroundColor:loginButton.backgroundColor,fontSize:loginButton.fsize,borderRadius:loginButton.borderR,opacity:loginButton.opacity*0.01};var imgbtnStyle={width:loginButton.imgWidth-2,height:loginButton.imgHeight,color:loginButton.imgColor,fontSize:loginButton.imgFsize,backgroundColor:'rgba(255,255,255,0)',backgroundImage:'url('+(0,_pathUtil.addContentPath)(loginButton.content)+')',backgroundRepeat:'no-repeat',backgroundSize:loginButton.imgWidth-2+'px  '+loginButton.imgHeight+'px'};var btnImgStyle={width:loginButton.imgWidth-2,height:loginButton.imgHeight};var topstyle='';var _top='';if(loginButton.isloginbtn==false){topstyle='calc('+loginButton.rate_y*100+'% + 256px)';}else{topstyle=loginButton.rate_y*100+'% ';}var sub=parseInt($('.e9login-content .e9login-btn').css('top'))-parseInt($('.e9login-content .e9login-form-box').css('top'));var forgeth=$('.e9login-form-remember').height();if(parseInt(sub)>208&&parseInt(sub)<238){if(loginLength<3){if(forgeth>20){_top=20;}else{_top=0;}}else if(forgeth>20){_top=(loginLength-2)*65+20;}else{_top=(loginLength-2)*65;}}else if(loginLength<3){_top=0;}else{_top=(loginLength-2)*65;}return _react2.default.createElement('div',{className:'e9login-element e9login-btn',style:(0,_extends3.default)({paddingTop:_top+'px',top:''+topstyle},getElementStyle(loginButton))},loginButton.imgbtn==false?_react2.default.createElement('div',{className:'e9login-form-submit e9login-submit',style:submitStyle},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@jsr15m',type:'primary',loading:isLogging,id:'submit',name:'submit',className:'e9login-form-submit-btn',style:btnStyle,onClick:this.onLogin},labelObj.login)):_react2.default.createElement('div',{className:'e9login-form-submit e9login-submit',style:submitStyle},_react2.default.createElement('div',{style:(0,_extends3.default)({},btnImgStyle,{opacity:loginButton.imgopacity*0.01})},loginButton.isShowtext==true?_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@zpx66h',type:'primary',loading:isLogging,id:'submit',name:'submit',className:'e9login-form-submit-btn',style:imgbtnStyle,onClick:this.onLogin},labelObj.login):_react2.default.createElement('div',{className:'e9login-submit-img',style:{cursor:'pointer'},onClick:this.onLogin},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(loginButton.content),style:btnImgStyle})))));}},{key:'onLogin',value:function onLogin(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onLogin();}}]);return LoginBtn;}(_react2.default.Component))||_class)||_class);exports.default=LoginBtn;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.loginButtonDef=undefined;var _pathUtil=__webpack_require__(11);// 登录按钮默认数据
var loginButtonDef={showtype:'loginButton',isLock:true,color:'#bacde0',// 文字颜色
fsize:18,backgroundColor:'#0b1a32',// 按钮背景色
isAbsolute:0,// 位置
level:'center',// 水平
vertical:'middle',// 垂直
levelMargin:0,// 水平边距
verticalMargin:233,// 垂直边距
x:0,y:0,rate_x:0,rate_y:0,width:324,height:45,// 按钮宽高
original_width:324,original_height:45,opacity:100,borderR:0,// button type : button/image
imgbtn:false,isShowtext:true,imgWidth:324,imgHeight:45,content:(0,_pathUtil.addContentPath)('/images/loginbtn.png'),imgopacity:100,imgColor:'#bacde0',// 文字颜色
imgFsize:18,isloginbtn:true};exports.loginButtonDef=loginButtonDef;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(222);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MultiLang=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MultiLang,_React$Component);function MultiLang(props){(0,_classCallCheck3.default)(this,MultiLang);var _this=(0,_possibleConstructorReturn3.default)(this,(MultiLang.__proto__||(0,_getPrototypeOf2.default)(MultiLang)).call(this,props));_this.onMultiLangChange=function(){};return _this;}(0,_createClass3.default)(MultiLang,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,isSetting=_props.isSetting,getState=_props.getState;var multiLangs=portalLoginStore.multiLangs,state=portalLoginStore.state,setState=portalLoginStore.setState;state=getState();var _state=state,langId=_state.langId,langText=_state.langText,hasMultiLang=_state.hasMultiLang,multiLangVisible=_state.multiLangVisible;if(!hasMultiLang){return _react2.default.createElement('div',{className:'e7login-multiLang'});}var selectedClassName='';var multiLangListComp='';if(multiLangVisible){selectedClassName='e7login-multiLangText-selected';multiLangListComp=_react2.default.createElement('div',{className:'e7login-multiLangList'},_react2.default.createElement('ul',null,multiLangs.map(function(item){return _react2.default.createElement('li',{className:'e7login-multiLangList-item '+(item.id==langId?'e7login-multiLangList-selected':''),onClick:function onClick(){portalLoginStore.getLoginForm({langId:item.id});portalLoginStore.setState({langId:item.id,langText:item.language,multiLangVisible:false});}},item.language);})));}return _react2.default.createElement('div',{className:'e7login-multiLang'},_react2.default.createElement('div',{className:'e7login-multiLangText '+selectedClassName,onClick:function onClick(e){if(!isSetting){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();setState({multiLangVisible:!multiLangVisible});}}},_react2.default.createElement('div',{className:'e7login-multiLangText-text'},langText),_react2.default.createElement('div',{className:'e7login-multiLangText-icon'},'\u25BC')),multiLangListComp);}}]);return MultiLang;}(_react2.default.Component))||_class)||_class);exports.default=MultiLang;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E7Form=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E7Form,_React$Component);function E7Form(props){(0,_classCallCheck3.default)(this,E7Form);var _this2=(0,_possibleConstructorReturn3.default)(this,(E7Form.__proto__||(0,_getPrototypeOf2.default)(E7Form)).call(this,props));_this2.getLoginForm=_this2.getLoginForm.bind(_this2);_this2.onLabelClick=_this2.onLabelClick.bind(_this2);_this2.onInputChange=_this2.onInputChange.bind(_this2);_this2.getDynamicPassword=_this2.getDynamicPassword.bind(_this2);_this2.onLogin=_this2.onLogin.bind(_this2);return _this2;}(0,_createClass3.default)(E7Form,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var portalLoginStore=this.props.portalLoginStore;var loginFormDataLoading=portalLoginStore.loginFormDataLoading;if(loginFormDataLoading){portalLoginStore.doAfterLoginRenderEvent();}var _this=this;jQuery('.e7login-form-input').unbind().keydown(function(e){e=e||window.event;var key=e.keyCode||e.which||e.charCode;if(key==13){var inputs=jQuery('.e7login-form-input');var idx=inputs.index(this);var nxtIdx=idx+1;var nxtInput=jQuery('.e7login-form-input:eq('+nxtIdx+')');if(nxtInput.length>0){nxtInput.focus();}else{_this.onLogin();}}});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var state=portalLoginStore.state,dynamicPasswordTime=portalLoginStore.dynamicPasswordTime,onPasswordForget=portalLoginStore.onPasswordForget,onRememberChange=portalLoginStore.onRememberChange,onValidateCodeChange=portalLoginStore.onValidateCodeChange,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,isRememberPW=_state.isRememberPW,isRememberAccount=_state.isRememberAccount,isRememberPassword=_state.isRememberPassword,cacheAccount=_state.cacheAccount,cachePassword=_state.cachePassword,_state$loginSettingIn=_state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,loginFormItems=_state.loginFormItems,loginFormHiddenItems=_state.loginFormHiddenItems,_state$loginSetting=_state.loginSetting,loginSetting=_state$loginSetting===undefined?{}:_state$loginSetting,validateCode=_state.validateCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=loginForm.color;var needforgotpassword=loginSetting.needforgotpassword,_loginSetting$validat=loginSetting.validateCodeKey,validateCodeKey=_loginSetting$validat===undefined?'':_loginSetting$validat;var validateCodeSrc=validateCode+'&validateCodeKey='+validateCodeKey;return _react2.default.createElement('div',{className:'e7login-form'},loginFormItems.map(function(item,index){var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;}else if(item.atype=='password'){defaultValue=cachePassword;}var itemComp=_react2.default.createElement('div',{key:index,className:'e7login-form-item'},_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e7login-form-input',placeholder:item.label,defaultValue:defaultValue,onBlur:function onBlur(){return item.atype=='account'&&_this3.getLoginForm();},onChange:_this3.onInputChange}));if(item.atype=='dynamicPassword'){itemComp=_react2.default.createElement('div',{key:index,className:'e7login-form-item e7login-form-item-dp'},_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e7login-form-input e7login-form-input-dp',placeholder:item.label,onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e7login-form-dynamic',style:{color:color}},dynamicPasswordTime>0?_react2.default.createElement('span',{className:'e7login-form-dynamic-text',style:{color:'#ccc'}},labelObj.resend,'(',dynamicPasswordTime,'s)'):_react2.default.createElement('span',{className:'e7login-form-dynamic-text',onClick:_this3.getDynamicPassword},labelObj.send)));}if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',{key:index,className:'e7login-form-item e7login-form-item-vc'},_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,className:'e7login-form-input e7login-form-input-vc',placeholder:item.label,onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e7login-form-vc-img'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(validateCodeSrc),alt:'',onClick:onValidateCodeChange})));}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,style:{display:'none'},dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'e7login-form-remember'},needforgotpassword=='1'&&_react2.default.createElement('div',{className:'e7login-form-remember-forget',title:labelObj.forgetPassword},_react2.default.createElement('span',{onClick:function onClick(){return onPasswordForget();}},labelObj.forgetPassword)),_react2.default.createElement('div',{className:'e7login-form-remember-content '+(isRememberPW=='1'?'':'e7login-display-hidden')},_react2.default.createElement('div',{className:'e7login-form-remember-account',title:labelObj.rememberAccount},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@yzgk3s',checked:isRememberAccount,onChange:function onChange(e){return onRememberChange('account',e.target.checked);}},labelObj.rememberAccount)),_react2.default.createElement('div',{className:'e7login-form-remember-password',title:labelObj.rememberPassword},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@8b314t',checked:isRememberPassword,onChange:function onChange(e){return onRememberChange('password',e.target.checked);}},labelObj.rememberPassword))),_react2.default.createElement('div',{className:'e7login-form-clear'})));}},{key:'getLoginForm',value:function getLoginForm(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);portalLoginStore.setStateAndCache('loginType','QRCode');}});}},{key:'onLabelClick',value:function onLabelClick(e){jQuery(e.target.parentNode).find('input').focus();}},{key:'onInputChange',value:function onInputChange(e){if(e.target.value){jQuery(e.target.parentNode).find('.e7login-form-label').addClass('e7login-display-hidden');}else{jQuery(e.target.parentNode).find('.e7login-form-label').removeClass('e7login-display-hidden');}}},{key:'getDynamicPassword',value:function getDynamicPassword(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getDynamicPassword();}},{key:'onLogin',value:function onLogin(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onLogin();}}]);return E7Form;}(_react2.default.Component))||_class)||_class);exports.default=E7Form;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _qrcode=__webpack_require__(77);var _qrcode2=_interopRequireDefault(_qrcode);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E7QRCode=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E7QRCode,_React$Component);function E7QRCode(props){(0,_classCallCheck3.default)(this,E7QRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(E7QRCode.__proto__||(0,_getPrototypeOf2.default)(E7QRCode)).call(this,props));_this.onRefresh=_this.onRefresh.bind(_this);_this.onDownload=_this.onDownload.bind(_this);return _this;}(0,_createClass3.default)(E7QRCode,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onQCLoginEnd();}},{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var qrcodeIsInvalid=portalLoginStore.qrcodeIsInvalid,emobileDownloadUrl=portalLoginStore.emobileDownloadUrl,_portalLoginStore$sta2=portalLoginStore.state,state=_portalLoginStore$sta2===undefined?{}:_portalLoginStore$sta2,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,_state$loginSettingIn=_state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,qrCode=_state.qrCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var size=this.props.size||100;var color=this.props.color||loginForm.color||'#fff';return _react2.default.createElement('div',{className:'e7login-QRCode'},_react2.default.createElement('div',{className:'e7login-QRCode-area'},qrcodeIsInvalid&&_react2.default.createElement('div',{className:'e7login-QRCode-timeout'},_react2.default.createElement('div',{className:'e7login-QRCode-timeout-mask'}),_react2.default.createElement('div',{className:'e7login-QRCode-timeout-tips'},labelObj.qrcodeisinvalid),_react2.default.createElement('i',{className:'icon-coms-Refresh e7login-QRCode-timeout-refresh',title:labelObj.refresh,onClick:this.onRefresh})),qrCode.text?_react2.default.createElement(_qrcode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_QRCode@p6brx0',value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#eaeaea'}):''),_react2.default.createElement('div',{className:'e7login-QRCode-describe',style:{color:color}},labelObj.qrcode),emobileDownloadUrl&&_react2.default.createElement('div',{className:'e7login-QRCode-download',onClick:this.onDownload},labelObj.download));}},{key:'onRefresh',value:function onRefresh(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta3=portalLoginStore.state,state=_portalLoginStore$sta3===undefined?{}:_portalLoginStore$sta3;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'onDownload',value:function onDownload(){var portalLoginStore=this.props.portalLoginStore;var emobileDownloadUrl=portalLoginStore.emobileDownloadUrl;window.open((0,_pathUtil.addContentPath)(emobileDownloadUrl));}}]);return E7QRCode;}(_react2.default.Component))||_class)||_class);exports.default=E7QRCode;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginBtn=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(LoginBtn,_React$Component);function LoginBtn(props){(0,_classCallCheck3.default)(this,LoginBtn);var _this=(0,_possibleConstructorReturn3.default)(this,(LoginBtn.__proto__||(0,_getPrototypeOf2.default)(LoginBtn)).call(this,props));_this.onLogin=_this.onLogin.bind(_this);return _this;}(0,_createClass3.default)(LoginBtn,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var state=portalLoginStore.state;state=getState();var _state=state,loginSettingInfo=_state.loginSettingInfo;var loginForm=loginSettingInfo.loginForm;var e7LoginButtonColor=loginForm.e7LoginButtonColor;return _react2.default.createElement('div',{className:'loginBtn',style:{color:e7LoginButtonColor},onClick:this.onLogin});}},{key:'onLogin',value:function onLogin(){var _props2=this.props,portalLoginStore=_props2.portalLoginStore,isSetting=_props2.isSetting;if(!isSetting){portalLoginStore.onLogin();}}}]);return LoginBtn;}(_react2.default.Component))||_class)||_class);exports.default=LoginBtn;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(228);

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MultiLang=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MultiLang,_React$Component);function MultiLang(props){(0,_classCallCheck3.default)(this,MultiLang);return(0,_possibleConstructorReturn3.default)(this,(MultiLang.__proto__||(0,_getPrototypeOf2.default)(MultiLang)).call(this,props));}(0,_createClass3.default)(MultiLang,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,overClass=_props.overClass,isSetting=_props.isSetting,getState=_props.getState;var multiLangs=portalLoginStore.multiLangs,state=portalLoginStore.state,setState=portalLoginStore.setState;state=getState();var _state=state,langId=_state.langId,langText=_state.langText,hasMultiLang=_state.hasMultiLang,multiLangVisible=_state.multiLangVisible;if(!hasMultiLang){return _react2.default.createElement('div',{className:'e8login-multiLang'});}var selectedClassName='';var multiLangListComp='';if(multiLangVisible){selectedClassName='e8login-multiLangText-selected';multiLangListComp=_react2.default.createElement('div',{className:'e8login-multiLangList'},_react2.default.createElement('ul',null,multiLangs.map(function(item){return _react2.default.createElement('li',{className:'e8login-multiLangList-item '+(item.id==langId?'e8login-multiLangList-selected':''),onClick:function onClick(){portalLoginStore.getLoginForm({langId:item.id});portalLoginStore.setState({langId:item.id,langText:item.language,multiLangVisible:false});}},item.language);})));}return _react2.default.createElement('div',{className:'e8login-multiLang '+overClass},_react2.default.createElement('div',{className:'e8login-multiLangText '+selectedClassName,onClick:function onClick(e){if(!isSetting){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();setState({multiLangVisible:!multiLangVisible});}}},_react2.default.createElement('div',{className:'e8login-multiLangText-text'},langText),_react2.default.createElement('div',{className:'e8login-multiLangText-icon'},'\u25BC')),multiLangListComp);}}]);return MultiLang;}(_react2.default.Component))||_class)||_class);exports.default=MultiLang;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8Form=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8Form,_React$Component);function E8Form(props){(0,_classCallCheck3.default)(this,E8Form);var _this2=(0,_possibleConstructorReturn3.default)(this,(E8Form.__proto__||(0,_getPrototypeOf2.default)(E8Form)).call(this,props));_this2.getLoginForm=_this2.getLoginForm.bind(_this2);_this2.onLabelClick=_this2.onLabelClick.bind(_this2);_this2.onInputChange=_this2.onInputChange.bind(_this2);_this2.getDynamicPassword=_this2.getDynamicPassword.bind(_this2);_this2.onLogin=_this2.onLogin.bind(_this2);return _this2;}(0,_createClass3.default)(E8Form,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var portalLoginStore=this.props.portalLoginStore;var loginFormDataLoading=portalLoginStore.loginFormDataLoading;if(loginFormDataLoading){portalLoginStore.doAfterLoginRenderEvent();}var _this=this;jQuery('.e8login-form-input').unbind().keydown(function(e){e=e||window.event;var key=e.keyCode||e.which||e.charCode;if(key==13){var inputs=jQuery('.e8login-form-input');var idx=inputs.index(this);var nxtIdx=idx+1;var nxtInput=jQuery('.e8login-form-input:eq('+nxtIdx+')');if(nxtInput.length>0){nxtInput.focus();}else{_this.onLogin();}}});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var state=portalLoginStore.state,dynamicPasswordTime=portalLoginStore.dynamicPasswordTime,onPasswordForget=portalLoginStore.onPasswordForget,onRememberChange=portalLoginStore.onRememberChange,onValidateCodeChange=portalLoginStore.onValidateCodeChange,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,isRememberPW=_state.isRememberPW,isRememberAccount=_state.isRememberAccount,isRememberPassword=_state.isRememberPassword,cacheAccount=_state.cacheAccount,cachePassword=_state.cachePassword,_state$loginSettingIn=_state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,loginFormItems=_state.loginFormItems,loginFormHiddenItems=_state.loginFormHiddenItems,_state$loginSetting=_state.loginSetting,loginSetting=_state$loginSetting===undefined?{}:_state$loginSetting,validateCode=_state.validateCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=loginForm.color;var needforgotpassword=loginSetting.needforgotpassword,_loginSetting$validat=loginSetting.validateCodeKey,validateCodeKey=_loginSetting$validat===undefined?'':_loginSetting$validat;var validateCodeSrc=validateCode+'&validateCodeKey='+validateCodeKey;return _react2.default.createElement('div',{className:'e8login-form'},loginFormItems.map(function(item,index){var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;}else if(item.atype=='password'){defaultValue=cachePassword;}var itemComp=_react2.default.createElement('div',{key:index,className:'e8login-form-item'},_react2.default.createElement('i',{className:'wevicon-e9login-'+(item.atype=='account'?'account':'password')}),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e8login-form-input',placeholder:item.label,defaultValue:defaultValue,onBlur:function onBlur(){return item.atype=='account'&&_this3.getLoginForm();},onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e8login-form-vertical-util'}));if(item.atype=='dynamicPassword'){itemComp=_react2.default.createElement('div',{key:index,className:'e8login-form-item e8login-form-item-dp'},_react2.default.createElement('i',{className:'wevicon-e9login-password'}),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e8login-form-input e8login-form-input-dp',placeholder:item.label,onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e8login-form-dynamic',style:{color:color}},dynamicPasswordTime>0?_react2.default.createElement('span',{className:'e8login-form-dynamic-text',style:{color:'#ccc'}},labelObj.resend,'(',dynamicPasswordTime,'s)'):_react2.default.createElement('span',{className:'e8login-form-dynamic-text',onClick:_this3.getDynamicPassword},labelObj.send)));}if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',{key:index,className:'e8login-form-item e8login-form-item-vc'},_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,className:'e8login-form-input e8login-form-input-vc',placeholder:item.label,onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e8login-form-vc-img'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(validateCodeSrc),alt:'',onClick:onValidateCodeChange})));}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,style:{display:'none'},dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'e8login-form-remember'},_react2.default.createElement('div',{className:'e8login-form-remember-content '+(isRememberPW=='1'?'':'e8login-display-hidden')},_react2.default.createElement('div',{className:'e8login-form-remember-account',title:labelObj.rememberAccount},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@aw8byf',checked:isRememberAccount,onChange:function onChange(e){return onRememberChange('account',e.target.checked);}},labelObj.rememberAccount)),_react2.default.createElement('div',{className:'e8login-form-remember-password',title:labelObj.rememberPassword},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@4osnwa',checked:isRememberPassword,onChange:function onChange(e){return onRememberChange('password',e.target.checked);}},labelObj.rememberPassword))),needforgotpassword=='1'&&_react2.default.createElement('div',{className:'e8login-form-remember-forget',title:labelObj.forgetPassword},_react2.default.createElement('span',{onClick:function onClick(){return onPasswordForget();}},labelObj.forgetPassword)),_react2.default.createElement('div',{className:'e8login-form-clear'})));}},{key:'getLoginForm',value:function getLoginForm(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);portalLoginStore.setStateAndCache('loginType','QRCode');}});}},{key:'onLabelClick',value:function onLabelClick(e){jQuery(e.target.parentNode).find('input').focus();}},{key:'onInputChange',value:function onInputChange(e){if(e.target.value){jQuery(e.target.parentNode).find('.e8login-form-label').addClass('e8login-display-hidden');}else{jQuery(e.target.parentNode).find('.e8login-form-label').removeClass('e8login-display-hidden');}}},{key:'getDynamicPassword',value:function getDynamicPassword(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getDynamicPassword();}},{key:'onLogin',value:function onLogin(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onLogin();}}]);return E8Form;}(_react2.default.Component))||_class)||_class);exports.default=E8Form;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _qrcode=__webpack_require__(77);var _qrcode2=_interopRequireDefault(_qrcode);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8QRCode=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8QRCode,_React$Component);function E8QRCode(props){(0,_classCallCheck3.default)(this,E8QRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(E8QRCode.__proto__||(0,_getPrototypeOf2.default)(E8QRCode)).call(this,props));_this.onRefresh=_this.onRefresh.bind(_this);_this.onDownload=_this.onDownload.bind(_this);return _this;}(0,_createClass3.default)(E8QRCode,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onQCLoginEnd();}},{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var qrcodeIsInvalid=portalLoginStore.qrcodeIsInvalid,emobileDownloadUrl=portalLoginStore.emobileDownloadUrl,_portalLoginStore$sta2=portalLoginStore.state,state=_portalLoginStore$sta2===undefined?{}:_portalLoginStore$sta2,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,_state$loginSettingIn=_state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,qrCode=_state.qrCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var size=this.props.size||110;var color=this.props.color||loginForm.color||'#fff';return _react2.default.createElement('div',{className:'e8login-QRCode'},_react2.default.createElement('div',{className:'e8login-QRCode-area'},qrcodeIsInvalid&&_react2.default.createElement('div',{className:'e8login-QRCode-timeout'},_react2.default.createElement('div',{className:'e8login-QRCode-timeout-mask'}),_react2.default.createElement('div',{className:'e8login-QRCode-timeout-tips'},labelObj.qrcodeisinvalid),_react2.default.createElement('i',{className:'icon-coms-Refresh e8login-QRCode-timeout-refresh',title:labelObj.refresh,onClick:this.onRefresh})),qrCode.text?_react2.default.createElement(_qrcode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_QRCode@0kvlk7',value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#eaeaea'}):''),_react2.default.createElement('div',{className:'e8login-QRCode-describe',style:{color:color}},labelObj.qrcode),emobileDownloadUrl&&_react2.default.createElement('div',{className:'e8login-QRCode-download',onClick:this.onDownload},labelObj.download));}},{key:'onRefresh',value:function onRefresh(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta3=portalLoginStore.state,state=_portalLoginStore$sta3===undefined?{}:_portalLoginStore$sta3;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'onDownload',value:function onDownload(){var portalLoginStore=this.props.portalLoginStore;var emobileDownloadUrl=portalLoginStore.emobileDownloadUrl;window.open((0,_pathUtil.addContentPath)(emobileDownloadUrl));}}]);return E8QRCode;}(_react2.default.Component))||_class)||_class);exports.default=E8QRCode;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoginBtn=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(LoginBtn,_React$Component);function LoginBtn(props){(0,_classCallCheck3.default)(this,LoginBtn);var _this=(0,_possibleConstructorReturn3.default)(this,(LoginBtn.__proto__||(0,_getPrototypeOf2.default)(LoginBtn)).call(this,props));_this.onLogin=_this.onLogin.bind(_this);return _this;}(0,_createClass3.default)(LoginBtn,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var state=portalLoginStore.state,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,loginSettingInfo=_state.loginSettingInfo;var loginForm=loginSettingInfo.loginForm;var e8LoginButtonColor=loginForm.e8LoginButtonColor;return _react2.default.createElement('div',{className:'loginBtn',style:{color:e8LoginButtonColor},onClick:this.onLogin},labelObj.login);}},{key:'onLogin',value:function onLogin(){var _props2=this.props,portalLoginStore=_props2.portalLoginStore,isSetting=_props2.isSetting;if(!isSetting){portalLoginStore.onLogin();}}}]);return LoginBtn;}(_react2.default.Component))||_class)||_class);exports.default=LoginBtn;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _comsMobx=__webpack_require__(157);var _weaPortalPublic=__webpack_require__(33);var _ecology=__webpack_require__(234);var _ecology2=_interopRequireDefault(_ecology);var _ecology3=__webpack_require__(331);var _ecology4=_interopRequireDefault(_ecology3);var _layout=__webpack_require__(356);var _layout2=_interopRequireDefault(_layout);var _layout3=__webpack_require__(395);var _layout4=_interopRequireDefault(_layout3);var _layout5=__webpack_require__(399);var _layout6=_interopRequireDefault(_layout5);var _layout7=__webpack_require__(405);var _layout8=_interopRequireDefault(_layout7);var _themeUtil=__webpack_require__(150);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Theme=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Theme,_React$Component);function Theme(props){(0,_classCallCheck3.default)(this,Theme);return(0,_possibleConstructorReturn3.default)(this,(Theme.__proto__||(0,_getPrototypeOf2.default)(Theme)).call(this,props));}(0,_createClass3.default)(Theme,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,_props$location=_props.location,location=_props$location===undefined?{}:_props$location,portalThemeStore=_props.portalThemeStore;var params=(0,_extends3.default)({},(0,_themeUtil.getSearchParams)(window.location.search),location.query||{});portalThemeStore.getThemeInfo(params);portalThemeStore.getThemeConfig(params);}},{key:'componentDidMount',value:function componentDidMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.doAfterThemeRenderEvent();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.removePlugins();}},{key:'render',value:function render(){var _props2=this.props,_props2$location=_props2.location,location=_props2$location===undefined?{}:_props2$location,portalThemeStore=_props2.portalThemeStore;var loading=portalThemeStore.loading,customloading=portalThemeStore.customloading,pluginloading=portalThemeStore.pluginloading,_portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the;var themeType=themeInfo.themeType,themeLayoutType=themeInfo.themeLayoutType,_themeInfo$layoutData=themeInfo.layoutData,layoutData=_themeInfo$layoutData===undefined?{}:_themeInfo$layoutData;if(loading){var loadingStyle={position:'absolute',top:'50%',width:'100%',height:'32px',marginTop:'-16px',textAlign:'center'};return _react2.default.createElement(_antd.Spin,{ecId:(this&&this.props&&this.props.ecId||'')+'_Spin@qj5rss',spinning:true,size:'large',style:loadingStyle});}var themeCom=_react2.default.createElement('div',null);if(themeType=='ecology8'){themeCom=_react2.default.createElement(_ecology2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E8Theme@09l3wo'},this.props));}else if(themeType=='ecology9'){if(themeLayoutType=='1'){themeCom=_react2.default.createElement(_ecology4.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9Theme@8021o7'},this.props));}else if(themeLayoutType=='2'){themeCom=_react2.default.createElement(_layout2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9ThemeLayout2@ma5tdf'},this.props));}else if(themeLayoutType=='3'){themeCom=_react2.default.createElement(_layout4.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9ThemeLayout3@e31q63'},this.props));}else if(themeLayoutType=='4'){themeCom=_react2.default.createElement(_layout6.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9ThemeLayout4@evdrb8'},this.props));}else if(themeLayoutType=='5'){themeCom=_react2.default.createElement(_layout8.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9ThemeLayout5@aafrqk'},this.props));}else{themeCom=_react2.default.createElement(_ecology4.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9Theme@5bqgx6'},this.props));}}else if(themeType=='ECustom'){var layoutId=layoutData.layoutId,layoutType=layoutData.layoutType,layoutCustom=layoutData.layoutCustom,_layoutData$layoutCon=layoutData.layoutConfig,layoutConfig=_layoutData$layoutCon===undefined?{}:_layoutData$layoutCon,layoutUUID=layoutData.layoutUUID;if(layoutCustom=='1'){if(customloading&&window[layoutConfig.module]){var ECustomTheme=window[layoutConfig.module].com[layoutConfig.component];themeCom=_react2.default.createElement(ECustomTheme,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_ECustomTheme@wruomq'},this.props));}else if(window.rewritePortalTheme&&typeof window.rewritePortalTheme=='function'){themeCom=window.rewritePortalTheme((0,_extends3.default)({},this.props),{id:layoutUUID});}}else{themeCom=_react2.default.createElement(_weaPortalPublic.WeaPortalLayout,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPortalLayout@io210g',id:layoutId,layoutId:layoutId,layoutType:layoutType},this.props));}}else{themeCom=_react2.default.createElement(_ecology4.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9Theme@6vjpbq'},this.props));}return _react2.default.createElement('div',{style:{width:'100%',height:'100%'}},_react2.default.createElement(_ecCom.WeaPopoverHrm,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPopoverHrm@y37a6e'}),!pluginloading&&_react2.default.createElement(_comsMobx.WeaMessageCenter.FixedPop,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMessageCenter.FixedPop@j062ma',systemSetStore:_comsMobx.WeaMessageCenter.store}),themeCom,_react2.default.createElement('div',{id:'portal-bay-window-outer'},_react2.default.createElement(_weaPortalPublic.WeaPortalFloatArea,null)));}}]);return Theme;}(_react2.default.Component))||_class)||_class);exports.default=Theme;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);__webpack_require__(235);var _E8Header=__webpack_require__(248);var _E8Header2=_interopRequireDefault(_E8Header);var _E8LeftMenu=__webpack_require__(327);var _E8LeftMenu2=_interopRequireDefault(_E8LeftMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E8Theme=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8Theme,_React$Component);function E8Theme(props){(0,_classCallCheck3.default)(this,E8Theme);var _this=(0,_possibleConstructorReturn3.default)(this,(E8Theme.__proto__||(0,_getPrototypeOf2.default)(E8Theme)).call(this,props));_this.exitTranslatepage=function(){var portalThemeStore=_this.props.portalThemeStore;portalThemeStore.setTranslatepage(0);// 左侧菜单高度更正
var asdh=$('.e8aside-container').height()-$('.e8aside-container .e8left-lmt').height()-$('.e8aside-container .e8left-lmb').height()+30;$('.e8aside-container #menuScrollWrapper').css({height:asdh});};return _this;}(0,_createClass3.default)(E8Theme,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,portalThemeStore=_props.portalThemeStore,location=_props.location;var pathname=location.pathname,query=location.query;portalThemeStore.getTopMenu(pathname,query);}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var searchParams=portalThemeStore.searchParams,_portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the,translatepage=portalThemeStore.translatepage;var hideHeader=searchParams.hideHeader,hideAside=searchParams.hideAside;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$cssfile=themeData.cssfile,cssfile=_themeData$cssfile===undefined?'left':_themeData$cssfile,maincolor=themeData.maincolor;var contenttop='';if(hideHeader=='true'){contenttop=translatepage=='1'?'30px':'0px';}else{contenttop=translatepage=='1'?'85px':'55px';}return _react2.default.createElement('div',{className:'e8theme-layout-container e8theme-color-'+cssfile},translatepage=='1'?_react2.default.createElement('div',{className:'e8theme-translate'},_react2.default.createElement('div',{className:'trans-tips'},getLabel(518684,'您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')),_react2.default.createElement('div',{className:'trans-exit',onClick:this.exitTranslatepage},getLabel(518685,'退出翻译模式'))):null,hideHeader=='true'?null:_react2.default.createElement('div',{className:'e8theme-layout-header',style:translatepage=='1'?{top:'30px'}:{top:'0px'}},_react2.default.createElement(_E8Header2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8Header@421ipu'})),_react2.default.createElement('div',{className:'e8theme-layout-content',style:{top:contenttop}},_react2.default.createElement('div',{id:'themeLayoutMask',className:'e8theme-layout-mask'}),hideAside=='true'?null:_react2.default.createElement('div',{className:'e8theme-layout-aside'},_react2.default.createElement(_E8LeftMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8LeftMenu@elvh5g'})),_react2.default.createElement('div',{className:'e8theme-layout-main',style:hideHeader=='true'&&hideAside=='true'?{padding:0}:{backgroundColor:maincolor}},_react2.default.createElement('div',{id:'themeLayoutRoute',className:'e8theme-layout-route'},this.props.children),_react2.default.createElement('div',{id:'themeLayoutFrame',className:'e8theme-layout-frame'},_react2.default.createElement('iframe',{id:'mainFrame',name:'mainFrame',src:'about:blank'})))));}}]);return E8Theme;}(_react2.default.Component))||_class)||_class);exports.default=E8Theme;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(236);__webpack_require__(237);__webpack_require__(238);__webpack_require__(239);__webpack_require__(240);__webpack_require__(241);__webpack_require__(242);__webpack_require__(243);__webpack_require__(244);__webpack_require__(245);__webpack_require__(246);__webpack_require__(247);

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E8TopLogo=__webpack_require__(249);var _E8TopLogo2=_interopRequireDefault(_E8TopLogo);var _E8TopMenu=__webpack_require__(250);var _E8TopMenu2=_interopRequireDefault(_E8TopMenu);var _E8FreqUseMenu=__webpack_require__(251);var _E8FreqUseMenu2=_interopRequireDefault(_E8FreqUseMenu);var _E8QuickSearch=__webpack_require__(319);var _E8QuickSearch2=_interopRequireDefault(_E8QuickSearch);var _E8HeaderRight=__webpack_require__(322);var _E8HeaderRight2=_interopRequireDefault(_E8HeaderRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8Header=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8Header,_React$Component);function E8Header(){(0,_classCallCheck3.default)(this,E8Header);return(0,_possibleConstructorReturn3.default)(this,(E8Header.__proto__||(0,_getPrototypeOf2.default)(E8Header)).apply(this,arguments));}(0,_createClass3.default)(E8Header,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the;var themeLogoWidth=themeInfo.themeLogoWidth,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var topcolor=themeData.topcolor;var logoWidth=themeLogoWidth==''?225:parseInt(themeLogoWidth);return _react2.default.createElement('div',{className:'e8header-container'},_react2.default.createElement('div',{className:'e8header-left',style:{width:logoWidth}},_react2.default.createElement(_E8TopLogo2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8TopLogo@9hb35e'})),_react2.default.createElement('div',{className:'e8header-right',style:topcolor?{backgroundColor:topcolor,marginLeft:logoWidth}:{marginLeft:logoWidth}},_react2.default.createElement('div',{className:'e8header-right-menu'},_react2.default.createElement(_E8TopMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8TopMenu@esnjio'}),_react2.default.createElement(_E8FreqUseMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8FreqUseMenu@4kyuqs'}),_react2.default.createElement(_E8QuickSearch2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8QuickSearch@iy0cjw'})),_react2.default.createElement(_E8HeaderRight2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8HeaderRight@btzmp2'})));}}]);return E8Header;}(_react2.default.Component))||_class)||_class);exports.default=E8Header;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8TopLogo=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8TopLogo,_React$Component);function E8TopLogo(){(0,_classCallCheck3.default)(this,E8TopLogo);return(0,_possibleConstructorReturn3.default)(this,(E8TopLogo.__proto__||(0,_getPrototypeOf2.default)(E8TopLogo)).apply(this,arguments));}(0,_createClass3.default)(E8TopLogo,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the;var themeLogo=themeInfo.themeLogo,themeLogoName=themeInfo.themeLogoName,themeLogoWidth=themeInfo.themeLogoWidth,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var logocolor=themeData.logocolor;var logoWidth=themeLogoWidth==''?225:parseInt(themeLogoWidth);return _react2.default.createElement('div',{className:'e8header-top-logo wea-f14',style:logocolor?{backgroundColor:logocolor,width:logoWidth}:{width:logoWidth}},themeLogo?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(themeLogo),alt:''}):_react2.default.createElement('span',null,themeLogoName));}}]);return E8TopLogo;}(_react2.default.Component))||_class)||_class);exports.default=E8TopLogo;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8TopMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8TopMenu,_React$Component);function E8TopMenu(props){(0,_classCallCheck3.default)(this,E8TopMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E8TopMenu.__proto__||(0,_getPrototypeOf2.default)(E8TopMenu)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);_this.onTopMenuClick=_this.onTopMenuClick.bind(_this);return _this;}(0,_createClass3.default)(E8TopMenu,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;jQuery('.e8header-top-menu').hover(function(){},function(){_this2.onVisibleChange(false);});}},{key:'render',value:function render(){var _this3=this;var portalThemeStore=this.props.portalThemeStore;var topMenuObj=portalThemeStore.topMenuObj,topMenuVisible=portalThemeStore.topMenuVisible,translatepage=portalThemeStore.translatepage;var _topMenuObj$topMenu=topMenuObj.topMenu,topMenu=_topMenuObj$topMenu===undefined?[]:_topMenuObj$topMenu,_topMenuObj$topMenuSe=topMenuObj.topMenuSelected,topMenuSelected=_topMenuObj$topMenuSe===undefined?{}:_topMenuObj$topMenuSe;var selectedId=topMenuSelected.id;return _react2.default.createElement('div',{className:'e8header-top-menu '+(topMenuVisible?'e8header-top-menu-open':'')},_react2.default.createElement('div',{className:'e8header-top-menu-items'},topMenu.map(function(item,index){if(item){var id=item.id,name=item.name,fname=item.fname;var selectedClassName=id==selectedId?'e8header-top-menu-item-selected':'';return _react2.default.createElement('div',{key:index,'data-id':id,className:'e8header-top-menu-item '+selectedClassName,title:fname,onClick:function onClick(){return _this3.onTopMenuClick(item);}},translatepage=='1'?fname:name);}return _react2.default.createElement('div',null);})),_react2.default.createElement('div',{className:'e8header-top-menu-btn',onClick:function onClick(){return _this3.onVisibleChange(!topMenuVisible);}}));}},{key:'onVisibleChange',value:function onVisibleChange(visible){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onTopMenuVisibleChange(visible);}},{key:'onTopMenuClick',value:function onTopMenuClick(topMenuSelected){this.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onTopMenuSelectedChange(topMenuSelected);portalThemeStore.onLeftMenuModeChange('inline');}}]);return E8TopMenu;}(_react2.default.Component))||_class)||_class);exports.default=E8TopMenu;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _E9FreqUseMenu=__webpack_require__(78);var _E9FreqUseMenu2=_interopRequireDefault(_E9FreqUseMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8FreqUseMenu=function(_React$Component){(0,_inherits3.default)(E8FreqUseMenu,_React$Component);function E8FreqUseMenu(){(0,_classCallCheck3.default)(this,E8FreqUseMenu);return(0,_possibleConstructorReturn3.default)(this,(E8FreqUseMenu.__proto__||(0,_getPrototypeOf2.default)(E8FreqUseMenu)).apply(this,arguments));}(0,_createClass3.default)(E8FreqUseMenu,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e8header-freq-use-menu'},_react2.default.createElement(_E9FreqUseMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9FreqUseMenu@4e7qya'}));}}]);return E8FreqUseMenu;}(_react2.default.Component);exports.default=E8FreqUseMenu;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _E9FreqUseMenuContent=__webpack_require__(253);var _E9FreqUseMenuContent2=_interopRequireDefault(_E9FreqUseMenuContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_ecCom.WeaIntro.Step;var IntroStep3=(_dec=(0,_mobxReact.inject)('portalIntroStore'),_dec2=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(IntroStep3,_React$Component);function IntroStep3(props){(0,_classCallCheck3.default)(this,IntroStep3);var _this=(0,_possibleConstructorReturn3.default)(this,(IntroStep3.__proto__||(0,_getPrototypeOf2.default)(IntroStep3)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);return _this;}(0,_createClass3.default)(IntroStep3,[{key:'render',value:function render(){var _props=this.props,portalIntroStore=_props.portalIntroStore,portalThemeStore=_props.portalThemeStore;var intro_step=portalIntroStore.intro_step;var freqUseMenuVisible=portalThemeStore.freqUseMenuVisible,translatepage=portalThemeStore.translatepage;return _react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@gelal5',trigger:'click',placement:'bottomLeft',content:_react2.default.createElement(Step,{ecId:(this&&this.props&&this.props.ecId||'')+'_Step@odw5xs',id:'portal-intro3'},_react2.default.createElement(_E9FreqUseMenuContent2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9FreqUseMenuContent@59fncw',onVisibleChange:this.onVisibleChange})),overlayClassName:translatepage=='1'?'e9header-freq-use-menu-overlay-tran':'e9header-freq-use-menu-overlay',visible:freqUseMenuVisible,onVisibleChange:this.onVisibleChange,afterPopupVisibleChange:function afterPopupVisibleChange(v){return intro_step.intro3&&v&&setTimeout(function(){return window.portal_intro.goToStep(3);},150);}},_react2.default.createElement('div',{className:'e9header-freq-use-menu-icon'},_react2.default.createElement('i',{className:'icon-coms-classification'})));}},{key:'onVisibleChange',value:function onVisibleChange(visible){var _props2=this.props,portalIntroStore=_props2.portalIntroStore,portalThemeStore=_props2.portalThemeStore;var intro_step=portalIntroStore.intro_step;!intro_step.intro3&&portalThemeStore.onFreqUseMenuVisibleChange(visible);var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){themeLayoutMask.style.display='block';}else{themeLayoutMask.style.display='none';}}}]);return IntroStep3;}(_react2.default.Component))||_class)||_class)||_class);exports.default=IntroStep3;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;// import E9FreqUseMenuSetting from './E9FreqUseMenuSetting';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _E9FreqUseMenuSettingNew=__webpack_require__(254);var _E9FreqUseMenuSettingNew2=_interopRequireDefault(_E9FreqUseMenuSettingNew);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var getCurrentLabel=_ecCom.WeaInputLocale.getCurrentLabel;var getMultiStrFromBase64=_ecCom.WeaInputLocale.getMultiStrFromBase64;var E9FreqUseMenuContent=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9FreqUseMenuContent,_React$Component);function E9FreqUseMenuContent(props){(0,_classCallCheck3.default)(this,E9FreqUseMenuContent);var _this=(0,_possibleConstructorReturn3.default)(this,(E9FreqUseMenuContent.__proto__||(0,_getPrototypeOf2.default)(E9FreqUseMenuContent)).call(this,props));_this.getFreqUseMenu=_this.getFreqUseMenu.bind(_this);_this.onFreqUseMenuClick=_this.onFreqUseMenuClick.bind(_this);return _this;}(0,_createClass3.default)(E9FreqUseMenuContent,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$fre=portalThemeStore.freqUseMenu,freqUseMenu=_portalThemeStore$fre===undefined?[]:_portalThemeStore$fre,account=portalThemeStore.account;var _freqUseMenu=(0,_mobx.toJS)(freqUseMenu);var _account=(0,_mobx.toJS)(account);return _react2.default.createElement('div',{className:'e9header-freq-use-menu-content'},_react2.default.createElement('div',{style:{padding:'5px 0'}},_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@dvuywz',height:'100%'},_react2.default.createElement('div',{className:'e9header-freq-use-menu-items'},_freqUseMenu.map(function(item,index){var id=item.infoid,menunamemultlang=item.menunamemultlang;var name=getCurrentLabel(getMultiStrFromBase64(menunamemultlang));return _react2.default.createElement('div',{key:index,'data-id':id,className:'e9header-freq-use-menu-item',title:name,onClick:function onClick(){return _this2.onFreqUseMenuClick(item);}},name);})))),_react2.default.createElement('div',{className:'e9header-freq-use-menu-setting',title:getLabel(19653,'设置'),onClick:function onClick(){return _this2.props.onVisibleChange(false);}},_react2.default.createElement(_E9FreqUseMenuSettingNew2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9FreqUseMenuSetting@nmb9l5',account:_account,callback:this.getFreqUseMenu},_react2.default.createElement('i',{className:'wevicon-freq-use-menu-setting'}),_react2.default.createElement('span',{style:{marginLeft:'5px'}},getLabel(19653,'设置')))));}},{key:'getFreqUseMenu',value:function getFreqUseMenu(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getFreqUseMenu();}},{key:'onFreqUseMenuClick',value:function onFreqUseMenuClick(item){this.props.onVisibleChange(false);var obj=(0,_extends3.default)({},item);for(var k in item){if(Object.prototype.hasOwnProperty.call(item,k)){if(k=='menulink'){obj.url=item[k];}else if(k=='linktype'){if(item[k]=='0'){obj.target='mainFrame';}else{obj.target='_blank';}}}}var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain(obj);}}]);return E9FreqUseMenuContent;}(_react2.default.Component))||_class)||_class);exports.default=E9FreqUseMenuContent;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(112);var _stringify2=_interopRequireDefault(_stringify);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _isEqual=__webpack_require__(255);var _isEqual2=_interopRequireDefault(_isEqual);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _index=__webpack_require__(318);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=_antd.Menu.Item;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9FreqUseMenuSettingNew=(_dec=(0,_index.inject)('portalThemeStore'),_dec(_class=(0,_index.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9FreqUseMenuSettingNew,_React$Component);function E9FreqUseMenuSettingNew(props){(0,_classCallCheck3.default)(this,E9FreqUseMenuSettingNew);var _this=(0,_possibleConstructorReturn3.default)(this,(E9FreqUseMenuSettingNew.__proto__||(0,_getPrototypeOf2.default)(E9FreqUseMenuSettingNew)).call(this,props));_this.state={visible:false,loading:false,treeData:[],checkedKeys:[],halfCheckedKeys:[],expandedKeys:[],datas:[],ids:[],selectedKeys:[],showDrop:false};_this.getRightMenus=_this.getRightMenus.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.getData=_this.getData.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.getRowSelection=_this.getRowSelection.bind(_this);_this.onChangeSub=_this.onChangeSub.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.onShowDrop=_this.onShowDrop.bind(_this);_this.onChangeBrowser=_this.onChangeBrowser.bind(_this);_this.onChangeBrowser1=_this.onChangeBrowser1.bind(_this);_this.onChangeMenuName=_this.onChangeMenuName.bind(_this);_this.getValidator=_this.getValidator.bind(_this);_this.onAddTab=_this.onAddTab.bind(_this);_this.uuid=_this.uuid.bind(_this);// this.getMType = this.getMType.bind(this);
// this.getMenuid = this.getMenuid.bind(this);
return _this;}(0,_createClass3.default)(E9FreqUseMenuSettingNew,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,datas=_state.datas;var _props$account=this.props.account,account=_props$account===undefined?{}:_props$account;var footer=[_react2.default.createElement('div',{style:{display:'inline-block',paddingRight:'12px'}},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@n9lh3v',key:'save',type:'primary',onClick:this.onSave},getLabel(30986,'保存'))),account.userid==1&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@mnxami',type:194,tabs:[{key:'1',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}},{key:'2',name:getLabel(384541,'按组织架构'),selected:false}],customized:true,isSingle:false,inputStyle:{width:'300px',marginLeft:'-31px'},onChange:function onChange(ids){return _this2.onChangeSub(ids);},title:getLabel(25332,'组织结构')},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@8i5no0',style:{marginRight:'10px'},type:'primary'},getLabel(390658,'同步到按钮')))),_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(OperateMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_OperateMenu@o9o62z',dropMenuDatas:this.getRightMenus(),onShowDrop:this.onShowDrop,onDropMenuClick:this.onRightMenuClick,showDrop:this.state.showDrop},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@c88jw4',onClick:this.onShowDrop},getLabel(17499,'更多'),'>>')))];return _react2.default.createElement('div',{onClick:this.getData},this.props.children,_react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@gxs438',visible:visible,title:getLabel(385807,'常用菜单设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',buttons:footer,style:{width:'50%',height:524},onCancel:this.onCancel,hasScroll:true,loading:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@bq4v2u',inDialog:true,datas:this.getRightMenus(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{style:{clear:'both'}}),_react2.default.createElement(_ecCom.WeaTableEditable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTableEditable@79bsub',ref:function ref(el){_this2.table=el;},showCopy:false,datas:datas,getRowSelection:this.getRowSelection,columns:this.getColumns(),validator:this.getValidator(),willAdd:this.onAddTab,draggable:true,onChange:function onChange(datas){_this2.setState({datas:datas});},willEdit:function willEdit(datas){var record=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(record.key=='menutype'){var _datas=datas;_datas[record.index].menuname='';_datas[record.index].menulink='';_datas[record.index].menunamemultlang='';_this2.setState({datas:_datas});}else{_this2.setState({datas:datas});}}}))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_isEqual2.default)(nextProps.value,this.props.value)){this.setState({datas:nextProps.value});}}},{key:'onChange',value:function onChange(datas){datas.map(function(item){if(item.menutype=='input'){item.menulink=item.menutype1[1];}else if(item.menutype=='browser'){// item.menulink = item.menutype1[1].names;
}});this.setState({datas:datas});}},{key:'onAddTab',value:function onAddTab(){var datas=this.state.datas;var newdatas=[].concat((0,_toConsumableArray3.default)(datas));newdatas.push({id:this.uuid(),key:newdatas.length,menulink:'',menuname:'',linktype:'0',menutype:'0',menuid:'0',mType:'0'});this.setState({datas:newdatas});}},{key:'uuid',value:function uuid(){var s=[];var hexDigits='0123456789abcdef';for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]='4';// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]='-';s[13]='-';s[18]='-';s[23]='-';var uuid=s.join('');return uuid;}},{key:'getValidator',value:function getValidator(){var validator={rules:{menunamemultlang:'required',menuname:'required'},errorMessage:{// 自定义对应规则的错误提示信息
required:getLabel(385869,'此项必填')}};return validator;}},{key:'onChangeBrowser',value:function onChangeBrowser(ids,names,da){var data=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var index=arguments[4];var string=arguments[5];var datas=this.state.datas;var Mtype='';if(da.length!=0){Mtype=da[0].sourcetype;}var _datas=[].concat((0,_toConsumableArray3.default)(datas));if(string=='portalmenu'){if(data.length==0){_datas[index].menunamemultlang='';_datas[index].menuname='';_datas[index].menulink='';}else{_datas[index].menunamemultlang=names;_datas[index].menuname=names;_datas[index].mType=typeof Mtype=='undefined'?'':Mtype==1?'left':Mtype==2?'top':Mtype==4?'page':'custom';_datas[index].menuid=ids;// new
if(data[0].fullrouteurl&&data[0].fullrouteurl!==''){_datas[index].menulink=data[0].fullrouteurl;}else if(data[0].linkAddress&&datas[0].linkAddress!==''){_datas[index].menulink=data[0].linkAddress;}}this.setState({datas:_datas});}else if(string=='systempage'){if(data[0].activeKey=='1'){_datas[index].menulink=data[0].dropMenuUrl+ids;if(data[0].dropMenuValue=='1'){_datas[index].menunamemultlang=getLabel(1986,'新建文档');_datas[index].menuname=getLabel(1986,'新建文档');}else if(data[0].dropMenuValue=='2'){_datas[index].menunamemultlang=getLabel(1212,'我的文档');_datas[index].menuname=getLabel(1212,'我的文档');}else if(data[0].dropMenuValue=='3'){_datas[index].menunamemultlang=getLabel(16397,'最新文档');_datas[index].menuname=getLabel(16397,'最新文档');}else if(data[0].dropMenuValue=='4'){_datas[index].menunamemultlang=getLabel(16398,'文档目录');_datas[index].menuname=getLabel(16398,'文档目录');}}else if(data[0].activeKey=='2'){var arr=ids.split(',');var wftypeIds=[];var wfIds=[];arr.map(function(item){if(item.lastIndexOf('wftype')!=-1){wftypeIds.push(item.split('wftype_').join(''));}else{wfIds.push(item.split('wf_').join(''));}});data.map(function(item){if(item.allVersionIds&&item.allVersionIds!=''){var allVersionIdsArrs=item.allVersionIds.split(',');if(allVersionIdsArrs.length>1){allVersionIdsArrs.map(function(allVersionIdsItem){if(allVersionIdsItem!=''){wfIds.push(allVersionIdsItem);}});}else{wfIds.push(allVersionIdsArrs.join(''));}}});var viewType='';if(data[0].dropMenuValue=='1'){_datas[index].menunamemultlang=getLabel(84759,'新建流程');_datas[index].menuname=getLabel(84759,'新建流程');var _jsonstr='wfRange='+wfIds.toString();_datas[index].menulink=data[0].dropMenuUrl+_jsonstr;this.setState({datas:_datas});return;}else if(data[0].dropMenuValue=='2'){_datas[index].menunamemultlang=getLabel(1207,'待办事宜');_datas[index].menuname=getLabel(1207,'待办事宜');viewType='1';}else if(data[0].dropMenuValue=='3'){_datas[index].menunamemultlang=getLabel(84758,'已办事宜');_datas[index].menuname=getLabel(84758,'已办事宜');viewType='2';}else if(data[0].dropMenuValue=='4'){_datas[index].menunamemultlang=getLabel(17992,'办结事宜');_datas[index].menuname=getLabel(17992,'办结事宜');viewType='3';}else if(data[0].dropMenuValue=='5'){_datas[index].menunamemultlang=getLabel(21639,'抄送事宜');_datas[index].menuname=getLabel(21639,'抄送事宜');viewType='5';}else if(data[0].dropMenuValue=='6'){_datas[index].menunamemultlang=getLabel(21640,'督办事宜');_datas[index].menuname=getLabel(21640,'督办事宜');viewType='6';}else if(data[0].dropMenuValue=='7'){_datas[index].menunamemultlang=getLabel(1210,'我的请求');_datas[index].menuname=getLabel(1210,'我的请求');viewType='4';}var jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0};if(viewType=='2'){jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0,isArrangement:1};}else if(viewType=='1'){jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0,showView:1};}else if(viewType=='6'){// 督办
var _jsonstr2='workflowId='+wfIds.toString();_datas[index].menulink=data[0].dropMenuUrl+escape((0,_stringify2.default)(_jsonstr2));_datas[index].menulink='/spa/workflow/index_mobx.jsp#/main/workflow/supervise?fromwhere=jsonFilter&'+_jsonstr2;this.setState({datas:_datas});return;}_datas[index].menulink=data[0].dropMenuUrl+escape((0,_stringify2.default)(jsonstr));}this.setState({datas:_datas});}}},{key:'onChangeBrowser1',value:function onChangeBrowser1(ids,names){var data=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var index=arguments[3];var string=arguments[4];var datas=this.state.datas;var _datas=[].concat((0,_toConsumableArray3.default)(datas));if(string=='systempage'&&data.length>0){if(data[0].activeKey=='1'){_datas[index].menulink=data[0].dropMenuUrl+ids;if(data[0].dropMenuValue=='1'){_datas[index].menunamemultlang=getLabel(1986,'新建文档');_datas[index].menuname=getLabel(1986,'新建文档');}else if(data[0].dropMenuValue=='2'){_datas[index].menunamemultlang=getLabel(1212,'我的文档');_datas[index].menuname=getLabel(1212,'我的文档');}else if(data[0].dropMenuValue=='3'){_datas[index].menunamemultlang=getLabel(16397,'最新文档');_datas[index].menuname=getLabel(16397,'最新文档');}else if(data[0].dropMenuValue=='4'){_datas[index].menunamemultlang=getLabel(16398,'文档目录');_datas[index].menuname=getLabel(16398,'文档目录');}}else if(data[0].activeKey=='2'){var arr=ids.split(',');var wftypeIds=[];var wfIds=[];arr.map(function(item){if(item.lastIndexOf('wftype')!=-1){wftypeIds.push(item.split('wftype_').join(''));}else{wfIds.push(item.split('wf_').join(''));}});data.map(function(item){if(item.allVersionIds&&item.allVersionIds!=''){var allVersionIdsArrs=item.allVersionIds.split(',');if(allVersionIdsArrs.length>1){allVersionIdsArrs.map(function(allVersionIdsItem){if(allVersionIdsItem!=''){wfIds.push(allVersionIdsItem);}});}else{wfIds.push(allVersionIdsArrs.join(''));}}});var viewType='';if(data[0].dropMenuValue=='1'){_datas[index].menunamemultlang=getLabel(84759,'新建流程');_datas[index].menuname=getLabel(84759,'新建流程');var _jsonstr3='wfRange='+wfIds.toString();_datas[index].menulink=data[0].dropMenuUrl+_jsonstr3;this.setState({datas:_datas});return;}else if(data[0].dropMenuValue=='2'){_datas[index].menunamemultlang=getLabel(1207,'待办事宜');_datas[index].menuname=getLabel(1207,'待办事宜');viewType='1';}else if(data[0].dropMenuValue=='3'){_datas[index].menunamemultlang=getLabel(84758,'已办事宜');_datas[index].menuname=getLabel(84758,'已办事宜');viewType='2';}else if(data[0].dropMenuValue=='4'){_datas[index].menunamemultlang=getLabel(17992,'办结事宜');_datas[index].menuname=getLabel(17992,'办结事宜');viewType='3';}else if(data[0].dropMenuValue=='5'){_datas[index].menunamemultlang=getLabel(21639,'抄送事宜');_datas[index].menuname=getLabel(21639,'抄送事宜');viewType='5';}else if(data[0].dropMenuValue=='6'){_datas[index].menunamemultlang=getLabel(21640,'督办事宜');_datas[index].menuname=getLabel(21640,'督办事宜');viewType='6';}else if(data[0].dropMenuValue=='7'){_datas[index].menunamemultlang=getLabel(1210,'我的请求');_datas[index].menuname=getLabel(1210,'我的请求');viewType='4';}var jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0};if(viewType=='2'){jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0,isArrangement:1};}else if(viewType=='1'){jsonstr={flowids:wfIds,viewType:viewType,typeids:wftypeIds,isExclude:0,showView:1};}else if(viewType=='6'){// 督办
var _jsonstr4='workflowId='+wfIds.toString();_datas[index].menulink=data[0].dropMenuUrl+escape((0,_stringify2.default)(_jsonstr4));_datas[index].menulink='/spa/workflow/index_mobx.jsp#/main/workflow/supervise?fromwhere=jsonFilter&'+_jsonstr4;this.setState({datas:_datas});return;}_datas[index].menulink=data[0].dropMenuUrl+escape((0,_stringify2.default)(jsonstr));}this.setState({datas:_datas});}else{_datas[index].menunamemultlang='';_datas[index].menuname='';this.setState({datas:_datas});}}},{key:'getColumns',value:function getColumns(){var _this3=this;var datas=this.state.datas;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var columns=[{title:getLabel(385808,'菜单地址'),dataIndex:'menutype',display:'true',key:'menutype',width:'15%',com:[{label:'',type:'SELECT',editType:'1',// select 组件属性，参看具体组件
key:'menutype',options:[{key:'0',selected:true,showname:getLabel(33496,'系统菜单')},{key:'2',selected:false,showname:getLabel(31560,'系统页面')},{key:'1',selected:false,showname:getLabel(385809,'自定义URL')}],width:120,disabled:false,otherParams:{className:'test-className'}// 其它属性，会被平铺到组件上。
}]},{title:'',dataIndex:'menuname',display:'true',key:'menuname',width:'45%',com:[{key:'menuname',type:'CUSTOM',viewAttr:'3',render:function render(text,record,index){var loginButton='';if(record.menutype=='0'){var replaceDatas=[];if(record.menulink&&record.menuname){replaceDatas=[{id:record.menulink,name:record.menuname}];}loginButton=_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_WeaBrowser@kgx0wq@'+record.menuid,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',tabs:[{name:getLabel(33675,'前端菜单'),key:'1',dataParams:{sourcetype:'1'},conditionDataParams:{sourcetype:'1'}// mType:'left'
},{name:getLabel(33676,'后端菜单'),key:'2',dataParams:{sourcetype:'2'},conditionDataParams:{sourcetype:'2'}// mType:'top'
},{name:getLabel(18773,'自定义菜单'),key:'3',dataParams:{sourcetype:'3'},conditionDataParams:{sourcetype:'3'}// mType:'custom'
},{name:getLabel(23094,'系统门户页面'),key:'4',dataParams:{sourcetype:'4'},conditionDataParams:{sourcetype:'4'}// mType:'system'
}],type:'portalmenu',title:getLabel(33496,'系统菜单'),isMultCheckbox:true,isLoadAll:false,viewAttr:3,inputStyle:{width:'80%'},replaceDatas:replaceDatas,onChange:function onChange(ids,names,datas){_this3.onChangeBrowser(ids,names,datas,datas,index,'portalmenu');}});}else if(record.menutype=='1'){loginButton=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaInput,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_WeaInput@2qe1h8@'+record.menuid,style:{width:'80%'},viewAttr:3,value:record.menulink,onChange:function onChange(value){_datas[index].menulink=value;_datas[index].menuname=value;_this3.setState({datas:_datas});}}),_react2.default.createElement(_ecCom.WeaHelpfulTip,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_WeaHelpfulTip@n0hzkf@'+record.menuid,style:{display:'inline-block',padding:'0 0 8px 15px'},width:196// 如果要自定义宽度，在这里设置
,title:getLabel(386567,'外部地址，请在地址前加上http://或https://'),isCenter:true}));}else if(record.menutype=='2'){var _replaceDatas=[];if(record.menulink&&record.menuname){_replaceDatas=[{id:record.menulink,name:record.menuname}];}loginButton=_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_WeaBrowser@tmubl9@'+record.menuid,tabs:[{name:getLabel(22243,'文档'),key:'1',dataParams:{sourcetype:'1'}},{name:getLabel(30045,'流程'),key:'2',dataParams:{sourcetype:'2'}}],type:'systempage',title:getLabel(31560,'系统页面'),inputStyle:{width:'80%'},textDecoration:true,replaceDatas:_replaceDatas,viewAttr:3,onChange:function onChange(ids,names,datas){_this3.onChangeBrowser1(ids,names,datas,index,'systempage');},isSingle:false});}return _react2.default.createElement('div',{className:'wea-url'},_react2.default.createElement('div',{className:'wea-url-toolbarmore-upload'},loginButton));}}]},{title:getLabel(30173,'打开方式'),dataIndex:'linktype',display:'true',key:'linktype',width:'15%',com:[{label:'',type:'SELECT',editType:'1',// select 组件属性，参看具体组件
key:'linktype',options:[{key:'0',selected:true,showname:getLabel(20597,'默认窗口')},{key:'1',selected:false,showname:getLabel(18717,'弹出窗口')}],width:120}]},{title:getLabel(30828,'显示名称'),dataIndex:'menunamemultlang',display:'true',key:'menunamemultlang',width:'15%',className:'xsmc',com:[{label:'',type:'INPUT',viewAttr:3,editType:'1',key:'menunamemultlang',width:120,inputType:'multilang',isBase64:true}]}];return columns;}},{key:'onChangeMenuName',value:function onChangeMenuName(value,index){var datas=this.state.datas;var _datas=datas;_datas[index].menuname=value;this.setState({datas:_datas});}},{key:'onShowDrop',value:function onShowDrop(){this.setState({showDrop:!this.state.showDrop});}},{key:'getRowSelection',value:function getRowSelection(rowSelection){var sel=(0,_extends3.default)({},rowSelection);sel.getCheckboxProps=function(record){return{disabled:record.id=='1'};};return sel;}},{key:'getRightMenus',value:function getRightMenus(){var rightMenus=[];rightMenus.push({disabled:false,icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存')});rightMenus.push({disabled:false,icon:_react2.default.createElement('i',{className:'icon-coms-content-o'}),content:getLabel(31129,'取消')});return rightMenus;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){if(key=='0'){this.onSave();}else if(key=='1'){this.onCancel();}}},{key:'getData',value:function getData(){var _this4=this;this.setState({visible:true,loading:true});_ecCom.WeaTools.callApi('/api/portal/frequsemenu/getdata','POST',{parentid:0,setting:'setting'}).then(function(data){_this4.setState({loading:false,datas:data});});}},{key:'onSave',value:function onSave(){var _this5=this;var result=this.table.doValidate();var datas=this.state.datas;this.setState({loading:true});if(result.pass){_ecCom.WeaTools.callApi('/api/portal/frequsemenu/savedata','POST',{datas:(0,_stringify2.default)(datas)}).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);}else{_this5.setState({loading:false});_antd.message.success(getLabel(83551,'保存成功！'));_this5.setState({visible:false});if(_this5.props.callback&&typeof _this5.props.callback=='function'){_this5.props.callback();}}var portalThemeStore=_this5.props.portalThemeStore;portalThemeStore.getFreqUseMenu();});}}},{key:'onChangeSub',value:function onChangeSub(ids){var _this6=this;var datas=this.state.datas;if(ids==null||ids==''){return;}_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:_react2.default.createElement('div',null,_react2.default.createElement('div',null,getLabel(387399,'确定要同步当前的常用菜单设置到选择的分部吗？')),_react2.default.createElement('div',{style:{color:'red'}},getLabel(387400,'注意：此操作会删除用户已有的常用菜单'))),onOk:function onOk(){_this6.setState({loading:true});_ecCom.WeaTools.callApi('/api/portal/frequsemenu/syncfreqmenu','POST',{datas:(0,_stringify2.default)(datas),ids:ids}).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);}else{_antd.message.success(getLabel(387135,'同步成功！'));if(_this6.props.callback&&typeof _this6.props.callback=='function'){_this6.props.callback();}}});_this6.setState({loading:false});}});}},{key:'onCancel',value:function onCancel(){this.setState({visible:false});}}]);return E9FreqUseMenuSettingNew;}(_react2.default.Component))||_class)||_class);exports.default=E9FreqUseMenuSettingNew;var OperateMenu=function(_React$Component2){(0,_inherits3.default)(OperateMenu,_React$Component2);function OperateMenu(){(0,_classCallCheck3.default)(this,OperateMenu);return(0,_possibleConstructorReturn3.default)(this,(OperateMenu.__proto__||(0,_getPrototypeOf2.default)(OperateMenu)).apply(this,arguments));}(0,_createClass3.default)(OperateMenu,[{key:'render',value:function render(){var _this8=this;var _props=this.props,dropMenuDatas=_props.dropMenuDatas,onDropMenuClick=_props.onDropMenuClick,onShowDrop=_props.onShowDrop,showDrop=_props.showDrop,children=_props.children;var menu=dropMenuDatas?_react2.default.createElement(_antd.Menu,{ecId:(this&&this.props&&this.props.ecId||'')+'_Menu@1h91bv',mode:'vertical',onClick:function onClick(o){if(typeof onDropMenuClick==='function')onDropMenuClick(o.key);dropMenuDatas.forEach(function(d){if(d.key===o.key&&typeof d.onClick==='function')d.onClick(o.key);});}},dropMenuDatas.map(function(d,i){return _react2.default.createElement(Item,{ecId:(_this8&&_this8.props&&_this8.props.ecId||'')+'_Item@yqr7wu@'+(d.key||i),key:d.key||i,disabled:d.disabled},_react2.default.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return _react2.default.createElement('div',{className:'portal-portalsetting-moremenu-pop'},_react2.default.createElement('div',{className:'wea-new-top-drop-menu wea-right-menu',style:{display:showDrop?'block':'none'},onMouseLeave:onShowDrop},_react2.default.createElement('div',{className:'wea-right-menu-icon-background'}),menu),children);}}]);return OperateMenu;}(_react2.default.Component);

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(256);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(257),
    isObjectLike = __webpack_require__(85);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(258),
    equalArrays = __webpack_require__(164),
    equalByTag = __webpack_require__(292),
    equalObjects = __webpack_require__(296),
    getTag = __webpack_require__(170),
    isArray = __webpack_require__(84),
    isBuffer = __webpack_require__(138),
    isTypedArray = __webpack_require__(139);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(264),
    stackDelete = __webpack_require__(265),
    stackGet = __webpack_require__(266),
    stackHas = __webpack_require__(267),
    stackSet = __webpack_require__(268);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(80);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(80);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(80);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(80);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(136),
    MapCache = __webpack_require__(163);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(159),
    isMasked = __webpack_require__(272),
    isObject = __webpack_require__(161),
    toSource = __webpack_require__(162);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(137);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(273);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(276),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(136);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(277),
    hashDelete = __webpack_require__(278),
    hashGet = __webpack_require__(279),
    hashHas = __webpack_require__(280),
    hashSet = __webpack_require__(281);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(163),
    setCacheAdd = __webpack_require__(288),
    setCacheHas = __webpack_require__(289);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(137),
    Uint8Array = __webpack_require__(293),
    eq = __webpack_require__(158),
    equalArrays = __webpack_require__(164),
    mapToArray = __webpack_require__(294),
    setToArray = __webpack_require__(295);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(297);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(298),
    getSymbols = __webpack_require__(300),
    keys = __webpack_require__(303);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(299),
    isArray = __webpack_require__(84);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(301),
    stubArray = __webpack_require__(302);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(304),
    baseKeys = __webpack_require__(167),
    isArrayLike = __webpack_require__(169);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(305),
    isArguments = __webpack_require__(165),
    isArray = __webpack_require__(84),
    isBuffer = __webpack_require__(138),
    isIndex = __webpack_require__(308),
    isTypedArray = __webpack_require__(139);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isLength = __webpack_require__(166),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(160);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)(module)))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(313);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports, __webpack_require__(14), __webpack_require__(0), __webpack_require__(19)) :
	typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
	(factory((global.mobxReact = global.mobxReact || {}),global.mobx,global.React,global.ReactDOM));
}(this, (function (exports,mobx,React,ReactDOM) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;
var ReactDOM__default = 'default' in ReactDOM ? ReactDOM['default'] : ReactDOM;

var empty = {};

var empty_1 = empty.unstable_batchedUpdates;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
  function EventEmitter() {
    classCallCheck(this, EventEmitter);
    this.listeners = [];
  }

  createClass(EventEmitter, [{
    key: "on",
    value: function on(cb) {
      var _this = this;

      this.listeners.push(cb);
      return function () {
        var index = _this.listeners.indexOf(cb);
        if (index !== -1) _this.listeners.splice(index, 1);
      };
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (fn) {
        return fn(data);
      });
    }
  }]);
  return EventEmitter;
}();

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    return mobx.untracked(function () {
      componentName = componentName || '<<anonymous>>';
      propFullName = propFullName || propName;
      if (props[propName] == null) {
        if (isRequired) {
          var actual = props[propName] === null ? 'null' : 'undefined';
          return new Error('The ' + location + ' `' + propFullName + '` is marked as required ' + 'in `' + componentName + '`, but its value is `' + actual + '`.');
        }
        return null;
      } else {
        return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
      }
    });
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    return mobx.untracked(function () {
      if (allowNativeType) {
        if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
      }
      var mobxChecker = void 0;
      switch (mobxType) {
        case 'Array':
          mobxChecker = mobx.isObservableArray;break;
        case 'Object':
          mobxChecker = mobx.isObservableObject;break;
        case 'Map':
          mobxChecker = mobx.isObservableMap;break;
        default:
          throw new Error('Unexpected mobxType: ' + mobxType);
      }
      var propValue = props[propName];
      if (!mobxChecker(propValue)) {
        var preciseType = getPreciseType(propValue);
        var nativeTypeExpectationMessage = allowNativeType ? ' or javascript `' + mobxType.toLowerCase() + '`' : '';
        return new Error('Invalid prop `' + propFullName + '` of type `' + preciseType + '` supplied to' + ' `' + componentName + '`, expected `mobx.Observable' + mobxType + '`' + nativeTypeExpectationMessage + '.');
      }
      return null;
    });
  });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
      rest[_key2 - 5] = arguments[_key2];
    }

    return mobx.untracked(function () {
      if (typeof typeChecker !== 'function') {
        return new Error('Property `' + propFullName + '` of component `' + componentName + '` has ' + 'invalid PropType notation.');
      }
      var error = createObservableTypeCheckerCreator(allowNativeType, 'Array')(props, propName, componentName);
      if (error instanceof Error) return error;
      var propValue = props[propName];
      for (var i = 0; i < propValue.length; i++) {
        error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + '[' + i + ']'].concat(rest));
        if (error instanceof Error) return error;
      }
      return null;
    });
  });
}

var observableArray = createObservableTypeCheckerCreator(false, 'Array');
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, 'Map');
var observableObject = createObservableTypeCheckerCreator(false, 'Object');
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, 'Array');
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, 'Object');



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

var index = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};

function isStateless(component) {
  return !component.prototype.render;
}

var injectorContextTypes = {
  mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
  contextTypes: {
    get: function get$$1() {
      return injectorContextTypes;
    },
    set: function set$$1(_) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: true,
    enumerable: false
  },
  isMobxInjector: {
    value: true,
    writable: true,
    configurable: true,
    enumerable: true
  }
};

/**
 * Store Injection
 */
function createStoreInjector(grabStoresFn, component, injectNames) {
  var _class, _temp2;

  var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
  if (injectNames) displayName += "-with-" + injectNames;

  var Injector = (_temp2 = _class = function (_Component) {
    inherits(Injector, _Component);

    function Injector() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, Injector);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
        _this.wrappedInstance = instance;
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Injector, [{
      key: 'render',
      value: function render() {
        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
        // See this test: 'using a custom injector is not too reactive' in inject.js
        var newProps = {};
        for (var key in this.props) {
          if (this.props.hasOwnProperty(key)) {
            newProps[key] = this.props[key];
          }
        }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
        for (var _key2 in additionalProps) {
          newProps[_key2] = additionalProps[_key2];
        }

        if (!isStateless(component)) {
          newProps.ref = this.storeRef;
        }

        return React__default.createElement(component, newProps);
      }
    }]);
    return Injector;
  }(React.Component), _class.displayName = displayName, _temp2);

  // Static fields from component should be visible on the generated Injector

  index(Injector, component);

  Injector.wrappedComponent = component;
  Object.defineProperties(Injector, proxiedInjectorProps);

  return Injector;
}

function grabStoresByName(storeNames) {
  return function (baseStores, nextProps) {
    storeNames.forEach(function (storeName) {
      if (storeName in nextProps) // prefer props over stores
        return;
      if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
      nextProps[storeName] = baseStores[storeName];
    });
    return nextProps;
  };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
  var grabStoresFn = void 0;
  if (typeof arguments[0] === "function") {
    grabStoresFn = arguments[0];
    return function (componentClass) {
      var injected = createStoreInjector(grabStoresFn, componentClass);
      injected.isMobxInjector = false; // supress warning
      // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
      // see #111
      injected = observer(injected);
      injected.isMobxInjector = true; // restore warning
      return injected;
    };
  } else {
    var storeNames = [];
    for (var i = 0; i < arguments.length; i++) {
      storeNames[i] = arguments[i];
    }grabStoresFn = grabStoresByName(storeNames);
    return function (componentClass) {
      return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
    };
  }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode(component) {
  if (ReactDOM__default) {
    try {
      return ReactDOM__default.findDOMNode(component);
    } catch (e) {
      // findDOMNode will throw in react-test-renderer, see:
      // See https://github.com/mobxjs/mobx-react/issues/216
      // Is there a better heuristic?
      return null;
    }
  }
  return null;
}

function reportRendering(component) {
  var node = findDOMNode(component);
  if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

  renderReporter.emit({
    event: 'render',
    renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
    totalTime: Date.now() - component.__$mobRenderStart,
    component: component,
    node: node
  });
}

function trackComponents() {
  if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
  if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
  isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
  var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var base = target[funcName];
  var mixinFunc = reactiveMixin[funcName];
  var f = !base ? mixinFunc : runMixinFirst === true ? function () {
    mixinFunc.apply(this, arguments);
    base.apply(this, arguments);
  } : function () {
    base.apply(this, arguments);
    mixinFunc.apply(this, arguments);
  };

  // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
  // ...but that breaks react-hot-loader, see #231...
  target[funcName] = f;
}

function isObjectShallowModified(prev, next) {
  if (null == prev || null == next || (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) !== "object" || (typeof next === 'undefined' ? 'undefined' : _typeof(next)) !== "object") {
    return prev !== next;
  }
  var keys = Object.keys(prev);
  if (keys.length !== Object.keys(next).length) {
    return true;
  }
  var key = void 0;
  for (var i = keys.length - 1; i >= 0, key = keys[i]; i--) {
    if (next[key] !== prev[key]) {
      return true;
    }
  }
  return false;
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
  componentWillMount: function componentWillMount() {
    var _this = this;

    if (isUsingStaticRendering === true) return;
    // Generate friendly name for debugging
    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID;

    /**
     * If props are shallowly modified, react will render anyway,
     * so atom.reportChanged() should not result in yet another re-render
     */
    var skipRender = false;
    /**
     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
     * so detect these changes
     */
    var isForcingUpdate = false;

    function makePropertyObservableReference(propName) {
      var valueHolder = this[propName];
      var atom = new mobx.Atom("reactive " + propName);
      Object.defineProperty(this, propName, {
        configurable: true, enumerable: true,
        get: function get$$1() {
          atom.reportObserved();
          return valueHolder;
        },
        set: function set$$1(v) {
          if (!isForcingUpdate && isObjectShallowModified(valueHolder, v)) {
            valueHolder = v;
            skipRender = true;
            atom.reportChanged();
            skipRender = false;
          } else {
            valueHolder = v;
          }
        }
      });
    }

    // make this.props an observable reference, see #124
    makePropertyObservableReference.call(this, "props");
    // make state an observable reference
    makePropertyObservableReference.call(this, "state");

    // wire up reactive render
    var baseRender = this.render.bind(this);
    var reaction = null;
    var isRenderingPending = false;

    var initialRender = function initialRender() {
      reaction = new mobx.Reaction(initialName + '#' + rootNodeID + '.render()', function () {
        if (!isRenderingPending) {
          // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
          // This unidiomatic React usage but React will correctly warn about this so we continue as usual
          // See #85 / Pull #44
          isRenderingPending = true;
          if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
          if (_this.__$mobxIsUnmounted !== true) {
            // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
            // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
            // However, people also claim this migth happen during unit tests..
            var hasError = true;
            try {
              isForcingUpdate = true;
              if (!skipRender) React__default.Component.prototype.forceUpdate.call(_this);
              hasError = false;
            } finally {
              isForcingUpdate = false;
              if (hasError) reaction.dispose();
            }
          }
        }
      });
      reactiveRender.$mobx = reaction;
      _this.render = reactiveRender;
      return reactiveRender();
    };

    var reactiveRender = function reactiveRender() {
      isRenderingPending = false;
      var exception = undefined;
      var rendering = undefined;
      reaction.track(function () {
        if (isDevtoolsEnabled) {
          _this.__$mobRenderStart = Date.now();
        }
        try {
          rendering = mobx.extras.allowStateChanges(false, baseRender);
        } catch (e) {
          exception = e;
        }
        if (isDevtoolsEnabled) {
          _this.__$mobRenderEnd = Date.now();
        }
      });
      if (exception) {
        errorsReporter.emit(exception);
        throw exception;
      }
      return rendering;
    };

    this.render = initialRender;
  },

  componentWillUnmount: function componentWillUnmount() {
    if (isUsingStaticRendering === true) return;
    this.render.$mobx && this.render.$mobx.dispose();
    this.__$mobxIsUnmounted = true;
    if (isDevtoolsEnabled) {
      var node = findDOMNode(this);
      if (node && componentByNodeRegistery) {
        componentByNodeRegistery.delete(node);
      }
      renderReporter.emit({
        event: 'destroy',
        component: this,
        node: node
      });
    }
  },

  componentDidMount: function componentDidMount() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (isUsingStaticRendering) {
      console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    }
    // update on any state changes (as is the default)
    if (this.state !== nextState) {
      return true;
    }
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return isObjectShallowModified(this.props, nextProps);
  }
};

/**
 * Observer function / decorator
 */
function observer(arg1, arg2) {
  if (typeof arg1 === "string") {
    throw new Error("Store names should be provided as array");
  }
  if (Array.isArray(arg1)) {
    // component needs stores
    if (!warnedAboutObserverInjectDeprecation) {
      warnedAboutObserverInjectDeprecation = true;
      console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
    }
    if (!arg2) {
      // invoked as decorator
      return function (componentClass) {
        return observer(arg1, componentClass);
      };
    } else {
      return inject.apply(null, arg1)(observer(arg2));
    }
  }
  var componentClass = arg1;

  if (componentClass.isMobxInjector === true) {
    console.warn('Mobx observer: You are trying to use \'observer\' on a component that already has \'inject\'. Please apply \'observer\' before applying \'inject\'');
  }

  // Stateless function component:
  // If it is function but doesn't seem to be a react class constructor,
  // wrap it to a react class automatically
  if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React__default.Component.isPrototypeOf(componentClass)) {
    var _class, _temp;

    return observer((_temp = _class = function (_Component) {
      inherits(_class, _Component);

      function _class() {
        classCallCheck(this, _class);
        return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      createClass(_class, [{
        key: 'render',
        value: function render() {
          return componentClass.call(this, this.props, this.context);
        }
      }]);
      return _class;
    }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
  }

  if (!componentClass) {
    throw new Error("Please pass a valid component to 'observer'");
  }

  var target = componentClass.prototype || componentClass;
  mixinLifecycleEvents(target);
  componentClass.isMobXReactObserver = true;
  return componentClass;
}

function mixinLifecycleEvents(target) {
  patch(target, "componentWillMount", true);
  ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
    patch(target, funcName);
  });
  if (!target.shouldComponentUpdate) {
    target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
  }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
  var children = _ref.children;
  return children();
});

Observer.propTypes = {
  children: function children(propValue, key, componentName, location, propFullName) {
    if (typeof propValue[key] !== 'function') return new Error('Invalid prop `' + propFullName + '` of type `' + _typeof(propValue[key]) + '` supplied to' + ' `' + componentName + '`, expected `function`.');
  }
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
  inherits(Provider, _Component);

  function Provider() {
    classCallCheck(this, Provider);
    return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  createClass(Provider, [{
    key: 'render',
    value: function render() {
      return React__default.Children.only(this.props.children);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var stores = {};
      // inherit stores
      var baseStores = this.context.mobxStores;
      if (baseStores) for (var key in baseStores) {
        stores[key] = baseStores[key];
      }
      // add own stores
      for (var _key in this.props) {
        if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
      }return {
        mobxStores: stores
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Maybe this warning is too aggressive?
      if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
      if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
        if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
    }
  }]);
  return Provider;
}(React.Component), _class.contextTypes = {
  mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
  mobxStores: objectOrObservableObject.isRequired
}, _temp);

var TARGET_LIB_NAME = void 0;
TARGET_LIB_NAME = 'mobx-react';
if (!mobx) throw new Error(TARGET_LIB_NAME + ' requires the MobX package');
if (!React__default) throw new Error(TARGET_LIB_NAME + ' requires React to be available');

if ("browser" === 'browser' && typeof ReactDOM.unstable_batchedUpdates === "function") mobx.extras.setReactionScheduler(ReactDOM.unstable_batchedUpdates);
if (false) mobx.extras.setReactionScheduler(empty_1);

var onError = function onError(fn) {
  return errorsReporter.on(fn);
};

/* DevTool support */
if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ? 'undefined' : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === 'object') {
  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(exports, mobx);
}

exports.propTypes = propTypes;
exports.PropTypes = propTypes;
exports.onError = onError;
exports['default'] = exports;
exports.observer = observer;
exports.Observer = Observer;
exports.renderReporter = renderReporter;
exports.componentByNodeRegistery = componentByNodeRegistery;
exports.trackComponents = trackComponents;
exports.useStaticRendering = useStaticRendering;
exports.Provider = Provider;
exports.inject = inject;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _E9QuickSearch=__webpack_require__(66);var _E9QuickSearch2=_interopRequireDefault(_E9QuickSearch);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8QuickSearch=function(_React$Component){(0,_inherits3.default)(E8QuickSearch,_React$Component);function E8QuickSearch(){(0,_classCallCheck3.default)(this,E8QuickSearch);return(0,_possibleConstructorReturn3.default)(this,(E8QuickSearch.__proto__||(0,_getPrototypeOf2.default)(E8QuickSearch)).apply(this,arguments));}(0,_createClass3.default)(E8QuickSearch,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e8header-quick-search'},_react2.default.createElement(_E9QuickSearch2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearch@8211ov'}));}}]);return E8QuickSearch;}(_react2.default.Component);exports.default=E8QuickSearch;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9QuickSearchTypes=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9QuickSearchTypes,_React$Component);function E9QuickSearchTypes(props){(0,_classCallCheck3.default)(this,E9QuickSearchTypes);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QuickSearchTypes.__proto__||(0,_getPrototypeOf2.default)(E9QuickSearchTypes)).call(this,props));_this.onQuickSearchTypesClick=_this.onQuickSearchTypesClick.bind(_this);return _this;}(0,_createClass3.default)(E9QuickSearchTypes,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var quickSearchTypes=portalThemeStore.quickSearchTypes;return _react2.default.createElement('div',{className:'e9header-quick-search-types-content'},quickSearchTypes.map(function(item,index){var type=item.type,name=item.name,icon=item.icon;var iconCom=null;if(icon){if(type==10){iconCom=_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(icon),alt:''});}else{iconCom=_react2.default.createElement('i',{className:icon,style:{fontSize:'16px',marginLeft:'1px',marginTop:'-8px'}});}}else{iconCom=_react2.default.createElement('i',{className:'wevicon-quick-search-'+type});}return _react2.default.createElement('div',{key:index,className:'e9header-quick-search-types-item',title:name,onClick:function onClick(){return _this2.onQuickSearchTypesClick(item);}},iconCom,_react2.default.createElement('span',null,name));}));}},{key:'onQuickSearchTypesClick',value:function onQuickSearchTypesClick(item){this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onQuickSearchTypesSelectedChange(item);}}]);return E9QuickSearchTypes;}(_react2.default.Component))||_class)||_class);exports.default=E9QuickSearchTypes;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9QuickSearchRcmd=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9QuickSearchRcmd,_React$Component);function E9QuickSearchRcmd(props){(0,_classCallCheck3.default)(this,E9QuickSearchRcmd);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QuickSearchRcmd.__proto__||(0,_getPrototypeOf2.default)(E9QuickSearchRcmd)).call(this,props));_this.onScroll=_this.onScroll.bind(_this);_this.onMenuClick=_this.onMenuClick.bind(_this);_this.onRcmdClick=_this.onRcmdClick.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}(0,_createClass3.default)(E9QuickSearchRcmd,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var $input=jQuery('#e9header-quick-search-input');$input.unbind('keydown');$input.keydown(function(e){e=e||window.event;switch(e.keyCode){case 38:{var $li=jQuery('.e9header-quick-search-rcmd-li');var $activeli=jQuery('.e9header-quick-search-rcmd-li.active');var $prevli=$activeli.prev();if($activeli.length&&$prevli.length){var index=$prevli.index();_this2.refs.scroll.scroll(index*35);$li.removeClass('active');$prevli.addClass('active');}else{// const value = $input.val();
// $input.val('').focus().val(value);
}break;}case 40:{// $input.blur();
var _$li=jQuery('.e9header-quick-search-rcmd-li');var _$activeli=jQuery('.e9header-quick-search-rcmd-li.active');if(_$activeli.length){var $nextli=_$activeli.next();if($nextli.length){var _index=$nextli.index();if(_index>=3){_this2.refs.scroll.scroll(_index*35);}_$li.removeClass('active');$nextli.addClass('active');}}else{_$li.eq(0).addClass('active');}break;}case 13:{var _$li2=jQuery('.e9header-quick-search-rcmd-li');var _$activeli2=jQuery('.e9header-quick-search-rcmd-li.active');if(_$activeli2.length){_$activeli2.click();// 点击后重置
_$li2.removeClass('active');_this2.refs.scroll.scroll(0);}else{_this2.props.onTypeSearch();}}}});}},{key:'render',value:function render(){var _this3=this;var portalThemeStore=this.props.portalThemeStore;var quickSearchMenus=portalThemeStore.quickSearchMenus,quickSearchAssociate=portalThemeStore.quickSearchAssociate;var _quickSearchMenus=(0,_mobx.toJS)(quickSearchMenus);var _quickSearchAssociate=(0,_mobx.toJS)(quickSearchAssociate);var hasMenus=_quickSearchMenus&&_quickSearchMenus.length;var hasAssociate=_quickSearchAssociate&&_quickSearchAssociate.length;return _react2.default.createElement('div',{className:'e9header-quick-search-rcmd-content'},_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-result'},hasMenus||hasAssociate?_react2.default.createElement('div',{ref:'title',className:'e9header-quick-search-rcmd-title'},hasMenus?getLabel(23036,'菜单'):getLabel(385782,'大家都在找')):null,_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@0pzqbs',ref:'scroll',height:'100%',onScroll:this.onScroll},_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-list'},hasMenus?_react2.default.createElement('ul',{className:'e9header-quick-search-rcmd-ul'},_quickSearchMenus.map(function(item,index){var moduleId=item.moduleId,name=item.name;return _react2.default.createElement('li',{key:index,className:'e9header-quick-search-rcmd-li',title:name,onClick:function onClick(){return _this3.onMenuClick(item);}},_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-icon e9header-top-menu-color'+(Math.abs(parseInt(moduleId,10))&7)},_react2.default.createElement('i',{className:'wevicon-top-menu-default wevicon-top-menu-'+moduleId})),_react2.default.createElement('span',null,name));})):null,_react2.default.createElement('div',{ref:'wsrcmd'}),hasMenus&&hasAssociate?_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-title'},getLabel(385782,'大家都在找')):'',hasAssociate?_react2.default.createElement('ul',{className:'e9header-quick-search-rcmd-ul'},_quickSearchAssociate.map(function(item,index){return _react2.default.createElement('li',{key:index,className:'e9header-quick-search-rcmd-li',title:item,onClick:function onClick(){return _this3.onRcmdClick(item);}},item);})):null))),_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-result'},_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-title'},getLabel(385801,'搜索建议')),_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-search',onClick:this.props.onTypeSearch},_react2.default.createElement('i',{className:'icon-coms-search'}),_react2.default.createElement('span',null,getLabel(385802,'查看系统内容搜索结果')),_react2.default.createElement('i',{className:'icon-coms-Right'}))),_react2.default.createElement('div',{className:'e9header-quick-search-rcmd-tip'},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@zkcj5o',onChange:this.onClose},getLabel(385803,'下次不再显示')),_react2.default.createElement(_ecCom.WeaHelpfulTip,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaHelpfulTip@xbkhga',title:getLabel(385804,'关闭后可在个性化设置中再次打开本功能')})));}},{key:'onScroll',value:function onScroll(){var $title=jQuery(this.refs.title);var $wsrcmd=jQuery(this.refs.wsrcmd);var top=$wsrcmd.position().top;if(top<=0){$title.html(getLabel(385782,'大家都在找'));}else{$title.html(getLabel(23036,'菜单'));}}},{key:'onMenuClick',value:function onMenuClick(item){this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;var moduleId=item.moduleId,moduleName=item.moduleName,infoId=item.infoId,mobxrouteurl=item.mobxrouteurl,target=item.target;if(target=='mainFrame'){portalThemeStore.onTopMenuSelectedChange({id:moduleId,name:moduleName},infoId,mobxrouteurl);}portalThemeStore.onLoadMain(item);// 点击后重置
var $li=jQuery('.e9header-quick-search-rcmd-li');$li.removeClass('active');this.refs.scroll.scroll(0);}},{key:'onRcmdClick',value:function onRcmdClick(value){this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onQuickSearch({from:'theme',type:'9',value:value});}},{key:'onClose',value:function onClose(e){this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.setQuickSearchShowRcmd(e.target.checked?'0':'1');}}]);return E9QuickSearchRcmd;}(_react2.default.Component))||_class)||_class);exports.default=E9QuickSearchRcmd;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E8ToolBar=__webpack_require__(323);var _E8ToolBar2=_interopRequireDefault(_E8ToolBar);var _E8ToolBarMore=__webpack_require__(324);var _E8ToolBarMore2=_interopRequireDefault(_E8ToolBarMore);var _E8Logout=__webpack_require__(326);var _E8Logout2=_interopRequireDefault(_E8Logout);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8HeaderRight=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8HeaderRight,_React$Component);function E8HeaderRight(props){(0,_classCallCheck3.default)(this,E8HeaderRight);return(0,_possibleConstructorReturn3.default)(this,(E8HeaderRight.__proto__||(0,_getPrototypeOf2.default)(E8HeaderRight)).call(this,props));}(0,_createClass3.default)(E8HeaderRight,[{key:'componentDidMount',value:function componentDidMount(){var portalThemeStore=this.props.portalThemeStore;var pluginReload=portalThemeStore.pluginReload;if(pluginReload){portalThemeStore.getPlugins();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var logo=$('.e8header-left').width();var rleft=$('.e8header-right-menu').width();var rright=$('.e8header-right-toolbar').width();var wid=logo+rleft+rright+30;$('.e8theme-layout-container').css({'min-width':wid});}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$plu=portalThemeStore.pluginIds,pluginIds=_portalThemeStore$plu===undefined?[]:_portalThemeStore$plu,pluginInsertCount=portalThemeStore.pluginInsertCount;return _react2.default.createElement('div',{className:'e8header-right-toolbar'},pluginIds.map(function(item,index){return _react2.default.createElement('div',{key:index,id:item,className:'e8header-toolbar-plugin'});}),pluginInsertCount>0?_react2.default.createElement('div',{className:'e8header-toolbar-splitter'}):null,_react2.default.createElement(_E8ToolBar2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8ToolBar@903owl'}),_react2.default.createElement(_E8ToolBarMore2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8ToolBarMore@9qe28y'}),_react2.default.createElement(_E8Logout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8Logout@vxhg98'}));}}]);return E8HeaderRight;}(_react2.default.Component))||_class)||_class);exports.default=E8HeaderRight;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _E9ToolBar=__webpack_require__(171);var _E9ToolBar2=_interopRequireDefault(_E9ToolBar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8ToolBar=function(_React$Component){(0,_inherits3.default)(E8ToolBar,_React$Component);function E8ToolBar(){(0,_classCallCheck3.default)(this,E8ToolBar);return(0,_possibleConstructorReturn3.default)(this,(E8ToolBar.__proto__||(0,_getPrototypeOf2.default)(E8ToolBar)).apply(this,arguments));}(0,_createClass3.default)(E8ToolBar,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e8header-toolbar'},_react2.default.createElement(_E9ToolBar2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9ToolBar@amwhxg'}));}}]);return E8ToolBar;}(_react2.default.Component);exports.default=E8ToolBar;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _E9ToolBarMore=__webpack_require__(172);var _E9ToolBarMore2=_interopRequireDefault(_E9ToolBarMore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8ToolBarMore=function(_React$Component){(0,_inherits3.default)(E8ToolBarMore,_React$Component);function E8ToolBarMore(){(0,_classCallCheck3.default)(this,E8ToolBarMore);return(0,_possibleConstructorReturn3.default)(this,(E8ToolBarMore.__proto__||(0,_getPrototypeOf2.default)(E8ToolBarMore)).apply(this,arguments));}(0,_createClass3.default)(E8ToolBarMore,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e8header-toolbar-more'},_react2.default.createElement(_E9ToolBarMore2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9ToolBarMore@sz8w69'}));}}]);return E8ToolBarMore;}(_react2.default.Component);exports.default=E8ToolBarMore;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _weaPortalPublic=__webpack_require__(33);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_ecCom.WeaIntro.Step;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var IntroStep4=(_dec=(0,_mobxReact.inject)('portalIntroStore'),_dec2=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(IntroStep4,_React$Component);function IntroStep4(props){(0,_classCallCheck3.default)(this,IntroStep4);var _this=(0,_possibleConstructorReturn3.default)(this,(IntroStep4.__proto__||(0,_getPrototypeOf2.default)(IntroStep4)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);_this.onMenuClick=_this.onMenuClick.bind(_this);return _this;}(0,_createClass3.default)(IntroStep4,[{key:'render',value:function render(){var _this2=this;var _props=this.props,portalIntroStore=_props.portalIntroStore,portalThemeStore=_props.portalThemeStore;var intro_step=portalIntroStore.intro_step;var _portalThemeStore$too=portalThemeStore.toolbarMoreMenu,toolbarMoreMenu=_portalThemeStore$too===undefined?[]:_portalThemeStore$too,toolbarMoreMenuVisible=portalThemeStore.toolbarMoreMenuVisible,translatepage=portalThemeStore.translatepage;var _toolbarMoreMenu=(0,_mobx.toJS)(toolbarMoreMenu);if(_toolbarMoreMenu.length==0){return null;}return _react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@vt08uu',trigger:'click',placement:'bottomLeft',content:_react2.default.createElement(Step,{ecId:(this&&this.props&&this.props.ecId||'')+'_Step@csceyb',id:'portal-intro4'},_react2.default.createElement('div',{className:'e9header-toolbar-more-content'},_toolbarMoreMenu.map(function(item,index){var name=item.name,icon=item.icon,type=item.type;return _react2.default.createElement('div',{key:index,className:'e9header-toolbar-more-item',title:name,onClick:function onClick(){return _this2.onMenuClick(item);}},_react2.default.createElement('i',{className:icon,style:type=='cus'?{margin:'-7px 0 0 2px',fontSize:'14px'}:{}}),_react2.default.createElement('span',null,name,' '));}))),overlayClassName:translatepage=='1'?'e9header-toolbar-more-overlay-tran':'e9header-toolbar-more-overlay',visible:toolbarMoreMenuVisible,onVisibleChange:this.onVisibleChange,afterPopupVisibleChange:function afterPopupVisibleChange(v){return intro_step.intro4&&v&&setTimeout(function(){return window.portal_intro.goToStep(4);},150);}},_react2.default.createElement('div',{className:'e9header-toolbar-more-icon',title:getLabel(17499,'更多')},_react2.default.createElement(_weaPortalPublic.WeaPlugin,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPlugin@q2xv86',ref:'WeaPlugin'}),_react2.default.createElement(_weaPortalPublic.WeaLicense,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLicense@yejte8',ref:'WeaLicense'}),_react2.default.createElement(_weaPortalPublic.WeaVersion,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaVersion@30l554',ref:'WeaVersion'}),_react2.default.createElement(_weaPortalPublic.WeaSystemSetting,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSystemSetting@cwybvm',ref:'WeaSystemSetting'}),_react2.default.createElement('i',{className:'wevicon-toolbar-more'})));}},{key:'onVisibleChange',value:function onVisibleChange(visible){var _props2=this.props,portalIntroStore=_props2.portalIntroStore,portalThemeStore=_props2.portalThemeStore;var intro_step=portalIntroStore.intro_step;!intro_step.intro4&&portalThemeStore.onToolbarMoreMenuVisibleChange(visible);var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){themeLayoutMask.style.display='block';}else{themeLayoutMask.style.display='none';}}},{key:'onMenuClick',value:function onMenuClick(item){this.onVisibleChange(false);var id=item.id,url=item.url,mobxrouteurl=item.mobxrouteurl,linkmode=item.linkmode,_item$width=item.width,width=_item$width===undefined?700:_item$width,_item$height=item.height,height=_item$height===undefined?500:_item$height;if(linkmode=='1'){if(id=='3'||id=='5'||id=='6'||id=='8'){var ref={'3':'WeaPlugin','5':'WeaLicense','6':'WeaVersion','8':'WeaSystemSetting'}[id];this.refs[ref].onShow();}else{var dialog=_ecCom.WeaTools.createDialog({title:name,url:url,icon:'icon-coms-content',iconBgcolor:'#1a57a0',style:{width:width,height:height},parentClassName:'e9header-toolbar-dialog'});dialog.show();}}else{var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain({url:url,mobxrouteurl:mobxrouteurl,target:linkmode=='0'?'_blank':'mainFrame'});}}}]);return IntroStep4;}(_react2.default.Component))||_class)||_class)||_class);exports.default=IntroStep4;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8Logout=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8Logout,_React$Component);function E8Logout(props){(0,_classCallCheck3.default)(this,E8Logout);var _this=(0,_possibleConstructorReturn3.default)(this,(E8Logout.__proto__||(0,_getPrototypeOf2.default)(E8Logout)).call(this,props));_this.onLogout=_this.onLogout.bind(_this);return _this;}(0,_createClass3.default)(E8Logout,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e8header-logout',onClick:this.onLogout},_react2.default.createElement('div',{className:'e8header-logout-icon'},_react2.default.createElement('i',{className:'wevicon-account-logout'})));}},{key:'onLogout',value:function onLogout(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLogout();}}]);return E8Logout;}(_react2.default.Component))||_class)||_class);exports.default=E8Logout;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _weaPortalPublic=__webpack_require__(33);var _E8LeftMenuTop=__webpack_require__(328);var _E8LeftMenuTop2=_interopRequireDefault(_E8LeftMenuTop);var _E8LeftMenuBottom=__webpack_require__(330);var _E8LeftMenuBottom2=_interopRequireDefault(_E8LeftMenuBottom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E8LeftMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8LeftMenu,_React$Component);function E8LeftMenu(props){(0,_classCallCheck3.default)(this,E8LeftMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E8LeftMenu.__proto__||(0,_getPrototypeOf2.default)(E8LeftMenu)).call(this,props));_this.newheight=function(){var asdh=$('.e8aside-container').height()-$('.e8aside-container .e8left-lmt').height()-$('.e8aside-container .e8left-lmb').height();$('.e8aside-container #menuScrollWrapper').css({height:asdh});};_this.onSelect=_this.onSelect.bind(_this);_this.onModeChange=_this.onModeChange.bind(_this);return _this;}(0,_createClass3.default)(E8LeftMenu,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.newheight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.newheight);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadLeftMenuCount();}},{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the,leftMenuObj=portalThemeStore.leftMenuObj,leftMenuMode=portalThemeStore.leftMenuMode,translatepage=portalThemeStore.translatepage;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var leftcolor=themeData.leftcolor;var _leftMenuObj$leftMenu=leftMenuObj.leftMenu,leftMenu=_leftMenuObj$leftMenu===undefined?[]:_leftMenuObj$leftMenu,_leftMenuObj$leftMenu2=leftMenuObj.leftMenuSelected,leftMenuSelected=_leftMenuObj$leftMenu2===undefined?{}:_leftMenuObj$leftMenu2,leftMenuType=leftMenuObj.leftMenuType;var _leftMenu=(0,_mobx.toJS)(leftMenu);var _leftMenuSelected=(0,_mobx.toJS)(leftMenuSelected);var _selectedKey=_leftMenuSelected.id;return _react2.default.createElement('div',{className:'e8aside-container',style:leftcolor?{backgroundColor:leftcolor}:{}},_react2.default.createElement('div',{style:{width:'225px',height:'100%',display:leftMenuMode=='inline'?'block':'none'}},_react2.default.createElement(_weaPortalPublic.WeaMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMenu@g0wp99',mode:leftMenuMode,needSwitch:false,inlineWidth:225,verticalWidth:0,datas:leftMenuType=='email'&&leftMenuMode=='inline'?_leftMenu.slice(2):_leftMenu,defaultSelectedKey:_selectedKey,onSelect:this.onSelect,onModeChange:this.onModeChange,addonBefore:_react2.default.createElement(_E8LeftMenuTop2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8LeftMenuTop@4gjuw5',emailMenu:leftMenuType=='email'?_leftMenu:[],onSelect:this.onSelect}),addonBeforeHeight:leftMenuType=='email'?115:80,addonAfter:_react2.default.createElement(_E8LeftMenuBottom2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8LeftMenuBottom@cbnkbb'}),addonAfterHeight:48,translatepageheight:translatepage=='1'?30:0})),_react2.default.createElement('div',{className:'e8left-lmb-shrink',style:{display:leftMenuMode=='inline'?'block':'none'},title:getLabel(20721,'收缩'),onClick:function onClick(){return _this2.onModeChange('vertical');}}),_react2.default.createElement('div',{className:'e8left-lmb-expand',style:{display:leftMenuMode=='vertical'?'block':'none'},title:getLabel(15315,'展开'),onClick:function onClick(){return _this2.onModeChange('inline');}}));}},{key:'onSelect',value:function onSelect(key,item,type){window.isPortalRender=true;// type=0表示正常点击菜单，type=1表示点击菜单后面的图标
var portalThemeStore=this.props.portalThemeStore;if(type==1&&item.id=='536-53606'){// 邮件菜单，清空垃圾箱
portalThemeStore.onClearEmail(item);}else if(type==0&&(item.id==='536-53611'||item.id==='536-53610'||item.id==='536-53616')){// 我的文件夹和我的标签菜单不跳转路由
if(window.weaEmail&&window.weaEmail.functions&&typeof window.weaEmail.functions.updateMenuCount=='function'){window.weaEmail.functions.updateMenuCount(item);}}else{if(type==1){item.url=item.titleUrl;}portalThemeStore.onLeftMenuSelectedChange(item);portalThemeStore.onLoadMain(item);}}},{key:'onModeChange',value:function onModeChange(leftMenuMode){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuModeChange(leftMenuMode);}}]);return E8LeftMenu;}(_react2.default.Component))||_class)||_class);exports.default=E8LeftMenu;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _E8LeftMenuTop4Email=__webpack_require__(329);var _E8LeftMenuTop4Email2=_interopRequireDefault(_E8LeftMenuTop4Email);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E8LeftMenuTop=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8LeftMenuTop,_React$Component);function E8LeftMenuTop(props){(0,_classCallCheck3.default)(this,E8LeftMenuTop);var _this=(0,_possibleConstructorReturn3.default)(this,(E8LeftMenuTop.__proto__||(0,_getPrototypeOf2.default)(E8LeftMenuTop)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);_this.onOpenCard=_this.onOpenCard.bind(_this);_this.onAccountChange=_this.onAccountChange.bind(_this);_this.onFontSizeChange=_this.onFontSizeChange.bind(_this);_this.onLangChange=_this.onLangChange.bind(_this);return _this;}(0,_createClass3.default)(E8LeftMenuTop,[{key:'componentWillMount',value:function componentWillMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getAccount();portalThemeStore.getAccountMoreMenu();portalThemeStore.getTranslatepower();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var userwidth=$('.e8aside-container .e8left-lmt-hrm-user').width()+35;if(userwidth!=null){$('.e8aside-container .e8left-lmt-hrm-dept').css({'max-width':'calc( 100% - '+userwidth+'px )'});}}},{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var multiLangs=portalThemeStore.multiLangs,langId=portalThemeStore.langId,themeInfo=portalThemeStore.themeInfo,topMenuObj=portalThemeStore.topMenuObj,account=portalThemeStore.account,accountSize=portalThemeStore.accountSize,accountList=portalThemeStore.accountList,accountListVisible=portalThemeStore.accountListVisible,accountMoreMenu=portalThemeStore.accountMoreMenu,fontSettingVisible=portalThemeStore.fontSettingVisible,langSettingVisible=portalThemeStore.langSettingVisible,translatepower=portalThemeStore.translatepower,translatepage=portalThemeStore.translatepage;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData,_themeInfo$themeFontS=themeInfo.themeFontSize,themeFontSize=_themeInfo$themeFontS===undefined?'12':_themeInfo$themeFontS;var hrmcolor=themeData.hrmcolor;var _topMenuObj$topMenuSe=topMenuObj.topMenuSelected,topMenuSelected=_topMenuObj$topMenuSe===undefined?{}:_topMenuObj$topMenuSe;var topMenuId=topMenuSelected.id,topMenuName=topMenuSelected.sname,topMenuName2=topMenuSelected.fname;var curuserid=account.userid,_account$username=account.username,username=_account$username===undefined?'':_account$username,_account$deptname=account.deptname,deptname=_account$deptname===undefined?'':_account$deptname,showSearch=account.showSearch;var langText='';multiLangs.forEach(function(item){return item.id==langId&&(langText=item.language);});if(fontSettingVisible){$('.e8left-e9header-font-setting-overlay').css('display','block');}else{$('.e8left-e9header-font-setting-overlay').css('display','none');}if(langSettingVisible){$('.e8left-e9header-lang-setting-overlay').css('display','block');}else{$('.e8left-e9header-lang-setting-overlay').css('display','none');}var aclistCom=_react2.default.createElement('div',{id:'e9header-account-content',className:'e9header-account-content'},accountSize>1?_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'e9header-account-title'},_react2.default.createElement('span',null,getLabel(131608,'主次账号切换'))),showSearch?_react2.default.createElement('div',{className:'e9header-account-search'},_react2.default.createElement('div',{className:'e9header-account-search-title'},_react2.default.createElement('span',null,getLabel(507638,'分部'))),_react2.default.createElement('div',{className:'e9header-account-search-browser'},_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@9p3nr5',title:getLabel(507638,'分部'),type:164,isSingle:true,tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],hasAdvanceSerach:true,getPopupContainer:function getPopupContainer(){return document.getElementById('e9header-account-content');},onOpen:function onOpen(){return window.accountListVisible=true;},onClose:function onClose(){return window.accountListVisible=false;},onChange:function onChange(id){return portalThemeStore.getAccountList(id);}})),_react2.default.createElement('div',{style:{clear:'both'}})):null,_react2.default.createElement('div',{className:'e9header-account-splitter'})):null,_react2.default.createElement('div',{className:'e9header-account-list',style:accountSize>3?{overflowY:'scroll'}:{overflowY:'hidden'}},accountList.map(function(item,index){var userid=item.userid,usertype=item.usertype,username=item.username,jobs=item.jobs,subcompanyname=item.subcompanyname,deptname=item.deptname;deptname=subcompanyname+'/'+deptname;deptname=deptname=='/'?'':deptname;return _react2.default.createElement('div',{key:index},_react2.default.createElement('div',{className:'e9header-account-item'},_react2.default.createElement('div',{className:'e9header-account-item-img',onClick:function onClick(e){return _this2.onOpenCard(e,userid);}},_react2.default.createElement(_ecCom.WeaAvatar,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaAvatar@gfzazo@'+userid,userId:userid})),_react2.default.createElement('div',{className:'e9header-account-item-info',onClick:function onClick(e){if(userid!=curuserid){_this2.onAccountChange(userid);}else{_this2.onOpenCard(e,userid);}}},usertype=='0'&&_react2.default.createElement('span',{className:'e9header-account-item-usertype'},_react2.default.createElement('i',{className:'icon-coms02-Main-account-number'})),_react2.default.createElement('span',{title:username,className:'e9header-account-item-username',onClick:function onClick(e){return _this2.onOpenCard(e,userid);}},username),_react2.default.createElement('span',{title:jobs,className:'e9header-account-item-jobs'},jobs),_react2.default.createElement('br',null),_react2.default.createElement('div',{title:deptname,className:'e9header-account-item-deptname'},deptname)),accountSize>1&&userid==curuserid?_react2.default.createElement('i',{className:'icon-coms02-icon-Completion e9header-account-checked'}):''),_react2.default.createElement('div',{className:'e9header-account-splitter'}));})),_react2.default.createElement('div',{className:'e9header-account-setting'},accountMoreMenu.map(function(item,index){if(item.sType=='font'){return _react2.default.createElement(_antd.Popover,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Popover@xud0gl',key:index,trigger:'click',placement:'leftTop',content:_react2.default.createElement(FontSizeSettingContent,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_FontSizeSettingContent@4aqgi9',fontSize:themeFontSize,onChange:_this2.onFontSizeChange}),overlayClassName:'e8left-e9header-font-setting-overlay',visible:fontSettingVisible,onVisibleChange:function onVisibleChange(visible){return portalThemeStore.onFontSettingVisibleChange(visible);}},_react2.default.createElement('div',{className:'e9header-account-setting-item',title:item.name,style:{paddingRight:100}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name),_react2.default.createElement('span',{style:{position:'absolute',right:'40px'}},{12:getLabel(149,'默认'),14:getLabel(18145,'中'),16:getLabel(18144,'大')}[themeFontSize]),_react2.default.createElement('i',{className:'icon-coms-organization-right',style:{position:'absolute',right:'10px'}})));}else if(item.sType=='language'&&multiLangs&&multiLangs.length>1){return _react2.default.createElement('div',null,_react2.default.createElement(_antd.Popover,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Popover@vmax7b',key:index,trigger:'click',placement:'leftTop',content:_react2.default.createElement(LangSettingContent,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_LangSettingContent@a3rktj',langId:langId,multiLangs:multiLangs,onChange:_this2.onLangChange}),overlayClassName:'e8left-e9header-lang-setting-overlay',visible:langSettingVisible,onVisibleChange:function onVisibleChange(visible){return portalThemeStore.onLangSettingVisibleChange(visible);}},_react2.default.createElement('div',{className:'e9header-account-setting-item',title:item.name,style:{paddingRight:100}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name),_react2.default.createElement('span',{style:{position:'absolute',right:'40px'}},langText),_react2.default.createElement('i',{className:'icon-coms-organization-right',style:{position:'absolute',right:'10px'}}))),translatepower==true?_react2.default.createElement('div',{key:index+'.1',className:'e9header-account-setting-item',title:getLabel(518686,'翻译模式'),onClick:function onClick(){portalThemeStore.setTranslatepage(1);// 左侧菜单高度更正
var asdh=$('.e8aside-container').height()-$('.e8aside-container .e8left-lmt').height()-$('.e8aside-container .e8left-lmb').height()-30;$('.e8aside-container #menuScrollWrapper').css({height:asdh});}},_react2.default.createElement('i',{className:'icon-coms02-Translation'}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},getLabel(518686,'翻译模式'))):null);}return null;})));return _react2.default.createElement('div',{className:'e8left-lmt'},_react2.default.createElement('div',{className:'e8left-lmt-hrm',style:hrmcolor?{backgroundColor:hrmcolor}:{}},_react2.default.createElement('span',{className:''+(deptname==''?'e8left-lmt-hrm-userall':'e8left-lmt-hrm-user'),title:username,onClick:function onClick(){return portalThemeStore.onLoadMain({mobxrouteurl:'/hrm/card/cardInfo'});}},username),_react2.default.createElement('span',{className:'e8left-lmt-hrm-dept',style:deptname==''?{display:'none'}:{},title:deptname},deptname),_react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@jqz0i7',trigger:'click',placement:'bottom',content:aclistCom,overlayClassName:translatepage=='1'?'e8left-account-overlay-tran':'e8left-account-overlay',visible:accountListVisible,onVisibleChange:this.onVisibleChange},_react2.default.createElement('span',{className:'e8left-lmt-account-icon'},_react2.default.createElement('i',{className:'wevicon-account-arrow'})))),_react2.default.createElement('div',{className:'e8left-lmt-tmn',style:topMenuId=='536'?{borderBottom:'none'}:{}},_react2.default.createElement('span',null,translatepage=='1'?topMenuName2:topMenuName)),topMenuId=='536'?_react2.default.createElement(_E8LeftMenuTop4Email2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E8LeftMenuTop4Email@w997ri',emailMenu:this.props.emailMenu,onSelect:this.props.onSelect}):'');}},{key:'onVisibleChange',value:function onVisibleChange(visible){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onAccountListVisibleChange(visible);portalThemeStore.getTranslatepower();var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){themeLayoutMask.style.display='block';}else{themeLayoutMask.style.display='none';}}},{key:'onOpenCard',value:function onOpenCard(e,userid){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();this.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain({mobxrouteurl:'/hrm/card/cardInfo/'+userid});}},{key:'onAccountChange',value:function onAccountChange(userid){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onAccountChange(userid);}},{key:'onFontSizeChange',value:function onFontSizeChange(fontSize){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onFontSizeChange(fontSize);portalThemeStore.onFontSettingVisibleChange(false);}},{key:'onLangChange',value:function onLangChange(langId,langText){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLangChange(langId,langText);portalThemeStore.onLangSettingVisibleChange(false);}}]);return E8LeftMenuTop;}(_react2.default.Component))||_class)||_class);var FontSizeSettingContent=function(_React$Component2){(0,_inherits3.default)(FontSizeSettingContent,_React$Component2);function FontSizeSettingContent(){(0,_classCallCheck3.default)(this,FontSizeSettingContent);return(0,_possibleConstructorReturn3.default)(this,(FontSizeSettingContent.__proto__||(0,_getPrototypeOf2.default)(FontSizeSettingContent)).apply(this,arguments));}(0,_createClass3.default)(FontSizeSettingContent,[{key:'render',value:function render(){var _this4=this;var fontSize=this.props.fontSize;var selectedComp=_react2.default.createElement('i',{className:'icon-coms-Selected e9header-font-setting-selected'});return _react2.default.createElement('div',{className:'e9header-font-setting-content'},_react2.default.createElement('div',{className:'e9header-font-setting-item',onClick:function onClick(){return _this4.props.onChange('16');}},_react2.default.createElement('i',{className:'icon-coms-text',style:{fontSize:'16px'}}),_react2.default.createElement('span',{style:{fontSize:'16px',marginLeft:'8px'}},getLabel(18144,'大')),fontSize=='16'?selectedComp:''),_react2.default.createElement('div',{className:'e9header-font-setting-item',onClick:function onClick(){return _this4.props.onChange('14');}},_react2.default.createElement('i',{className:'icon-coms-text',style:{fontSize:'14px'}}),_react2.default.createElement('span',{style:{fontSize:'14px',marginLeft:'10px'}},getLabel(18145,'中')),fontSize=='14'?selectedComp:''),_react2.default.createElement('div',{className:'e9header-font-setting-item',onClick:function onClick(){return _this4.props.onChange('12');}},_react2.default.createElement('i',{className:'icon-coms-text',style:{fontSize:'12px'}}),_react2.default.createElement('span',{style:{fontSize:'12px',marginLeft:'12px'}},getLabel(149,'默认')),fontSize=='12'?selectedComp:''));}}]);return FontSizeSettingContent;}(_react2.default.Component);var LangSettingContent=function(_React$Component3){(0,_inherits3.default)(LangSettingContent,_React$Component3);function LangSettingContent(){(0,_classCallCheck3.default)(this,LangSettingContent);return(0,_possibleConstructorReturn3.default)(this,(LangSettingContent.__proto__||(0,_getPrototypeOf2.default)(LangSettingContent)).apply(this,arguments));}(0,_createClass3.default)(LangSettingContent,[{key:'render',value:function render(){var _this6=this;var selectedComp=_react2.default.createElement('i',{className:'icon-coms-Selected e9header-lang-setting-selected'});return _react2.default.createElement('div',{className:'e9header-lang-setting-content'},this.props.multiLangs.map(function(item,index){return _react2.default.createElement('div',{key:index,className:'e9header-lang-setting-item',onClick:function onClick(){return _this6.props.onChange(item.id,item.language);}},_react2.default.createElement('span',null,item.language),item.id==_this6.props.langId?selectedComp:'');}));}}]);return LangSettingContent;}(_react2.default.Component);exports.default=E8LeftMenuTop;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E8LeftMenuTop4Email=function(_React$Component){(0,_inherits3.default)(E8LeftMenuTop4Email,_React$Component);function E8LeftMenuTop4Email(props){(0,_classCallCheck3.default)(this,E8LeftMenuTop4Email);// type：写信（0），收信（1）
// dataItems：写信/收信的类型列表
var _this=(0,_possibleConstructorReturn3.default)(this,(E8LeftMenuTop4Email.__proto__||(0,_getPrototypeOf2.default)(E8LeftMenuTop4Email)).call(this,props));_this.state={type:0,visible:false,data:[],dataItems:[]};return _this;}(0,_createClass3.default)(E8LeftMenuTop4Email,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({data:nextProps.emailMenu});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,type=_state.type,visible=_state.visible,data=_state.data,dataItems=_state.dataItems;var writeEmailMenu=data[0]||{};var receiveEmailMenu=data[1]||{};var currentClassName=type==0?'e8left-lmt-email-item-ul-bc1':'e8left-lmt-email-item-ul-bc2';return _react2.default.createElement('div',{className:'e8left-lmt-email'},_react2.default.createElement('div',{className:'e8left-lmt-email-item',onClick:function onClick(){return _this2.onSelect(0,writeEmailMenu,0);}},_react2.default.createElement('div',{className:'e8left-lmt-email-title'},writeEmailMenu.name),_react2.default.createElement('div',{className:'e8left-lmt-email-dropdown',onClick:function onClick(e){return _this2.onSelectDropdown(e,0);}})),_react2.default.createElement('div',{className:'e8left-lmt-email-item',onClick:function onClick(){return _this2.onSelect(1,receiveEmailMenu,0);}},_react2.default.createElement('div',{className:'e8left-lmt-email-title'},receiveEmailMenu.name),_react2.default.createElement('div',{className:'e8left-lmt-email-dropdown',onClick:function onClick(e){return _this2.onSelectDropdown(e,1);}})),_react2.default.createElement('div',{className:'e8left-lmt-email-clear'}),visible?_react2.default.createElement('ul',{className:'e8left-lmt-email-item-ul '+currentClassName},dataItems.map(function(item,index){return _react2.default.createElement('li',{key:index,onClick:function onClick(){return _this2.onSelect(index,item,0);}},item.name);})):null);}},{key:'onSelectDropdown',value:function onSelectDropdown(e,type){e.stopPropagation();var data=this.state.data;var writeEmailMenu=data[0]||{};var receiveEmailMenu=data[1]||{};var dataItems=[];if(type==0){dataItems=writeEmailMenu.child||[];}else if(type==1){dataItems=receiveEmailMenu.child||[];}this.setState({type:type,visible:type!=this.state.type||!this.state.visible,dataItems:dataItems});}},{key:'onSelect',value:function onSelect(key,item,type){this.setState({visible:false});this.props.onSelect(key,item,type);}}]);return E8LeftMenuTop4Email;}(_react2.default.Component);exports.default=E8LeftMenuTop4Email;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _weaPortalPublic=__webpack_require__(33);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E8LeftMenuBottom=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E8LeftMenuBottom,_React$Component);function E8LeftMenuBottom(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,E8LeftMenuBottom);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=E8LeftMenuBottom.__proto__||(0,_getPrototypeOf2.default)(E8LeftMenuBottom)).call.apply(_ref,[this].concat(args))),_this),_this.onOpen=function(obj){var portalThemeStore=_this.props.portalThemeStore;portalThemeStore.onLoadMain(obj);},_this.onShowThemeCenter=function(){var portalThemeStore=_this.props.portalThemeStore;var _portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the;if(themeInfo.themeAppoint){_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(126325,'分部已指定主题模板，不能修改!')});}else{_this.refs.WeaThemeCenter.onShow();}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(E8LeftMenuBottom,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$acc=portalThemeStore.accountMoreMenu,accountMoreMenu=_portalThemeStore$acc===undefined?[]:_portalThemeStore$acc;return _react2.default.createElement('div',{className:'e8left-lmb'},_react2.default.createElement(_weaPortalPublic.WeaThemeCenter,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaThemeCenter@z3a5cq',ref:'WeaThemeCenter'}),accountMoreMenu.map(function(item,index){if(item.sType=='custom'){return _react2.default.createElement('div',{className:'e8left-lmb-item'},_react2.default.createElement('div',{key:index,className:'e8left-lmb-personal',onClick:function onClick(){return _this2.onOpen(item);}}));}else if(item.sType=='password'){return _react2.default.createElement('div',{className:'e8left-lmb-item'},_react2.default.createElement('div',{key:index,className:'e8left-lmb-password',onClick:function onClick(){return _this2.onOpen(item);}}));}else if(item.sType=='theme'){return _react2.default.createElement('div',{className:'e8left-lmb-item'},_react2.default.createElement('div',{key:index,className:'e8left-lmb-skin',onClick:_this2.onShowThemeCenter}));}}));}}]);return E8LeftMenuBottom;}(_react2.default.Component))||_class)||_class);exports.default=E8LeftMenuBottom;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);__webpack_require__(332);var _E9Header=__webpack_require__(347);var _E9Header2=_interopRequireDefault(_E9Header);var _E9LeftMenu=__webpack_require__(354);var _E9LeftMenu2=_interopRequireDefault(_E9LeftMenu);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9Theme=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Theme,_React$Component);function E9Theme(props){(0,_classCallCheck3.default)(this,E9Theme);var _this=(0,_possibleConstructorReturn3.default)(this,(E9Theme.__proto__||(0,_getPrototypeOf2.default)(E9Theme)).call(this,props));_this.exitTranslatepage=function(){var portalThemeStore=_this.props.portalThemeStore;portalThemeStore.setTranslatepage(0);// 左侧菜单高度更正
var asdh=$('.e9aside-container').height()-$('.e9aside-container .wea-intro-step').height()+30;$('.e9aside-container #menuScrollWrapper').css({height:asdh});};return _this;}(0,_createClass3.default)(E9Theme,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,_props$location=_props.location,location=_props$location===undefined?{}:_props$location,portalThemeStore=_props.portalThemeStore;var pathname=location.pathname,query=location.query;portalThemeStore.getTopMenu(pathname,query);}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$sea=portalThemeStore.searchParams,searchParams=_portalThemeStore$sea===undefined?{}:_portalThemeStore$sea,_portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the,translatepage=portalThemeStore.translatepage;var hideHeader=searchParams.hideHeader,hideAside=searchParams.hideAside;var themeColorType=themeInfo.themeColorType;var colorClassName=themeColorType?'e9theme-color-'+themeColorType:'';var contenttop='';if(hideHeader=='true'){contenttop=translatepage=='1'?'30px':'0px';}else{contenttop=translatepage=='1'?'85px':'55px';}return _react2.default.createElement('div',{className:'e9theme-layout-container '+colorClassName},translatepage=='1'?_react2.default.createElement('div',{className:'e9theme-translate'},_react2.default.createElement('div',{className:'trans-tips'},getLabel(518684,'您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')),_react2.default.createElement('div',{className:'trans-exit',onClick:this.exitTranslatepage},getLabel(518685,'退出翻译模式'))):null,hideHeader=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout-header',style:translatepage=='1'?{top:'30px'}:{top:'0px'}},_react2.default.createElement(_E9Header2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Header@a94fye'})),_react2.default.createElement('div',{className:'e9theme-layout-content',style:{top:contenttop}},_react2.default.createElement('div',{id:'themeLayoutMask',className:'e9theme-layout-mask'}),hideAside=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout-aside'},_react2.default.createElement(_E9LeftMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9LeftMenu@djnyzf'})),_react2.default.createElement('div',{className:'e9theme-layout-main',style:hideHeader=='true'&&hideAside=='true'?{padding:0}:{}},_react2.default.createElement('div',{id:'themeLayoutRoute',className:'e9theme-layout-route'},this.props.children),_react2.default.createElement('div',{id:'themeLayoutFrame',className:'e9theme-layout-frame'},_react2.default.createElement('iframe',{id:'mainFrame',name:'mainFrame',src:'about:blank'})))));}}]);return E9Theme;}(_react2.default.Component))||_class)||_class);exports.default=E9Theme;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(333);__webpack_require__(334);__webpack_require__(335);__webpack_require__(336);__webpack_require__(337);__webpack_require__(338);__webpack_require__(339);__webpack_require__(340);__webpack_require__(341);__webpack_require__(342);__webpack_require__(343);__webpack_require__(344);__webpack_require__(345);__webpack_require__(346);

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9TopLogo=__webpack_require__(86);var _E9TopLogo2=_interopRequireDefault(_E9TopLogo);var _E9Home=__webpack_require__(140);var _E9Home2=_interopRequireDefault(_E9Home);var _E9TopMenu=__webpack_require__(348);var _E9TopMenu2=_interopRequireDefault(_E9TopMenu);var _E9FreqUseMenu=__webpack_require__(78);var _E9FreqUseMenu2=_interopRequireDefault(_E9FreqUseMenu);var _E9QuickSearch=__webpack_require__(66);var _E9QuickSearch2=_interopRequireDefault(_E9QuickSearch);var _E9HeaderRight=__webpack_require__(87);var _E9HeaderRight2=_interopRequireDefault(_E9HeaderRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Header=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Header,_React$Component);function E9Header(){(0,_classCallCheck3.default)(this,E9Header);return(0,_possibleConstructorReturn3.default)(this,(E9Header.__proto__||(0,_getPrototypeOf2.default)(E9Header)).apply(this,arguments));}(0,_createClass3.default)(E9Header,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the;var _themeInfo$themeLogoW=themeInfo.themeLogoWidth,themeLogoWidth=_themeInfo$themeLogoW===undefined?'':_themeInfo$themeLogoW,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$header=styleConfig.header,header=_styleConfig$header===undefined?{}:_styleConfig$header;var fontSize=parseInt(header.fontSize||'12px');var logoWidth=themeLogoWidth==''?197:parseInt(themeLogoWidth);return _react2.default.createElement('div',{className:'e9header-container wea-f'+fontSize},_react2.default.createElement('div',{className:'e9header-left',style:{width:logoWidth}},_react2.default.createElement(_E9TopLogo2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9TopLogo@6pkaxa'})),_react2.default.createElement('div',{className:'e9header-right',style:{marginLeft:logoWidth}},_react2.default.createElement('div',{className:'e9header-right-menu'},_react2.default.createElement(_E9Home2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Home@lul5fr'}),_react2.default.createElement(_E9TopMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9TopMenu@g9njkk'}),_react2.default.createElement(_E9FreqUseMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9FreqUseMenu@7aag3q'}),_react2.default.createElement(_E9QuickSearch2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearch@dcf5i2'})),_react2.default.createElement(_E9HeaderRight2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9HeaderRight@z9rtme'})));}}]);return E9Header;}(_react2.default.Component))||_class)||_class);exports.default=E9Header;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _IntroStep=__webpack_require__(349);var _IntroStep2=_interopRequireDefault(_IntroStep);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9TopMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9TopMenu,_React$Component);function E9TopMenu(props){(0,_classCallCheck3.default)(this,E9TopMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E9TopMenu.__proto__||(0,_getPrototypeOf2.default)(E9TopMenu)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);_this.onTopMenuClick=_this.onTopMenuClick.bind(_this);return _this;}(0,_createClass3.default)(E9TopMenu,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the,_portalThemeStore$top=portalThemeStore.topMenuObj,topMenuObj=_portalThemeStore$top===undefined?{}:_portalThemeStore$top,topMenuVisible=portalThemeStore.topMenuVisible,translatepage=portalThemeStore.translatepage;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$topmenu=styleConfig.topmenu,topmenu=_styleConfig$topmenu===undefined?{}:_styleConfig$topmenu;var topmenustyle=topmenu.style,_topmenu$showCount=topmenu.showCount,showCount=_topmenu$showCount===undefined?6:_topmenu$showCount;var _topMenuObj$topMenu=topMenuObj.topMenu,topMenu=_topMenuObj$topMenu===undefined?[]:_topMenuObj$topMenu,_topMenuObj$topMenuSe=topMenuObj.topMenuSelected,topMenuSelected=_topMenuObj$topMenuSe===undefined?{}:_topMenuObj$topMenuSe;var _topMenu=(0,_mobx.toJS)(topMenu);var _topMenuSelected=(0,_mobx.toJS)(topMenuSelected);var selectedId=_topMenuSelected.id;if(topmenustyle=='text'){return _react2.default.createElement('div',{className:'e9header-top-menu2 '+(topMenuVisible?'e9header-top-menu2-open':''),onMouseLeave:function onMouseLeave(){return _this2.onVisibleChange(false);}},_react2.default.createElement('div',{className:'e9header-top-menu2-content',style:{maxWidth:showCount*60+56}},topMenuVisible?_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@ofz6wt',height:'100%'},_react2.default.createElement('div',{className:'e9header-top-menu2-items',style:{maxWidth:showCount*60+1,maxHeight:$(document.body).height()-10}},_topMenu.map(function(item,index){var id=item.id,name=item.name,fname=item.fname;var selected=id==selectedId;return _react2.default.createElement('div',{key:index,'data-id':id,className:'e9header-top-menu2-item '+(selected?'e9header-top-menu2-item-selected':''),title:translatepage=='1'?item.fname:item.name,onClick:function onClick(){return _this2.onTopMenuClick(item);}},translatepage=='1'?fname:name);}),_react2.default.createElement('div',{style:{clear:'both'}})),topMenu.length>showCount&&_react2.default.createElement('div',{className:'e9header-top-menu2-btn',onClick:function onClick(){return _this2.onVisibleChange(!topMenuVisible);}},_react2.default.createElement('i',{className:'icon-coms-List'})),_react2.default.createElement('div',{style:{clear:'both'}})):_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'e9header-top-menu2-items',style:{maxWidth:showCount*60+1}},_topMenu.map(function(item,index){var id=item.id,name=item.name,fname=item.fname;var selected=id==selectedId;return _react2.default.createElement('div',{key:index,'data-id':id,className:'e9header-top-menu2-item '+(selected?'e9header-top-menu2-item-selected':''),title:translatepage=='1'?item.fname:item.name,onClick:function onClick(){return _this2.onTopMenuClick(item);}},translatepage=='1'?fname:name);}),_react2.default.createElement('div',{style:{clear:'both'}})),topMenu.length>showCount&&_react2.default.createElement('div',{className:'e9header-top-menu2-btn',onClick:function onClick(){return _this2.onVisibleChange(!topMenuVisible);}},_react2.default.createElement('i',{className:'icon-coms-List'})),_react2.default.createElement('div',{style:{clear:'both'}}))));}return _react2.default.createElement('div',{className:'e9header-top-menu'},_react2.default.createElement(_IntroStep2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_IntroStep1@jylky3'}));}},{key:'onVisibleChange',value:function onVisibleChange(visible){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onTopMenuVisibleChange(visible);}},{key:'onTopMenuClick',value:function onTopMenuClick(topMenuSelected){this.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onTopMenuSelectedChange(topMenuSelected);}}]);return E9TopMenu;}(_react2.default.Component))||_class)||_class);exports.default=E9TopMenu;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _E9TopMenuContent=__webpack_require__(350);var _E9TopMenuContent2=_interopRequireDefault(_E9TopMenuContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_ecCom.WeaIntro.Step,Intro=_ecCom.WeaIntro.Intro;var IntroStep1=(_dec=(0,_mobxReact.inject)('portalIntroStore'),_dec2=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(IntroStep1,_React$Component);function IntroStep1(props){(0,_classCallCheck3.default)(this,IntroStep1);var _this=(0,_possibleConstructorReturn3.default)(this,(IntroStep1.__proto__||(0,_getPrototypeOf2.default)(IntroStep1)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);return _this;}(0,_createClass3.default)(IntroStep1,[{key:'render',value:function render(){var _props=this.props,portalIntroStore=_props.portalIntroStore,portalThemeStore=_props.portalThemeStore;var intro_step=portalIntroStore.intro_step;var _portalThemeStore$top=portalThemeStore.topMenuObj,topMenuObj=_portalThemeStore$top===undefined?{}:_portalThemeStore$top,topMenuVisible=portalThemeStore.topMenuVisible,translatepage=portalThemeStore.translatepage;var _topMenuObj$topMenuSe=topMenuObj.topMenuSelected,topMenuSelected=_topMenuObj$topMenuSe===undefined?{}:_topMenuObj$topMenuSe;var selectedName=topMenuSelected.name,tran_selectedName=topMenuSelected.fname;return _react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@hmhmuq',trigger:'hover',placement:'bottomLeft',content:_react2.default.createElement(Step,{ecId:(this&&this.props&&this.props.ecId||'')+'_Step@pp6y2s',id:'portal-intro1'},_react2.default.createElement(_E9TopMenuContent2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9TopMenuContent@dkhawp',onVisibleChange:this.onVisibleChange})),overlayClassName:translatepage=='1'?'e9header-top-menu-overlay-tran':'e9header-top-menu-overlay',visible:topMenuVisible,onVisibleChange:this.onVisibleChange,afterPopupVisibleChange:function afterPopupVisibleChange(v){return intro_step.intro1&&v&&setTimeout(function(){return window.portal_intro.start();},500);}},_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'e9header-top-menu-icon'},_react2.default.createElement('i',{className:'wevicon-top-menu-common'})),_react2.default.createElement('div',{className:'e9header-top-menu-name wea-f14',title:translatepage=='1'?tran_selectedName:selectedName},translatepage=='1'?tran_selectedName:selectedName),_react2.default.createElement(Intro,{ecId:(this&&this.props&&this.props.ecId||'')+'_Intro@bsy0gz',onReady:function onReady(intro){window.portal_intro=intro;portalIntroStore.getPortalIntroInfo(portalThemeStore);}})));}},{key:'onVisibleChange',value:function onVisibleChange(visible){var _props2=this.props,portalIntroStore=_props2.portalIntroStore,portalThemeStore=_props2.portalThemeStore;var intro_step=portalIntroStore.intro_step;!intro_step.intro1&&portalThemeStore.onTopMenuVisibleChange(visible);var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){themeLayoutMask.style.display='block';portalThemeStore.onFreqUseMenuVisibleChange(false);portalThemeStore.onQuickSearchTypesVisibleChange(false);portalThemeStore.onQuickSearchRcmdVisibleChange(false);portalThemeStore.onToolbarMoreMenuVisibleChange(false);portalThemeStore.onAccountVisibleChange(false);}else{themeLayoutMask.style.display='none';}}}]);return IntroStep1;}(_react2.default.Component))||_class)||_class)||_class);exports.default=IntroStep1;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9TopMenuContent=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9TopMenuContent,_React$Component);function E9TopMenuContent(props){(0,_classCallCheck3.default)(this,E9TopMenuContent);var _this=(0,_possibleConstructorReturn3.default)(this,(E9TopMenuContent.__proto__||(0,_getPrototypeOf2.default)(E9TopMenuContent)).call(this,props));_this.onTopMenuClick=_this.onTopMenuClick.bind(_this);return _this;}(0,_createClass3.default)(E9TopMenuContent,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$top=portalThemeStore.topMenuObj,topMenuObj=_portalThemeStore$top===undefined?{}:_portalThemeStore$top,translatepage=portalThemeStore.translatepage;var _topMenuObj$topMenu=topMenuObj.topMenu,topMenu=_topMenuObj$topMenu===undefined?[]:_topMenuObj$topMenu,_topMenuObj$topMenuSe=topMenuObj.topMenuSelected,topMenuSelected=_topMenuObj$topMenuSe===undefined?{}:_topMenuObj$topMenuSe;var selectedId=topMenuSelected.id;return _react2.default.createElement('div',{className:'e9header-top-menu-content'},_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@6pg4wr',height:'100%'},_react2.default.createElement('div',{className:'e9header-top-menu-items'},topMenu.map(function(item,index){if(item&&item.id!='0'){var id=item.id,name=item.name,fname=item.fname,icon=item.icon,iconType=item.iconType,iconImgSrc=item.iconImgSrc;var selectedClassName=id==selectedId?'e9header-top-menu-selected':'';return _react2.default.createElement('div',{key:index,'data-id':id,className:'e9header-top-menu-item e9header-top-menu-color'+(Math.abs(parseInt(id,10))&7)+' '+selectedClassName,title:fname,onClick:function onClick(){return _this2.onTopMenuClick(item);}},_react2.default.createElement('div',{className:'e9header-top-menu-item-cover'},_react2.default.createElement('div',{className:'e9header-top-menu-item-icon'},iconType=='2'&&iconImgSrc?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(iconImgSrc),alt:'',width:'30px',height:'30px'}):icon?_react2.default.createElement('i',{className:icon,style:{fontSize:'30px'}}):_react2.default.createElement('i',{className:'wevicon-top-menu-default wevicon-top-menu-'+id})),_react2.default.createElement('div',{className:'e9header-top-menu-item-name'},translatepage=='1'?fname:name)));}return _react2.default.createElement('div',null);}))));}},{key:'onTopMenuClick',value:function onTopMenuClick(topMenuSelected){this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onTopMenuSelectedChange(topMenuSelected);}}]);return E9TopMenuContent;}(_react2.default.Component))||_class)||_class);exports.default=E9TopMenuContent;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _IntroStep=__webpack_require__(352);var _IntroStep2=_interopRequireDefault(_IntroStep);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Account=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Account,_React$Component);function E9Account(props){(0,_classCallCheck3.default)(this,E9Account);return(0,_possibleConstructorReturn3.default)(this,(E9Account.__proto__||(0,_getPrototypeOf2.default)(E9Account)).call(this,props));}(0,_createClass3.default)(E9Account,[{key:'componentWillMount',value:function componentWillMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.getAccount();portalThemeStore.getAccountMoreMenu();}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e9header-account'},_react2.default.createElement(_IntroStep2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_IntroStep5@855pt1'}));}}]);return E9Account;}(_react2.default.Component))||_class)||_class);exports.default=E9Account;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _E9AccountContent=__webpack_require__(353);var _E9AccountContent2=_interopRequireDefault(_E9AccountContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_ecCom.WeaIntro.Step;var IntroStep5=(_dec=(0,_mobxReact.inject)('portalIntroStore'),_dec2=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(IntroStep5,_React$Component);function IntroStep5(props){(0,_classCallCheck3.default)(this,IntroStep5);var _this=(0,_possibleConstructorReturn3.default)(this,(IntroStep5.__proto__||(0,_getPrototypeOf2.default)(IntroStep5)).call(this,props));_this.onVisibleChange=_this.onVisibleChange.bind(_this);return _this;}(0,_createClass3.default)(IntroStep5,[{key:'render',value:function render(){var _props=this.props,portalIntroStore=_props.portalIntroStore,portalThemeStore=_props.portalThemeStore;var _portalThemeStore$acc=portalThemeStore.account,account=_portalThemeStore$acc===undefined?{}:_portalThemeStore$acc,accountVisible=portalThemeStore.accountVisible,translatepage=portalThemeStore.translatepage;var intro_step=portalIntroStore.intro_step;var userid=account.userid,username=account.username,_account$showMore=account.showMore,showMore=_account$showMore===undefined?false:_account$showMore;if(showMore){return _react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@zvl3zq',trigger:'click',placement:'bottomLeft',content:_react2.default.createElement(Step,{ecId:(this&&this.props&&this.props.ecId||'')+'_Step@yu0src',id:'portal-intro5'},_react2.default.createElement(_E9AccountContent2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9AccountContent@0j6quu',onVisibleChange:this.onVisibleChange})),overlayClassName:translatepage=='1'?'e9header-account-overlay-tran':'e9header-account-overlay',visible:accountVisible,onVisibleChange:this.onVisibleChange,afterPopupVisibleChange:function afterPopupVisibleChange(v){return intro_step.intro5&&v&&setTimeout(function(){return window.portal_intro.goToStep(5);},150);}},_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'e9header-account-img'},_react2.default.createElement(_ecCom.WeaAvatar,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaAvatar@0qr9xm',userId:userid})),_react2.default.createElement('span',{className:'e9header-account-username'},username),_react2.default.createElement('span',{className:'e9header-account-icon'},_react2.default.createElement('i',{className:'wevicon-account-arrow'}))));}return _react2.default.createElement('div',{onClick:function onClick(){return portalThemeStore.onLoadMain({mobxrouteurl:'/hrm/card/cardInfo'});}},_react2.default.createElement('div',{className:'e9header-account-img'},_react2.default.createElement(_ecCom.WeaAvatar,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaAvatar@4dc2k0',userId:userid})),_react2.default.createElement('span',{className:'e9header-account-username'},username));}},{key:'onVisibleChange',value:function onVisibleChange(visible){var _props2=this.props,portalIntroStore=_props2.portalIntroStore,portalThemeStore=_props2.portalThemeStore;var intro_step=portalIntroStore.intro_step;!intro_step.intro5&&portalThemeStore.onAccountVisibleChange(visible);var themeLayoutMask=document.getElementById('themeLayoutMask');if(visible){portalThemeStore.getTranslatepower();themeLayoutMask.style.display='block';}else{themeLayoutMask.style.display='none';}}}]);return IntroStep5;}(_react2.default.Component))||_class)||_class)||_class);exports.default=IntroStep5;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _weaPortalPublic=__webpack_require__(33);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9AccountContent=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9AccountContent,_React$Component);function E9AccountContent(props){(0,_classCallCheck3.default)(this,E9AccountContent);var _this=(0,_possibleConstructorReturn3.default)(this,(E9AccountContent.__proto__||(0,_getPrototypeOf2.default)(E9AccountContent)).call(this,props));_this.onOpenCard=_this.onOpenCard.bind(_this);_this.onAccountChange=_this.onAccountChange.bind(_this);_this.onFontSizeChange=_this.onFontSizeChange.bind(_this);_this.onLangChange=_this.onLangChange.bind(_this);_this.onShowThemeCenter=_this.onShowThemeCenter.bind(_this);_this.onLogout=_this.onLogout.bind(_this);return _this;}(0,_createClass3.default)(E9AccountContent,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$mul=portalThemeStore.multiLangs,multiLangs=_portalThemeStore$mul===undefined?[]:_portalThemeStore$mul,langId=portalThemeStore.langId,_portalThemeStore$the=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the===undefined?{}:_portalThemeStore$the,_portalThemeStore$acc=portalThemeStore.account,account=_portalThemeStore$acc===undefined?{}:_portalThemeStore$acc,accountSize=portalThemeStore.accountSize,_portalThemeStore$acc2=portalThemeStore.accountList,accountList=_portalThemeStore$acc2===undefined?[]:_portalThemeStore$acc2,_portalThemeStore$acc3=portalThemeStore.accountMoreMenu,accountMoreMenu=_portalThemeStore$acc3===undefined?[]:_portalThemeStore$acc3,fontSettingVisible=portalThemeStore.fontSettingVisible,langSettingVisible=portalThemeStore.langSettingVisible,translatepower=portalThemeStore.translatepower;var _themeInfo$themeFontS=themeInfo.themeFontSize,themeFontSize=_themeInfo$themeFontS===undefined?'12':_themeInfo$themeFontS;var curuserid=account.userid,showSearch=account.showSearch;var langText='';multiLangs.forEach(function(item){return item.id==langId&&(langText=item.language);});return _react2.default.createElement('div',{id:'e9header-account-content',className:'e9header-account-content'},accountSize>1?_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'e9header-account-title'},_react2.default.createElement('span',null,getLabel(131608,'主次账号切换'))),showSearch?_react2.default.createElement('div',{className:'e9header-account-search'},_react2.default.createElement('div',{className:'e9header-account-search-title'},_react2.default.createElement('span',null,getLabel(507638,'分部'))),_react2.default.createElement('div',{className:'e9header-account-search-browser'},_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@evjmg3',title:getLabel(507638,'分部'),type:164,isSingle:true,tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],hasAdvanceSerach:true,getPopupContainer:function getPopupContainer(){return document.getElementById('e9header-account-content');},onOpen:function onOpen(){return window.accountVisible=true;},onClose:function onClose(){return window.accountVisible=false;},onChange:function onChange(id){return portalThemeStore.getAccountList(id);}})),_react2.default.createElement('div',{style:{clear:'both'}})):null,_react2.default.createElement('div',{className:'e9header-account-splitter'})):null,_react2.default.createElement('div',{className:'e9header-account-list',style:accountSize>3?{overflowY:'scroll'}:{overflowY:'hidden'}},accountList.map(function(item,index){var userid=item.userid,usertype=item.usertype,username=item.username,jobs=item.jobs,subcompanyname=item.subcompanyname,deptname=item.deptname;deptname=subcompanyname+'/'+deptname;deptname=deptname=='/'?'':deptname;return _react2.default.createElement('div',{key:index},_react2.default.createElement('div',{className:'e9header-account-item'},_react2.default.createElement('div',{className:'e9header-account-item-img',onClick:function onClick(e){return _this2.onOpenCard(e,userid);}},_react2.default.createElement(_ecCom.WeaAvatar,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaAvatar@votfw2@'+userid,userId:userid})),_react2.default.createElement('div',{className:'e9header-account-item-info',onClick:function onClick(e){if(accountSize>1&&userid!=curuserid){_this2.onAccountChange(userid);}else{_this2.onOpenCard(e,userid);}}},usertype=='0'&&_react2.default.createElement('span',{className:'e9header-account-item-usertype'},_react2.default.createElement('i',{className:'icon-coms02-Main-account-number'})),_react2.default.createElement('span',{title:username,className:'e9header-account-item-username',onClick:function onClick(e){return _this2.onOpenCard(e,userid);}},username),_react2.default.createElement('span',{title:jobs,className:'e9header-account-item-jobs'},jobs),_react2.default.createElement('br',null),_react2.default.createElement('div',{title:deptname,className:'e9header-account-item-deptname'},deptname)),accountSize>1&&userid==curuserid?_react2.default.createElement('i',{className:'icon-coms02-icon-Completion e9header-account-checked'}):''),_react2.default.createElement('div',{className:'e9header-account-splitter'}));})),_react2.default.createElement('div',{className:'e9header-account-setting'},accountMoreMenu.map(function(item,index){if(item.sType=='font'){return _react2.default.createElement(_antd.Popover,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Popover@ngqkwa',key:index,trigger:'click',placement:'leftTop',content:_react2.default.createElement(FontSizeSettingContent,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_FontSizeSettingContent@j6r2mq',fontSize:themeFontSize,onChange:_this2.onFontSizeChange}),overlayClassName:'e9header-font-setting-overlay',visible:fontSettingVisible,onVisibleChange:function onVisibleChange(visible){return portalThemeStore.onFontSettingVisibleChange(visible);}},_react2.default.createElement('div',{className:'e9header-account-setting-item',title:item.name,style:{paddingRight:100}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name),_react2.default.createElement(_ecCom.WeaHelpfulTip,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaHelpfulTip@hqyn95',title:getLabel(386450,'注意：字体大小修改只对使用系统标准样式的内容有效，对于用户自行定义的样式（例如：流程表单内容、文档内容）不生效')}),_react2.default.createElement('span',{style:{position:'absolute',right:'40px'}},{12:getLabel(149,'默认'),14:getLabel(18145,'中'),16:getLabel(18144,'大')}[themeFontSize]),_react2.default.createElement('i',{className:'icon-coms-organization-right',style:{position:'absolute',right:'10px'}})));}else if(item.sType=='language'&&multiLangs&&multiLangs.length>1){return _react2.default.createElement('div',null,_react2.default.createElement(_antd.Popover,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Popover@29g9u9',key:index,trigger:'click',placement:'leftTop',content:_react2.default.createElement(LangSettingContent,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_LangSettingContent@opxani',langId:langId,multiLangs:multiLangs,onChange:_this2.onLangChange}),overlayClassName:'e9header-lang-setting-overlay',visible:langSettingVisible,onVisibleChange:function onVisibleChange(visible){return portalThemeStore.onLangSettingVisibleChange(visible);}},_react2.default.createElement('div',{className:'e9header-account-setting-item',title:item.name,style:{paddingRight:100}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name),_react2.default.createElement('span',{style:{position:'absolute',right:'40px'}},langText),_react2.default.createElement('i',{className:'icon-coms-organization-right',style:{position:'absolute',right:'10px'}}))),translatepower==true?_react2.default.createElement('div',{key:index+'.1',className:'e9header-account-setting-item',title:getLabel(518686,'翻译模式'),onClick:function onClick(){_this2.props.onVisibleChange(false);portalThemeStore.setTranslatepage(1);// 左侧菜单高度更正
var asdh=$('.e9aside-container').height()-$('.e9aside-container .wea-intro-step').height()-30;$('.e9aside-container #menuScrollWrapper').css({height:asdh});}},_react2.default.createElement('i',{className:'icon-coms02-Translation'}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},getLabel(518686,'翻译模式'))):null);}else if(item.sType=='custom'){return _react2.default.createElement('div',{key:index,className:'e9header-account-setting-item',title:item.name,onClick:function onClick(){_this2.props.onVisibleChange(false);portalThemeStore.onLoadMain({url:item.url});}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name));}else if(item.sType=='password'){return _react2.default.createElement('div',{key:index,className:'e9header-account-setting-item',title:item.name,onClick:function onClick(){_this2.props.onVisibleChange(false);portalThemeStore.onLoadMain({url:item.url});}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name));}else if(item.sType=='theme'){return _react2.default.createElement('div',{key:index,className:'e9header-account-setting-item',title:item.name,onClick:function onClick(){_this2.props.onVisibleChange(false);_this2.onShowThemeCenter();}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name),_react2.default.createElement(_weaPortalPublic.WeaThemeCenter,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaThemeCenter@iuw0qq',ref:'WeaThemeCenter'}));}else if(item.sType=='layout'){return _react2.default.createElement('div',{key:index,className:'e9header-account-setting-item',title:item.name,onClick:function onClick(){_this2.props.onVisibleChange(false);_this2.refs.WeaThemeLayout.onShow();}},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name),_react2.default.createElement(_weaPortalPublic.WeaThemeLayout,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaThemeLayout@bqovyd',ref:'WeaThemeLayout'}));}else if(item.sType=='logout'){return _react2.default.createElement('div',{key:index,className:'e9header-account-setting-item',title:item.name,onClick:_this2.onLogout},_react2.default.createElement('i',{className:item.icon}),_react2.default.createElement('span',{className:'e9header-account-setting-title'},item.name));}return null;})));}},{key:'onOpenCard',value:function onOpenCard(e,userid){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain({mobxrouteurl:'/hrm/card/cardInfo/'+userid});}},{key:'onAccountChange',value:function onAccountChange(userid){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onAccountChange(userid);}},{key:'onFontSizeChange',value:function onFontSizeChange(fontSize){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onFontSizeChange(fontSize);portalThemeStore.onFontSettingVisibleChange(false);}},{key:'onLangChange',value:function onLangChange(langId,langText){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLangChange(langId,langText);portalThemeStore.onLangSettingVisibleChange(false);}},{key:'onShowThemeCenter',value:function onShowThemeCenter(){var portalThemeStore=this.props.portalThemeStore;var _portalThemeStore$the2=portalThemeStore.themeInfo,themeInfo=_portalThemeStore$the2===undefined?{}:_portalThemeStore$the2;if(themeInfo.themeAppoint){_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(126325,'分部已指定主题模板，不能修改!')});}else{this.refs.WeaThemeCenter.onShow();}}},{key:'onLogout',value:function onLogout(){this.props.onVisibleChange(false);var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLogout();}}]);return E9AccountContent;}(_react2.default.Component))||_class)||_class);var FontSizeSettingContent=function(_React$Component2){(0,_inherits3.default)(FontSizeSettingContent,_React$Component2);function FontSizeSettingContent(){(0,_classCallCheck3.default)(this,FontSizeSettingContent);return(0,_possibleConstructorReturn3.default)(this,(FontSizeSettingContent.__proto__||(0,_getPrototypeOf2.default)(FontSizeSettingContent)).apply(this,arguments));}(0,_createClass3.default)(FontSizeSettingContent,[{key:'render',value:function render(){var _this4=this;var fontSize=this.props.fontSize;var selectedCom=_react2.default.createElement('i',{className:'icon-coms-Selected e9header-font-setting-selected'});return _react2.default.createElement('div',{className:'e9header-font-setting-content'},_react2.default.createElement('div',{className:'e9header-font-setting-item',onClick:function onClick(){return _this4.props.onChange('16');}},_react2.default.createElement('i',{className:'icon-coms-text',style:{fontSize:'16px'}}),_react2.default.createElement('span',{style:{fontSize:'16px',marginLeft:'8px'}},getLabel(18144,'大')),fontSize=='16'?selectedCom:''),_react2.default.createElement('div',{className:'e9header-font-setting-item',onClick:function onClick(){return _this4.props.onChange('14');}},_react2.default.createElement('i',{className:'icon-coms-text',style:{fontSize:'14px'}}),_react2.default.createElement('span',{style:{fontSize:'14px',marginLeft:'10px'}},getLabel(18145,'中')),fontSize=='14'?selectedCom:''),_react2.default.createElement('div',{className:'e9header-font-setting-item',onClick:function onClick(){return _this4.props.onChange('12');}},_react2.default.createElement('i',{className:'icon-coms-text',style:{fontSize:'12px'}}),_react2.default.createElement('span',{style:{fontSize:'12px',marginLeft:'12px'}},getLabel(149,'默认')),fontSize=='12'?selectedCom:''));}}]);return FontSizeSettingContent;}(_react2.default.Component);var LangSettingContent=function(_React$Component3){(0,_inherits3.default)(LangSettingContent,_React$Component3);function LangSettingContent(){(0,_classCallCheck3.default)(this,LangSettingContent);return(0,_possibleConstructorReturn3.default)(this,(LangSettingContent.__proto__||(0,_getPrototypeOf2.default)(LangSettingContent)).apply(this,arguments));}(0,_createClass3.default)(LangSettingContent,[{key:'render',value:function render(){var _this6=this;var selectedCom=_react2.default.createElement('i',{className:'icon-coms-Selected e9header-lang-setting-selected'});return _react2.default.createElement('div',{className:'e9header-lang-setting-content'},this.props.multiLangs.map(function(item,index){return _react2.default.createElement('div',{key:index,className:'e9header-lang-setting-item',onClick:function onClick(){return _this6.props.onChange(item.id,item.language);}},_react2.default.createElement('span',null,item.language),item.id==_this6.props.langId?selectedCom:'');}));}}]);return LangSettingContent;}(_react2.default.Component);exports.default=E9AccountContent;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _weaPortalPublic=__webpack_require__(33);var _E9LeftMenuTop4Email=__webpack_require__(355);var _E9LeftMenuTop4Email2=_interopRequireDefault(_E9LeftMenuTop4Email);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9LeftMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9LeftMenu,_React$Component);function E9LeftMenu(props){(0,_classCallCheck3.default)(this,E9LeftMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E9LeftMenu.__proto__||(0,_getPrototypeOf2.default)(E9LeftMenu)).call(this,props));_this.newheight=function(){var asdh=$('.e9aside-container').height()-$('.e9aside-container .wea-intro-step').height();$('.e9aside-container #menuScrollWrapper').css({height:asdh});$('.wea-menu-vertical .ant-menu-vertical .ant-menu-submenu > .ant-menu-sub').css({maxHeight:asdh,overflow:'auto'});};_this.onSelect=_this.onSelect.bind(_this);_this.onModeChange=_this.onModeChange.bind(_this);return _this;}(0,_createClass3.default)(E9LeftMenu,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.newheight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.newheight);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadLeftMenuCount();}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo,leftMenuObj=portalThemeStore.leftMenuObj,leftMenuMode=portalThemeStore.leftMenuMode,translatepage=portalThemeStore.translatepage;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$leftmenu=styleConfig.leftmenu,leftmenu=_styleConfig$leftmenu===undefined?{}:_styleConfig$leftmenu;var fontSize=parseInt(leftmenu.titleFontSize||'12px');var _leftMenuObj$leftMenu=leftMenuObj.leftMenu,leftMenu=_leftMenuObj$leftMenu===undefined?[]:_leftMenuObj$leftMenu,_leftMenuObj$leftMenu2=leftMenuObj.leftMenuSelected,leftMenuSelected=_leftMenuObj$leftMenu2===undefined?{}:_leftMenuObj$leftMenu2,leftMenuType=leftMenuObj.leftMenuType;var _leftMenu=(0,_mobx.toJS)(leftMenu);var _leftMenuSelected=(0,_mobx.toJS)(leftMenuSelected);var _selectedKey=_leftMenuSelected.id;return _react2.default.createElement('div',{className:'e9aside-container'},_react2.default.createElement(_weaPortalPublic.WeaMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMenu@og5dar',mode:leftMenuMode,needSwitch:true,inlineWidth:197,verticalWidth:61,fontSize:fontSize,datas:leftMenuType=='email'&&leftMenuMode=='inline'?_leftMenu.slice(2):_leftMenu,defaultSelectedKey:_selectedKey,onSelect:this.onSelect,onModeChange:this.onModeChange,addonBefore:leftMenuType=='email'?_react2.default.createElement(_E9LeftMenuTop4Email2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9LeftMenuTop4Email@pggxty',emailMenu:_leftMenu,onSelect:this.onSelect}):null,addonBeforeHeight:leftMenuType=='email'?40:0,translatepageheight:translatepage=='1'?30:0,translatepage:translatepage}));}},{key:'onSelect',value:function onSelect(key,item,type){window.isPortalRender=true;// type=0表示正常点击菜单，type=1表示点击菜单后面的图标
var portalThemeStore=this.props.portalThemeStore;if(type==1&&item.id=='536-53606'){// 邮件菜单，清空垃圾箱
portalThemeStore.onClearEmail(item);}else if(type==0&&(item.id==='536-53611'||item.id==='536-53610'||item.id==='536-53616')){// 我的文件夹和我的标签菜单不跳转路由
if(window.weaEmail&&window.weaEmail.functions&&typeof window.weaEmail.functions.updateMenuCount=='function'){window.weaEmail.functions.updateMenuCount(item);}}else{if(type==1){item.url=item.titleUrl;}portalThemeStore.onLeftMenuSelectedChange(item);portalThemeStore.onLoadMain(item);}}},{key:'onModeChange',value:function onModeChange(leftMenuMode){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuModeChange(leftMenuMode);}}]);return E9LeftMenu;}(_react2.default.Component))||_class)||_class);exports.default=E9LeftMenu;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9LeftMenuTop4Email=function(_React$Component){(0,_inherits3.default)(E9LeftMenuTop4Email,_React$Component);function E9LeftMenuTop4Email(props){(0,_classCallCheck3.default)(this,E9LeftMenuTop4Email);// type：写信（0），收信（1）
// dataItems：写信/收信的类型列表
var _this=(0,_possibleConstructorReturn3.default)(this,(E9LeftMenuTop4Email.__proto__||(0,_getPrototypeOf2.default)(E9LeftMenuTop4Email)).call(this,props));_this.state={type:0,visible:false,data:props.emailMenu,dataItems:[]};return _this;}(0,_createClass3.default)(E9LeftMenuTop4Email,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({data:nextProps.emailMenu});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,type=_state.type,visible=_state.visible,data=_state.data,dataItems=_state.dataItems;var writeEmailMenu=data[0]||{};var receiveEmailMenu=data[1]||{};var currentClassName=type==0?'e9left-menu-email-item-ul-bc1':'e9left-menu-email-item-ul-bc2';var selectedClassName1=type==0&&visible?'e9left-menu-email-item-selected':'';var selectedClassName2=type==1&&visible?'e9left-menu-email-item-selected':'';return _react2.default.createElement('div',{className:'e9left-menu-email'},_react2.default.createElement('div',{className:'e9left-menu-email-item '+selectedClassName1,onClick:function onClick(){return _this2.onSelect(0,writeEmailMenu,0);}},_react2.default.createElement('i',{className:'wevicon wevicon-menu-default wevicon-menu-536-53601'}),_react2.default.createElement('span',{className:'e9left-menu-email-title',title:writeEmailMenu.name},writeEmailMenu.name),_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@rirm9y',type:'caret-down',onClick:function onClick(e){return _this2.onSelectDropdown(e,0);}})),_react2.default.createElement('div',{className:'e9left-menu-email-item '+selectedClassName2,onClick:function onClick(){return _this2.onSelect(1,receiveEmailMenu,0);}},_react2.default.createElement('i',{className:'wevicon wevicon-menu-default wevicon-menu-536-53602'}),_react2.default.createElement('span',{className:'e9left-menu-email-title',title:receiveEmailMenu.name},receiveEmailMenu.name),_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@li2e63',type:'caret-down',onClick:function onClick(e){return _this2.onSelectDropdown(e,1);}})),_react2.default.createElement('div',{className:'e9left-menu-email-clear '}),visible?_react2.default.createElement('ul',{className:'e9left-menu-email-item-ul '+currentClassName},dataItems.map(function(item,index){return _react2.default.createElement('li',{key:index,onClick:function onClick(){return _this2.onSelect(index,item,0);}},item.name);})):null);}},{key:'onSelectDropdown',value:function onSelectDropdown(e,type){e.stopPropagation();var data=this.state.data;var writeEmailMenu=data[0]||{};var receiveEmailMenu=data[1]||{};var dataItems=[];if(type==0){dataItems=writeEmailMenu.child||[];}else if(type==1){dataItems=receiveEmailMenu.child||[];}this.setState({type:type,visible:type!=this.state.type||!this.state.visible,dataItems:dataItems});}},{key:'onSelect',value:function onSelect(key,item,type){this.setState({visible:false});this.props.onSelect(key,item,type);}}]);return E9LeftMenuTop4Email;}(_react2.default.Component);exports.default=E9LeftMenuTop4Email;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);__webpack_require__(357);var _E9Header=__webpack_require__(173);var _E9Header2=_interopRequireDefault(_E9Header);var _E9NavMenu=__webpack_require__(359);var _E9NavMenu2=_interopRequireDefault(_E9NavMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9ThemeLayout2=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9ThemeLayout2,_React$Component);function E9ThemeLayout2(props){(0,_classCallCheck3.default)(this,E9ThemeLayout2);var _this=(0,_possibleConstructorReturn3.default)(this,(E9ThemeLayout2.__proto__||(0,_getPrototypeOf2.default)(E9ThemeLayout2)).call(this,props));_this.exitTranslatepage=function(){var portalThemeStore=_this.props.portalThemeStore;portalThemeStore.setTranslatepage(0);};return _this;}(0,_createClass3.default)(E9ThemeLayout2,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,portalThemeStore=_props.portalThemeStore,location=_props.location;var pathname=location.pathname,query=location.query;portalThemeStore.getTopMenu(pathname,query);}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var searchParams=portalThemeStore.searchParams,themeInfo=portalThemeStore.themeInfo,_portalThemeStore$fro=portalThemeStore.frontEndMenu,frontEndMenu=_portalThemeStore$fro===undefined?[]:_portalThemeStore$fro,translatepage=portalThemeStore.translatepage;var hideHeader=searchParams.hideHeader,hideAside=searchParams.hideAside;var themeColorType=themeInfo.themeColorType;var colorClassName=themeColorType?'e9theme-color-'+themeColorType:'';var navbartop='';if(hideHeader=='true'){navbartop=translatepage=='1'?'30px':'0px';}else{navbartop=translatepage=='1'?'85px':'55px';}var contenttop='';if(hideHeader=='true'&&hideAside=='true'){translatepage=='1'?contenttop='30px':contenttop='0px';}else if(hideHeader=='true'&&hideAside!='true'){translatepage=='1'?contenttop='85px':contenttop='55px';}else if(hideHeader!='true'&&hideAside=='true'){translatepage=='1'?contenttop='85px':contenttop='55px';}else{translatepage=='1'?contenttop='140px':contenttop='110px';}return _react2.default.createElement('div',{className:'e9theme-layout2-container '+colorClassName},translatepage=='1'?_react2.default.createElement('div',{className:'e9theme-translate'},_react2.default.createElement('div',{className:'trans-tips'},getLabel(518684,'您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')),_react2.default.createElement('div',{className:'trans-exit',onClick:this.exitTranslatepage},getLabel(518685,'退出翻译模式'))):null,hideHeader=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout2-header',style:translatepage=='1'?{top:'30px'}:{top:'0px'}},_react2.default.createElement(_E9Header2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Header@yunt21'})),hideAside=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout2-navbar',style:{top:navbartop}},frontEndMenu&&frontEndMenu.length>0&&_react2.default.createElement(_E9NavMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9NavMenu@ibs085'})),_react2.default.createElement('div',{className:'e9theme-layout2-content',style:{top:contenttop}},_react2.default.createElement('div',{id:'themeLayoutMask',className:'e9theme-layout2-mask'}),_react2.default.createElement('div',{className:'e9theme-layout2-main',style:hideHeader=='true'&&hideAside=='true'?{padding:0}:{}},_react2.default.createElement('div',{id:'themeLayoutRoute',className:'e9theme-layout2-route'},this.props.children),_react2.default.createElement('div',{id:'themeLayoutFrame',className:'e9theme-layout2-frame'},_react2.default.createElement('iframe',{id:'mainFrame',name:'mainFrame',src:'about:blank'})))));}}]);return E9ThemeLayout2;}(_react2.default.Component))||_class)||_class);exports.default=E9ThemeLayout2;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(358);

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);__webpack_require__(174);var _rcMenu=__webpack_require__(175);var _rcMenu2=_interopRequireDefault(_rcMenu);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var isScrolling=false;var E9NavMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9NavMenu,_React$Component);function E9NavMenu(props){(0,_classCallCheck3.default)(this,E9NavMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E9NavMenu.__proto__||(0,_getPrototypeOf2.default)(E9NavMenu)).call(this,props));_this.getNavMenu=_this.getNavMenu.bind(_this);_this.onNext=_this.onNext.bind(_this);_this.onPrev=_this.onPrev.bind(_this);_this.onTitleClick=_this.onTitleClick.bind(_this);_this.onSelect=_this.onSelect.bind(_this);_this.getData=_this.getData.bind(_this);_this.setHeight=_this.setHeight.bind(_this);return _this;}(0,_createClass3.default)(E9NavMenu,[{key:'componentDidMount',value:function componentDidMount(){var $menu=$('.e9navbar-container .pt-menu-root');var containerWidth=$(window).width()-72;var contentWidth=$menu.width();if(contentWidth>containerWidth){this.refs.prev.style.display='block';this.refs.next.style.display='block';}}},{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo,_portalThemeStore$fro=portalThemeStore.frontEndMenu,frontEndMenu=_portalThemeStore$fro===undefined?[]:_portalThemeStore$fro,leftMenuObj=portalThemeStore.leftMenuObj;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$leftmenu=styleConfig.leftmenu,leftmenu=_styleConfig$leftmenu===undefined?{}:_styleConfig$leftmenu;var fontSize=parseInt(leftmenu.titleFontSize||'12px');var _leftMenuObj$leftMenu=leftMenuObj.leftMenuSelected,leftMenuSelected=_leftMenuObj$leftMenu===undefined?{}:_leftMenuObj$leftMenu;var _frontEndMenu=(0,_mobx.toJS)(frontEndMenu);var _leftMenuSelected=(0,_mobx.toJS)(leftMenuSelected);var _selectedKeys=[_leftMenuSelected.id||''];return _react2.default.createElement('div',{className:'e9navbar-container wea-f'+fontSize},_react2.default.createElement('span',{ref:'prev',className:'e9navbar-prev',onClick:this.onPrev},_react2.default.createElement('span',{className:'ant-tabs-tab-prev-icon'})),_react2.default.createElement(_rcMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Menu@mliyu9',ref:function ref(_ref){return _this2.menuRef=_ref;},mode:'horizontal',prefixCls:'pt-menu',openAnimation:'zoom',subMenuCloseDelay:0.2,selectedKeys:_selectedKeys,onClick:this.onSelect,onOpenChange:this.setHeight},this.getNavMenu(_frontEndMenu,1,fontSize,_selectedKeys[0])),_react2.default.createElement('span',{ref:'next',className:'e9navbar-next',onClick:this.onNext},_react2.default.createElement('span',{className:'ant-tabs-tab-next-icon'})));}},{key:'getNavMenu',value:function getNavMenu(data,level,fontSize,_selectedKeys){var _this3=this;var portalThemeStore=this.props.portalThemeStore;var translatepage=portalThemeStore.translatepage;return data.map(function(item){var name=translatepage=='1'?item.fname?item.fname:item.name:item.name;if(item.child&&item.child.length){return _react2.default.createElement(_rcMenu.SubMenu,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_SubMenu@n75bka@'+item.id,key:item.id,popupClassName:'e9navbar-sub-container wea-f'+fontSize,className:_selectedKeys==item.id?'e9navbar-e9submenu-selected':'e9navbar-e9submenu-unselected',title:level==1?_react2.default.createElement('span',{className:'e9navbar-top-menu-icon'},item.iconType=='2'&&item.iconImgSrc?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item.iconImgSrc),alt:''}):item.icon?_react2.default.createElement('i',{className:item.icon}):_react2.default.createElement('i',{className:'wevicon-top-menu-default wevicon-top-menu-'+(item.infoId||0)}),_react2.default.createElement('span',{title:name},name)):_react2.default.createElement('span',{title:name},name),data:item,onTitleClick:function onTitleClick(){return _this3.onTitleClick(item);}},_this3.getNavMenu(item.child,level+1,fontSize,_selectedKeys));}return _react2.default.createElement(_rcMenu.Item,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_MenuItem@a2m3hp@'+item.id,key:item.id,data:item},level==1?_react2.default.createElement('div',{className:'pt-menu-item-title'},_react2.default.createElement('span',{className:'e9navbar-top-menu-icon'},item.iconType=='2'&&item.iconImgSrc?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item.iconImgSrc),alt:''}):item.icon?_react2.default.createElement('i',{className:item.icon}):_react2.default.createElement('i',{className:'wevicon-top-menu-default wevicon-top-menu-'+(item.infoId||0)}),_react2.default.createElement('span',{title:name},name))):_react2.default.createElement('span',{title:name},name));});}},{key:'setHeight',value:function setHeight(){if($('.pt-menu-submenu-popup ul').length>0){$('.pt-menu-submenu-popup ul').css({'max-height':$(window).height()-150,'overflow-x':'hidden','overflow-y':'auto'});}}},{key:'onNext',value:function onNext(){var $menu=$('.e9navbar-container .pt-menu-root');var containerWidth=$(window).width()-72;var contentWidth=$menu.width();var contentLeft=$menu.position().left;if(!isScrolling&&contentWidth+contentLeft>containerWidth){isScrolling=true;$menu.animate({left:contentLeft-containerWidth/2},300,function(){isScrolling=false;});}}},{key:'onPrev',value:function onPrev(){var $menu=$('.e9navbar-container .pt-menu-root');var containerWidth=$(window).width()-72;// const contentWidth = $menu.width();
var contentLeft=$menu.position().left;if(!isScrolling&&contentLeft<0){isScrolling=true;var leftValue=contentLeft*2+containerWidth;if(leftValue<=0){$menu.animate({left:contentLeft+containerWidth/2},300,function(){isScrolling=false;});}else{$menu.animate({left:0},300,function(){isScrolling=false;});}}}},{key:'onTitleClick',value:function onTitleClick(data){var portalThemeStore=this.props.portalThemeStore;if(data.mobxrouteurl||data.fullrouteurl||data.url&&data.url!='javascript:void(0);'){portalThemeStore.onLeftMenuSelectedChange(data);portalThemeStore.onLoadMain(data);}else if(data.child&&data.child.length){var item=data.child[0];if(data.url!=''){for(;;){if(item.mobxrouteurl||item.fullrouteurl||item.url&&item.url!='javascript:void(0);'){portalThemeStore.onLeftMenuSelectedChange(item);portalThemeStore.onLoadMain(item);break;}else if(item.child&&item.child.length){item=item.child[0];}else{break;}}}else{// 当前菜单不存在url，获取当前菜单的下级菜单url
this.getData(item,1);}}}},{key:'getData',value:function getData(data,level){if(data.mobxrouteurl||data.fullrouteurl||data.url&&data.url!='javascript:void(0);'){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuSelectedChange(data);portalThemeStore.onLoadMain(data);}else if(data.child&&data.child.length){var item=data.child[0];this.getData(item,level+1);}}},{key:'onSelect',value:function onSelect(e){var data=e.item.props.data;var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuSelectedChange(data);portalThemeStore.onLoadMain(data);if(this.menuRef&&this.menuRef.store){this.menuRef.store.setState({openKeys:[]});}}}]);return E9NavMenu;}(_react2.default.Component))||_class)||_class);exports.default=E9NavMenu;

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(67);











var Menu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Menu, _React$Component);

  function Menu(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Menu);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.isRootMenu = true;

    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;
    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }
    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: { '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey) }
    });
    return _this;
  }

  Menu.prototype.componentDidMount = function componentDidMount() {
    this.updateMiniStore();
  };

  Menu.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateMiniStore();
  };

  // onKeyDown needs to be exposed as a instance method
  // e.g., in rc-select, we need to navigate menu item while
  // current active item is rc-select input box rather than the menu itself


  Menu.prototype.updateMiniStore = function updateMiniStore() {
    if ('selectedKeys' in this.props) {
      this.store.setState({
        selectedKeys: this.props.selectedKeys || []
      });
    }
    if ('openKeys' in this.props) {
      this.store.setState({
        openKeys: this.props.openKeys || []
      });
    }
  };

  Menu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    props.className += ' ' + props.prefixCls + '-root';
    props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.onClick,
      onOpenChange: this.onOpenChange,
      onDeselect: this.onDeselect,
      onSelect: this.onSelect,
      openTransitionName: this.getOpenTransitionName(),
      parentMenu: this
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_mini_store__["Provider"],
      { store: this.store },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { ref: function ref(c) {
            return _this2.innerMenu = c;
          } }),
        this.props.children
      )
    );
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Menu.propTypes = {
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  subMenuOpenDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  subMenuCloseDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  forceSubMenuRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  selectable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSelect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      // root menu
      var selectedKeys = _this3.store.getState().selectedKeys;
      var selectedKey = selectInfo.key;
      if (props.multiple) {
        selectedKeys = selectedKeys.concat([selectedKey]);
      } else {
        selectedKeys = [selectedKey];
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onSelect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onKeyDown = function (e, callback) {
    _this3.innerMenu.getWrappedInstance().onKeyDown(e, callback);
  };

  this.onOpenChange = function (event) {
    var props = _this3.props;
    var openKeys = _this3.store.getState().openKeys.concat();
    var changed = false;
    var processSingle = function processSingle(e) {
      var oneChanged = false;
      if (e.open) {
        oneChanged = openKeys.indexOf(e.key) === -1;
        if (oneChanged) {
          openKeys.push(e.key);
        }
      } else {
        var index = openKeys.indexOf(e.key);
        oneChanged = index !== -1;
        if (oneChanged) {
          openKeys.splice(index, 1);
        }
      }
      changed = changed || oneChanged;
    };
    if (Array.isArray(event)) {
      // batch change call
      event.forEach(processSingle);
    } else {
      processSingle(event);
    }
    if (changed) {
      if (!('openKeys' in _this3.props)) {
        _this3.store.setState({ openKeys: openKeys });
      }
      props.onOpenChange(openKeys);
    }
  };

  this.onDeselect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      var selectedKeys = _this3.store.getState().selectedKeys.concat();
      var selectedKey = selectInfo.key;
      var index = selectedKeys.indexOf(selectedKey);
      if (index !== -1) {
        selectedKeys.splice(index, 1);
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onDeselect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.getOpenTransitionName = function () {
    var props = _this3.props;
    var transitionName = props.openTransitionName;
    var animationName = props.openAnimation;
    if (!transitionName && typeof animationName === 'string') {
      transitionName = props.prefixCls + '-open-' + animationName;
    }
    return transitionName;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(363);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__(364);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactLifecyclesCompat = __webpack_require__(177);

var _PropTypes = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, null, [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, prevState) {
          // using ownProps
          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
            return {
              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
              props: props
            };
          }
          return { props: props };
        }
      }]);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }
          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          if (!(0, _shallowequal2.default)(_this.state.subscribed, nextState)) {
            _this.setState({ subscribed: nextState });
          }
        };

        _this.store = context.miniStore;
        _this.state = {
          subscribed: finnalMapStateToProps(_this.store.getState(), props),
          store: _this.store,
          props: props
        };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };


    (0, _reactLifecyclesCompat.polyfill)(Connect);

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var DOMWrap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DOMWrap, _React$Component);

  function DOMWrap() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DOMWrap);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DOMWrap.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    if (!props.visible) {
      props.className += ' ' + props.hiddenClassName;
    }
    var Tag = props.tag;
    delete props.tag;
    delete props.hiddenClassName;
    delete props.visible;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, props);
  };

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DOMWrap.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__placements__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_animate__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(67);
















var guid = 0;

var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var _extends2;

  var menuId = Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.defaultActiveFirst, (_extends2 = {}, _extends2[menuId] = defaultActiveFirst, _extends2))
  });
};

var SubMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SubMenu, _React$Component);

  function SubMenu(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SubMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;
    var eventKey = props.eventKey;
    var defaultActiveFirst = store.getState().defaultActiveFirst;

    _this.isRootMenu = false;

    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  SubMenu.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  SubMenu.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var _props = this.props,
        mode = _props.mode,
        parentMenu = _props.parentMenu,
        manualRef = _props.manualRef;

    // invoke customized ref to expose component to mixin

    if (manualRef) {
      manualRef(this);
    }

    if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
      return;
    }

    this.minWidthTimeout = setTimeout(function () {
      return _this2.adjustWidth();
    }, 0);
  };

  SubMenu.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        onDestroy = _props2.onDestroy,
        eventKey = _props2.eventKey;

    if (onDestroy) {
      onDestroy(eventKey);
    }

    /* istanbul ignore if */
    if (this.minWidthTimeout) {
      clearTimeout(this.minWidthTimeout);
    }

    /* istanbul ignore if */
    if (this.mouseenterTimeout) {
      clearTimeout(this.mouseenterTimeout);
    }
  };

  SubMenu.prototype.renderChildren = function renderChildren(children) {
    var props = this.props;
    var baseProps = {
      mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
      visible: this.props.isOpen,
      level: props.level + 1,
      inlineIndent: props.inlineIndent,
      focusable: false,
      onClick: this.onSubMenuClick,
      onSelect: this.onSelect,
      onDeselect: this.onDeselect,
      onDestroy: this.onDestroy,
      selectedKeys: props.selectedKeys,
      eventKey: props.eventKey + '-menu-',
      openKeys: props.openKeys,
      openTransitionName: props.openTransitionName,
      openAnimation: props.openAnimation,
      onOpenChange: this.onOpenChange,
      subMenuOpenDelay: props.subMenuOpenDelay,
      parentMenu: this,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      triggerSubMenuAction: props.triggerSubMenuAction,
      builtinPlacements: props.builtinPlacements,
      defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
      multiple: props.multiple,
      prefixCls: props.rootPrefixCls,
      id: this._menuId,
      manualRef: this.saveMenuInstance
    };

    var haveRendered = this.haveRendered;
    this.haveRendered = true;

    this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender;
    // never rendered not planning to, don't render
    if (!this.haveOpened) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null);
    }

    // don't show transition on first rendering (no animation for opened menu)
    // show appear transition if it's not visible (not sure why)
    // show appear transition if it's not inline mode
    var transitionAppear = haveRendered || !baseProps.visible || !baseProps.mode === 'inline';

    baseProps.className = ' ' + baseProps.prefixCls + '-sub';
    var animProps = {};

    if (baseProps.openTransitionName) {
      animProps.transitionName = baseProps.openTransitionName;
    } else if (typeof baseProps.openAnimation === 'object') {
      animProps.animation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps.openAnimation);
      if (!transitionAppear) {
        delete animProps.animation.appear;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_rc_animate__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, animProps, {
        showProp: 'visible',
        component: '',
        transitionAppear: transitionAppear
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps, { id: this._menuId }),
        children
      )
    );
  };

  SubMenu.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);
    var isOpen = props.isOpen;
    var prefixCls = this.getPrefixCls();
    var isInlineMode = props.mode === 'inline';
    var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));

    if (!this._menuId) {
      if (props.eventKey) {
        this._menuId = props.eventKey + '$Menu';
      } else {
        this._menuId = '$__$' + ++guid + '$Menu';
      }
    }

    var mouseEvents = {};
    var titleClickEvents = {};
    var titleMouseEvents = {};
    if (!props.disabled) {
      mouseEvents = {
        onMouseLeave: this.onMouseLeave,
        onMouseEnter: this.onMouseEnter
      };

      // only works in title, not outer li
      titleClickEvents = {
        onClick: this.onTitleClick
      };
      titleMouseEvents = {
        onMouseEnter: this.onTitleMouseEnter,
        onMouseLeave: this.onTitleMouseLeave
      };
    }

    var style = {};
    if (isInlineMode) {
      style.paddingLeft = props.inlineIndent * props.level;
    }

    var ariaOwns = {};
    // only set aria-owns when menu is open
    // otherwise it would be an invalid aria-owns value
    // since corresponding node cannot be found
    if (this.props.isOpen) {
      ariaOwns = {
        'aria-owns': this._menuId
      };
    }

    var title = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
        ref: this.saveSubMenuTitle,
        style: style,
        className: prefixCls + '-title'
      }, titleMouseEvents, titleClickEvents, {
        'aria-expanded': isOpen
      }, ariaOwns, {
        'aria-haspopup': 'true',
        title: typeof props.title === 'string' ? props.title : undefined
      }),
      props.title,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', { className: prefixCls + '-arrow' })
    );
    var children = this.renderChildren(props.children);

    var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
      return triggerNode.parentNode;
    };
    var popupPlacement = popupPlacementMap[props.mode];
    var popupAlign = props.popupOffset ? { offset: props.popupOffset } : {};
    var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
    var disabled = props.disabled,
        triggerSubMenuAction = props.triggerSubMenuAction,
        subMenuOpenDelay = props.subMenuOpenDelay,
        forceSubMenuRender = props.forceSubMenuRender,
        subMenuCloseDelay = props.subMenuCloseDelay,
        builtinPlacements = props.builtinPlacements;

    __WEBPACK_IMPORTED_MODULE_14__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, props, mouseEvents, {
        className: className,
        role: 'menuitem'
      }),
      isInlineMode && title,
      isInlineMode && children,
      !isInlineMode && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
        {
          prefixCls: prefixCls,
          popupClassName: prefixCls + '-popup ' + popupClassName,
          getPopupContainer: getPopupContainer,
          builtinPlacements: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__placements__["a" /* default */], builtinPlacements),
          popupPlacement: popupPlacement,
          popupVisible: isOpen,
          popupAlign: popupAlign,
          popup: children,
          action: disabled ? [] : [triggerSubMenuAction],
          mouseEnterDelay: subMenuOpenDelay,
          mouseLeaveDelay: subMenuCloseDelay,
          onPopupVisibleChange: this.onPopupVisibleChange,
          forceRender: forceSubMenuRender
        },
        title
      )
    );
  };

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SubMenu.propTypes = {
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // TODO: remove
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  popupOffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  mode: 'vertical',
  title: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onDestroy = function (key) {
    _this3.props.onDestroy(key);
  };

  this.onKeyDown = function (e) {
    var keyCode = e.keyCode;
    var menu = _this3.menuInstance;
    var _props3 = _this3.props,
        isOpen = _props3.isOpen,
        store = _props3.store;


    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER) {
      _this3.onTitleClick(e);
      updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      return true;
    }

    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
      if (isOpen) {
        menu.onKeyDown(e);
      } else {
        _this3.triggerOpenChange(true);
        // need to update current menu's defaultActiveFirst value
        updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      }
      return true;
    }
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].LEFT) {
      var handled = void 0;
      if (isOpen) {
        handled = menu.onKeyDown(e);
      } else {
        return undefined;
      }
      if (!handled) {
        _this3.triggerOpenChange(false);
        handled = true;
      }
      return handled;
    }

    if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
      return menu.onKeyDown(e);
    }
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onPopupVisibleChange = function (visible) {
    _this3.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
  };

  this.onMouseEnter = function (e) {
    var _props4 = _this3.props,
        key = _props4.eventKey,
        onMouseEnter = _props4.onMouseEnter,
        store = _props4.store;

    updateDefaultActiveFirst(store, _this3.props.eventKey, false);
    onMouseEnter({
      key: key,
      domEvent: e
    });
  };

  this.onMouseLeave = function (e) {
    var _props5 = _this3.props,
        parentMenu = _props5.parentMenu,
        eventKey = _props5.eventKey,
        onMouseLeave = _props5.onMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleMouseEnter = function (domEvent) {
    var _props6 = _this3.props,
        key = _props6.eventKey,
        onItemHover = _props6.onItemHover,
        onTitleMouseEnter = _props6.onTitleMouseEnter;

    onItemHover({
      key: key,
      hover: true
    });
    onTitleMouseEnter({
      key: key,
      domEvent: domEvent
    });
  };

  this.onTitleMouseLeave = function (e) {
    var _props7 = _this3.props,
        parentMenu = _props7.parentMenu,
        eventKey = _props7.eventKey,
        onItemHover = _props7.onItemHover,
        onTitleMouseLeave = _props7.onTitleMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onItemHover({
      key: eventKey,
      hover: false
    });
    onTitleMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleClick = function (e) {
    var props = _this3.props;

    props.onTitleClick({
      key: props.eventKey,
      domEvent: e
    });
    if (props.triggerSubMenuAction === 'hover') {
      return;
    }
    _this3.triggerOpenChange(!props.isOpen, 'click');
    updateDefaultActiveFirst(props.store, _this3.props.eventKey, false);
  };

  this.onSubMenuClick = function (info) {
    _this3.props.onClick(_this3.addKeyPath(info));
  };

  this.onSelect = function (info) {
    _this3.props.onSelect(info);
  };

  this.onDeselect = function (info) {
    _this3.props.onDeselect(info);
  };

  this.getPrefixCls = function () {
    return _this3.props.rootPrefixCls + '-submenu';
  };

  this.getActiveClassName = function () {
    return _this3.getPrefixCls() + '-active';
  };

  this.getDisabledClassName = function () {
    return _this3.getPrefixCls() + '-disabled';
  };

  this.getSelectedClassName = function () {
    return _this3.getPrefixCls() + '-selected';
  };

  this.getOpenClassName = function () {
    return _this3.props.rootPrefixCls + '-submenu-open';
  };

  this.saveMenuInstance = function (c) {
    // children menu instance
    _this3.menuInstance = c;
  };

  this.addKeyPath = function (info) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, info, {
      keyPath: (info.keyPath || []).concat(_this3.props.eventKey)
    });
  };

  this.triggerOpenChange = function (open, type) {
    var key = _this3.props.eventKey;
    var openChange = function openChange() {
      _this3.onOpenChange({
        key: key,
        item: _this3,
        trigger: type,
        open: open
      });
    };
    if (type === 'mouseenter') {
      // make sure mouseenter happen after other menu item's mouseleave
      _this3.mouseenterTimeout = setTimeout(function () {
        openChange();
      }, 0);
    } else {
      openChange();
    }
  };

  this.isChildrenSelected = function () {
    var ret = { find: false };
    Object(__WEBPACK_IMPORTED_MODULE_14__util__["d" /* loopMenuItemRecursively */])(_this3.props.children, _this3.props.selectedKeys, ret);
    return ret.find;
  };

  this.isOpen = function () {
    return _this3.props.openKeys.indexOf(_this3.props.eventKey) !== -1;
  };

  this.adjustWidth = function () {
    /* istanbul ignore if */
    if (!_this3.subMenuTitle || !_this3.menuInstance) {
      return;
    }
    var popupMenu = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this3.menuInstance);
    if (popupMenu.offsetWidth >= _this3.subMenuTitle.offsetWidth) {
      return;
    }

    /* istanbul ignore next */
    popupMenu.style.minWidth = _this3.subMenuTitle.offsetWidth + 'px';
  };

  this.saveSubMenuTitle = function (subMenuTitle) {
    _this3.subMenuTitle = subMenuTitle;
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var openKeys = _ref.openKeys,
      activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);

connected.isSubMenu = true;

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(376);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(371);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(372);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(373);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(181);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(378);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(380);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(179);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(184);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(183);
} catch (err) {
  var index = __webpack_require__(183);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(185);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(67);













/* eslint react/no-is-mounted:0 */

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);
        return true;
      }
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;

      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;

      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;

      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _this,
        domEvent: e
      };
      onClick(info);
      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    return _this;
  }

  MenuItem.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    this.callRef();
  };

  MenuItem.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.active) {
      __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default()(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this), __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.props.parentMenu), {
        onlyScrollIfNeeded: true
      });
    }
    this.callRef();
  };

  MenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
    var props = this.props;
    if (props.onDestroy) {
      props.onDestroy(props.eventKey);
    }
  };

  MenuItem.prototype.getPrefixCls = function getPrefixCls() {
    return this.props.rootPrefixCls + '-item';
  };

  MenuItem.prototype.getActiveClassName = function getActiveClassName() {
    return this.getPrefixCls() + '-active';
  };

  MenuItem.prototype.getSelectedClassName = function getSelectedClassName() {
    return this.getPrefixCls() + '-selected';
  };

  MenuItem.prototype.getDisabledClassName = function getDisabledClassName() {
    return this.getPrefixCls() + '-disabled';
  };

  MenuItem.prototype.callRef = function callRef() {
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  MenuItem.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = props.isSelected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
    var attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.attribute, {
      title: props.title,
      className: className,
      // set to menuitem by default
      role: props.role || 'menuitem',
      'aria-disabled': props.disabled
    });

    if (props.role === 'option') {
      // overwrite to option
      attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, attrs, {
        role: 'option',
        'aria-selected': props.isSelected
      });
    } else if (props.role === null || props.role === 'none') {
      // sometimes we want to specify role inside <li/> element
      // <li><a role='menuitem'>Link</a></li> would be a good example
      // in this case the role on <li/> should be "none" to
      // remove the implied listitem role.
      // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
      attrs.role = 'none';
    }
    // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
    var mouseEvent = {
      onClick: props.disabled ? null : this.onClick,
      onMouseLeave: props.disabled ? null : this.onMouseLeave,
      onMouseEnter: props.disabled ? null : this.onMouseEnter
    };
    var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style);
    if (props.mode === 'inline') {
      style.paddingLeft = props.inlineIndent * props.level;
    }
    __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, attrs, mouseEvent, {
        style: style
      }),
      props.children
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MenuItem.propTypes = {
  attribute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  isSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};
MenuItem.isMenuItem = true;

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(391);

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(392);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(67);









var MenuItemGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItemGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;

      return renderMenuItem(item, index, _this.props.subMenuKey);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MenuItemGroup.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = props.rootPrefixCls;

    var titleClassName = rootPrefixCls + '-item-group-title';
    var listClassName = rootPrefixCls + '-item-group-list';
    var title = props.title,
        children = props.children;

    __WEBPACK_IMPORTED_MODULE_7__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: className + ' ' + rootPrefixCls + '-item-group' }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: titleClassName,
          title: typeof title === 'string' ? title : undefined
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'ul',
        { className: listClassName },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, this.renderInnerMenuItem)
      )
    );
  };

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItemGroup.propTypes = {
  renderMenuItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  subMenuKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
MenuItemGroup.defaultProps = {
  disabled: true
};


MenuItemGroup.isMenuItemGroup = true;

/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Divider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Divider, _React$Component);

  function Divider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Divider);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Divider.prototype.render = function render() {
    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = _props.rootPrefixCls;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
  };

  return Divider;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Divider.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);__webpack_require__(396);var _E9Header=__webpack_require__(173);var _E9Header2=_interopRequireDefault(_E9Header);var _E9LeftMenu=__webpack_require__(398);var _E9LeftMenu2=_interopRequireDefault(_E9LeftMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9ThemeLayout3=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9ThemeLayout3,_React$Component);function E9ThemeLayout3(props){(0,_classCallCheck3.default)(this,E9ThemeLayout3);var _this=(0,_possibleConstructorReturn3.default)(this,(E9ThemeLayout3.__proto__||(0,_getPrototypeOf2.default)(E9ThemeLayout3)).call(this,props));_this.exitTranslatepage=function(){var portalThemeStore=_this.props.portalThemeStore;portalThemeStore.setTranslatepage(0);};return _this;}(0,_createClass3.default)(E9ThemeLayout3,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,portalThemeStore=_props.portalThemeStore,location=_props.location;var pathname=location.pathname,query=location.query;portalThemeStore.getTopMenu(pathname,query);}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var searchParams=portalThemeStore.searchParams,themeInfo=portalThemeStore.themeInfo,translatepage=portalThemeStore.translatepage;var hideHeader=searchParams.hideHeader,hideAside=searchParams.hideAside;var themeColorType=themeInfo.themeColorType;var colorClassName=themeColorType?'e9theme-color-'+themeColorType:'';var contenttop='';if(hideHeader=='true'){contenttop=translatepage=='1'?'30px':'0px';}else{contenttop=translatepage=='1'?'85px':'55px';}return _react2.default.createElement('div',{className:'e9theme-layout3-container '+colorClassName},translatepage=='1'?_react2.default.createElement('div',{className:'e9theme-translate'},_react2.default.createElement('div',{className:'trans-tips'},getLabel(518684,'您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')),_react2.default.createElement('div',{className:'trans-exit',onClick:this.exitTranslatepage},getLabel(518685,'退出翻译模式'))):null,hideHeader=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout3-header',style:translatepage=='1'?{top:'30px'}:{top:'0px'}},_react2.default.createElement(_E9Header2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Header@1g05c5'})),_react2.default.createElement('div',{className:'e9theme-layout3-content',style:{top:contenttop}},_react2.default.createElement('div',{id:'themeLayoutMask',className:'e9theme-layout3-mask'}),hideAside=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout3-left'},_react2.default.createElement(_E9LeftMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9LeftMenu@zdgecl'})),_react2.default.createElement('div',{className:'e9theme-layout3-main',style:hideHeader=='true'&&hideAside=='true'?{padding:0}:{}},_react2.default.createElement('div',{id:'themeLayoutRoute',className:'e9theme-layout3-route'},this.props.children),_react2.default.createElement('div',{id:'themeLayoutFrame',className:'e9theme-layout3-frame'},_react2.default.createElement('iframe',{id:'mainFrame',name:'mainFrame',src:'about:blank'})))));}}]);return E9ThemeLayout3;}(_react2.default.Component))||_class)||_class);exports.default=E9ThemeLayout3;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(397);

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);__webpack_require__(174);var _rcMenu=__webpack_require__(175);var _rcMenu2=_interopRequireDefault(_rcMenu);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9LeftMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9LeftMenu,_React$Component);function E9LeftMenu(props){(0,_classCallCheck3.default)(this,E9LeftMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E9LeftMenu.__proto__||(0,_getPrototypeOf2.default)(E9LeftMenu)).call(this,props));_this.getLeftMenu=_this.getLeftMenu.bind(_this);_this.onTitleClick=_this.onTitleClick.bind(_this);_this.onSelect=_this.onSelect.bind(_this);_this.getData=_this.getData.bind(_this);_this.setHeight=_this.setHeight.bind(_this);return _this;}(0,_createClass3.default)(E9LeftMenu,[{key:'render',value:function render(){var _this2=this;var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo,_portalThemeStore$fro=portalThemeStore.frontEndMenu,frontEndMenu=_portalThemeStore$fro===undefined?[]:_portalThemeStore$fro,leftMenuObj=portalThemeStore.leftMenuObj;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$leftmenu=styleConfig.leftmenu,leftmenu=_styleConfig$leftmenu===undefined?{}:_styleConfig$leftmenu;var fontSize=parseInt(leftmenu.titleFontSize||'12px');var _leftMenuObj$leftMenu=leftMenuObj.leftMenuSelected,leftMenuSelected=_leftMenuObj$leftMenu===undefined?{}:_leftMenuObj$leftMenu;var _frontEndMenu=(0,_mobx.toJS)(frontEndMenu);var _leftMenuSelected=(0,_mobx.toJS)(leftMenuSelected);var _selectedKeys=[_leftMenuSelected.id||''];return _react2.default.createElement('div',{className:'e9left-container wea-f'+fontSize},_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@wog2cl',height:'100%'},_react2.default.createElement(_rcMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Menu@xsqy22',ref:function ref(_ref){return _this2.menuRef=_ref;},mode:'vertical',prefixCls:'pt-menu',openAnimation:'zoom',subMenuCloseDelay:0.2,selectedKeys:_selectedKeys,onClick:this.onSelect,onOpenChange:this.setHeight},this.getLeftMenu(_frontEndMenu,1,fontSize,_selectedKeys[0]))));}},{key:'getLeftMenu',value:function getLeftMenu(data,level,fontSize,_selectedKeys){var _this3=this;var portalThemeStore=this.props.portalThemeStore;var translatepage=portalThemeStore.translatepage;return data.map(function(item){var name=translatepage=='1'?item.fname?item.fname:item.name:item.name;if(item.child&&item.child.length){return _react2.default.createElement(_rcMenu.SubMenu,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_SubMenu@zgy0bq@'+item.id,key:item.id,popupClassName:'e9left-sub-container wea-f'+fontSize,title:level==1?_react2.default.createElement('span',{className:'e9aside-top-menu-icon'},item.iconType=='2'&&item.iconImgSrc?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item.iconImgSrc),alt:''}):item.icon?_react2.default.createElement('i',{className:item.icon}):_react2.default.createElement('i',{className:'wevicon-top-menu-default wevicon-top-menu-'+(item.infoId||0)}),_react2.default.createElement('span',{title:name},name)):_react2.default.createElement('span',{title:name},name),className:_selectedKeys==item.id?'e9left3-e9submenu-selected':'e9left3-e9submenu-unselected',data:item,onTitleClick:function onTitleClick(){return _this3.onTitleClick(item);}},_this3.getLeftMenu(item.child,level+1,fontSize,_selectedKeys));}return _react2.default.createElement(_rcMenu.Item,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_MenuItem@wcqbr0@'+item.id,key:item.id,data:item},level==1?_react2.default.createElement('div',{className:'pt-menu-item-title'},_react2.default.createElement('span',{className:'e9aside-top-menu-icon'},item.iconType=='2'&&item.iconImgSrc?_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item.iconImgSrc),alt:''}):item.icon?_react2.default.createElement('i',{className:item.icon}):_react2.default.createElement('i',{className:'wevicon-top-menu-default wevicon-top-menu-'+(item.infoId||0)}),_react2.default.createElement('span',{title:name},name))):_react2.default.createElement('span',{title:name},name));});}},{key:'setHeight',value:function setHeight(){if($('.pt-menu-submenu-popup ul').length>0){$('.pt-menu-submenu-popup ul').css({'max-height':$(window).height()-20,'overflow-x':'hidden','overflow-y':'auto'});}}},{key:'onTitleClick',value:function onTitleClick(data){var portalThemeStore=this.props.portalThemeStore;if(data.mobxrouteurl||data.fullrouteurl||data.url&&data.url!='javascript:void(0);'){portalThemeStore.onLeftMenuSelectedChange(data);portalThemeStore.onLoadMain(data);}else if(data.child&&data.child.length){var item=data.child[0];if(data.url!=''){for(;;){if(item.mobxrouteurl||item.fullrouteurl||item.url&&item.url!='javascript:void(0);'){portalThemeStore.onLeftMenuSelectedChange(item);portalThemeStore.onLoadMain(item);break;}else if(item.child&&item.child.length){item=item.child[0];}else{break;}}}else{// 当前菜单不存在url，获取当前菜单的下级菜单url
this.getData(item,1);}}}},{key:'getData',value:function getData(data,level){if(data.mobxrouteurl||data.fullrouteurl||data.url&&data.url!='javascript:void(0);'){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuSelectedChange(data);portalThemeStore.onLoadMain(data);}else if(data.child&&data.child.length){var item=data.child[0];this.getData(item,level+1);}}},{key:'onSelect',value:function onSelect(e){var data=e.item.props.data;var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuSelectedChange(data);portalThemeStore.onLoadMain(data);if(this.menuRef&&this.menuRef.store){this.menuRef.store.setState({openKeys:[]});}}}]);return E9LeftMenu;}(_react2.default.Component))||_class)||_class);exports.default=E9LeftMenu;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);__webpack_require__(400);var _E9Header=__webpack_require__(402);var _E9Header2=_interopRequireDefault(_E9Header);var _E9LeftMenu=__webpack_require__(404);var _E9LeftMenu2=_interopRequireDefault(_E9LeftMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9ThemeLayout4=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9ThemeLayout4,_React$Component);function E9ThemeLayout4(props){(0,_classCallCheck3.default)(this,E9ThemeLayout4);var _this=(0,_possibleConstructorReturn3.default)(this,(E9ThemeLayout4.__proto__||(0,_getPrototypeOf2.default)(E9ThemeLayout4)).call(this,props));_this.exitTranslatepage=function(){var portalThemeStore=_this.props.portalThemeStore;portalThemeStore.setTranslatepage(0);// 左侧菜单高度更正
var asdh=$('.e9aside-container').height()+30;$('.e9aside-container #menuScrollWrapper').css({height:asdh});};return _this;}(0,_createClass3.default)(E9ThemeLayout4,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,portalThemeStore=_props.portalThemeStore,location=_props.location;var pathname=location.pathname,query=location.query;portalThemeStore.getTopMenu(pathname,query);}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var searchParams=portalThemeStore.searchParams,themeInfo=portalThemeStore.themeInfo,translatepage=portalThemeStore.translatepage;var hideHeader=searchParams.hideHeader,hideAside=searchParams.hideAside;var themeColorType=themeInfo.themeColorType;var colorClassName=themeColorType?'e9theme-color-'+themeColorType:'';var contenttop='';if(hideHeader=='true'){contenttop=translatepage=='1'?'30px':'0px';}else{contenttop=translatepage=='1'?'85px':'55px';}return _react2.default.createElement('div',{className:'e9theme-layout4-container '+colorClassName},translatepage=='1'?_react2.default.createElement('div',{className:'e9theme-translate'},_react2.default.createElement('div',{className:'trans-tips'},getLabel(518684,'您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')),_react2.default.createElement('div',{className:'trans-exit',onClick:this.exitTranslatepage},getLabel(518685,'退出翻译模式'))):null,hideHeader=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout4-header',style:translatepage=='1'?{top:'30px'}:{top:'0px'}},_react2.default.createElement(_E9Header2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Header@yvwl3v'})),_react2.default.createElement('div',{className:'e9theme-layout4-content',style:{top:contenttop}},_react2.default.createElement('div',{id:'themeLayoutMask',className:'e9theme-layout4-mask'}),hideAside=='true'?null:_react2.default.createElement('div',{className:'e9theme-layout4-aside'},_react2.default.createElement(_E9LeftMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9LeftMenu@dwlkku'})),_react2.default.createElement('div',{className:'e9theme-layout4-main',style:hideHeader=='true'&&hideAside=='true'?{padding:0}:{}},_react2.default.createElement('div',{id:'themeLayoutRoute',className:'e9theme-layout4-route'},this.props.children),_react2.default.createElement('div',{id:'themeLayoutFrame',className:'e9theme-layout4-frame'},_react2.default.createElement('iframe',{id:'mainFrame',name:'mainFrame',src:'about:blank'})))));}}]);return E9ThemeLayout4;}(_react2.default.Component))||_class)||_class);exports.default=E9ThemeLayout4;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(401);

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9Switch=__webpack_require__(403);var _E9Switch2=_interopRequireDefault(_E9Switch);var _E9TopLogo=__webpack_require__(86);var _E9TopLogo2=_interopRequireDefault(_E9TopLogo);var _E9Home=__webpack_require__(140);var _E9Home2=_interopRequireDefault(_E9Home);var _E9FreqUseMenu=__webpack_require__(78);var _E9FreqUseMenu2=_interopRequireDefault(_E9FreqUseMenu);var _E9QuickSearch=__webpack_require__(66);var _E9QuickSearch2=_interopRequireDefault(_E9QuickSearch);var _E9HeaderRight=__webpack_require__(87);var _E9HeaderRight2=_interopRequireDefault(_E9HeaderRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Header=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Header,_React$Component);function E9Header(){(0,_classCallCheck3.default)(this,E9Header);return(0,_possibleConstructorReturn3.default)(this,(E9Header.__proto__||(0,_getPrototypeOf2.default)(E9Header)).apply(this,arguments));}(0,_createClass3.default)(E9Header,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo;var themeLogoWidth=themeInfo.themeLogoWidth,_themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$header=styleConfig.header,header=_styleConfig$header===undefined?{}:_styleConfig$header;var fontSize=parseInt(header.fontSize||'12px');var logoWidth=themeLogoWidth==''?197:parseInt(themeLogoWidth);return _react2.default.createElement('div',{className:'e9header-container wea-f'+fontSize},_react2.default.createElement(_E9Switch2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Switch@p247cq'}),_react2.default.createElement('div',{className:'e9header-left',style:{width:logoWidth}},_react2.default.createElement(_E9TopLogo2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9TopLogo@nfzojo'})),_react2.default.createElement('div',{className:'e9header-right',style:{marginLeft:logoWidth}},_react2.default.createElement('div',{className:'e9header-right-menu'},_react2.default.createElement(_E9Home2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9Home@c0oajc'}),_react2.default.createElement(_E9FreqUseMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9FreqUseMenu@uajl7l'}),_react2.default.createElement(_E9QuickSearch2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearch@4kyd58'})),_react2.default.createElement(_E9HeaderRight2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_E9HeaderRight@z3mafc'})));}}]);return E9Header;}(_react2.default.Component))||_class)||_class);exports.default=E9Header;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Switch=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Switch,_React$Component);function E9Switch(props){(0,_classCallCheck3.default)(this,E9Switch);var _this=(0,_possibleConstructorReturn3.default)(this,(E9Switch.__proto__||(0,_getPrototypeOf2.default)(E9Switch)).call(this,props));_this.onModeChange=_this.onModeChange.bind(_this);return _this;}(0,_createClass3.default)(E9Switch,[{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var leftMenuMode=portalThemeStore.leftMenuMode;return _react2.default.createElement('div',{className:'e9header-switch',onClick:this.onModeChange},leftMenuMode=='inline'?_react2.default.createElement('i',{className:'anticon anticon-menu-fold'}):_react2.default.createElement('i',{className:'anticon anticon-menu-unfold'}));}},{key:'onModeChange',value:function onModeChange(){var portalThemeStore=this.props.portalThemeStore;var leftMenuMode=portalThemeStore.leftMenuMode;portalThemeStore.onLeftMenuModeChange(leftMenuMode=='inline'?'vertical':'inline');}}]);return E9Switch;}(_react2.default.Component))||_class)||_class);exports.default=E9Switch;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(14);var _mobxReact=__webpack_require__(6);var _weaPortalPublic=__webpack_require__(33);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9LeftMenu=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9LeftMenu,_React$Component);function E9LeftMenu(props){(0,_classCallCheck3.default)(this,E9LeftMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(E9LeftMenu.__proto__||(0,_getPrototypeOf2.default)(E9LeftMenu)).call(this,props));_this.newheight=function(){var asdh=$('.e9aside-container').height();$('.e9aside-container #menuScrollWrapper').css({height:asdh});$('.wea-menu-vertical .ant-menu-vertical .ant-menu-submenu>.ant-menu-sub').css({maxHeight:asdh,overflow:'auto'});};_this.onSelect=_this.onSelect.bind(_this);return _this;}(0,_createClass3.default)(E9LeftMenu,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.newheight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.newheight);}},{key:'render',value:function render(){var portalThemeStore=this.props.portalThemeStore;var themeInfo=portalThemeStore.themeInfo,frontEndMenu=portalThemeStore.frontEndMenu,leftMenuObj=portalThemeStore.leftMenuObj,leftMenuMode=portalThemeStore.leftMenuMode,translatepage=portalThemeStore.translatepage;var _themeInfo$themeData=themeInfo.themeData,themeData=_themeInfo$themeData===undefined?{}:_themeInfo$themeData;var _themeData$styleConfi=themeData.styleConfig,styleConfig=_themeData$styleConfi===undefined?{}:_themeData$styleConfi;var _styleConfig$leftmenu=styleConfig.leftmenu,leftmenu=_styleConfig$leftmenu===undefined?{}:_styleConfig$leftmenu;var fontSize=parseInt(leftmenu.titleFontSize||'12px');var _leftMenuObj$leftMenu=leftMenuObj.leftMenuSelected,leftMenuSelected=_leftMenuObj$leftMenu===undefined?{}:_leftMenuObj$leftMenu;var _frontEndMenu=(0,_mobx.toJS)(frontEndMenu);var _leftMenuSelected=(0,_mobx.toJS)(leftMenuSelected);var _selectedKey=_leftMenuSelected.id;return _react2.default.createElement('div',{className:'e9aside-container',style:{display:leftMenuMode=='inline'?'block':'none'}},_react2.default.createElement(_weaPortalPublic.WeaMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMenu@hp6hi7',mode:'vertical',needSwitch:false,inlineWidth:197,verticalWidth:65,fontSize:fontSize,datas:_frontEndMenu,defaultSelectedKey:_selectedKey,onSelect:this.onSelect,translatepageheight:translatepage=='1'?30:0,translatepage:translatepage}));}},{key:'onSelect',value:function onSelect(key,item){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLeftMenuSelectedChange(item);portalThemeStore.onLoadMain(item);}}]);return E9LeftMenu;}(_react2.default.Component))||_class)||_class);exports.default=E9LeftMenu;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);__webpack_require__(406);var _E9Header=__webpack_require__(409);var _E9Header2=_interopRequireDefault(_E9Header);var _E9DeskTop=__webpack_require__(411);var _E9DeskTop2=_interopRequireDefault(_E9DeskTop);var _E9DeskTopBgImg=__webpack_require__(423);var _E9DeskTopBgImg2=_interopRequireDefault(_E9DeskTopBgImg);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9ThemeLayout5=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9ThemeLayout5,_React$Component);function E9ThemeLayout5(props){(0,_classCallCheck3.default)(this,E9ThemeLayout5);var _this=(0,_possibleConstructorReturn3.default)(this,(E9ThemeLayout5.__proto__||(0,_getPrototypeOf2.default)(E9ThemeLayout5)).call(this,props));_this.widthChange=function(){var desklogo=$('.e9header-top-logo').width();var deskrleft=$('.e9header-home').width()+$('.e9header-quick-search').width()+10;var deskrright=$('.e9header-right-toolbar').width();var deskwid=desklogo+deskrleft+deskrright+50;$('.e9layout-desktop-container').css({'min-width':deskwid+'px'});};_this.widthChange=_this.widthChange.bind(_this);return _this;}(0,_createClass3.default)(E9ThemeLayout5,[{key:'componentDidMount',value:function componentDidMount(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain({mobxrouteurl:'/main/?theme=ecology9&layout=5'});window.addEventListener('resize',this.widthChange);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.widthChange);}},{key:'render',value:function render(){var location=this.props.location;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var layout=query.layout;return _react2.default.createElement('div',{className:'e9layout-desktop-container'},_react2.default.createElement(_E9DeskTopBgImg2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9DeskTopBgImg@4r01q0'},this.props)),_react2.default.createElement('div',{className:'e9layout-desktop-header'},_react2.default.createElement(_E9Header2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9Header@xmrq25'},this.props))),_react2.default.createElement('div',{className:'e9layout-desktop-content'},_react2.default.createElement('div',{id:'themeLayoutMask',className:'e9layout-desktop-mask'}),_react2.default.createElement('div',{className:'e9layout-desktop-main'},_react2.default.createElement('div',{id:'themeLayoutRoute',className:'e9layout-desktop-route',style:layout=='5'?{}:{backgroundColor:'#fff'}},layout=='5'?_react2.default.createElement(_E9DeskTop2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9DeskTop@oqdngt'},this.props)):this.props.children),_react2.default.createElement('div',{id:'themeLayoutFrame',className:'e9layout-desktop-frame'},_react2.default.createElement('iframe',{id:'mainFrame',name:'mainFrame',src:'about:blank'})))));}}]);return E9ThemeLayout5;}(_react2.default.Component))||_class)||_class);exports.default=E9ThemeLayout5;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(407);__webpack_require__(408);

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _E9TopLogo=__webpack_require__(86);var _E9TopLogo2=_interopRequireDefault(_E9TopLogo);var _E9QuickSearch=__webpack_require__(66);var _E9QuickSearch2=_interopRequireDefault(_E9QuickSearch);var _E9Home=__webpack_require__(410);var _E9Home2=_interopRequireDefault(_E9Home);var _E9HeaderRight=__webpack_require__(87);var _E9HeaderRight2=_interopRequireDefault(_E9HeaderRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Header=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Header,_React$Component);function E9Header(){(0,_classCallCheck3.default)(this,E9Header);return(0,_possibleConstructorReturn3.default)(this,(E9Header.__proto__||(0,_getPrototypeOf2.default)(E9Header)).apply(this,arguments));}(0,_createClass3.default)(E9Header,[{key:'componentDidUpdate',value:function componentDidUpdate(){var desklogo=$('.e9header-top-logo').width();var deskrleft=$('.e9header-home').width()+$('.e9header-quick-search').width()+10;var deskrright=$('.e9header-right-toolbar').width();var deskwid=desklogo+deskrleft+deskrright+50;$('.e9layout-desktop-container').css({'min-width':deskwid+'px'});}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e9header-container',style:{color:'#fff'}},_react2.default.createElement('div',{style:{float:'left'}},_react2.default.createElement('div',{style:{float:'left'}},_react2.default.createElement(_E9TopLogo2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9TopLogo@55amqw'},this.props))),_react2.default.createElement('div',{style:{float:'right'}},_react2.default.createElement(_E9Home2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9Home@pt1t6v'},this.props)),_react2.default.createElement(_E9QuickSearch2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9QuickSearch@xxn6j5'},this.props))),_react2.default.createElement('div',{style:{clear:'both'}})),_react2.default.createElement('div',{style:{float:'right'}},_react2.default.createElement(_E9HeaderRight2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_E9HeaderRight@y9iopb'},this.props))));}}]);return E9Header;}(_react2.default.Component))||_class)||_class);exports.default=E9Header;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9Home=(_dec=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9Home,_React$Component);function E9Home(props){(0,_classCallCheck3.default)(this,E9Home);var _this=(0,_possibleConstructorReturn3.default)(this,(E9Home.__proto__||(0,_getPrototypeOf2.default)(E9Home)).call(this,props));_this.onHomeClick=_this.onHomeClick.bind(_this);return _this;}(0,_createClass3.default)(E9Home,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'e9header-home',title:getLabel(513044,'首页'),onClick:this.onHomeClick},_react2.default.createElement('div',{className:'e9header-home-icon'},_react2.default.createElement('i',{className:'wevicon-home'})));}},{key:'onHomeClick',value:function onHomeClick(){var portalThemeStore=this.props.portalThemeStore;portalThemeStore.onLoadMain({mobxrouteurl:'/main/?theme=ecology9&layout=5'});}}]);return E9Home;}(_react2.default.Component))||_class)||_class);exports.default=E9Home;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _mobx=__webpack_require__(14);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(412);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _AddMenu=__webpack_require__(413);var _AddMenu2=_interopRequireDefault(_AddMenu);var _DragSort=__webpack_require__(414);var _DragSort2=_interopRequireDefault(_DragSort);var _MoreMenus=__webpack_require__(421);var _MoreMenus2=_interopRequireDefault(_MoreMenus);var _BgImages=__webpack_require__(422);var _BgImages2=_interopRequireDefault(_BgImages);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9DeskTop=(_dec=(0,_mobxReact.inject)('portalDeskTopStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9DeskTop,_React$Component);function E9DeskTop(props){(0,_classCallCheck3.default)(this,E9DeskTop);var _this=(0,_possibleConstructorReturn3.default)(this,(E9DeskTop.__proto__||(0,_getPrototypeOf2.default)(E9DeskTop)).call(this,props));_this.onPrev=_this.onPrev.bind(_this);_this.onNext=_this.onNext.bind(_this);_this.afterChange=_this.afterChange.bind(_this);_this.shouldCancelStart=_this.shouldCancelStart.bind(_this);return _this;}(0,_createClass3.default)(E9DeskTop,[{key:'componentWillMount',value:function componentWillMount(){var portalDeskTopStore=this.props.portalDeskTopStore;portalDeskTopStore.getDatas();}},{key:'componentDidMount',value:function componentDidMount(){var portalDeskTopStore=this.props.portalDeskTopStore;var onWindowResize=function onWindowResize(){var width=jQuery('#e9desktopContentMiddle').width();var height=jQuery('#e9desktopContentMiddle').height();var menu_w_h=width*0.1428;portalDeskTopStore.setState({menu_w_h:menu_w_h,rowNum:parseInt(height/menu_w_h)});};onWindowResize();jQuery(window).resize(function(){return onWindowResize();});}},{key:'render',value:function render(){var portalDeskTopStore=this.props.portalDeskTopStore;var bgImageObj=portalDeskTopStore.bgImageObj,colNum=portalDeskTopStore.colNum,state=portalDeskTopStore.state,setState=portalDeskTopStore.setState,setAddState=portalDeskTopStore.setAddState,onSave=portalDeskTopStore.onSave,onSynchronize=portalDeskTopStore.onSynchronize;var isSetting=state.isSetting,isSystemer=state.isSystemer,datas=state.datas,moreDatas=state.moreDatas,moreDatasVisible=state.moreDatasVisible,rowNum=state.rowNum,current=state.current,bgImagesVisible=state.bgImagesVisible,imgid=state.imgid;var color=bgImageObj.color;var _datas=mobx.toJS(datas);var _moreDatas=mobx.toJS(moreDatas);var menuNum=rowNum*colNum;var page=Math.ceil(_datas.length/menuNum);var last=page-1;var displayComp=_react2.default.createElement('div',null);if(!(0,_isEmpty2.default)(_datas)){if(_datas.length>menuNum){var carouselItems=[];for(var i=0;i<page;i++){var items=_datas.slice(i*menuNum,(i+1)*menuNum);carouselItems.push(_react2.default.createElement('div',{className:'e9desktop-carousel-item'},_react2.default.createElement(_DragSort2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_DragSort@kf0lgd@'+i,isSetting:isSetting,datas:_datas,items:items,start:i*menuNum,num:menuNum,shouldCancelStart:this.shouldCancelStart,onSort:setState})));}displayComp=_react2.default.createElement(_antd.Carousel,{ecId:(this&&this.props&&this.props.ecId||'')+'_Carousel@honadl',key:current,initialSlide:current,dots:true,afterChange:this.afterChange},carouselItems);}else{displayComp=_react2.default.createElement(_DragSort2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_DragSort@r39ymg',isSetting:isSetting,items:_datas,shouldCancelStart:this.shouldCancelStart,onSort:setState});}}return _react2.default.createElement('div',{className:'e9desktop-container',onClick:function onClick(e){var _moreDatasVisible=false;var _bgImagesVisible=false;var className=e.target.className;if(className&&className.indexOf('e9desktop-footer-icon')!=-1){if(className.indexOf('wevicon-toolbar-more')!=-1){_moreDatasVisible=!moreDatasVisible;}else if(className.indexOf('wevicon-e9login-palette')!=-1){_bgImagesVisible=!bgImagesVisible;}}setState({moreDatasVisible:_moreDatasVisible,bgImagesVisible:_bgImagesVisible});}},_react2.default.createElement('div',{className:'e9desktop-content',style:{color:color||'#fff'}},_react2.default.createElement('div',{className:'e9desktop-content-left'},_react2.default.createElement('i',{title:current>0?getLabel(26029,'上一页'):'',className:'icon-coms-Left '+(_datas.length>menuNum?current>0?'':'e9desktop-display-none':'e9desktop-display-none'),onClick:this.onPrev})),_react2.default.createElement('div',{id:'e9desktopContentMiddle',className:'e9desktop-content-middle '+(isSetting?'e9desktop-content-setting':'e9desktop-content-view')},displayComp),_react2.default.createElement('div',{className:'e9desktop-content-right'},_react2.default.createElement('i',{title:current<last?getLabel(26028,'下一页'):'',className:'icon-coms-Right '+(_datas.length>menuNum?current<last?'':'e9desktop-display-none':'e9desktop-display-none'),onClick:this.onNext}))),_react2.default.createElement('div',{className:'e9desktop-footer'},_react2.default.createElement(_AddMenu2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_AddMenu@j24mse'}),_react2.default.createElement('div',{className:'e9desktop-footer-btns '+(isSetting?'':'e9desktop-display-none')},_react2.default.createElement('div',{className:'e9desktop-footer-btns-background'}),_react2.default.createElement('div',{className:'e9desktop-footer-btns-content',style:isSystemer?{marginLeft:'-198px'}:{}},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@4p1202',type:'primary',onClick:function onClick(){return setAddState({visible:true,id:'',menuid:'',menutype:'1',menuname:'',menuicon:'',url:'',unreadapiaddr:'',replaceData:[]});}},getLabel(387142,'添加应用')),_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@rwjdbn',type:'primary',onClick:function onClick(){return onSave('');}},getLabel(30986,'保存')),isSystemer?_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@j7qkia',title:getLabel(33553,'分部'),type:194,customized:true,isSingle:false,onChange:function onChange(ids){return onSynchronize(ids);}},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@of80dg',type:'primary'},getLabel(387143,'同步到...'))):'',_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@vw6rah',onClick:function onClick(){return setState({isSetting:false});}},getLabel(31129,'取消')))),_react2.default.createElement('div',{className:'e9desktop-footer-icons '+(isSetting?'e9desktop-display-none':'')},_moreDatas.length?_react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@9wht4x',trigger:'click',placement:'topLeft',content:_react2.default.createElement(_MoreMenus2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MoreMenus@dykimf'}),overlayClassName:'e9desktop-footer-icons-overlay',visible:moreDatasVisible,onVisibleChange:function onVisibleChange(){return setState({moreDatasVisible:true});}},_react2.default.createElement('i',{style:{left:0},className:'wevicon-toolbar-more e9desktop-footer-icon '+(imgid?'e9desktop-footer-icon-white':'e9desktop-footer-icon-dark'),title:getLabel(17499,'更多')})):'',_react2.default.createElement('i',{style:{left:48},className:'icon-coms-Flow-setting e9desktop-footer-icon '+(imgid?'e9desktop-footer-icon-white':'e9desktop-footer-icon-dark'),onClick:function onClick(){return setState({isSetting:true});},title:getLabel(131607,'应用管理')}),_react2.default.createElement(_antd.Popover,{ecId:(this&&this.props&&this.props.ecId||'')+'_Popover@smur54',trigger:'click',placement:'topLeft',content:_react2.default.createElement(_BgImages2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_BgImages@ki034x'}),visible:bgImagesVisible,onVisibleChange:function onVisibleChange(){return setState({bgImagesVisible:true});}},_react2.default.createElement('i',{style:{left:96},className:'wevicon-e9login-palette e9desktop-footer-icon '+(imgid?'e9desktop-footer-icon-white':'e9desktop-footer-icon-dark'),title:getLabel(387144,'背景自定义')})))));}},{key:'onPrev',value:function onPrev(){var portalDeskTopStore=this.props.portalDeskTopStore;var state=portalDeskTopStore.state;var current=state.current;current-=1;portalDeskTopStore.setState({current:current<0?0:current});}},{key:'onNext',value:function onNext(){var portalDeskTopStore=this.props.portalDeskTopStore;var colNum=portalDeskTopStore.colNum,state=portalDeskTopStore.state;var current=state.current,rowNum=state.rowNum;var datas=mobx.toJS(state.datas);var last=Math.ceil(datas.length/(rowNum*colNum))-1;current+=1;portalDeskTopStore.setState({current:current>last?last:current});}},{key:'afterChange',value:function afterChange(current){var portalDeskTopStore=this.props.portalDeskTopStore;portalDeskTopStore.setState({current:current});}},{key:'shouldCancelStart',value:function shouldCancelStart(e){var portalDeskTopStore=this.props.portalDeskTopStore;var state=portalDeskTopStore.state;var className=e.target.className;var index=parseInt(jQuery(e.target).parents('.e9desktop-item').attr('data-index'));var item=state.datas[index];if(className=='e9desktop-item-icon'||className=='e9desktop-item-icon-move'||className=='e9desktop-item-icon-shadow'||className=='e9desktop-item-icon-setting'){return false;}if(className=='icon-coms-Need-feedback'){portalDeskTopStore.setAddState((0,_extends3.default)({},item,{visible:true}));}if(className=='e9desktop-item-icon-delete'||className=='anticon anticon-cross'){portalDeskTopStore.onDelete(index,item);}return true;}}]);return E9DeskTop;}(_react2.default.Component))||_class)||_class);exports.default=E9DeskTop;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(167),
    getTag = __webpack_require__(170),
    isArguments = __webpack_require__(165),
    isArray = __webpack_require__(84),
    isArrayLike = __webpack_require__(169),
    isBuffer = __webpack_require__(138),
    isPrototype = __webpack_require__(168),
    isTypedArray = __webpack_require__(139);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _mobx=__webpack_require__(14);var mobx=_interopRequireWildcard(_mobx);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var AddMenu=(_dec=(0,_mobxReact.inject)('portalDeskTopStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(AddMenu,_React$Component);function AddMenu(props){(0,_classCallCheck3.default)(this,AddMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(AddMenu.__proto__||(0,_getPrototypeOf2.default)(AddMenu)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenus=_this.getRightMenus.bind(_this);return _this;}(0,_createClass3.default)(AddMenu,[{key:'render',value:function render(){var portalDeskTopStore=this.props.portalDeskTopStore;var add_state=portalDeskTopStore.add_state,setAddState=portalDeskTopStore.setAddState;var visible=add_state.visible,id=add_state.id,menutype=add_state.menutype,menuname=add_state.menuname,menuicon=add_state.menuicon,url=add_state.url,unreadapiaddr=add_state.unreadapiaddr,replaceData=add_state.replaceData;var colProps={labelCol:{span:6},wrapperCol:{span:16}};return _react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@v8c03y',title:''+(id?getLabel(82178,'编辑应用'):getLabel(387142,'添加应用')),visible:visible,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',hasScroll:true,style:{width:700},buttons:this.getButtons(),onCancel:function onCancel(){return setAddState({visible:false});}},_react2.default.createElement(_ecCom.WeaRightMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@l5jxg1',datas:this.getRightMenus()},_react2.default.createElement('div',{className:'e9desktop-menu-add'},_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@4gxgm7',label:getLabel(385808,'菜单地址')},colProps),_react2.default.createElement(_antd.Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@7ri69s',gutter:8},_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@vkwq3x',span:8},_react2.default.createElement(_ecCom.WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@m418jk',value:menutype,options:[{key:'1',selected:true,showname:getLabel(33496,'系统菜单')},{key:'2',selected:false,showname:getLabel(385809,'自定义URL')}],onChange:function onChange(value){return setAddState({menutype:value});}})),_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@ccu1pl',span:16},menutype=='2'?_react2.default.createElement(_ecCom.WeaInput,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInput@1hi5mg',value:url,viewAttr:3,onChange:function onChange(value){var url=value;if(value.indexOf('www.')==0)url='http://'+url;setAddState({url:url});},helpfulTip:getLabel('386567','外部地址，请在地址前加上http://或https://')}):_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@1y764w',title:getLabel(33496,'系统菜单'),type:'portalmenu',tabs:[{name:getLabel(33675,'前端菜单'),key:'1',dataParams:{sourcetype:'1'},conditionDataParams:{sourcetype:'1'}}],viewAttr:3,replaceDatas:mobx.toJS(replaceData),onChange:function onChange(id,name,data){return setAddState({menuid:id,menuname:name,replaceData:data});}})))),_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@z8dgec',label:getLabel(30828,'显示名称')},colProps),_react2.default.createElement(_ecCom.WeaInput,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInput@a0w59a',value:menuname,isBase64:true,inputType:'multilang',getCurrentLabel:menuname,viewAttr:3,onChange:function onChange(value){setAddState({menuname:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@6bz0ct',label:getLabel(387148,'未读数接口地址')},colProps),_react2.default.createElement(_ecCom.WeaInput,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInput@zbv8bg',value:unreadapiaddr,onChange:function onChange(value){return setAddState({unreadapiaddr:value});},helpfulTip:getLabel(387149,'如需在应用图标上显示未读数，请配置未读数获取接口地址，如不配置则不显示未读数')})),_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@ljbp2p',label:getLabel(22969,'图标')},colProps,{style:{height:'80px',lineHeight:'80px'}}),menuicon?_react2.default.createElement('div',{className:'e9desktop-menu-add-img-edit'},_react2.default.createElement(_ecCom.WeaUpload,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaUpload@y3rw8l',uploadId:'uploadfile',uploadUrl:'/api/portal/fileupload/uploadfile',multiSelection:false,category:'stirng',limitType:'png,gif,jpeg,jpg,bmp',onChange:function onChange(ids,list){if(list&&list.length){setAddState({menuicon:list[list.length-1].filelink});}}},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(menuicon),alt:'',className:'e9desktop-menu-add-img-edit-img',title:getLabel(387150,'更换图标')})),_react2.default.createElement('div',{className:'e9desktop-menu-add-img-edit-del',title:getLabel(82746,'删除图标')},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@iskqzq',type:'cross',onClick:function onClick(){return setAddState({menuicon:''});}}))):_react2.default.createElement('div',{className:'e9desktop-menu-add-img-add'},_react2.default.createElement(_ecCom.WeaUpload,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaUpload@piulad',uploadId:'uploadfile',uploadUrl:'/api/portal/fileupload/uploadfile',multiSelection:false,category:'stirng',limitType:'png,gif,jpeg,jpg,bmp',onChange:function onChange(ids,list){if(list&&list.length){setAddState({menuicon:list[list.length-1].filelink});}}},_react2.default.createElement('div',{className:'e9desktop-menu-add-img-add-icon',title:getLabel(387151,'添加图标')},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@gyl6dw',type:'plus'})))),_react2.default.createElement('div',{className:'e9desktop-menu-add-img-desc'},getLabel(387152,'（建议使用的图片大小为：120*120）'))))));}},{key:'getButtons',value:function getButtons(){var portalDeskTopStore=this.props.portalDeskTopStore;var onAddSave=portalDeskTopStore.onAddSave;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@vce273',type:'primary',onClick:onAddSave},getLabel(30986,'保存')));btns.push(_react2.default.createElement(_ecCom.WeaMoreButton,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMoreButton@xxnvhe',datas:this.getRightMenus()}));return btns;}},{key:'getRightMenus',value:function getRightMenus(){var portalDeskTopStore=this.props.portalDeskTopStore;var onAddSave=portalDeskTopStore.onAddSave;var btns=[];btns.push({key:'1',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存'),onClick:onAddSave});return btns;}}]);return AddMenu;}(_react2.default.Component))||_class)||_class);exports.default=AddMenu;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSortableHoc=__webpack_require__(415);var _AppMenu=__webpack_require__(420);var _AppMenu2=_interopRequireDefault(_AppMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SortableItem=(0,_reactSortableHoc.SortableElement)(function(_ref){var _index=_ref._index,item=_ref.item;return _react2.default.createElement(_AppMenu2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_AppMenu@x0iaqm',key:_index,index:_index,item:item});});var SortableList=(0,_reactSortableHoc.SortableContainer)(function(_ref2){var items=_ref2.items,start=_ref2.start;return _react2.default.createElement('div',{className:'e9desktop-content-menus'},items.map(function(item,index){return _react2.default.createElement(SortableItem,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_SortableItem@jq4ohs@'+index,key:'item-'+index,index:start+index,_index:start+index,item:item});}));});var DragSort=function(_React$Component){(0,_inherits3.default)(DragSort,_React$Component);function DragSort(props){(0,_classCallCheck3.default)(this,DragSort);var _this=(0,_possibleConstructorReturn3.default)(this,(DragSort.__proto__||(0,_getPrototypeOf2.default)(DragSort)).call(this,props));_this.onSortEnd=_this.onSortEnd.bind(_this);return _this;}(0,_createClass3.default)(DragSort,[{key:'onSortEnd',value:function onSortEnd(_ref3){var oldIndex=_ref3.oldIndex,newIndex=_ref3.newIndex;var _props=this.props,datas=_props.datas,items=_props.items,start=_props.start,num=_props.num,onSort=_props.onSort;var _datas=(0,_reactSortableHoc.arrayMove)(items,oldIndex,newIndex);var __datas=_datas.filter(function(item){if(item)return item;});if(datas){datas.splice.apply(datas,[start,num].concat((0,_toConsumableArray3.default)(__datas)));onSort({datas:datas});}else{onSort({datas:__datas});}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,isSetting=_props2.isSetting,items=_props2.items,_props2$start=_props2.start,start=_props2$start===undefined?0:_props2$start,shouldCancelStart=_props2.shouldCancelStart;if(isSetting){return _react2.default.createElement(SortableList,{ecId:(this&&this.props&&this.props.ecId||'')+'_SortableList@97pyym',axis:'xy',items:items,start:start,shouldCancelStart:shouldCancelStart,onSortEnd:this.onSortEnd});}return _react2.default.createElement('div',{className:'e9desktop-content-menus'},items.map(function(item,index){return _react2.default.createElement(_AppMenu2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_AppMenu@b84zix@'+index,key:'item-'+index,index:start+index,item:item});}));}}]);return DragSort;}(_react2.default.Component);exports.default=DragSort;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(91);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(416);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(418);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(419);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(19);

var _invariant = __webpack_require__(92);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(417);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (event.button === 2 || shouldCancelStart(event)) {
          return false;
        }

        _this._touched = true;
        _this._pos = (0, _utils.getPosition)(event);

        var node = (0, _utils.closest)(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(event.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (!(0, _utils.isTouchEvent)(event) && event.target.tagName.toLowerCase() === 'a') {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          var position = (0, _utils.getPosition)(event);
          var delta = _this._delta = {
            x: _this._pos.x - position.x,
            y: _this._pos.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);

          if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (event) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = (0, _utils.getEdgeOffset)(node, _this.container);
          _this.initialOffset = (0, _utils.getPosition)(event);
          _this.initialScroll = {
            top: _this.container.scrollTop,
            left: _this.container.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = event.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) {
            onSortStart({ node: node, index: index, collection: collection }, event);
          }
        }
      };

      _this.handleSortMove = function (event) {
        var onSortMove = _this.props.onSortMove;

        event.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(event);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      };

      _this.handleSortEnd = function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, event);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var container = this.getContainer();

        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;

          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;

          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : _this2.container;

          var _loop = function _loop(key) {
            if (_this2.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this2.container.addEventListener(eventName, _this2.events[key], false);
              });
            }
          };

          for (var key in _this2.events) {
            _loop(key);
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.container) {
          var _loop2 = function _loop2(key) {
            if (_this3.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this3.container.removeEventListener(eventName, _this3.events[key]);
              });
            }
          };

          for (var key in this.events) {
            _loop2(key);
          }
        }
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var width = this.width,
            height = this.height;
        var lockOffset = this.props.lockOffset;

        var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];

        (0, _invariant2.default)(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _offsets = _slicedToArray(offsets, 2),
            minLockOffset = _offsets[0],
            maxLockOffset = _offsets[1];

        return [(0, _utils.getLockPixelOffset)({ lockOffset: minLockOffset, width: width, height: height }), (0, _utils.getLockPixelOffset)({ lockOffset: maxLockOffset, width: width, height: height })];
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(event) {
        var _props = this.props,
            lockAxis = _props.lockAxis,
            lockToContainerEdges = _props.lockToContainerEdges;


        var offset = (0, _utils.getPosition)(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };

        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props2 = this.props,
            transitionDuration = _props2.transitionDuration,
            hideSortableGhost = _props2.hideSortableGhost,
            onSortOver = _props2.onSortOver;

        var nodes = this.manager.getOrderedRefs();
        var containerScrollDelta = {
          left: this.container.scrollLeft - this.initialScroll.left,
          top: this.container.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var windowScrollDelta = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = (0, _utils.getEdgeOffset)(node, this.container);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = (0, _utils.getEdgeOffset)(nextNode.node, this.container);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (onSortOver && this.newIndex !== prevIndex) {
          onSortOver({
            newIndex: this.newIndex,
            oldIndex: prevIndex,
            index: this.index,
            collection: this.manager.active.collection
          });
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'getContainer',
      value: function getContainer() {
        var getContainer = this.props.getContainer;


        if (typeof getContainer !== 'function') {
          return (0, _reactDom.findDOMNode)(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortOver: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

exports.default = Manager;


function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;

  return index1 - index2;
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(19);

var _invariant = __webpack_require__(92);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _invariant = __webpack_require__(92);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var AppMenu=(_dec=(0,_mobxReact.inject)('portalDeskTopStore'),_dec2=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(AppMenu,_React$Component);function AppMenu(props){(0,_classCallCheck3.default)(this,AppMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(AppMenu.__proto__||(0,_getPrototypeOf2.default)(AppMenu)).call(this,props));_this.getUnReadCount=_this.getUnReadCount.bind(_this);_this.state={unReadCount:0};return _this;}(0,_createClass3.default)(AppMenu,[{key:'componentWillMount',value:function componentWillMount(){var item=this.props.item;this.getUnReadCount(item);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.item.unreadapiaddr!=this.props.item.unreadapiaddr){this.getUnReadCount(nextProps.item);}}},{key:'render',value:function render(){var _props=this.props,portalDeskTopStore=_props.portalDeskTopStore,portalThemeStore=_props.portalThemeStore,index=_props.index,item=_props.item;var bgImageObj=portalDeskTopStore.bgImageObj,state=portalDeskTopStore.state,setAddState=portalDeskTopStore.setAddState,onDelete=portalDeskTopStore.onDelete;var isSetting=state.isSetting,isSystemer=state.isSystemer,menu_w_h=state.menu_w_h;var _bgImageObj$color=bgImageObj.color,color=_bgImageObj$color===undefined?'#fff':_bgImageObj$color;var id=item.id,menuid=item.menuid,langmenuname=item.langmenuname,menuicon=item.menuicon,url=item.url,mobxrouteurl=item.mobxrouteurl,createtype=item.createtype;var unReadCount=this.state.unReadCount;return _react2.default.createElement('div',{'data-index':index,className:'e9desktop-item',style:{height:menu_w_h}},_react2.default.createElement('div',{'data-id':id,'data-menuid':menuid,className:'e9desktop-item-icon',title:langmenuname,onMouseOver:function onMouseOver(e){if(isSetting){if(e.target.className=='e9desktop-item-icon-delete'||e.target.className=='anticon anticon-cross'){jQuery(e.currentTarget).find('.e9desktop-item-icon-move').hide();jQuery(e.currentTarget).find('.icon-coms-Need-feedback').hide();jQuery(e.currentTarget).find('.e9desktop-item-icon-shadow').hide();}else if(isSystemer||createtype=='cus'){jQuery(e.currentTarget).find('.e9desktop-item-icon-move').show();jQuery(e.currentTarget).find('.icon-coms-Need-feedback').show();}else{jQuery(e.currentTarget).find('.e9desktop-item-icon-shadow').show();}}else{jQuery(e.currentTarget).find('.e9desktop-item-icon-shadow').show();}},onMouseLeave:function onMouseLeave(e){jQuery(e.currentTarget).find('.e9desktop-item-icon-move').hide();jQuery(e.currentTarget).find('.icon-coms-Need-feedback').hide();jQuery(e.currentTarget).find('.e9desktop-item-icon-shadow').hide();}},_react2.default.createElement('div',{className:'e9desktop-item-icon-shadow',onClick:function onClick(){return portalThemeStore.onLoadMain({url:url,mobxrouteurl:mobxrouteurl});}}),!isSetting&&unReadCount>0?_react2.default.createElement('div',{className:'e9desktop-item-icon-badge'},_react2.default.createElement(_antd.Badge,{ecId:(this&&this.props&&this.props.ecId||'')+'_Badge@36jvrn',count:unReadCount},_react2.default.createElement('span',null))):'',isSetting?_react2.default.createElement('div',{className:'e9desktop-item-icon-setting'},isSystemer||createtype=='cus'?_react2.default.createElement('div',{className:'e9desktop-item-icon-move',title:getLabel(18381,'拖动排序')}):'',isSystemer||createtype=='cus'?_react2.default.createElement('i',{className:'icon-coms-Need-feedback',title:getLabel(26473,'编辑'),onClick:function onClick(){return setAddState((0,_extends3.default)({},item,{visible:true}));}}):'',_react2.default.createElement('div',{className:'e9desktop-item-icon-delete',title:getLabel(91,'删除')},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@3h0zs0',type:'cross',onClick:function onClick(){return onDelete(index,item);}}))):'',_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(menuicon||'/wui/theme/ecology9/image/layout/layout5/desktop-icon-default.png'),alt:'',className:'e9desktop-item-icon-img'})),_react2.default.createElement('div',{className:'e9desktop-item-name',style:{color:color},title:langmenuname},_react2.default.createElement('span',{className:'e9desktop-item-menuname',onClick:function onClick(){return!isSetting&&portalThemeStore.onLoadMain({url:url,mobxrouteurl:mobxrouteurl});}},langmenuname)));}},{key:'getUnReadCount',value:function getUnReadCount(item){var _this2=this;if(item&&item.unreadapiaddr){_ecCom.WeaTools.callApi(item.unreadapiaddr,'POST').then(function(result){var _result$count=result.count,count=_result$count===undefined?0:_result$count;_this2.setState({unReadCount:parseInt(count)});});}}}]);return AppMenu;}(_react2.default.Component))||_class)||_class)||_class);exports.default=AppMenu;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(112);var _stringify2=_interopRequireDefault(_stringify);var _toConsumableArray2=__webpack_require__(42);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _mobx=__webpack_require__(14);var mobx=_interopRequireWildcard(_mobx);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var MoreMenus=(_dec=(0,_mobxReact.inject)('portalDeskTopStore'),_dec2=(0,_mobxReact.inject)('portalThemeStore'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MoreMenus,_React$Component);function MoreMenus(props){(0,_classCallCheck3.default)(this,MoreMenus);var _this=(0,_possibleConstructorReturn3.default)(this,(MoreMenus.__proto__||(0,_getPrototypeOf2.default)(MoreMenus)).call(this,props));_this.onSetting=_this.onSetting.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.state={isSetting:false};return _this;}(0,_createClass3.default)(MoreMenus,[{key:'render',value:function render(){var _this2=this;var _props=this.props,portalDeskTopStore=_props.portalDeskTopStore,portalThemeStore=_props.portalThemeStore;var state=portalDeskTopStore.state,setState=portalDeskTopStore.setState;var isSystemer=state.isSystemer,moreDatas=state.moreDatas;var isSetting=this.state.isSetting;var columns=[{key:'menuicon',dataIndex:'menuicon',width:isSetting?'48':'60',render:function render(text,record){return _react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(text||'/wui/theme/ecology9/image/layout/layout5/desktop-icon-default.png'),alt:'',className:'e9desktop-menu-more-img',onClick:function onClick(){return portalThemeStore.onLoadMain({url:record.url,mobxrouteurl:record.mobxrouteurl});}});}},{key:'langmenuname',dataIndex:'langmenuname',width:'*',render:function render(text,record){return _react2.default.createElement('div',{className:'e9desktop-menu-more-name',onClick:function onClick(){return portalThemeStore.onLoadMain({url:record.url,mobxrouteurl:record.mobxrouteurl});}},text);}},{key:'operate',width:isSetting?'60':'10',render:function render(text,record,index){return _react2.default.createElement('div',null,isSetting?_react2.default.createElement('div',{className:'e9desktop-menu-more-icons'},_react2.default.createElement('i',{className:'icon-coms-plus',title:getLabel(387141,'添加到桌面'),onClick:function onClick(){return _this2.onAdd(index);}}),isSystemer||record.createtype=='cus'?_react2.default.createElement(_antd.Popconfirm,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Popconfirm@zwkmgw@'+index,placement:'topLeft',title:getLabel(15097,'确定要删除吗？'),onConfirm:function onConfirm(){return _this2.onDelete(index);}},_react2.default.createElement('i',{className:'icon-coms-delete',title:getLabel(91,'删除')})):''):'');}}];return _react2.default.createElement('div',{className:'e9desktop-menu-more'},_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@rg3be3',height:'100%'},_react2.default.createElement('div',{style:{maxHeight:'300px'}},_react2.default.createElement(_ecCom.WeaTable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTable@vfp209',showHeader:false,columns:columns,dataSource:mobx.toJS(moreDatas),pagination:false,draggable:isSetting,onDrop:function onDrop(newDatas){return setState({moreDatas:newDatas});}}))),_react2.default.createElement('div',{className:'e9desktop-menu-more-btn e9desktop-menu-more-'+(isSetting?'save':'setting'),onClick:function onClick(){return _this2.onSetting(!isSetting);}},_react2.default.createElement('span',null,isSetting?getLabel(86,'保存'):getLabel(385650,'设置'))));}},{key:'onSetting',value:function onSetting(isSetting){this.setState({isSetting:isSetting});if(!isSetting){var portalDeskTopStore=this.props.portalDeskTopStore;portalDeskTopStore.onSave();}}},{key:'onAdd',value:function onAdd(index){var portalDeskTopStore=this.props.portalDeskTopStore;var state=portalDeskTopStore.state;var moreDatas=[].concat((0,_toConsumableArray3.default)(state.moreDatas));var deleteDatas=moreDatas.splice(index,1);deleteDatas[0].ismore='0';var datas=[].concat((0,_toConsumableArray3.default)(state.datas));datas.push(deleteDatas[0]);portalDeskTopStore.setState({datas:datas,moreDatas:moreDatas});var sortList=[];datas.map(function(item){sortList.push({id:item.id,ismore:'0'});});moreDatas.map(function(item){sortList.push({id:item.id,ismore:'1'});});_ecCom.WeaTools.callApi('/api/portal/desktop/sortMenuList','POST',{sortList:(0,_stringify2.default)(sortList)});}},{key:'onDelete',value:function onDelete(index){var portalDeskTopStore=this.props.portalDeskTopStore;var state=portalDeskTopStore.state;var moreDatas=[].concat((0,_toConsumableArray3.default)(state.moreDatas));var deleteDatas=moreDatas.splice(index,1);portalDeskTopStore.setState({moreDatas:moreDatas});var id=deleteDatas[0].id;_ecCom.WeaTools.callApi('/api/portal/desktop/delMenu','POST',{id:id});}}]);return MoreMenus;}(_react2.default.Component))||_class)||_class)||_class);exports.default=MoreMenus;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var isScrolling=false;var BgImages=(_dec=(0,_mobxReact.inject)('portalDeskTopStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BgImages,_React$Component);function BgImages(props){(0,_classCallCheck3.default)(this,BgImages);var _this=(0,_possibleConstructorReturn3.default)(this,(BgImages.__proto__||(0,_getPrototypeOf2.default)(BgImages)).call(this,props));_this.onPrev=_this.onPrev.bind(_this);_this.onNext=_this.onNext.bind(_this);return _this;}(0,_createClass3.default)(BgImages,[{key:'render',value:function render(){var _this2=this;var portalDeskTopStore=this.props.portalDeskTopStore;var bgImageObj=portalDeskTopStore.bgImageObj,state=portalDeskTopStore.state,setState=portalDeskTopStore.setState,setColor=portalDeskTopStore.setColor,addBgImage=portalDeskTopStore.addBgImage,delBgImage=portalDeskTopStore.delBgImage;var isSystemer=state.isSystemer,autoCarousel=state.autoCarousel,carouselTime=state.carouselTime,imgid=state.imgid,bgImages=state.bgImages;var color=bgImageObj.color;var images=bgImages.map(function(item,index){var selectedClassName=item.id==imgid?'e9desktop-bg-images-selected':'';return _react2.default.createElement('div',{key:index,className:'e9desktop-bg-images-item'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(item.imgsrc),alt:'',className:'e9desktop-bg-images-item-img '+selectedClassName,onClick:function onClick(){return setState({imgid:item.id,autoCarousel:false});}}),isSystemer?_react2.default.createElement(_antd.Popconfirm,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Popconfirm@1bgmxr@'+item.id,title:getLabel(15097,'确定要删除吗？'),onConfirm:function onConfirm(){return delBgImage(item);}},_react2.default.createElement(_antd.Icon,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Icon@biamj2@'+item.id,type:'cross-circle',className:'e9desktop-bg-images-item-delete',title:getLabel(91,'删除')})):'');});if(isSystemer){images.push(_react2.default.createElement('div',{className:'e9desktop-bg-images-item e9desktop-bg-images-item-add'},_react2.default.createElement(_ecCom.WeaUpload,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaUpload@q5rkkq',uploadId:'uploadfile',uploadUrl:'/api/portal/fileupload/uploadfile',multiSelection:false,category:'stirng',limitType:'png,gif,jpeg,jpg,bmp',onChange:function onChange(ids,list){if(list&&list.length){addBgImage(list[list.length-1].filelink);}}},_react2.default.createElement('div',{className:'e9desktop-bg-images-item-add-icon',title:getLabel(20001,'上传图片')},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@7rh69e',type:'plus'})))));}var length=images.length;return _react2.default.createElement('div',{className:'e9desktop-bg-images-content'},_react2.default.createElement('div',{className:'e9desktop-bg-images-toolbar'},_react2.default.createElement('div',{className:'e9desktop-bg-images-label',style:{marginRight:'20px'}},getLabel(387145,'单击切换背景')),_react2.default.createElement(_ecCom.WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@65woeq',value:autoCarousel,content:getLabel(387146,'自动轮播'),onChange:function onChange(){return setState({autoCarousel:!autoCarousel});}}),_react2.default.createElement('div',{className:'e9desktop-bg-images-label'},getLabel(387147,'轮播速度：')),_react2.default.createElement(_antd.InputNumber,{ecId:(this&&this.props&&this.props.ecId||'')+'_InputNumber@lxs2rw',value:carouselTime,min:0,disabled:!autoCarousel,style:{width:'70px',marginTop:'-4px'},onChange:function onChange(value){return setState({carouselTime:value});}})),_react2.default.createElement('div',{className:'e9desktop-bg-images-toolbar'},_react2.default.createElement('div',{className:'e9desktop-bg-images-label'},getLabel(128223,'字体颜色：')),_react2.default.createElement(_ecCom.WeaColorPicker,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaColorPicker@apev8f',value:color,onChange:setColor})),_react2.default.createElement('div',{className:'e9desktop-bg-images'},_react2.default.createElement('i',{className:'icon-coms-Left e9desktop-bg-images-prev '+(length<6?'e9desktop-display-none':''),title:getLabel(26029,'上一页'),onClick:this.onPrev}),_react2.default.createElement('div',{className:'e9desktop-bg-images-items'},_react2.default.createElement('div',{style:{position:'relative',width:length*70}},images)),_react2.default.createElement('i',{className:'icon-coms-Right e9desktop-bg-images-next '+(length<6?'e9desktop-display-none':'icon-coms-pointer'),title:getLabel(26028,'下一页'),onClick:this.onNext})));}},{key:'onPrev',value:function onPrev(){var $obj=jQuery('.e9desktop-bg-images-items>div');var left=$obj.position().left;if(!isScrolling&&left<0){isScrolling=true;$obj.animate({left:left+70+'px'},200,function(){isScrolling=false;});}}},{key:'onNext',value:function onNext(){var $obj=jQuery('.e9desktop-bg-images-items>div');var width=$obj.width();var left=$obj.position().left;if(!isScrolling&&width-350+left>0){isScrolling=true;$obj.animate({left:left-70+'px'},200,function(){isScrolling=false;});}}}]);return BgImages;}(_react2.default.Component))||_class)||_class);exports.default=BgImages;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9DeskTopBgImg=(_dec=(0,_mobxReact.inject)('portalDeskTopStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(E9DeskTopBgImg,_React$Component);function E9DeskTopBgImg(props){(0,_classCallCheck3.default)(this,E9DeskTopBgImg);var _this=(0,_possibleConstructorReturn3.default)(this,(E9DeskTopBgImg.__proto__||(0,_getPrototypeOf2.default)(E9DeskTopBgImg)).call(this,props));_this.beforeChange=_this.beforeChange.bind(_this);_this.state={imgStyle:{width:jQuery(window).width(),height:jQuery(window).height()}};return _this;}(0,_createClass3.default)(E9DeskTopBgImg,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;jQuery(window).resize(function(){_this2.setState({imgStyle:{width:jQuery(window).width(),height:jQuery(window).height()}});});}},{key:'render',value:function render(){var _this3=this;var portalDeskTopStore=this.props.portalDeskTopStore;var state=portalDeskTopStore.state,bgImageObj=portalDeskTopStore.bgImageObj;var bgImages=state.bgImages,autoCarousel=state.autoCarousel,carouselTime=state.carouselTime;var initialSlide=bgImageObj.initialSlide,imgsrc=bgImageObj.imgsrc;var displayComp=_react2.default.createElement('div',{className:'e9desktop-bg-image',style:imgsrc?{backgroundImage:'url('+(0,_pathUtil.addContentPath)(imgsrc)+')'}:{}});if(autoCarousel){displayComp=_react2.default.createElement(_antd.Carousel,{ecId:(this&&this.props&&this.props.ecId||'')+'_Carousel@s8zl4a',autoplay:true,initialSlide:initialSlide,dots:false,fade:true,speed:800,autoplaySpeed:carouselTime*1000,beforeChange:this.beforeChange},bgImages.map(function(item,index){return _react2.default.createElement('img',{key:index,src:(0,_pathUtil.addContentPath)(item.imgsrc),alt:'',style:_this3.state.imgStyle});}));}return _react2.default.createElement('div',{className:'e9desktop-bg-container'},displayComp,_react2.default.createElement('div',{className:'e9desktop-bg-header'}));}},{key:'beforeChange',value:function beforeChange(from,to){var portalDeskTopStore=this.props.portalDeskTopStore;var state=portalDeskTopStore.state;var bgImages=state.bgImages;portalDeskTopStore.setState2({imgid:bgImages[to].id});}}]);return E9DeskTopBgImg;}(_react2.default.Component))||_class)||_class);exports.default=E9DeskTopBgImg;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(30);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(9);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);__webpack_require__(425);var _multiLang=__webpack_require__(427);var _multiLang2=_interopRequireDefault(_multiLang);var _form=__webpack_require__(428);var _form2=_interopRequireDefault(_form);var _qRCode=__webpack_require__(429);var _qRCode2=_interopRequireDefault(_qRCode);var _LoginBtn=__webpack_require__(430);var _LoginBtn2=_interopRequireDefault(_LoginBtn);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SimpleFormCloud=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(SimpleFormCloud,_React$Component);function SimpleFormCloud(props){(0,_classCallCheck3.default)(this,SimpleFormCloud);var _this=(0,_possibleConstructorReturn3.default)(this,(SimpleFormCloud.__proto__||(0,_getPrototypeOf2.default)(SimpleFormCloud)).call(this,props));_initialiseProps.call(_this);return _this;}(0,_createClass3.default)(SimpleFormCloud,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.loginInfo&&(nextProps.loginInfo.showQrcode!=this.props.loginInfo.showQrcode||nextProps.loginInfo.defaultQrcode!=this.props.loginInfo.defaultQrcode||nextProps.loginInfo.onlyQrcode!=this.props.loginInfo.onlyQrcode)){this.setLoginType(nextProps);}}},{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,portalLoginStore=_props.portalLoginStore,isNeedGetLoginInfo=_props.isNeedGetLoginInfo;if(isNeedGetLoginInfo==true){portalLoginStore.getLoginInfo();}else{this.setLoginType();}this.setState({loadFinish:true});}},{key:'render',value:function render(){var loadFinish=this.state.loadFinish;if(loadFinish){var portalLoginStore=this.props.portalLoginStore;var state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache,getElementStyle=portalLoginStore.getElementStyle,labelObj=portalLoginStore.labelObj;state=this.getState();var _state2=state,_state2$loginSettingI=_state2.loginSettingInfo,loginSettingInfo=_state2$loginSettingI===undefined?{}:_state2$loginSettingI,loginType=_state2.loginType;var loginInfo=loginSettingInfo.loginInfo,loginForm=loginSettingInfo.loginForm;var showQrcode=loginInfo.showQrcode,defaultQrcode=loginInfo.defaultQrcode,onlyQrcode=loginInfo.onlyQrcode;var isSetting=false;if(this.props.isFormCloudSetting==true){isSetting=true;}var positionDynamicCss={};if(this.props.isPositionDynamicCss==true){positionDynamicCss=getElementStyle(loginForm);positionDynamicCss.position='absolute';}else{positionDynamicCss.position='relative';}return _react2.default.createElement('div',{className:'simpleFormCloud',style:(0,_extends3.default)({},positionDynamicCss)},_react2.default.createElement('div',{className:'simpleFormCloud-main'},_react2.default.createElement('div',{className:'multilang-qrcode'},_react2.default.createElement(_multiLang2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MultiLang@wzuzkb',isSetting:isSetting,getState:this.getState}),isSetting&&showQrcode&&!defaultQrcode&&!onlyQrcode||!isSetting&&showQrcode&&loginType=='form'?_react2.default.createElement('i',{className:'qRCode-scan icon-coms-Scan',title:labelObj.smdl,onClick:function onClick(){return setStateAndCache('loginType','QRCode');}}):null,isSetting&&showQrcode&&defaultQrcode&&!onlyQrcode||!isSetting&&(showQrcode&&!onlyQrcode||!showQrcode)&&loginType!='form'?_react2.default.createElement('i',{className:'qRCode-revoke icon-coms-Revoke2',title:labelObj.fh,onClick:function onClick(){return setStateAndCache('loginType','form');}}):null),isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?_react2.default.createElement(_form2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Form@lh9360',getState:this.getState}):_react2.default.createElement(_qRCode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_QRCode@f70uqt',getState:this.getState}),isSetting&&(!showQrcode||showQrcode&&!defaultQrcode&&!onlyQrcode)||!isSetting&&loginType=='form'?_react2.default.createElement(_LoginBtn2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LoginBtn@6x1udf',isSetting:isSetting,getState:this.getState}):null));}return null;}}]);return SimpleFormCloud;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.state={loadFinish:false};this.getState=function(props){if(!props){props=_this2.props;}var portalLoginStore=_this2.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var _state$loginSettingIn=state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn;var _props2=props,loginInfo=_props2.loginInfo,loginForm=_props2.loginForm,isRememberPW=_props2.isRememberPW;var _state=(0,_assign2.default)({},state);var _loginSettingInfo=(0,_assign2.default)({},loginSettingInfo);if(loginInfo&&loginForm){var _loginInfo=(0,_assign2.default)({},loginSettingInfo.loginInfo,loginInfo);var _loginForm=(0,_assign2.default)({},loginSettingInfo.loginForm,loginForm);_loginSettingInfo.loginInfo=_loginInfo;_loginSettingInfo.loginForm=_loginForm;_state.loginSettingInfo=_loginSettingInfo;if(isRememberPW){_state.isRememberPW=isRememberPW;}}return _state;};this.setLoginType=function(props){var portalLoginStore=_this2.props.portalLoginStore;var state=portalLoginStore.state,setStateAndCache=portalLoginStore.setStateAndCache;state=_this2.getState(props);var _state3=state,_state3$loginSettingI=_state3.loginSettingInfo,loginSettingInfo=_state3$loginSettingI===undefined?{}:_state3$loginSettingI;var _loginSettingInfo$log=loginSettingInfo.loginInfo,showQrcode=_loginSettingInfo$log.showQrcode,defaultQrcode=_loginSettingInfo$log.defaultQrcode;if(showQrcode&&defaultQrcode){setStateAndCache('loginType','QRCode');}else{setStateAndCache('loginType','form');}};},_temp))||_class)||_class);exports.default=SimpleFormCloud;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(426);

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MultiLang=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MultiLang,_React$Component);function MultiLang(props){(0,_classCallCheck3.default)(this,MultiLang);var _this=(0,_possibleConstructorReturn3.default)(this,(MultiLang.__proto__||(0,_getPrototypeOf2.default)(MultiLang)).call(this,props));_this.onMultiLangChange=function(){};return _this;}(0,_createClass3.default)(MultiLang,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,isSetting=_props.isSetting,getState=_props.getState;var multiLangs=portalLoginStore.multiLangs,state=portalLoginStore.state,setState=portalLoginStore.setState;state=getState();var _state=state,langId=_state.langId,langText=_state.langText,hasMultiLang=_state.hasMultiLang,multiLangVisible=_state.multiLangVisible;if(!hasMultiLang){return _react2.default.createElement('div',{className:'simplelogin-multiLang'});}var selectedClassName='';var multiLangListComp='';if(multiLangVisible){selectedClassName='simplelogin-multiLangText-selected';multiLangListComp=_react2.default.createElement('div',{className:'simplelogin-multiLangList'},_react2.default.createElement('ul',null,multiLangs.map(function(item){return _react2.default.createElement('li',{className:'simplelogin-multiLangList-item '+(item.id==langId?'simplelogin-multiLangList-selected':''),onClick:function onClick(){portalLoginStore.getLoginForm({langId:item.id});portalLoginStore.setState({langId:item.id,langText:item.language,multiLangVisible:false});}},item.language);})));}return _react2.default.createElement('div',{className:'simplelogin-multiLang'},_react2.default.createElement('div',{className:'simplelogin-multiLangText '+selectedClassName,onClick:function onClick(e){if(!isSetting){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();setState({multiLangVisible:!multiLangVisible});}}},_react2.default.createElement('div',{className:'simplelogin-multiLangText-text'},langText),_react2.default.createElement('div',{className:'simplelogin-multiLangText-icon'},'\u25BC')),multiLangListComp);}}]);return MultiLang;}(_react2.default.Component))||_class)||_class);exports.default=MultiLang;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _antd=__webpack_require__(10);var _ecCom=__webpack_require__(7);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Form=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Form,_React$Component);function Form(props){(0,_classCallCheck3.default)(this,Form);var _this2=(0,_possibleConstructorReturn3.default)(this,(Form.__proto__||(0,_getPrototypeOf2.default)(Form)).call(this,props));_this2.getLoginForm=_this2.getLoginForm.bind(_this2);_this2.onLabelClick=_this2.onLabelClick.bind(_this2);_this2.onInputChange=_this2.onInputChange.bind(_this2);_this2.getDynamicPassword=_this2.getDynamicPassword.bind(_this2);_this2.onLogin=_this2.onLogin.bind(_this2);return _this2;}(0,_createClass3.default)(Form,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var portalLoginStore=this.props.portalLoginStore;var loginFormDataLoading=portalLoginStore.loginFormDataLoading;if(loginFormDataLoading){portalLoginStore.doAfterLoginRenderEvent();}var _this=this;jQuery('.simplelogin-form-input').unbind().keydown(function(e){e=e||window.event;var key=e.keyCode||e.which||e.charCode;if(key==13){var inputs=jQuery('.simplelogin-form-input');var idx=inputs.index(this);var nxtIdx=idx+1;var nxtInput=jQuery('.simplelogin-form-input:eq('+nxtIdx+')');if(nxtInput.length>0){nxtInput.focus();}else{_this.onLogin();}}});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var state=portalLoginStore.state,dynamicPasswordTime=portalLoginStore.dynamicPasswordTime,onPasswordForget=portalLoginStore.onPasswordForget,onRememberChange=portalLoginStore.onRememberChange,onValidateCodeChange=portalLoginStore.onValidateCodeChange,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,isRememberPW=_state.isRememberPW,isRememberAccount=_state.isRememberAccount,isRememberPassword=_state.isRememberPassword,cacheAccount=_state.cacheAccount,cachePassword=_state.cachePassword,_state$loginSettingIn=_state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,loginFormItems=_state.loginFormItems,loginFormHiddenItems=_state.loginFormHiddenItems,_state$loginSetting=_state.loginSetting,loginSetting=_state$loginSetting===undefined?{}:_state$loginSetting,validateCode=_state.validateCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=loginForm.color;var needforgotpassword=loginSetting.needforgotpassword,_loginSetting$validat=loginSetting.validateCodeKey,validateCodeKey=_loginSetting$validat===undefined?'':_loginSetting$validat;var validateCodeSrc=validateCode+'&validateCodeKey='+validateCodeKey;return _react2.default.createElement('div',{className:'simplelogin-form'},loginFormItems.map(function(item,index){var label='';var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;label=getLabel(2072,'用户名');}else if(item.atype=='password'){defaultValue=cachePassword;label=getLabel(409,'密码');}var itemComp=_react2.default.createElement('div',{key:index,className:'simplelogin-form-item'},_react2.default.createElement('div',{className:'simplelogin-form-item-label'},label,':'),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'simplelogin-form-input',defaultValue:defaultValue,onBlur:function onBlur(){return item.atype=='account'&&_this3.getLoginForm();},onChange:_this3.onInputChange}));if(item.atype=='dynamicPassword'){itemComp=_react2.default.createElement('div',{key:index,className:'simplelogin-form-item simplelogin-form-item-dp'},_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'simplelogin-form-input simplelogin-form-input-dp',placeholder:item.label,onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'simplelogin-form-dynamic',style:{color:color}},dynamicPasswordTime>0?_react2.default.createElement('span',{className:'simplelogin-form-dynamic-text',style:{color:'#ccc'}},labelObj.resend,'(',dynamicPasswordTime,'s)'):_react2.default.createElement('span',{className:'simplelogin-form-dynamic-text',onClick:_this3.getDynamicPassword},labelObj.send)));}if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',{key:index,className:'simplelogin-form-item simplelogin-form-item-vc'},_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,className:'simplelogin-form-input simplelogin-form-input-vc',placeholder:item.label,onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'simplelogin-form-vc-img'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(validateCodeSrc),alt:'',onClick:onValidateCodeChange})));}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,style:{display:'none'},dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'simplelogin-form-remember'},needforgotpassword=='1'&&_react2.default.createElement('div',{className:'simplelogin-form-remember-forget',title:labelObj.forgetPassword},_react2.default.createElement('span',{onClick:function onClick(){return onPasswordForget();}},labelObj.forgetPassword)),_react2.default.createElement('div',{className:'simplelogin-form-remember-content '+(isRememberPW=='1'?'':'simplelogin-display-hidden')},_react2.default.createElement('div',{className:'simplelogin-form-remember-account',title:labelObj.rememberAccount},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@yzgk3s',checked:isRememberAccount,onChange:function onChange(e){return onRememberChange('account',e.target.checked);}},labelObj.rememberAccount)),_react2.default.createElement('div',{className:'simplelogin-form-remember-password',title:labelObj.rememberPassword},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@8b314t',checked:isRememberPassword,onChange:function onChange(e){return onRememberChange('password',e.target.checked);}},labelObj.rememberPassword))),_react2.default.createElement('div',{className:'simplelogin-form-clear'})));}},{key:'getLoginForm',value:function getLoginForm(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);portalLoginStore.setStateAndCache('loginType','QRCode');}});}},{key:'onLabelClick',value:function onLabelClick(e){jQuery(e.target.parentNode).find('input').focus();}},{key:'onInputChange',value:function onInputChange(e){if(e.target.value){jQuery(e.target.parentNode).find('.simplelogin-form-label').addClass('simplelogin-display-hidden');}else{jQuery(e.target.parentNode).find('.simplelogin-form-label').removeClass('simplelogin-display-hidden');}}},{key:'getDynamicPassword',value:function getDynamicPassword(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.getDynamicPassword();}},{key:'onLogin',value:function onLogin(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onLogin();}}]);return Form;}(_react2.default.Component))||_class)||_class);exports.default=Form;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _qrcode=__webpack_require__(77);var _qrcode2=_interopRequireDefault(_qrcode);var _pathUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SimpleQRCode=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SimpleQRCode,_React$Component);function SimpleQRCode(props){(0,_classCallCheck3.default)(this,SimpleQRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(SimpleQRCode.__proto__||(0,_getPrototypeOf2.default)(SimpleQRCode)).call(this,props));_this.onRefresh=_this.onRefresh.bind(_this);_this.onDownload=_this.onDownload.bind(_this);return _this;}(0,_createClass3.default)(SimpleQRCode,[{key:'componentDidMount',value:function componentDidMount(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta=portalLoginStore.state,state=_portalLoginStore$sta===undefined?{}:_portalLoginStore$sta;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var portalLoginStore=this.props.portalLoginStore;portalLoginStore.onQCLoginEnd();}},{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var qrcodeIsInvalid=portalLoginStore.qrcodeIsInvalid,emobileDownloadUrl=portalLoginStore.emobileDownloadUrl,_portalLoginStore$sta2=portalLoginStore.state,state=_portalLoginStore$sta2===undefined?{}:_portalLoginStore$sta2,labelObj=portalLoginStore.labelObj;state=getState();var _state=state,_state$loginSettingIn=_state.loginSettingInfo,loginSettingInfo=_state$loginSettingIn===undefined?{}:_state$loginSettingIn,qrCode=_state.qrCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var size=this.props.size||100;var color=this.props.color||loginForm.color||'#fff';return _react2.default.createElement('div',{className:'simplelogin-QRCode'},_react2.default.createElement('div',{className:'simplelogin-QRCode-area'},qrcodeIsInvalid&&_react2.default.createElement('div',{className:'simplelogin-QRCode-timeout'},_react2.default.createElement('div',{className:'simplelogin-QRCode-timeout-mask'}),_react2.default.createElement('div',{className:'simplelogin-QRCode-timeout-tips'},labelObj.qrcodeisinvalid),_react2.default.createElement('i',{className:'icon-coms-Refresh simplelogin-QRCode-timeout-refresh',title:labelObj.refresh,onClick:this.onRefresh})),qrCode.text?_react2.default.createElement(_qrcode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_QRCode@p6brx0',value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#eaeaea'}):''),_react2.default.createElement('div',{className:'simplelogin-QRCode-describe',style:{color:color}},labelObj.qrcode),emobileDownloadUrl&&_react2.default.createElement('div',{className:'simplelogin-QRCode-download',onClick:this.onDownload},labelObj.download));}},{key:'onRefresh',value:function onRefresh(){var portalLoginStore=this.props.portalLoginStore;var _portalLoginStore$sta3=portalLoginStore.state,state=_portalLoginStore$sta3===undefined?{}:_portalLoginStore$sta3;var loginId=state.cacheAccount,langId=state.langId;portalLoginStore.getLoginForm({loginId:loginId,langId:langId},function(){return portalLoginStore.onQCLoginStart();});}},{key:'onDownload',value:function onDownload(){var portalLoginStore=this.props.portalLoginStore;var emobileDownloadUrl=portalLoginStore.emobileDownloadUrl;window.open((0,_pathUtil.addContentPath)(emobileDownloadUrl));}}]);return SimpleQRCode;}(_react2.default.Component))||_class)||_class);exports.default=SimpleQRCode;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(6);var _ecCom=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var LoginBtn=(_dec=(0,_mobxReact.inject)('portalLoginStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(LoginBtn,_React$Component);function LoginBtn(props){(0,_classCallCheck3.default)(this,LoginBtn);var _this=(0,_possibleConstructorReturn3.default)(this,(LoginBtn.__proto__||(0,_getPrototypeOf2.default)(LoginBtn)).call(this,props));_this.onReset=function(){$(".simplelogin-form input").val("");};_this.onLogin=_this.onLogin.bind(_this);return _this;}(0,_createClass3.default)(LoginBtn,[{key:'render',value:function render(){var _props=this.props,portalLoginStore=_props.portalLoginStore,getState=_props.getState;var state=portalLoginStore.state;state=getState();var _state=state,loginSettingInfo=_state.loginSettingInfo;var loginForm=loginSettingInfo.loginForm;var e7LoginButtonColor=loginForm.e7LoginButtonColor;return _react2.default.createElement('div',{className:'loginBtns'},_react2.default.createElement('div',{className:'loginBtn',onClick:this.onLogin},getLabel(674,'登录')),_react2.default.createElement('div',{className:'resetBtn',onClick:this.onReset},getLabel(2022,'重置')));}},{key:'onLogin',value:function onLogin(){var _props2=this.props,portalLoginStore=_props2.portalLoginStore,isSetting=_props2.isSetting;if(!isSetting){portalLoginStore.onLogin();}}}]);return LoginBtn;}(_react2.default.Component))||_class)||_class);exports.default=LoginBtn;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js?v=9f6f469d